var Ho = Object.defineProperty;
var So = (s, e, t) => e in s ? Ho(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var U = (s, e, t) => (So(s, typeof e != "symbol" ? e + "" : e, t), t), Mo = (s, e, t) => {
  if (!e.has(s))
    throw TypeError("Cannot " + t);
};
var Ts = (s, e, t) => {
  if (e.has(s))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(s) : e.set(s, t);
};
var An = (s, e, t) => (Mo(s, e, "access private method"), t);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Mn = window, ai = Mn.ShadowRoot && (Mn.ShadyCSS === void 0 || Mn.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, li = Symbol(), qi = /* @__PURE__ */ new WeakMap();
let Hr = class {
  constructor(e, t, n) {
    if (this._$cssResult$ = !0, n !== li)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = t;
  }
  get styleSheet() {
    let e = this.o;
    const t = this.t;
    if (ai && e === void 0) {
      const n = t !== void 0 && t.length === 1;
      n && (e = qi.get(t)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), n && qi.set(t, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
};
const Fo = (s) => new Hr(typeof s == "string" ? s : s + "", void 0, li), De = (s, ...e) => {
  const t = s.length === 1 ? s[0] : e.reduce((n, i, r) => n + ((o) => {
    if (o._$cssResult$ === !0)
      return o.cssText;
    if (typeof o == "number")
      return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + s[r + 1], s[0]);
  return new Hr(t, s, li);
}, jo = (s, e) => {
  ai ? s.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach((t) => {
    const n = document.createElement("style"), i = Mn.litNonce;
    i !== void 0 && n.setAttribute("nonce", i), n.textContent = t.cssText, s.appendChild(n);
  });
}, Gi = ai ? (s) => s : (s) => s instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const n of e.cssRules)
    t += n.cssText;
  return Fo(t);
})(s) : s;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Es;
const Bn = window, Ui = Bn.trustedTypes, No = Ui ? Ui.emptyScript : "", Zi = Bn.reactiveElementPolyfillSupport, qs = { toAttribute(s, e) {
  switch (e) {
    case Boolean:
      s = s ? No : null;
      break;
    case Object:
    case Array:
      s = s == null ? s : JSON.stringify(s);
  }
  return s;
}, fromAttribute(s, e) {
  let t = s;
  switch (e) {
    case Boolean:
      t = s !== null;
      break;
    case Number:
      t = s === null ? null : Number(s);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(s);
      } catch {
        t = null;
      }
  }
  return t;
} }, Sr = (s, e) => e !== s && (e == e || s == s), ks = { attribute: !0, type: String, converter: qs, reflect: !1, hasChanged: Sr }, Gs = "finalized";
let zt = class extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
  }
  static addInitializer(e) {
    var t;
    this.finalize(), ((t = this.h) !== null && t !== void 0 ? t : this.h = []).push(e);
  }
  static get observedAttributes() {
    this.finalize();
    const e = [];
    return this.elementProperties.forEach((t, n) => {
      const i = this._$Ep(n, t);
      i !== void 0 && (this._$Ev.set(i, n), e.push(i));
    }), e;
  }
  static createProperty(e, t = ks) {
    if (t.state && (t.attribute = !1), this.finalize(), this.elementProperties.set(e, t), !t.noAccessor && !this.prototype.hasOwnProperty(e)) {
      const n = typeof e == "symbol" ? Symbol() : "__" + e, i = this.getPropertyDescriptor(e, n, t);
      i !== void 0 && Object.defineProperty(this.prototype, e, i);
    }
  }
  static getPropertyDescriptor(e, t, n) {
    return { get() {
      return this[t];
    }, set(i) {
      const r = this[e];
      this[t] = i, this.requestUpdate(e, r, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) || ks;
  }
  static finalize() {
    if (this.hasOwnProperty(Gs))
      return !1;
    this[Gs] = !0;
    const e = Object.getPrototypeOf(this);
    if (e.finalize(), e.h !== void 0 && (this.h = [...e.h]), this.elementProperties = new Map(e.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t = this.properties, n = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
      for (const i of n)
        this.createProperty(i, t[i]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(e) {
    const t = [];
    if (Array.isArray(e)) {
      const n = new Set(e.flat(1 / 0).reverse());
      for (const i of n)
        t.unshift(Gi(i));
    } else
      e !== void 0 && t.push(Gi(e));
    return t;
  }
  static _$Ep(e, t) {
    const n = t.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  _$Eu() {
    var e;
    this._$E_ = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (e = this.constructor.h) === null || e === void 0 || e.forEach((t) => t(this));
  }
  addController(e) {
    var t, n;
    ((t = this._$ES) !== null && t !== void 0 ? t : this._$ES = []).push(e), this.renderRoot !== void 0 && this.isConnected && ((n = e.hostConnected) === null || n === void 0 || n.call(e));
  }
  removeController(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.splice(this._$ES.indexOf(e) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((e, t) => {
      this.hasOwnProperty(t) && (this._$Ei.set(t, this[t]), delete this[t]);
    });
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) !== null && e !== void 0 ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return jo(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var e;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostConnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostDisconnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  attributeChangedCallback(e, t, n) {
    this._$AK(e, n);
  }
  _$EO(e, t, n = ks) {
    var i;
    const r = this.constructor._$Ep(e, n);
    if (r !== void 0 && n.reflect === !0) {
      const o = (((i = n.converter) === null || i === void 0 ? void 0 : i.toAttribute) !== void 0 ? n.converter : qs).toAttribute(t, n.type);
      this._$El = e, o == null ? this.removeAttribute(r) : this.setAttribute(r, o), this._$El = null;
    }
  }
  _$AK(e, t) {
    var n;
    const i = this.constructor, r = i._$Ev.get(e);
    if (r !== void 0 && this._$El !== r) {
      const o = i.getPropertyOptions(r), a = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((n = o.converter) === null || n === void 0 ? void 0 : n.fromAttribute) !== void 0 ? o.converter : qs;
      this._$El = r, this[r] = a.fromAttribute(t, o.type), this._$El = null;
    }
  }
  requestUpdate(e, t, n) {
    let i = !0;
    e !== void 0 && (((n = n || this.constructor.getPropertyOptions(e)).hasChanged || Sr)(this[e], t) ? (this._$AL.has(e) || this._$AL.set(e, t), n.reflect === !0 && this._$El !== e && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(e, n))) : i = !1), !this.isUpdatePending && i && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (t) {
      Promise.reject(t);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((i, r) => this[r] = i), this._$Ei = void 0);
    let t = !1;
    const n = this._$AL;
    try {
      t = this.shouldUpdate(n), t ? (this.willUpdate(n), (e = this._$ES) === null || e === void 0 || e.forEach((i) => {
        var r;
        return (r = i.hostUpdate) === null || r === void 0 ? void 0 : r.call(i);
      }), this.update(n)) : this._$Ek();
    } catch (i) {
      throw t = !1, this._$Ek(), i;
    }
    t && this._$AE(n);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.forEach((n) => {
      var i;
      return (i = n.hostUpdated) === null || i === void 0 ? void 0 : i.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$EC !== void 0 && (this._$EC.forEach((t, n) => this._$EO(n, this[n], t)), this._$EC = void 0), this._$Ek();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
};
zt[Gs] = !0, zt.elementProperties = /* @__PURE__ */ new Map(), zt.elementStyles = [], zt.shadowRootOptions = { mode: "open" }, Zi == null || Zi({ ReactiveElement: zt }), ((Es = Bn.reactiveElementVersions) !== null && Es !== void 0 ? Es : Bn.reactiveElementVersions = []).push("1.6.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Cs;
const Wn = window, Ht = Wn.trustedTypes, Qi = Ht ? Ht.createPolicy("lit-html", { createHTML: (s) => s }) : void 0, Us = "$lit$", _e = `lit$${(Math.random() + "").slice(9)}$`, Mr = "?" + _e, Xo = `<${Mr}>`, ut = document, nn = () => ut.createComment(""), sn = (s) => s === null || typeof s != "object" && typeof s != "function", Fr = Array.isArray, Ro = (s) => Fr(s) || typeof (s == null ? void 0 : s[Symbol.iterator]) == "function", Ps = `[ 	
\f\r]`, Gt = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Ji = /-->/g, Ki = />/g, ot = RegExp(`>|${Ps}(?:([^\\s"'>=/]+)(${Ps}*=${Ps}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), _i = /'/g, $i = /"/g, jr = /^(?:script|style|textarea|title)$/i, Io = (s) => (e, ...t) => ({ _$litType$: s, strings: e, values: t }), b = Io(1), ht = Symbol.for("lit-noChange"), ee = Symbol.for("lit-nothing"), er = /* @__PURE__ */ new WeakMap(), ct = ut.createTreeWalker(ut, 129, null, !1);
function Nr(s, e) {
  if (!Array.isArray(s) || !s.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return Qi !== void 0 ? Qi.createHTML(e) : e;
}
const Bo = (s, e) => {
  const t = s.length - 1, n = [];
  let i, r = e === 2 ? "<svg>" : "", o = Gt;
  for (let a = 0; a < t; a++) {
    const l = s[a];
    let u, h, p = -1, g = 0;
    for (; g < l.length && (o.lastIndex = g, h = o.exec(l), h !== null); )
      g = o.lastIndex, o === Gt ? h[1] === "!--" ? o = Ji : h[1] !== void 0 ? o = Ki : h[2] !== void 0 ? (jr.test(h[2]) && (i = RegExp("</" + h[2], "g")), o = ot) : h[3] !== void 0 && (o = ot) : o === ot ? h[0] === ">" ? (o = i ?? Gt, p = -1) : h[1] === void 0 ? p = -2 : (p = o.lastIndex - h[2].length, u = h[1], o = h[3] === void 0 ? ot : h[3] === '"' ? $i : _i) : o === $i || o === _i ? o = ot : o === Ji || o === Ki ? o = Gt : (o = ot, i = void 0);
    const y = o === ot && s[a + 1].startsWith("/>") ? " " : "";
    r += o === Gt ? l + Xo : p >= 0 ? (n.push(u), l.slice(0, p) + Us + l.slice(p) + _e + y) : l + _e + (p === -2 ? (n.push(void 0), a) : y);
  }
  return [Nr(s, r + (s[t] || "<?>") + (e === 2 ? "</svg>" : "")), n];
};
class rn {
  constructor({ strings: e, _$litType$: t }, n) {
    let i;
    this.parts = [];
    let r = 0, o = 0;
    const a = e.length - 1, l = this.parts, [u, h] = Bo(e, t);
    if (this.el = rn.createElement(u, n), ct.currentNode = this.el.content, t === 2) {
      const p = this.el.content, g = p.firstChild;
      g.remove(), p.append(...g.childNodes);
    }
    for (; (i = ct.nextNode()) !== null && l.length < a; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) {
          const p = [];
          for (const g of i.getAttributeNames())
            if (g.endsWith(Us) || g.startsWith(_e)) {
              const y = h[o++];
              if (p.push(g), y !== void 0) {
                const f = i.getAttribute(y.toLowerCase() + Us).split(_e), x = /([.?@])?(.*)/.exec(y);
                l.push({ type: 1, index: r, name: x[2], strings: f, ctor: x[1] === "." ? Vo : x[1] === "?" ? qo : x[1] === "@" ? Go : Kn });
              } else
                l.push({ type: 6, index: r });
            }
          for (const g of p)
            i.removeAttribute(g);
        }
        if (jr.test(i.tagName)) {
          const p = i.textContent.split(_e), g = p.length - 1;
          if (g > 0) {
            i.textContent = Ht ? Ht.emptyScript : "";
            for (let y = 0; y < g; y++)
              i.append(p[y], nn()), ct.nextNode(), l.push({ type: 2, index: ++r });
            i.append(p[g], nn());
          }
        }
      } else if (i.nodeType === 8)
        if (i.data === Mr)
          l.push({ type: 2, index: r });
        else {
          let p = -1;
          for (; (p = i.data.indexOf(_e, p + 1)) !== -1; )
            l.push({ type: 7, index: r }), p += _e.length - 1;
        }
      r++;
    }
  }
  static createElement(e, t) {
    const n = ut.createElement("template");
    return n.innerHTML = e, n;
  }
}
function St(s, e, t = s, n) {
  var i, r, o, a;
  if (e === ht)
    return e;
  let l = n !== void 0 ? (i = t._$Co) === null || i === void 0 ? void 0 : i[n] : t._$Cl;
  const u = sn(e) ? void 0 : e._$litDirective$;
  return (l == null ? void 0 : l.constructor) !== u && ((r = l == null ? void 0 : l._$AO) === null || r === void 0 || r.call(l, !1), u === void 0 ? l = void 0 : (l = new u(s), l._$AT(s, t, n)), n !== void 0 ? ((o = (a = t)._$Co) !== null && o !== void 0 ? o : a._$Co = [])[n] = l : t._$Cl = l), l !== void 0 && (e = St(s, l._$AS(s, e.values), l, n)), e;
}
class Wo {
  constructor(e, t) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    var t;
    const { el: { content: n }, parts: i } = this._$AD, r = ((t = e == null ? void 0 : e.creationScope) !== null && t !== void 0 ? t : ut).importNode(n, !0);
    ct.currentNode = r;
    let o = ct.nextNode(), a = 0, l = 0, u = i[0];
    for (; u !== void 0; ) {
      if (a === u.index) {
        let h;
        u.type === 2 ? h = new un(o, o.nextSibling, this, e) : u.type === 1 ? h = new u.ctor(o, u.name, u.strings, this, e) : u.type === 6 && (h = new Uo(o, this, e)), this._$AV.push(h), u = i[++l];
      }
      a !== (u == null ? void 0 : u.index) && (o = ct.nextNode(), a++);
    }
    return ct.currentNode = ut, r;
  }
  v(e) {
    let t = 0;
    for (const n of this._$AV)
      n !== void 0 && (n.strings !== void 0 ? (n._$AI(e, n, t), t += n.strings.length - 2) : n._$AI(e[t])), t++;
  }
}
class un {
  constructor(e, t, n, i) {
    var r;
    this.type = 2, this._$AH = ee, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = n, this.options = i, this._$Cp = (r = i == null ? void 0 : i.isConnected) === null || r === void 0 || r;
  }
  get _$AU() {
    var e, t;
    return (t = (e = this._$AM) === null || e === void 0 ? void 0 : e._$AU) !== null && t !== void 0 ? t : this._$Cp;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return t !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = t.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, t = this) {
    e = St(this, e, t), sn(e) ? e === ee || e == null || e === "" ? (this._$AH !== ee && this._$AR(), this._$AH = ee) : e !== this._$AH && e !== ht && this._(e) : e._$litType$ !== void 0 ? this.g(e) : e.nodeType !== void 0 ? this.$(e) : Ro(e) ? this.T(e) : this._(e);
  }
  k(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  $(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.k(e));
  }
  _(e) {
    this._$AH !== ee && sn(this._$AH) ? this._$AA.nextSibling.data = e : this.$(ut.createTextNode(e)), this._$AH = e;
  }
  g(e) {
    var t;
    const { values: n, _$litType$: i } = e, r = typeof i == "number" ? this._$AC(e) : (i.el === void 0 && (i.el = rn.createElement(Nr(i.h, i.h[0]), this.options)), i);
    if (((t = this._$AH) === null || t === void 0 ? void 0 : t._$AD) === r)
      this._$AH.v(n);
    else {
      const o = new Wo(r, this), a = o.u(this.options);
      o.v(n), this.$(a), this._$AH = o;
    }
  }
  _$AC(e) {
    let t = er.get(e.strings);
    return t === void 0 && er.set(e.strings, t = new rn(e)), t;
  }
  T(e) {
    Fr(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let n, i = 0;
    for (const r of e)
      i === t.length ? t.push(n = new un(this.k(nn()), this.k(nn()), this, this.options)) : n = t[i], n._$AI(r), i++;
    i < t.length && (this._$AR(n && n._$AB.nextSibling, i), t.length = i);
  }
  _$AR(e = this._$AA.nextSibling, t) {
    var n;
    for ((n = this._$AP) === null || n === void 0 || n.call(this, !1, !0, t); e && e !== this._$AB; ) {
      const i = e.nextSibling;
      e.remove(), e = i;
    }
  }
  setConnected(e) {
    var t;
    this._$AM === void 0 && (this._$Cp = e, (t = this._$AP) === null || t === void 0 || t.call(this, e));
  }
}
class Kn {
  constructor(e, t, n, i, r) {
    this.type = 1, this._$AH = ee, this._$AN = void 0, this.element = e, this.name = t, this._$AM = i, this.options = r, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = ee;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e, t = this, n, i) {
    const r = this.strings;
    let o = !1;
    if (r === void 0)
      e = St(this, e, t, 0), o = !sn(e) || e !== this._$AH && e !== ht, o && (this._$AH = e);
    else {
      const a = e;
      let l, u;
      for (e = r[0], l = 0; l < r.length - 1; l++)
        u = St(this, a[n + l], t, l), u === ht && (u = this._$AH[l]), o || (o = !sn(u) || u !== this._$AH[l]), u === ee ? e = ee : e !== ee && (e += (u ?? "") + r[l + 1]), this._$AH[l] = u;
    }
    o && !i && this.j(e);
  }
  j(e) {
    e === ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
}
class Vo extends Kn {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === ee ? void 0 : e;
  }
}
const Yo = Ht ? Ht.emptyScript : "";
class qo extends Kn {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    e && e !== ee ? this.element.setAttribute(this.name, Yo) : this.element.removeAttribute(this.name);
  }
}
class Go extends Kn {
  constructor(e, t, n, i, r) {
    super(e, t, n, i, r), this.type = 5;
  }
  _$AI(e, t = this) {
    var n;
    if ((e = (n = St(this, e, t, 0)) !== null && n !== void 0 ? n : ee) === ht)
      return;
    const i = this._$AH, r = e === ee && i !== ee || e.capture !== i.capture || e.once !== i.once || e.passive !== i.passive, o = e !== ee && (i === ee || r);
    r && this.element.removeEventListener(this.name, this, i), o && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var t, n;
    typeof this._$AH == "function" ? this._$AH.call((n = (t = this.options) === null || t === void 0 ? void 0 : t.host) !== null && n !== void 0 ? n : this.element, e) : this._$AH.handleEvent(e);
  }
}
class Uo {
  constructor(e, t, n) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    St(this, e);
  }
}
const tr = Wn.litHtmlPolyfillSupport;
tr == null || tr(rn, un), ((Cs = Wn.litHtmlVersions) !== null && Cs !== void 0 ? Cs : Wn.litHtmlVersions = []).push("2.8.0");
const Zo = (s, e, t) => {
  var n, i;
  const r = (n = t == null ? void 0 : t.renderBefore) !== null && n !== void 0 ? n : e;
  let o = r._$litPart$;
  if (o === void 0) {
    const a = (i = t == null ? void 0 : t.renderBefore) !== null && i !== void 0 ? i : null;
    r._$litPart$ = o = new un(e.insertBefore(nn(), a), a, void 0, t ?? {});
  }
  return o._$AI(s), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var zs, Ls;
class fe extends zt {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, t;
    const n = super.createRenderRoot();
    return (e = (t = this.renderOptions).renderBefore) !== null && e !== void 0 || (t.renderBefore = n.firstChild), n;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = Zo(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!1);
  }
  render() {
    return ht;
  }
}
fe.finalized = !0, fe._$litElement$ = !0, (zs = globalThis.litElementHydrateSupport) === null || zs === void 0 || zs.call(globalThis, { LitElement: fe });
const nr = globalThis.litElementPolyfillSupport;
nr == null || nr({ LitElement: fe });
((Ls = globalThis.litElementVersions) !== null && Ls !== void 0 ? Ls : globalThis.litElementVersions = []).push("3.3.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Pe = (s) => (e) => typeof e == "function" ? ((t, n) => (customElements.define(t, n), n))(s, e) : ((t, n) => {
  const { kind: i, elements: r } = n;
  return { kind: i, elements: r, finisher(o) {
    customElements.define(t, o);
  } };
})(s, e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Qo = (s, e) => e.kind === "method" && e.descriptor && !("value" in e.descriptor) ? { ...e, finisher(t) {
  t.createProperty(e.key, s);
} } : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: e.key, initializer() {
  typeof e.initializer == "function" && (this[e.key] = e.initializer.call(this));
}, finisher(t) {
  t.createProperty(e.key, s);
} }, Jo = (s, e, t) => {
  e.constructor.createProperty(t, s);
};
function T(s) {
  return (e, t) => t !== void 0 ? Jo(s, e, t) : Qo(s, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function O(s) {
  return T({ ...s, state: !0 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ko = ({ finisher: s, descriptor: e }) => (t, n) => {
  var i;
  if (n === void 0) {
    const r = (i = t.originalKey) !== null && i !== void 0 ? i : t.key, o = e != null ? { kind: "method", placement: "prototype", key: r, descriptor: e(t.key) } : { ...t, key: r };
    return s != null && (o.finisher = function(a) {
      s(a, r);
    }), o;
  }
  {
    const r = t.constructor;
    e !== void 0 && Object.defineProperty(t, n, e(n)), s == null || s(r, n);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function hn(s, e) {
  return Ko({ descriptor: (t) => {
    const n = { get() {
      var i, r;
      return (r = (i = this.renderRoot) === null || i === void 0 ? void 0 : i.querySelector(s)) !== null && r !== void 0 ? r : null;
    }, enumerable: !0, configurable: !0 };
    if (e) {
      const i = typeof t == "symbol" ? Symbol() : "__" + t;
      n.get = function() {
        var r, o;
        return this[i] === void 0 && (this[i] = (o = (r = this.renderRoot) === null || r === void 0 ? void 0 : r.querySelector(s)) !== null && o !== void 0 ? o : null), this[i];
      };
    }
    return n;
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var As;
((As = window.HTMLSlotElement) === null || As === void 0 ? void 0 : As.prototype.assignedElements) != null;
const _o = De`
  .headline {
    color: var(--text-color);
    font-size: var(--font-r-large);
    padding: 0;
    margin: var(--d-small) 0 var(--d-large);

    @media (min-width: 1024px) {
      font-size: var(--font-r-base);
      text-align: center;
    }
  }
  [role='button'] {
    text-decoration: none;
    color: var(--text-color);
    display: block;
    font-size: var(--font-rel-base);
  }
  .teaser-list {
    list-style-type: none;
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .teaser-list.always-row {
    text-align: left;
  }
  .teaser-list:not(.always-row) {
    @media (min-width: 1024px) {
      flex-direction: row;
    }
  }
  .teaser-list-item {
    padding: var(--d-small);
    border-radius: var(--radius-base);
    background: var(--c-white);
    margin: var(--d-xsmall);
    color: var(--text-color);
    justify-content: space-evenly;
    box-shadow: var(--shadow);
    border: var(--border-base) solid transparent;

    @media (min-width: 768px) {
      min-height: 100px;
    }
  }
  .teaser-list-item:hover,
  .teaser-list-item:focus {
    color: var(--c-accent-dark);
    background: var(--c-secondary);
    transition: all 0.3s ease-in-out;
    border-color: var(--c-accent-high);
  }
  .teaser-list-item .teaser-click-label {
    color: var(--c-accent-high);
    font-weight: bold;
    display: block;
    margin-top: 20px;
    text-decoration: underline;
  }
`;
var $o = Object.defineProperty, ea = Object.getOwnPropertyDescriptor, Nt = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? ea(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && $o(e, t, i), i;
};
let et = class extends fe {
  constructor() {
    super(...arguments), this.teasers = [], this.heading = void 0, this.actionLabel = void 0, this.alwaysRow = !1, this.clickable = !1;
  }
  // Handle the click on a default prompt
  handleTeaserClick(s, e) {
    e == null || e.preventDefault();
    const t = new CustomEvent("teaser-click", {
      detail: {
        question: s.description
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  renderClickableTeaser(s) {
    return b`
      <a
        role="button"
        href="#"
        data-testid="default-question"
        @click="${(e) => this.handleTeaserClick(s, e)}"
        style="height: 100%;"
      >
        ${s.description}
        <span class="teaser-click-label">${this.actionLabel}</span>
      </a>
    `;
  }
  render() {
    return b`
      <div class="teaser-list-container">
        ${this.heading ? b`<h1 class="headline">${this.heading}</h1>` : ""}
        <ul class="teaser-list ${this.alwaysRow ? "always-row" : ""}">
          ${this.teasers.map(
      (s) => b`
              <li class="teaser-list-item">
                ${this.clickable ? this.renderClickableTeaser(s) : s.description}
              </li>
            `
    )}
        </ul>
      </div>
    `;
  }
};
et.styles = [_o];
Nt([
  T({ type: Array })
], et.prototype, "teasers", 2);
Nt([
  T({ type: String })
], et.prototype, "heading", 2);
Nt([
  T({ type: String })
], et.prototype, "actionLabel", 2);
Nt([
  T({ type: Boolean })
], et.prototype, "alwaysRow", 2);
Nt([
  T({ type: Boolean })
], et.prototype, "clickable", 2);
et = Nt([
  Pe("teaser-list-component")
], et);
const ta = De`
  .tab-component__list {
    list-style-type: none;
    display: flex;
    box-shadow: var(--shadow);
    border-radius: var(--radius-base);
    padding: var(--d-xsmall);
    width: 450px;
    margin: 0 auto;
    justify-content: space-evenly;
  }
  .tab-component__listItem {
    width: 33%;
    text-align: center;
  }
  .tab-component__link.active {
    background: linear-gradient(to left, var(--c-accent-light), var(--c-accent-high));
    color: var(--c-white);
  }
  .tab-component__link:not(.active):hover {
    background: var(--c-light-gray);
    cursor: pointer;
  }
  .tab-component__link {
    border-bottom: 4px solid transparent;
    border-radius: var(--radius-small);
    text-decoration: none;
    color: var(--text-color);
    font-weight: bold;
    font-size: var(--font-small);
    cursor: pointer;
    display: block;
    padding: var(--d-small);
  }
  .tab-component__content {
    position: relative;
  }
  .tab-component__tab {
    position: absolute;
    top: 0;
    left: 30px;
    display: none;
    width: 100%;
    @media (max-width: 1024px) {
      position: relative;
      left: 0;
    }
  }
  .tab-component__tab.active {
    display: block;
  }
`;
var na = Object.defineProperty, sa = Object.getOwnPropertyDescriptor, ci = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? sa(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && na(e, t, i), i;
};
let on = class extends fe {
  constructor() {
    super(...arguments), this.tabs = [], this.selectedTabId = void 0;
  }
  activateTab(s) {
    s.preventDefault();
    const e = s.target.id;
    this.selectedTabId = e;
  }
  renderTabListItem(s, e) {
    return b`
      <li class="tab-component__listItem">
        <a
          id="${s.id}"
          class="tab-component__link ${e ? "active" : ""}"
          role="tab"
          href="#"
          aria-selected="${e}"
          aria-hidden="${!e}"
          aria-controls="tabpanel-${s.id}"
          @click="${(t) => this.activateTab(t)}"
          title="${s.label}"
        >
          ${s.label}
        </a>
      </li>
    `;
  }
  renderTabContent(s, e) {
    return b`
      <div
        id="tabpanel-${s.id}"
        class="tab-component__tab ${e ? "active" : ""}"
        role="tabpanel"
        tabindex="${e ? "0" : "-1"}"
        aria-labelledby="${s.id}"
      >
        <slot name="${s.id}"></slot>
      </div>
    `;
  }
  render() {
    return b`
      <div class="tab-component">
        <nav>
          <ul class="tab-component__list" role="tablist">
            ${this.tabs.map((s) => this.renderTabListItem(s, s.id === this.selectedTabId))}
          </ul>
        </nav>
        <div class="tab-component__content">
          ${this.tabs.map((s) => this.renderTabContent(s, s.id === this.selectedTabId))}
        </div>
      </div>
    `;
  }
};
on.styles = [ta];
ci([
  T({ type: Array })
], on.prototype, "tabs", 2);
ci([
  T({ type: String })
], on.prototype, "selectedTabId", 2);
on = ci([
  Pe("tab-component")
], on);
/*! @license DOMPurify 3.4.16 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.16/LICENSE */
function sr(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var t = 0, n = Array(e); t < e; t++)
    n[t] = s[t];
  return n;
}
function ia(s) {
  if (Array.isArray(s))
    return s;
}
function ra(s, e) {
  var t = s == null ? null : typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (t != null) {
    var n, i, r, o, a = [], l = !0, u = !1;
    try {
      if (r = (t = t.call(s)).next, e === 0) {
        if (Object(t) !== t)
          return;
        l = !1;
      } else
        for (; !(l = (n = r.call(t)).done) && (a.push(n.value), a.length !== e); l = !0)
          ;
    } catch (h) {
      u = !0, i = h;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw i;
      }
    }
    return a;
  }
}
function oa() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
function aa(s, e) {
  return ia(s) || ra(s, e) || la(s, e) || oa();
}
function la(s, e) {
  if (s) {
    if (typeof s == "string")
      return sr(s, e);
    var t = {}.toString.call(s).slice(8, -1);
    return t === "Object" && s.constructor && (t = s.constructor.name), t === "Map" || t === "Set" ? Array.from(s) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? sr(s, e) : void 0;
  }
}
const Xr = Object.entries, ir = Object.setPrototypeOf, ca = Object.isFrozen, ua = Object.getPrototypeOf, ha = Object.getOwnPropertyDescriptor;
let ie = Object.freeze, oe = Object.seal, Lt = Object.create, Rr = typeof Reflect < "u" && Reflect, Zs = Rr.apply, Qs = Rr.construct;
ie || (ie = function(e) {
  return e;
});
oe || (oe = function(e) {
  return e;
});
Zs || (Zs = function(e, t) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    i[r - 2] = arguments[r];
  return e.apply(t, i);
});
Qs || (Qs = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return new e(...n);
});
const at = ne(Array.prototype.forEach), da = ne(Array.prototype.lastIndexOf), rr = ne(Array.prototype.pop), Ut = ne(Array.prototype.push), pa = ne(Array.prototype.splice), Ot = Array.isArray, _t = ne(String.prototype.toLowerCase), Os = ne(String.prototype.toString), or = ne(String.prototype.match), Zt = ne(String.prototype.replace), ar = ne(String.prototype.indexOf), fa = ne(String.prototype.trim), ga = ne(Number.prototype.toString), ma = ne(Boolean.prototype.toString), lr = typeof BigInt > "u" ? null : ne(BigInt.prototype.toString), cr = typeof Symbol > "u" ? null : ne(Symbol.prototype.toString), me = ne(Object.prototype.hasOwnProperty), Qt = ne(Object.prototype.toString), pe = ne(RegExp.prototype.test), Je = ba(TypeError);
function ne(s) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      n[i - 1] = arguments[i];
    return Zs(s, e, n);
  };
}
function ba(s) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return Qs(s, t);
  };
}
function R(s, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _t;
  if (ir && ir(s, null), !Ot(e))
    return s;
  let n = e.length;
  for (; n--; ) {
    let i = e[n];
    if (typeof i == "string") {
      const r = t(i);
      r !== i && (ca(e) || (e[n] = r), i = r);
    }
    s[i] = !0;
  }
  return s;
}
function va(s) {
  for (let e = 0; e < s.length; e++)
    me(s, e) || (s[e] = null);
  return s;
}
function we(s) {
  const e = Lt(null);
  for (const n of Xr(s)) {
    var t = aa(n, 2);
    const i = t[0], r = t[1];
    me(s, i) && (Ot(r) ? e[i] = va(r) : r && typeof r == "object" && r.constructor === Object ? e[i] = we(r) : e[i] = r);
  }
  return e;
}
function ya(s) {
  switch (typeof s) {
    case "string":
      return s;
    case "number":
      return ga(s);
    case "boolean":
      return ma(s);
    case "bigint":
      return lr ? lr(s) : "0";
    case "symbol":
      return cr ? cr(s) : "Symbol()";
    case "undefined":
      return Qt(s);
    case "function":
    case "object": {
      if (s === null)
        return Qt(s);
      const e = s, t = Ee(e, "toString");
      if (typeof t == "function") {
        const n = t(e);
        return typeof n == "string" ? n : Qt(n);
      }
      return Qt(s);
    }
    default:
      return Qt(s);
  }
}
function Ee(s, e) {
  for (; s !== null; ) {
    const n = ha(s, e);
    if (n) {
      if (n.get)
        return ne(n.get);
      if (typeof n.value == "function")
        return ne(n.value);
    }
    s = ua(s);
  }
  function t() {
    return null;
  }
  return t;
}
function wa(s) {
  try {
    return pe(s, ""), !0;
  } catch {
    return !1;
  }
}
const ur = ie([
  "a",
  "abbr",
  "acronym",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "bdi",
  "bdo",
  "big",
  "blink",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "col",
  "colgroup",
  "content",
  "data",
  "datalist",
  "dd",
  "decorator",
  "del",
  "details",
  "dfn",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "element",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "font",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meter",
  "nav",
  "nobr",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "search",
  "section",
  "select",
  "shadow",
  "slot",
  "small",
  "source",
  "spacer",
  "span",
  "strike",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "track",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
]), Ds = ie([
  "svg",
  "a",
  "altglyph",
  "altglyphdef",
  "altglyphitem",
  "animatecolor",
  "animatemotion",
  "animatetransform",
  "circle",
  "clippath",
  "defs",
  "desc",
  "ellipse",
  "enterkeyhint",
  "exportparts",
  "filter",
  "font",
  "g",
  "glyph",
  "glyphref",
  "hkern",
  "image",
  "inputmode",
  "line",
  "lineargradient",
  "marker",
  "mask",
  "metadata",
  "mpath",
  "part",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialgradient",
  "rect",
  "stop",
  "style",
  "switch",
  "symbol",
  "text",
  "textpath",
  "title",
  "tref",
  "tspan",
  "view",
  "vkern"
]), Hs = ie([
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence"
]), xa = ie([
  "animate",
  "color-profile",
  "cursor",
  "discard",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignobject",
  "hatch",
  "hatchpath",
  "mesh",
  "meshgradient",
  "meshpatch",
  "meshrow",
  "missing-glyph",
  "script",
  "set",
  "solidcolor",
  "unknown",
  "use"
]), Ss = ie([
  "math",
  "menclose",
  "merror",
  "mfenced",
  "mfrac",
  "mglyph",
  "mi",
  "mlabeledtr",
  "mmultiscripts",
  "mn",
  "mo",
  "mover",
  "mpadded",
  "mphantom",
  "mroot",
  "mrow",
  "ms",
  "mspace",
  "msqrt",
  "mstyle",
  "msub",
  "msup",
  "msubsup",
  "mtable",
  "mtd",
  "mtext",
  "mtr",
  "munder",
  "munderover",
  "mprescripts"
]), Ta = ie([
  "maction",
  "maligngroup",
  "malignmark",
  "mlongdiv",
  "mscarries",
  "mscarry",
  "msgroup",
  "mstack",
  "msline",
  "msrow",
  "semantics",
  "annotation",
  "annotation-xml",
  "mprescripts",
  "none"
]), hr = ie(["#text"]), dr = ie([
  "accept",
  "action",
  "align",
  "alt",
  "autocapitalize",
  "autocomplete",
  "autopictureinpicture",
  "autoplay",
  "background",
  "bgcolor",
  "border",
  "capture",
  "cellpadding",
  "cellspacing",
  "checked",
  "cite",
  "class",
  "clear",
  "color",
  "cols",
  "colspan",
  "command",
  "commandfor",
  "controls",
  "controlslist",
  "coords",
  "crossorigin",
  "datetime",
  "decoding",
  "default",
  "dir",
  "disabled",
  "disablepictureinpicture",
  "disableremoteplayback",
  "download",
  "draggable",
  "enctype",
  "enterkeyhint",
  "exportparts",
  "face",
  "for",
  "headers",
  "height",
  "hidden",
  "high",
  "href",
  "hreflang",
  "id",
  "inert",
  "inputmode",
  "integrity",
  "ismap",
  "kind",
  "label",
  "lang",
  "list",
  "loading",
  "loop",
  "low",
  "max",
  "maxlength",
  "media",
  "method",
  "min",
  "minlength",
  "multiple",
  "muted",
  "name",
  "nonce",
  "noshade",
  "novalidate",
  "nowrap",
  "open",
  "optimum",
  "part",
  "pattern",
  "placeholder",
  "playsinline",
  "popover",
  "popovertarget",
  "popovertargetaction",
  "poster",
  "preload",
  "pubdate",
  "radiogroup",
  "readonly",
  "rel",
  "required",
  "rev",
  "reversed",
  "role",
  "rows",
  "rowspan",
  "spellcheck",
  "scope",
  "selected",
  "shape",
  "size",
  "sizes",
  "slot",
  "span",
  "srclang",
  "start",
  "src",
  "srcset",
  "step",
  "style",
  "summary",
  "tabindex",
  "title",
  "translate",
  "type",
  "usemap",
  "valign",
  "value",
  "width",
  "wrap",
  "xmlns"
]), Ms = ie([
  "accent-height",
  "accumulate",
  "additive",
  "alignment-baseline",
  "amplitude",
  "ascent",
  "attributename",
  "attributetype",
  "azimuth",
  "basefrequency",
  "baseline-shift",
  "begin",
  "bias",
  "by",
  "class",
  "clip",
  "clippathunits",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "cx",
  "cy",
  "d",
  "dx",
  "dy",
  "diffuseconstant",
  "direction",
  "display",
  "divisor",
  "dominant-baseline",
  "dur",
  "edgemode",
  "elevation",
  "end",
  "exponent",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "filterunits",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyph-name",
  "glyphref",
  "gradientunits",
  "gradienttransform",
  "height",
  "href",
  "id",
  "image-rendering",
  "in",
  "in2",
  "intercept",
  "k",
  "k1",
  "k2",
  "k3",
  "k4",
  "kerning",
  "keypoints",
  "keysplines",
  "keytimes",
  "lang",
  "lengthadjust",
  "letter-spacing",
  "kernelmatrix",
  "kernelunitlength",
  "lighting-color",
  "local",
  "marker-end",
  "marker-mid",
  "marker-start",
  "markerheight",
  "markerunits",
  "markerwidth",
  "maskcontentunits",
  "maskunits",
  "max",
  "mask",
  "mask-type",
  "media",
  "method",
  "mode",
  "min",
  "name",
  "numoctaves",
  "offset",
  "operator",
  "opacity",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "paint-order",
  "path",
  "pathlength",
  "patterncontentunits",
  "patterntransform",
  "patternunits",
  "pointer-events",
  "points",
  "preservealpha",
  "preserveaspectratio",
  "primitiveunits",
  "r",
  "rx",
  "ry",
  "radius",
  "refx",
  "refy",
  "repeatcount",
  "repeatdur",
  "restart",
  "result",
  "rotate",
  "scale",
  "seed",
  "shape-rendering",
  "slope",
  "specularconstant",
  "specularexponent",
  "spreadmethod",
  "startoffset",
  "stddeviation",
  "stitchtiles",
  "stop-color",
  "stop-opacity",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke",
  "stroke-width",
  "style",
  "surfacescale",
  "systemlanguage",
  "tabindex",
  "tablevalues",
  "targetx",
  "targety",
  "transform",
  "transform-origin",
  "text-anchor",
  "text-decoration",
  "text-orientation",
  "text-rendering",
  "textlength",
  "type",
  "u1",
  "u2",
  "unicode",
  "values",
  "vector-effect",
  "viewbox",
  "visibility",
  "version",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "width",
  "word-spacing",
  "wrap",
  "writing-mode",
  "xchannelselector",
  "ychannelselector",
  "x",
  "x1",
  "x2",
  "xmlns",
  "y",
  "y1",
  "y2",
  "z",
  "zoomandpan"
]), pr = ie([
  "accent",
  "accentunder",
  "align",
  "bevelled",
  "close",
  "columnalign",
  "columnlines",
  "columnspacing",
  "columnspan",
  "denomalign",
  "depth",
  "dir",
  "display",
  "displaystyle",
  "encoding",
  "fence",
  "frame",
  "height",
  "href",
  "id",
  "largeop",
  "length",
  "linethickness",
  "lquote",
  "lspace",
  "mathbackground",
  "mathcolor",
  "mathsize",
  "mathvariant",
  "maxsize",
  "minsize",
  "movablelimits",
  "notation",
  "numalign",
  "open",
  "rowalign",
  "rowlines",
  "rowspacing",
  "rowspan",
  "rspace",
  "rquote",
  "scriptlevel",
  "scriptminsize",
  "scriptsizemultiplier",
  "selection",
  "separator",
  "separators",
  "stretchy",
  "subscriptshift",
  "supscriptshift",
  "symmetric",
  "voffset",
  "width",
  "xmlns"
]), On = ie([
  "xlink:href",
  "xml:id",
  "xlink:title",
  "xml:space",
  "xmlns:xlink"
]), Ea = oe(/{{[\w\W]*|^[\w\W]*}}/g), ka = oe(/<%[\w\W]*|^[\w\W]*%>/g), Ca = oe(/\${[\w\W]*/g), Pa = oe(/^data-[\-\w.\u00B7-\uFFFF]+$/), za = oe(/^aria-[\-\w]+$/), fr = oe(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), La = oe(/^(?:\w+script|data):/i), Aa = oe(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Oa = oe(/^html$/i), Da = oe(/^[a-z][.\w]*(-[.\w]+)+$/i), gr = oe(/<[/\w!]/g), mr = oe(/<[/\w]/g), Ha = oe(/<\/no(script|embed|frames)/i), Sa = oe(/\/>/i), ye = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  entityNode: 6,
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
}, Ir = [
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
], Ma = ie(R({}, Ir)), Fa = function() {
  const s = {};
  return at(Ir, (e) => {
    s[e] = oe(new RegExp("</" + e + "(?=[\\t\\n\\f\\r />])", "i"));
  }), ie(s);
}(), ja = function() {
  return typeof window > "u" ? null : window;
}, Na = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const i = "data-tt-policy-suffix";
  t && t.hasAttribute(i) && (n = t.getAttribute(i));
  const r = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(r, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, br = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, Ke = function(e, t, n, i) {
  return me(e, t) && Ot(e[t]) ? R(i.base ? we(i.base) : {}, e[t], i.transform) : n;
}, Fs = function(e, t, n) {
  const i = me(e, t) ? e[t] : void 0;
  return i && typeof i == "object" ? we(i) : n();
};
function Br() {
  let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ja();
  const e = (v) => Br(v);
  if (e.version = "3.4.16", e.removed = [], !s || !s.document || s.document.nodeType !== ye.document || !s.Element)
    return e.isSupported = !1, e;
  let t = s.document;
  const n = t, i = n.currentScript;
  s.DocumentFragment;
  const r = s.HTMLTemplateElement, o = s.Node, a = s.Element, l = s.NodeFilter;
  s.NamedNodeMap === void 0 && (s.NamedNodeMap || s.MozNamedAttrMap), s.HTMLFormElement;
  const u = s.DOMParser, h = s.trustedTypes, p = a.prototype, g = Ee(p, "cloneNode"), y = Ee(p, "remove"), f = Ee(p, "removeAttributeNode"), x = Ee(p, "nextSibling"), P = Ee(p, "childNodes"), S = Ee(p, "parentNode"), N = Ee(p, "shadowRoot"), K = Ee(p, "attributes"), A = o && o.prototype ? Ee(o.prototype, "nodeType") : null, F = o && o.prototype ? Ee(o.prototype, "nodeName") : null, $ = o && o.prototype ? Ee(o.prototype, "ownerDocument") : null, he = function(c) {
    return A ? A(c) : c.nodeType;
  }, Rt = function(c) {
    return F ? F(c) : c.nodeName;
  };
  if (typeof r == "function") {
    const v = t.createElement("template");
    v.content && v.content.ownerDocument && (t = v.content.ownerDocument);
  }
  let de, He = "", vt, It = !1, Ye = 0;
  const Bt = function() {
    if (Ye > 0)
      throw Je('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Be = function(c) {
    Bt(), Ye++;
    try {
      return de.createHTML(c);
    } finally {
      Ye--;
    }
  }, gn = function(c) {
    Bt(), Ye++;
    try {
      return de.createScriptURL(c);
    } finally {
      Ye--;
    }
  }, mn = function() {
    return It || (vt = Na(h, i), It = !0), vt;
  }, D = t, W = D.implementation, ae = D.createNodeIterator, be = D.createDocumentFragment, le = D.getElementsByTagName, ze = n.importNode;
  let X = br();
  e.isSupported = typeof Xr == "function" && typeof S == "function" && W && W.createHTMLDocument !== void 0;
  const Wt = Ea, qe = ka, Ge = Ca, rs = Pa, os = za, q = La, ce = Aa, tt = Da;
  let nt = fr, I = null;
  const as = R({}, [
    ...ur,
    ...Ds,
    ...Hs,
    ...Ss,
    ...hr
  ]);
  let Q = null;
  const ls = R({}, [
    ...dr,
    ...Ms,
    ...pr,
    ...On
  ]);
  let Se = Object.seal(Lt(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Vt = null, vi = null;
  const Ue = Object.seal(Lt(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let yi = !0, cs = !0, wi = !1, xi = !0, Ze = !1, st = !0, it = !1, us = !1, bn = null, vn = null, hs = !1, yt = !1, yn = !1, wn = !1, Ti = !0, Ei = !1;
  const ki = "user-content-";
  let ds = !0, ps = !1, wt = {}, xt = null;
  const Ci = R({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let Pi = null;
  const zi = R({}, [
    "audio",
    "video",
    "img",
    "source",
    "image",
    "track"
  ]);
  let Li = null;
  const Ai = R({}, [
    "alt",
    "class",
    "for",
    "id",
    "label",
    "name",
    "pattern",
    "placeholder",
    "role",
    "summary",
    "title",
    "value",
    "style",
    "xmlns"
  ]), xn = "http://www.w3.org/1998/Math/MathML", Tn = "http://www.w3.org/2000/svg", Me = "http://www.w3.org/1999/xhtml";
  let Tt = Me, fs = !1, gs = null;
  const mo = R({}, [
    xn,
    Tn,
    Me
  ], Os), Oi = ie([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext"
  ]);
  let ms = R({}, Oi);
  const Di = ie(["annotation-xml"]);
  let bs = R({}, Di);
  const bo = R({}, [
    "title",
    "style",
    "font",
    "a",
    "script"
  ]);
  let Yt = null;
  const vo = ["application/xhtml+xml", "text/html"], yo = "text/html";
  let _ = null, Et = null;
  const wo = t.createElement("form"), Hi = function(c) {
    return c instanceof RegExp || c instanceof Function;
  }, vs = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Et && Et === c)
      return;
    (!c || typeof c != "object") && (c = {}), c = we(c), Yt = vo.indexOf(c.PARSER_MEDIA_TYPE) === -1 ? yo : c.PARSER_MEDIA_TYPE, _ = Yt === "application/xhtml+xml" ? Os : _t, I = Ke(c, "ALLOWED_TAGS", as, { transform: _ }), Q = Ke(c, "ALLOWED_ATTR", ls, { transform: _ }), gs = Ke(c, "ALLOWED_NAMESPACES", mo, { transform: Os }), Li = Ke(c, "ADD_URI_SAFE_ATTR", Ai, {
      transform: _,
      base: Ai
    }), Pi = Ke(c, "ADD_DATA_URI_TAGS", zi, {
      transform: _,
      base: zi
    }), xt = Ke(c, "FORBID_CONTENTS", Ci, { transform: _ }), Vt = Ke(c, "FORBID_TAGS", we({}), { transform: _ }), vi = Ke(c, "FORBID_ATTR", we({}), { transform: _ }), wt = me(c, "USE_PROFILES") ? c.USE_PROFILES && typeof c.USE_PROFILES == "object" ? we(c.USE_PROFILES) : c.USE_PROFILES : !1, yi = c.ALLOW_ARIA_ATTR !== !1, cs = c.ALLOW_DATA_ATTR !== !1, wi = c.ALLOW_UNKNOWN_PROTOCOLS || !1, xi = c.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ze = c.SAFE_FOR_TEMPLATES || !1, st = c.SAFE_FOR_XML !== !1, it = c.WHOLE_DOCUMENT || !1, yt = c.RETURN_DOM || !1, yn = c.RETURN_DOM_FRAGMENT || !1, wn = c.RETURN_TRUSTED_TYPE || !1, hs = c.FORCE_BODY || !1, Ti = c.SANITIZE_DOM !== !1, Ei = c.SANITIZE_NAMED_PROPS || !1, ds = c.KEEP_CONTENT !== !1, ps = c.IN_PLACE || !1, nt = wa(c.ALLOWED_URI_REGEXP) ? c.ALLOWED_URI_REGEXP : fr, Tt = typeof c.NAMESPACE == "string" ? c.NAMESPACE : Me, ms = Fs(c, "MATHML_TEXT_INTEGRATION_POINTS", () => R({}, Oi)), bs = Fs(c, "HTML_INTEGRATION_POINTS", () => R({}, Di));
    const d = Fs(c, "CUSTOM_ELEMENT_HANDLING", () => Lt(null));
    if (Se = Lt(null), me(d, "tagNameCheck") && Hi(d.tagNameCheck) && (Se.tagNameCheck = d.tagNameCheck), me(d, "attributeNameCheck") && Hi(d.attributeNameCheck) && (Se.attributeNameCheck = d.attributeNameCheck), me(d, "allowCustomizedBuiltInElements") && typeof d.allowCustomizedBuiltInElements == "boolean" && (Se.allowCustomizedBuiltInElements = d.allowCustomizedBuiltInElements), oe(Se), Ze && (cs = !1), yn && (yt = !0), wt && (I = R({}, hr), Q = Lt(null), wt.html === !0 && (R(I, ur), R(Q, dr)), wt.svg === !0 && (R(I, Ds), R(Q, Ms), R(Q, On)), wt.svgFilters === !0 && (R(I, Hs), R(Q, Ms), R(Q, On)), wt.mathMl === !0 && (R(I, Ss), R(Q, pr), R(Q, On))), Ue.tagCheck = null, Ue.attributeCheck = null, me(c, "ADD_TAGS") && (typeof c.ADD_TAGS == "function" ? Ue.tagCheck = c.ADD_TAGS : Ot(c.ADD_TAGS) && (I === as && (I = we(I)), R(I, c.ADD_TAGS, _))), me(c, "ADD_ATTR") && (typeof c.ADD_ATTR == "function" ? Ue.attributeCheck = c.ADD_ATTR : Ot(c.ADD_ATTR) && (Q === ls && (Q = we(Q)), R(Q, c.ADD_ATTR, _))), me(c, "ADD_FORBID_CONTENTS") && Ot(c.ADD_FORBID_CONTENTS) && (xt === Ci && (xt = we(xt)), R(xt, c.ADD_FORBID_CONTENTS, _)), ds && (I["#text"] = !0), it && R(I, [
      "html",
      "head",
      "body"
    ]), I.table && (R(I, ["tbody"]), delete Vt.tbody), c.TRUSTED_TYPES_POLICY) {
      if (typeof c.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Je('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof c.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Je('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const m = de;
      de = c.TRUSTED_TYPES_POLICY;
      try {
        He = Be("");
      } catch (w) {
        throw de = m, w;
      }
    } else
      c.TRUSTED_TYPES_POLICY === null ? (de = void 0, He = "") : (de === void 0 && (de = mn()), de && typeof He == "string" && (He = Be("")));
    ie && ie(c), Et = c;
  }, Si = R({}, [
    ...Ds,
    ...Hs,
    ...xa
  ]), Mi = R({}, [...Ss, ...Ta]), xo = function(c, d, m) {
    return d.namespaceURI === Me ? c === "svg" : d.namespaceURI === xn ? c === "svg" && (m === "annotation-xml" || ms[m]) : !!Si[c];
  }, To = function(c, d, m) {
    return d.namespaceURI === Me ? c === "math" : d.namespaceURI === Tn ? c === "math" && bs[m] : !!Mi[c];
  }, Eo = function(c, d, m) {
    return d.namespaceURI === Tn && !bs[m] || d.namespaceURI === xn && !ms[m] ? !1 : !Mi[c] && (bo[c] || !Si[c]);
  }, ko = function(c) {
    let d = S(c);
    (!d || !d.tagName) && (d = {
      namespaceURI: Tt,
      tagName: "template"
    });
    const m = _t(c.tagName), w = _t(d.tagName);
    return gs[c.namespaceURI] ? c.namespaceURI === Tn ? xo(m, d, w) : c.namespaceURI === xn ? To(m, d, w) : c.namespaceURI === Me ? Eo(m, d, w) : !!(Yt === "application/xhtml+xml" && gs[c.namespaceURI]) : !1;
  }, Qe = function(c) {
    Ut(e.removed, { element: c });
    try {
      S(c).removeChild(c);
    } catch {
      if (y(c), !S(c))
        throw Je("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, Fi = function(c, d, m) {
    try {
      f(c, d);
    } catch {
      try {
        c.removeAttribute(m);
      } catch {
      }
    }
  }, En = function(c) {
    kn(c);
    const d = P(c);
    if (d) {
      const w = [];
      at(d, (L) => {
        Ut(w, L);
      }), at(w, (L) => {
        try {
          y(L);
        } catch {
        }
      });
    }
    const m = K(c);
    if (m)
      for (let w = m.length - 1; w >= 0; --w) {
        const L = m[w], M = L && L.name;
        typeof M == "string" && Fi(c, L, M);
      }
  }, rt = function(c, d, m) {
    if (!m)
      try {
        m = d.getAttributeNode(c);
      } catch {
        m = null;
      }
    Ut(e.removed, {
      attribute: m || null,
      from: d
    });
    try {
      m ? f(d, m) : d.removeAttribute(c);
    } catch {
      try {
        d.removeAttribute(c);
      } catch {
      }
    }
    if (c === "is")
      if (yt || yn)
        try {
          Qe(d);
        } catch {
        }
      else
        try {
          d.setAttribute(c, "");
        } catch {
        }
  }, Co = function(c) {
    const d = K(c);
    if (d)
      for (let m = d.length - 1; m >= 0; --m) {
        const w = d[m], L = w && w.name;
        typeof L != "string" || Q[_(L)] || Fi(c, w, L);
      }
  }, kn = function(c) {
    const d = [c];
    for (; d.length > 0; ) {
      const m = d.pop();
      he(m) === ye.element && Co(m);
      const w = P(m);
      if (w)
        for (let L = w.length - 1; L >= 0; --L)
          d.push(w[L]);
    }
  }, ji = function(c, d) {
    return st ? c === "patchsrc" ? !0 : c === "for" && d !== "label" && d !== "output" : !1;
  }, Po = function(c) {
    if (!st)
      return;
    const d = [c];
    for (; d.length > 0; ) {
      const m = d.pop(), w = he(m);
      if (w === ye.processingInstruction || w === ye.comment && pe(mr, m.data)) {
        try {
          y(m);
        } catch {
        }
        continue;
      }
      if (w === ye.element) {
        const M = m, j = _(Rt(m));
        try {
          M.hasAttribute && M.hasAttribute("patchsrc") && M.removeAttribute("patchsrc"), M.hasAttribute && M.hasAttribute("for") && ji("for", j) && M.removeAttribute("for");
        } catch {
        }
      }
      const L = P(m);
      if (L)
        for (let M = L.length - 1; M >= 0; --M)
          d.push(L[M]);
    }
  }, Ni = function(c) {
    let d = null, m = null;
    if (hs)
      c = "<remove></remove>" + c;
    else {
      const M = or(c, /^[\r\n\t ]+/);
      m = M && M[0];
    }
    Yt === "application/xhtml+xml" && Tt === Me && (c = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + c + "</body></html>");
    const w = de ? Be(c) : c;
    if (Tt === Me)
      try {
        d = new u().parseFromString(w, Yt);
      } catch {
      }
    if (!d || !d.documentElement) {
      d = W.createDocument(Tt, "template", null);
      try {
        d.documentElement.innerHTML = fs ? He : w;
      } catch {
      }
    }
    const L = d.body || d.documentElement;
    return c && m && L.insertBefore(t.createTextNode(m), L.childNodes[0] || null), Tt === Me ? le.call(d, it ? "html" : "body")[0] : it ? d.documentElement : L;
  }, Xi = function(c) {
    const d = $ ? $(c) : c.ownerDocument;
    return ae.call(d || c, c, l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION, null);
  }, Cn = function(c) {
    return c = Zt(c, Wt, " "), c = Zt(c, qe, " "), c = Zt(c, Ge, " "), c;
  }, ys = function(c) {
    var d;
    c.normalize();
    const m = $ ? $(c) : c.ownerDocument, w = ae.call(m || c, c, l.SHOW_TEXT | l.SHOW_COMMENT | l.SHOW_CDATA_SECTION | l.SHOW_PROCESSING_INSTRUCTION, null);
    let L = w.nextNode();
    for (; L; )
      L.data = Cn(L.data), L = w.nextNode();
    const M = (d = c.querySelectorAll) === null || d === void 0 ? void 0 : d.call(c, "template");
    M && at(M, (j) => {
      kt(j.content) && ys(j.content);
    });
  }, Pn = function(c) {
    const d = F ? F(c) : null;
    return typeof d != "string" || _(d) !== "form" ? !1 : typeof c.nodeName != "string" || typeof c.textContent != "string" || typeof c.removeChild != "function" || c.attributes !== K(c) || typeof c.removeAttribute != "function" || typeof c.removeAttributeNode != "function" || typeof c.getAttributeNode != "function" || typeof c.setAttribute != "function" || typeof c.namespaceURI != "string" || typeof c.insertBefore != "function" || typeof c.hasChildNodes != "function" || c.nodeType !== A(c) || c.childNodes !== P(c);
  }, kt = function(c) {
    if (!A || typeof c != "object" || c === null)
      return !1;
    try {
      return A(c) === ye.documentFragment;
    } catch {
      return !1;
    }
  }, qt = function(c) {
    if (!A || typeof c != "object" || c === null)
      return !1;
    try {
      return typeof A(c) == "number";
    } catch {
      return !1;
    }
  };
  function Fe(v, c, d) {
    v.length !== 0 && at(v, (m) => {
      m.call(e, c, d, Et);
    });
  }
  const zo = function(c, d) {
    return !!(st && c.hasChildNodes() && !qt(c.firstElementChild) && pe(gr, c.textContent) && pe(gr, c.innerHTML) || st && c.namespaceURI === Me && Ma[d] && (qt(c.firstElementChild) || typeof c.textContent == "string" && pe(Fa[d], c.textContent)) || c.nodeType === ye.processingInstruction || st && c.nodeType === ye.comment && pe(mr, c.data));
  }, zn = function(c, d) {
    if (c instanceof RegExp)
      return pe(c, d);
    if (c instanceof Function) {
      for (var m = arguments.length, w = new Array(m > 2 ? m - 2 : 0), L = 2; L < m; L++)
        w[L - 2] = arguments[L];
      return !!c(d, ...w);
    }
    return !1;
  }, Lo = function(c, d, m) {
    if (!Vt[d] && Wi(d) && zn(Se.tagNameCheck, d))
      return !1;
    if (ds && !xt[d]) {
      const w = S(c), L = P(c);
      if (L && w) {
        const M = L.length;
        for (let j = M - 1; j >= 0; --j) {
          const J = c === m ? g(L[j], !0) : L[j];
          w.insertBefore(J, x(c));
        }
      }
    }
    return Qe(c), !0;
  }, Ri = function(c, d, m, w) {
    return c.length === 0 ? d : d === m || d === w ? we(d) : d;
  }, Ct = function(c, d) {
    return c === d || S(c) !== null ? !1 : (ps && kn(c), !0);
  }, Ii = function(c, d) {
    if (Fe(X.beforeSanitizeElements, c, null), Ct(c, d))
      return !0;
    if (Pn(c))
      return Qe(c), !0;
    const m = _(Rt(c));
    if (I = Ri(X.uponSanitizeElement, I, as, bn), Fe(X.uponSanitizeElement, c, {
      tagName: m,
      allowedTags: I
    }), Ct(c, d))
      return !0;
    if (zo(c, m))
      return Qe(c), !0;
    if (Vt[m] || !(Ue.tagCheck instanceof Function && Ue.tagCheck(m)) && !I[m]) {
      const w = Lo(c, m, d);
      return w === !1 && (Fe(X.afterSanitizeElements, c, null), Ct(c, d)) ? !0 : w;
    }
    if (he(c) === ye.element && !ko(c) || (m === "noscript" || m === "noembed" || m === "noframes") && pe(Ha, c.innerHTML))
      return Qe(c), !0;
    if (Ze && c.nodeType === ye.text) {
      const w = Cn(c.textContent);
      c.textContent !== w && (Ut(e.removed, { element: c.cloneNode() }), c.textContent = w);
    }
    return Fe(X.afterSanitizeElements, c, null), Ct(c, d);
  }, Bi = function(c, d, m) {
    if (vi[d] || ji(d, c) || Ti && (d === "id" || d === "name") && (m in t || m in wo))
      return !1;
    const w = Q[d] || Ue.attributeCheck instanceof Function && Ue.attributeCheck(d, c);
    return cs && pe(rs, d) || yi && pe(os, d) ? !0 : w ? Li[d] || pe(nt, Zt(m, ce, "")) || (d === "src" || d === "xlink:href" || d === "href") && c !== "script" && ar(m, "data:") === 0 && Pi[c] || wi && !pe(q, Zt(m, ce, "")) ? !0 : !m : Wi(c) && zn(Se.tagNameCheck, c) && zn(Se.attributeNameCheck, d, c) || d === "is" && Se.allowCustomizedBuiltInElements && zn(Se.tagNameCheck, m);
  }, Ao = R({}, [
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "missing-glyph"
  ]), Wi = function(c) {
    return !Ao[_t(c)] && pe(tt, c);
  }, Oo = function(c, d, m, w) {
    if (de && typeof h == "object" && typeof h.getAttributeType == "function" && !m)
      switch (h.getAttributeType(c, d)) {
        case "TrustedHTML":
          return Be(w);
        case "TrustedScriptURL":
          return gn(w);
      }
    return w;
  }, Do = function(c, d, m, w) {
    try {
      return m ? c.setAttributeNS(m, d, w) : c.setAttribute(d, w), Pn(c) ? (Qe(c), !1) : !0;
    } catch {
      return rt(d, c), !1;
    }
  }, Vi = function(c, d) {
    if (Fe(X.beforeSanitizeAttributes, c, null), Ct(c, d))
      return;
    const m = c.attributes;
    if (!m || Pn(c))
      return;
    Q = Ri(X.uponSanitizeAttribute, Q, ls, vn);
    const w = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Q,
      forceKeepAttr: void 0
    };
    let L = m.length;
    const M = _(c.nodeName);
    for (; L--; ) {
      const j = m[L], J = j.name, Te = j.namespaceURI, ve = j.value, Pt = _(J), xs = ve;
      let ge = J === "value" ? xs : fa(xs), Yi = !1;
      if (w.attrName = Pt, w.attrValue = ge, w.keepAttr = !0, w.forceKeepAttr = void 0, Fe(X.uponSanitizeAttribute, c, w), ge = w.attrValue, Ei && (Pt === "id" || Pt === "name") && ar(ge, ki) !== 0 && (rt(J, c, j), ge = ki + ge, Yi = !0), st && pe(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, ge)) {
        rt(J, c, j);
        continue;
      }
      if (Pt === "attributename" && or(ge, "href")) {
        rt(J, c, j);
        continue;
      }
      if (!w.forceKeepAttr) {
        if (!w.keepAttr) {
          rt(J, c, j);
          continue;
        }
        if (!xi && pe(Sa, ge)) {
          rt(J, c, j);
          continue;
        }
        if (Ze && (ge = Cn(ge)), !Bi(M, Pt, ge)) {
          rt(J, c, j);
          continue;
        }
        ge = Oo(M, Pt, Te, ge), ge !== xs && Do(c, J, Te, ge) && Yi && rr(e.removed);
      }
    }
    Fe(X.afterSanitizeAttributes, c, null), Ct(c, d);
  }, Ln = function(c) {
    let d = null;
    const m = Xi(c);
    for (Fe(X.beforeSanitizeShadowDOM, c, null); d = m.nextNode(); )
      if (Fe(X.uponSanitizeShadowNode, d, null), Ii(d, c), Vi(d, c), kt(d.content) && Ln(d.content), he(d) === ye.element) {
        const w = N(d);
        kt(w) && (ws(w), Ln(w));
      }
    Fe(X.afterSanitizeShadowDOM, c, null);
  }, ws = function(c) {
    const d = [{
      node: c,
      shadow: null
    }];
    for (; d.length > 0; ) {
      const m = d.pop();
      if (m.shadow) {
        Ln(m.shadow);
        continue;
      }
      const w = m.node, L = he(w) === ye.element, M = P(w);
      if (M)
        for (let j = M.length - 1; j >= 0; --j)
          d.push({
            node: M[j],
            shadow: null
          });
      if (L) {
        const j = F ? F(w) : null;
        if (typeof j == "string" && _(j) === "template") {
          const J = w.content;
          kt(J) && d.push({
            node: J,
            shadow: null
          });
        }
      }
      if (L) {
        const j = N(w);
        kt(j) && d.push({
          node: null,
          shadow: j
        }, {
          node: j,
          shadow: null
        });
      }
    }
  };
  return e.sanitize = function(v) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = null, m = null, w = null, L = null;
    if (fs = !v, fs && (v = "<!-->"), typeof v != "string" && !qt(v) && (v = ya(v), typeof v != "string"))
      throw Je("dirty is not a string, aborting");
    if (!e.isSupported)
      return v;
    us ? (I = bn, Q = vn) : vs(c), (X.uponSanitizeElement.length > 0 || X.uponSanitizeAttribute.length > 0) && (I = we(I)), X.uponSanitizeAttribute.length > 0 && (Q = we(Q)), e.removed = [];
    const M = ps && typeof v != "string" && qt(v);
    if (M) {
      Po(v);
      const Te = Rt(v);
      if (typeof Te == "string") {
        const ve = _(Te);
        if (!I[ve] || Vt[ve])
          throw En(v), Je("root node is forbidden and cannot be sanitized in-place");
      }
      if (Pn(v))
        throw En(v), Je("root node is clobbered and cannot be sanitized in-place");
      try {
        ws(v);
      } catch (ve) {
        throw En(v), ve;
      }
    } else if (qt(v))
      d = Ni("<!---->"), m = d.ownerDocument.importNode(v, !0), m.nodeType === ye.element && m.nodeName === "BODY" || m.nodeName === "HTML" ? d = m : d.appendChild(m), ws(d);
    else {
      if (!yt && !Ze && !it && v.indexOf("<") === -1)
        return de && wn ? Be(v) : v;
      if (d = Ni(v), !d)
        return yt ? null : wn ? He : "";
    }
    d && hs && Qe(d.firstChild);
    const j = M ? v : d;
    try {
      const Te = Xi(j);
      for (; w = Te.nextNode(); )
        Ii(w, j), Vi(w, j), kt(w.content) && Ln(w.content);
    } catch (Te) {
      throw M && (En(v), at(e.removed, (ve) => {
        ve.element && kn(ve.element);
      })), Te;
    }
    if (M) {
      let Te = !1;
      if (at(e.removed, (ve) => {
        ve.element && (ve.element === v && (Te = !0), kn(ve.element));
      }), Te)
        throw Je("a node selected for removal could not be safely returned; refusing to sanitize in place");
      return Ze && ys(v), v;
    }
    if (yt) {
      if (Ze && ys(d), yn)
        for (L = be.call(d.ownerDocument); d.firstChild; )
          L.appendChild(d.firstChild);
      else
        L = d;
      return (Q.shadowroot || Q.shadowrootmode) && (L = ze.call(n, L, !0)), L;
    }
    let J = it ? d.outerHTML : d.innerHTML;
    return it && I["!doctype"] && d.ownerDocument && d.ownerDocument.doctype && d.ownerDocument.doctype.name && pe(Oa, d.ownerDocument.doctype.name) && (J = "<!DOCTYPE " + d.ownerDocument.doctype.name + `>
` + J), Ze && (J = Cn(J)), de && wn ? Be(J) : J;
  }, e.setConfig = function() {
    let v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    vs(v), us = !0, bn = I, vn = Q;
  }, e.clearConfig = function() {
    Et = null, us = !1, bn = null, vn = null, de = vt, He = "";
  }, e.isValidAttribute = function(v, c, d) {
    Et || vs({});
    const m = _(v), w = _(c);
    return Bi(m, w, d);
  }, e.addHook = function(v, c) {
    typeof c == "function" && me(X, v) && Ut(X[v], c);
  }, e.removeHook = function(v, c) {
    if (me(X, v)) {
      if (c !== void 0) {
        const d = da(X[v], c);
        return d === -1 ? void 0 : pa(X[v], d, 1)[0];
      }
      return rr(X[v]);
    }
  }, e.removeHooks = function(v) {
    me(X, v) && (X[v] = []);
  }, e.removeAllHooks = function() {
    X = br();
  }, e;
}
var Wr = Br();
const Xe = {
  BOT_TYPING_EFFECT_INTERVAL: 50,
  // in ms
  // Is default prompts enabled?
  IS_DEFAULT_PROMPTS_ENABLED: !0,
  // Default prompts to display in the chat
  DISPLAY_DEFAULT_PROMPTS_BUTTON: "Not sure what to ask? Try our suggestions!",
  // This are the chat bubbles that will be displayed in the chat
  CHAT_MESSAGES: [],
  // This are the labels for the chat button and input
  CHAT_BUTTON_LABEL_TEXT: "Ask Support",
  CHAT_IMG_PROMPT_LABEL_TEXT: "Upload file",
  CHAT_CANCEL_BUTTON_LABEL_TEXT: "Cancel Generation",
  CHAT_VOICE_BUTTON_LABEL_TEXT: "Voice input",
  CHAT_VOICE_REC_BUTTON_LABEL_TEXT: "Listening to voice input",
  LIVE_CHAT_BUTTON_LABEL_TEXT: "Live Chat",
  ADD_KDB_BUTTON_LABEL_TEXT: "Add to Knowledge Base",
  CHAT_INPUT_PLACEHOLDER: 'Type your question, eg. "How to search and book rentals?"',
  CHAT_INPUT_NEWLINE_HELPER: " for new line",
  AUTOCOMPLETE_STYLES_HELPER: " for styles",
  AUTOCOMPLETE_PROJECTS_HELPER: " for projects",
  AUTOCOMPLETE_KNOWLEDGE_HELPER: " for knowledge",
  USER_IS_BOT: "Support Assistant",
  RESET_BUTTON_LABEL_TEXT: "X",
  RESET_BUTTON_TITLE_TEXT: "Reset current question",
  RESET_CHAT_BUTTON_TITLE: "Reset chat",
  ADV_PROMPT_CHECKBOX_LABEL: "Advanced prompting",
  // Copy response to clipboard
  COPY_RESPONSE_BUTTON_LABEL_TEXT: "Copy Response",
  COPIED_SUCCESSFULLY_MESSAGE: "Response copied!",
  // Follow up questions text
  FOLLOW_UP_QUESTIONS_LABEL_TEXT: "You can also ask...",
  SHOW_THOUGH_PROCESS_BUTTON_LABEL_TEXT: "Show thought process",
  HIDE_THOUGH_PROCESS_BUTTON_LABEL_TEXT: "Hide thought process",
  SPEAK_BUTTON_LABEL_TEXT: "Read the response",
  DOWNLOAD_SPEECH_BUTTON_LABEL_TEXT: "Download voice response",
  LOADING_INDICATOR_TEXT: "Please wait. We are searching and generating an answer...",
  LOADING_TEXT: "Loading...",
  // API ERROR HANDLING IN UI
  API_ERROR_MESSAGE: "Sorry, we are having some problems. Please try again later.",
  INVALID_REQUEST_ERROR: "Unable to generate answer for this query. Please modify your question and try again.",
  // Config pertaining the response format
  THOUGHT_PROCESS_LABEL: "Thought Process",
  SUPPORT_CONTEXT_LABEL: "Support Context",
  CITATIONS_LABEL: "Learn More:",
  CITATIONS_TAB_LABEL: "Citations",
  // Custom Branding
  IS_CUSTOM_BRANDING: !0,
  // Custom Branding details
  // All these should come from persistence config
  BRANDING_URL: "#",
  BRANDING_LOGO_ALT: "Brand Logo",
  BRANDING_HEADLINE: "Welcome to the Support Assistant of our Brand",
  // Web Search Configuration
  WEB_SEARCH_CHECKBOX_LABEL: "Use web search",
  WEB_SEARCH_CHECKBOX_ENABLED: !0,
  // Deep Search Configuration
  DEEP_SEARCH_CHECKBOX_LABEL: "Use deep search",
  DEEP_SEARCH_CHECKBOX_ENABLED: !0,
  REASONING_LABEL: "Reasoning",
  // Autocomplete trigger notifications
  AUTOCOMPLETE_STYLE_SELECTED: 'Style "{name}" has been added',
  AUTOCOMPLETE_PROJECT_SELECTED: 'Project "{name}" has been added',
  AUTOCOMPLETE_KNOWLEDGE_SELECTED: 'Knowledge "{name}" has been added',
  TOOLTIPS: {
    CHAT_PICK_KDB: "Pick knowledge base entries",
    CHAT_SETTINGS: "Chat settings",
    SEND_PROMPT: "Send prompt",
    PROMPT_WITH_MICROPHONE: "Prompt with microphone",
    ATTACH_FILE_TO_PROMPT: "Attach file to prompt",
    CANCEL_REQUEST: "Cancel request"
  },
  AUTOCOMPLETE: {
    STYLES_PLACEHOLDER: "Type / to search styles...",
    PROJECTS_PLACEHOLDER: "Type # to search projects...",
    KNOWLEDGE_PLACEHOLDER: "Type @ to search knowledge..."
  },
  MODAL_TITLES: {
    CHAT_SETTINGS: "Chat Settings"
  },
  AUTOTALK_LABEL: "Auto Talk"
}, Xa = {
  TEASER_CTA_LABEL: "Ask now",
  HEADING_CHAT: "Chat with our support team",
  HEADING_ASK: "Ask a question",
  DEFAULT_PROMPTS: [
    {
      description: "How to search and book rentals?"
    },
    {
      description: "What is the refund policy?"
    },
    {
      description: "How to contact a representative?"
    }
  ]
}, Ra = {
  approach: "rrr",
  overrides: {
    retrieval_mode: "hybrid",
    semantic_ranker: !0,
    semantic_captions: !1,
    suggest_followup_questions: !0
  }
}, js = {
  // API URL for development purposes
  url: "http://localhost:3000",
  method: "POST",
  stream: !0
}, Ia = De`
  :host {
    --c-primary: #123f58;
    --c-secondary: #f5f5f5;
    --c-text: var(--c-primary);
    --c-white: #fff;
    --c-black: #111111;
    --c-red: #ff0000;
    --c-light-gray: #e3e3e3;
    --c-base-gray: var(--c-secondary);
    --c-dark-gray: #4e5288;
    --c-accent-high: #692b61;
    --c-accent-dark: #5e3c7d;
    --c-accent-light: #f6d5f2;
    --c-error: #8a0000;
    --c-error-background: rgb(253, 231, 233);
    --c-success: #26b32b;
    --font-r-small: 1vw;
    --font-r-base: 3vw;
    --font-r-large: 5vw;
    --font-base: 14px;
    --font-rel-base: 1.2rem;
    --font-small: small;
    --font-large: large;
    --font-larger: x-large;
    --border-base: 3px;
    --border-thin: 1px;
    --border-thicker: 8px;
    --radius-small: 5px;
    --radius-base: 10px;
    --radius-large: 25px;
    --radius-none: 0;
    --width-wide: 90%;
    --width-base: 80%;
    --width-narrow: 50%;
    --d-base: 20px;
    --d-small: 10px;
    --d-xsmall: 5px;
    --d-large: 30px;
    --d-xlarge: 50px;
    --shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    --ac-width: 350px;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: var(--d-base);
    color: var(--c-text);
    overflow: hidden;
    box-sizing: border-box;
  }
  :host([data-theme='dark']) {
    --c-primary: #fdfeff;
    --c-secondary: #32343e;
    --c-text: var(--c-primary);
    --c-white: var(--c-secondary);
    --c-black: var(--c-primary);
    --c-red: #ff0000;
    --c-light-gray: #636d9c;
    --c-dark-gray: #e3e3e3;
    --c-base-gray: var(--c-secondary);
    --c-accent-high: #dcdef8;
    --c-accent-dark: var(--c-primary);
    --c-accent-light: #032219;
    --c-error: #8a0000;
    --c-error-background: rgb(253, 231, 233);
    --c-success: #26b32b;
  }

  :host([data-theme='dark']) .input-helper-text {
    color: #b3b3b3;
  }

  html {
    scroll-behavior: smooth;
  }
  ul {
    margin-block-start: 0;
    margin-block-end: 0;
  }
  .button {
    color: var(--c-text);
    border: 0;
    background: none;
    cursor: pointer;
    text-decoration: underline;
  }
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 0;
    background: var(--c-black);
    z-index: 2;
    opacity: 0.8;
    transition: all 0.3s ease-in-out;
  }
  .overlay.active {
    @media (max-width: 1024px) {
      height: 100%;
    }
  }
  .display-none {
    display: none;
    visibility: hidden;
  }
  .display-flex-grow {
    flex-grow: 1;
  }
  .container-col {
    display: flex;
    flex-direction: column;
    gap: var(--d-small);
  }
  .container-row {
    flex-direction: row;
  }
  .chat__header--thread {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .chat__container {
    min-width: 100%;
    width: 100%;
    transition: width 0.3s ease-in-out;
    max-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* Messages container - scrollable area */
  .chat__messages-container {
    flex: 1;
    // overflow-y: auto;
    // overflow-x: hidden;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  /* Chat header styling */
  .chat__header--thread {
    flex-shrink: 0;
    padding: 0;
  }
  #chat-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: hidden;
    min-height: 0;
  }
  
  /* Chat header styling */
  .chat-header {
    padding: 1rem;
    border-bottom: 1px solid var(--chat_header_color, #e3e6f0);
    background: #f8f9fc;
    border-radius: 0.35rem 0.35rem 0 0;
    flex-shrink: 0;
  } 

  #chat-container > .chat__container {
    flex: 1;
    overflow: hidden;
    padding: 0;
    background: #f8f9fc;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  #chat-container > #chat-form {
    margin-top: 1rem;
    padding: 0.5rem;
    background: white;
    border: 1px solid var(--chat_header_color, #e3e6f0);
    border-radius: 0.35rem;
    flex-shrink: 0;
  }

  .chat__containerWrapper.aside-open {
    .chat__listItem {
      max-width: var(--width-wide);
    }
  }
  .chat__containerWrapper {
    display: grid;
    grid-template-columns: 1fr;
    gutter: var(--d-base);
    flex: 1;
    overflow-y: hidden;
    min-height: 0;
  }

  /* Drag and drop styles */
  .chat__containerWrapper.drag-over {
    position: relative;
  }

  .chat__containerWrapper.drag-over::before {
    content: "📁 Drop files here to upload";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(105, 43, 97, 0.1);
    border: 3px dashed var(--c-accent-high);
    border-radius: var(--radius-base);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--font-rel-base);
    font-weight: bold;
    color: var(--c-accent-high);
    z-index: 100;
    pointer-events: none;
    animation: pulse 1.5s ease-in-out infinite;
  }

  @keyframes pulse {
    0% { 
      background: rgba(105, 43, 97, 0.1);
      border-color: var(--c-accent-high);
    }
    50% { 
      background: rgba(105, 43, 97, 0.2);
      border-color: var(--c-accent-dark);
    }
    100% { 
      background: rgba(105, 43, 97, 0.1);
      border-color: var(--c-accent-high);
    }
  }

  .chat__containerWrapper.drag-over .chat__container {
    opacity: 0.5;
  }

  #chat__containerWrapper .fullscreen-col{
    display: none;
  }
  #chat__containerWrapper.has-fullscreen {
    display: flex;
    flex-direction: row;
    gap: 15px;
    background: #f8f8f8;
  }
  #chat__containerWrapper.has-fullscreen #chat-container{
    min-width: auto;
    width: auto;
  }
  #chat__containerWrapper.has-fullscreen.aside-open #chat-container{
    min-width: 40%;
    width: 40%;
  }
  #chat__containerWrapper.has-fullscreen .fullscreen-col{
    display: block;
  }
  .chat__containerWrapper.aside-open {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: 
      "chat"
      "aside";
    grid-template-rows: 1fr 1fr;
    grid-column-gap: var(--d-base);
    grid-row-gap: var(--d-base);
    flex: 1;
    overflow: hidden;
    min-height: 0;

    @media (min-width: 1024px) {
      grid-template-columns: 1fr 1fr;
      grid-template-areas: "chat aside";
      grid-template-rows: 1fr;
    }
  }
  .chat__containerWrapper.aside-open .chat__container {
    grid-area: chat;
    overflow: hidden;
    min-height: 0;
    max-height: 100%;
  }
  .chat__containerWrapper.aside-open .aside {
    grid-area: aside;
    width: 100%;
    border-left: var(--border-thin) solid var(--c-light-gray);
    max-width: none;
    min-width: 0;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;

    @media (max-width: 1024px) {
      border-left: none;
      border-top: var(--border-thin) solid var(--c-light-gray);
    }
  }
  @media (max-width: 1024px) {
    .aside {
      top: var(-d-large);
      left: auto;
      z-index: 3;
      background: var(--c-white);
      display: block;
      padding: var(--d-base);
      position: absolute;
      width: var(--width-base);
      border-radius: var(--radius-base);
    }
  }
  .form__container {
    margin-bottom: 0;
    flex-shrink: 0;
  }
  .form__container-sticky {
    position: relative;
    bottom: auto;
    z-index: 1;
    border-radius: 0.35rem;
    background: white;
    box-shadow: none;
    padding: 0;
    border: 1px solid var(--chat_header_color, #e3e6f0);
    flex-shrink: 0;
  }

  /* Form container drag over state */
  .form__container.drag-over {
    border: 2px dashed var(--c-accent-high);
    background: rgba(105, 43, 97, 0.05);
    position: relative;
    transition: all 0.2s ease-in-out;
  }

  .form__container.drag-over::after {
    content: "📎 Drop files to attach";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--c-accent-high);
    font-size: var(--font-small);
    font-weight: bold;
    pointer-events: none;
    background: rgba(255, 255, 255, 0.9);
    padding: var(--d-xsmall) var(--d-small);
    border-radius: var(--radius-small);
    z-index: 10;
  }

  .form__label {
    display: block;
    padding: var(-d-xsmall) 0;
    font-size: var(--font-small);
  }

  /* Input helper text styling */
  .input-helper-text {    
    font-size: 0.75rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .helper-explanation {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 0.75rem;
    color: #6c757d;

    .helper-ex-item {
      display: inline-flex;
      align-items: center;      
      gap: 5px;
    }
  }

  .keyboard-shortcut {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-style: italic;
    margin-left: auto;
  }

  shortcuts-info {
    margin-left: 10px;
  }

  @media (max-width: 768px) {
    .input-helper-text {
      font-size: 0.7rem;      
    }
  }

  .chatbox__button svg {
    fill: currentColor;
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
  }
  
  /* Button focus and disabled states */
  .chatbox__button:disabled,
  .chatbox__input:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background: #505050ff;
  }
  .chatbox__container {
    position: relative;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }
  
  /* Input group styling like Bootstrap */
  .chatbox__input-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    gap: 5px;
    background: white;
  }
  
  .chatbox__input-container:focus-within {
    outline: none;    
  }
  
  .chatbox__input {
    width: 100%;
    display: block;
    background: transparent;
    color: #212529;
    border: none;
    padding: 0.5rem 3.75rem 0.5rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.2;
    background-clip: padding-box;
    border-radius: 0.375rem 0 0 0.375rem;
    border: 1px solid #ced4da;
    min-height: 40px;
    max-height: 120px;
    height: 40px;
    resize: none;
    overflow-y: hidden;
    box-sizing: border-box;
    transition: height 0.1s ease-out;
    // border-radius: 0.375rem;
  }

  .input_container_wrapper{
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
  }

  .input_container_wrapper loading-indicator{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 5px;
    padding: 0 5px;
  }
  
  .chatbox__input:focus {
    outline: 0;
    box-shadow: none;
    border-color: var(--primary-color);    
  }
  
  .chatbox__input::placeholder {
    color: #6c757d;
    opacity: 1;
  }
  
  /* Input group append styling */
  .input-group-append {
    display: flex;
    margin-left: -1px;
    align-items: flex-end;
  }
  
  .input-group-append .chatbox__button {
    // position: relative;
    // z-index: 2;
    // margin-left: 0;
    // border-radius: 0;
    // min-height: 44px;
    // align-self: flex-end;
    // border-top-left-radius: 0;
    // border-bottom-left-radius: 0;

    width: 36px;
    height: 36px;
    border: 0;
    background: transparent;
    color: var(--muted);
    border-radius: 8px;
  }
  
  .input-group-append .chatbox__button:first-child {

  }
  
  .input-group-append .chatbox__button.live-chat {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
    border-left: none;
  }
  
  .input-group-append .chatbox__button:not(:last-child) {
    // border-right: 0;
  }
  /* Button styles for different variants */
  .chatbox__button {
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: var(--primary-color);
    border: 1px solid var(--primary-color);    
    font-size: 1rem;
    border-radius: 0;
    flex: 1 1 auto;
    padding: 0px 10px;
  }
  
  .chatbox__button:hover {
    color: #fff;
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }
  
  .chatbox__button:focus {
    color: #fff;
    background-color: var(--primary-color);
    border-color: var(--primary-color);    
  }
  
  .chatbox__button:disabled {
    pointer-events: none;
    opacity: 0.65;
  }
  
  /* Button variants */
  .chatbox__button.btn-outline-secondary {
    color: var(--alt_blu);
    border-color: var(--alt_blu);
    background-color: transparent;
  }
  
  .chatbox__button.btn-outline-secondary:hover {
    color: #fff;
    background-color: var(--alt_blu);
    border-color: var(--alt_blu);
  }
  
  .chatbox__button.btn-outline-danger {
    color: #dc3545;
    border-color: #dc3545;
    background-color: transparent;
  }
  
  .chatbox__button.btn-outline-danger:hover {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
  
  .chatbox__button--reset {
    position: absolute;
    right: 115px;
    top: 15px;
    background: #dc3545;
    border: 1px solid #dc3545;
    color: white;
    border-radius: 0.375rem;
    font-weight: normal;
    height: auto;
    width: auto;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
  }
  
  .chatbox__button--reset.started{
    right: 210px;
  }
  /* Chat options styling like Bootstrap form-check */
  .web-search__wrapper {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
  }
  
  .web-search__container {
    padding: 0;    
    position: relative;
    display: block;
    margin-top: 10px;
  }
  
  .web-search__checkbox {
    position: absolute;
    top: 0.25rem;
    left: 0;
    z-index: 2;
    width: 13px;
    height: 13px;
    margin: 0;
    opacity: 0;
    cursor: pointer;
  }
  
  .web-search__label {
    display: inline-block;
    font-size: 0.875rem;
    color: #6c757d;
    cursor: pointer;
    padding-left: 1.5rem;
    margin-bottom: 0;
    position: relative;
    font-weight: 500;
  }
  
  .web-search__label::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 13px;
    height: 13px;
    pointer-events: none;
    background-color: #fff;
    border: 1px solid #adb5bd;
    border-radius: 0.25em;
  }
  
  .web-search__label::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 13px;
    height: 13px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 0.5em 0.5em;
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
  }
  
  .web-search__checkbox:checked ~ .web-search__label::before {
      color: #fff;
      border-color: #2F2E2D;
      background-color: #2F2E2D;
  }
  
  .web-search__checkbox:checked ~ .web-search__label::after {
    opacity: 1;
    background-color: white;
    mask: url("/assets/images/check.svg") no-repeat center center;
    mask-size: 0.5em 0.5em;
    -webkit-mask: url("/assets/images/check.svg") no-repeat center center;
    -webkit-mask-size: 0.5em 0.5em;
  }
  
  .web-search__checkbox:focus ~ .web-search__label::before {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  .aside__header {
    display: flex;
    justify-content: end;
  }
  .tab-component__content {
    padding: var(--d-base) var(--d-base) var(--d-base) 0;
  }
  .tab-component__paragraph {
    font-family: monospace;
    font-size: var(--font-large);
    border: var(--border-thin) solid var(--c-light-gray);
    border-radius: var(--radius-large);
    padding: var(--d-base);
  }
  .kdb-pick {
    // margin-left: auto;
  }
  .settings-toggler {
    margin-left: 0;
  }
  .settings-toggler button{
    background: none;
    border: 1px solid var(--alt_blu);
    border-radius: 20px;
    cursor: pointer;
    color: var(--alt_blu);
    padding: 8px 5px 5px 5px;
    height: 35px;
    width: 35px;

    i {
          font-size: 1.1rem;
    }
  }

  #chat-form .input_container_wrapper .file-prompt-wrap {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
    
  #chat-form .input_container_wrapper .file-prompt-wrap .chatbox__file_prompt{
   
    background: none;
    box-shadow: none;
    padding: 5px;

    border-radius: 0.375rem;
    border: 1px solid var(--chat_border_color, #ced4da);
    cursor:pointer;
    color: var(--chat_border_color, #ced4da);    
  }

  #chat-form .input_container_wrapper .chatbox__file_prompt:hover {
    color: var(--alt_blu);
    border-color: var(--alt_blu);
  }

  #file-prompt-preview {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    flex-direction: row; 

    .file-prompt__file {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-radius: 0.375rem;
      border: 1px solid var(--chat_border_color, #ced4da);
      padding: 0.25rem;
      width: 120px;
      

      .file-prompt__header{
        .file-prompt__file-name {
        font-size: 0.75rem;
        }         
      }

      .file-prompt__img{
        display: block;
        width: 100%;
        height: 85px;
        border-radius: 0.375rem;
        border: 1px solid var(--chat_border_color, #ced4da);
      } 

      .file-prompt__file-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: var(--background_color, #f8f9fa);
        
        i {
          font-size: 1.5rem;
          color: var(--chat_border_color, #ced4da);
          margin-bottom: 0.25rem;
        }
        
        span {
          font-size: 0.6rem;
          color: var(--chat_border_color, #ced4da);
          font-weight: bold;
        }
      }
        
      .file-prompt__footer{
        display: flex;
        flex-direction: row;
        gap: 10px;
        width: 100%;
        justify-content: space-between;

        .file-prompt__file-size{
          color: var(--chat_border_color, #ced4da);
          font-size: 0.85rem;
        }        

        button.file-prompt__remove-button {
          background: var(--error_color, #900);
          color: #FFF;  
          box-shadow: none;
          border: none;
          border-radius: 0.375rem;  
          cursor: pointer;
        }

      }
      
    }

    /* Chat files display styles */
    .chat__files {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-top: 0.5rem;
    }

    .file-item {
      max-width: 200px;
      border-radius: 0.375rem;
      overflow: hidden;
      border: 1px solid var(--chat_border_color, #ced4da);

      &.non-image-file {
        display: flex;
        align-items: center;
        padding: 0.75rem;
        background: var(--background_color, #f8f9fa);
        gap: 0.75rem;
      }
    }

    .file-item__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      background: var(--chat_border_color, #ced4da);
      border-radius: 0.25rem;
      flex-shrink: 0;

      i {
        font-size: 1rem;
        color: white;
      }
    }

    .file-item__info {
      display: flex;
      flex-direction: column;
      gap: 0.125rem;
      overflow: hidden;
    }

    .file-item__name {
      font-size: 0.75rem;
      font-weight: 500;
      color: var(--color_text, #333);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-item__size {
      font-size: 0.625rem;
      color: var(--color_text_muted, #6c757d);
    }
  }

  #ai-assist-component {
    position: absolute;
    width: 300px;
    height: 210px;
    right: 0;
    top: -15px;
    transform: translateY(-100%);

    &.minimized {
      height: 40px;
    }
  }

  .footer-btns{
    margin-left: auto;
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .selected-style-badge {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    color: white;
    border: 1px solid #0056b3;
    border-radius: 1rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;        
    height: 37px;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
    transition: all 0.2s ease;
    white-space: nowrap;
  }

  .selected-style-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }

  .selected-style-badge .simple-icon-close {
    cursor: pointer;
    font-size: 0.75rem;
    opacity: 0.9;
    transition: all 0.2s ease;
    margin-left: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .selected-style-badge .simple-icon-close:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.25);
    transform: scale(1.1);
  }


  .selected-project-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  }

  .selected-project-badge .simple-icon-close {
    cursor: pointer;
    font-size: 0.75rem;
    opacity: 0.9;
    transition: all 0.2s ease;
    margin-left: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .selected-style-badge .simple-icon-close:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.25);
    transform: scale(1.1);
  }

  .selected-project-badge {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
    color: white;
    border: 1px solid #1e7e34;
    border-radius: 1rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;        
    height: 37px;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
    transition: all 0.2s ease;
    white-space: nowrap;
  }

  .selected-project-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  }

  .selected-project-badge .simple-icon-close {
    cursor: pointer;
    font-size: 0.75rem;
    opacity: 0.9;
    transition: all 0.2s ease;
    margin-left: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .selected-project-badge .simple-icon-close:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.25);
    transform: scale(1.1);
  }

  .chatbox__voice-switch {
    margin-bottom: 0.5rem;
  }

  #chat__containerWrapper .is-mini {
    .chat__list{
      padding-left: 0;
      padding-right: 0;
    }
    .chat__listItem.ai-message {
      
    }
  }
`;
function Ba(s, e) {
  const t = "Next questions:|<<([^>]+)>>", n = /\[(.*?)]/g, i = /:([\s\S]*?)(?:Follow-up questions:|Next questions:|<<|$)/, r = /^-\s*(.+)\n/gm, o = /Next Questions:(.*?)$/s, a = /<<([^<>]+)>>/g, l = {};
  let u = [], h = 1, p = s.replace(n, (F, $) => {
    const he = $.trim();
    return l[he] || (l[he] = h++), `<sup class="citation">${l[he]}</sup>`;
  });
  u = Object.keys(l).map((F, $) => ({
    ref: $ + 1,
    text: F
  })), e[0] = u;
  const g = p.includes(t), y = p.match(i), P = ((y ? y[1].trim() : "").match(r) || []).map((F) => F.replace(/^-\s*/, ""));
  e[1] = P;
  const S = g ? o : a, N = p.match(S) ?? [];
  let K = [];
  K = Wa([...N]);
  const A = p.indexOf("s:");
  return p = A !== -1 ? s.substring(0, A + 6) : s, e[2] = K, { replacedText: p, arrays: e };
}
function Wa(s) {
  return s && s.length > 0 && s[0].startsWith("<<") && (s = s.map((e) => e.replace("<<", "").replace(">>", ""))), s;
}
function vr() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Js(s) {
  return s.text.map((t) => {
    let n = t.value;
    return t.followingSteps && t.followingSteps.length > 0 && (n += `

` + t.followingSteps.map((i, r) => `${r + 1}.` + i).join(`
`)), n;
  }).join(`

`).replaceAll(/<br\s*\/?>/gi, `
`).replace(/<code-viewer[^>]*>([\s\S]*?)<\/code-viewer>/gi, (t, n) => n.replace(/<[^>]*>/g, "")).replaceAll(/<[^>]*>/g, "");
}
function Va(s) {
  return s.text.map((t) => {
    let n = t.value;
    return t.followingSteps && t.followingSteps.length > 0 && (n += "<br><br>" + t.followingSteps.map((i, r) => `${r + 1}. ${i}`).join("<br>")), n;
  }).join("<br><br>").replace(/<rws-tools[^>]*>[\s\S]*?<\/rws-tools>/gi, "").replace(/<share-window[^>]*>[\s\S]*?<\/share-window>/gi, "").replace(/<loading-indicator[^>]*>[\s\S]*?<\/loading-indicator>/gi, "").replace(/<citation-list[^>]*>[\s\S]*?<\/citation-list>/gi, "").replace(/<document-previewer[^>]*>[\s\S]*?<\/document-previewer>/gi, "").replace(/<teaser-list-component[^>]*>[\s\S]*?<\/teaser-list-component>/gi, "").replace(/<tab-component[^>]*>[\s\S]*?<\/tab-component>/gi, "").replace(/<reasoning-viewer[^>]*>[\s\S]*?<\/reasoning-viewer>/gi, "").replace(/<progress-bar[^>]*>[\s\S]*?<\/progress-bar>/gi, "").replace(/<voice-input-button[^>]*>[\s\S]*?<\/voice-input-button>/gi, "").replace(/<chat-action-button[^>]*>[\s\S]*?<\/chat-action-button>/gi, "").replace(/<chat-thread-component[^>]*>[\s\S]*?<\/chat-thread-component>/gi, "").replace(/<chat-component[^>]*>[\s\S]*?<\/chat-component>/gi, "").replace(/<chat-stage[^>]*>[\s\S]*?<\/chat-stage>/gi, "").replace(/<link-icon[^>]*>[\s\S]*?<\/link-icon>/gi, "").replace(/<code-viewer[^>]*>([\s\S]*?)<\/code-viewer>/gi, (t, n) => `<pre><code>${n}</code></pre>`).replace(/<file-tag[^>]*>[\s\S]*?<\/file-tag>/gi, "").replace(/<file-[a-z-]+[^>]*>[\s\S]*?<\/file-[a-z-]+>/gi, "").replace(/<(rws-tools|share-window|loading-indicator|citation-list|document-previewer|teaser-list-component|tab-component|reasoning-viewer|progress-bar|voice-input-button|chat-action-button|link-icon|file-tag|file-[a-z-]+)[^>]*\/>/gi, "");
}
class dt extends Error {
  constructor(e, t) {
    super(e), this.code = t;
  }
}
function lt(s, e, t) {
  return [...s.slice(0, e), t, ...s.slice(e + 1)];
}
async function dn() {
  await an.bind(this)("/assets/css/simple-line-icons.css"), await an.bind(this)("/assets/css/iconsminds.css");
}
async function an(s) {
  if (this.shadowRoot) {
    const e = await fetch(s).then((n) => n.text()), t = new CSSStyleSheet();
    await t.replace(e), this.shadowRoot.adoptedStyleSheets = [
      ...this.shadowRoot.adoptedStyleSheets,
      t
    ];
  }
}
const Ya = De`
  a svg {
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: relative;
    z-index: 1;
  }
  a {
    flex-shrink: 0;
    border-radius: calc(var(--radius-large) * 3);
    border: var(--border-thicker) solid transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-size: cover;
    background-image: linear-gradient(to right, var(--c-accent-light), var(--c-accent-high));
    width: calc(var(--d-xlarge) * 2);
    height: calc(var(--d-xlarge) * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--d-large);
    overflow: hidden;
    padding: var(--d-small);
    position: relative;
  }
  a::after {
    content: '';
    border-radius: calc(var(--radius-large) * 3);
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: absolute;
    background-color: var(--c-secondary);
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const qa = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, Vr = (s) => (...e) => ({ _$litDirective$: s, values: e });
class Ga {
  constructor(e) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, t, n) {
    this._$Ct = e, this._$AM = t, this._$Ci = n;
  }
  _$AS(e, t) {
    return this.update(e, t);
  }
  update(e, t) {
    return this.render(...t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Vn extends Ga {
  constructor(e) {
    if (super(e), this.et = ee, e.type !== qa.CHILD)
      throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(e) {
    if (e === ee || e == null)
      return this.ft = void 0, this.et = e;
    if (e === ht)
      return e;
    if (typeof e != "string")
      throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (e === this.et)
      return this.ft;
    this.et = e;
    const t = [e];
    return t.raw = t, this.ft = { _$litType$: this.constructor.resultType, strings: t, values: [] };
  }
}
Vn.directiveName = "unsafeHTML", Vn.resultType = 1;
const Fn = Vr(Vn);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Ks extends Vn {
}
Ks.directiveName = "unsafeSVG", Ks.resultType = 2;
const _n = Vr(Ks);
var Ua = Object.defineProperty, Za = Object.getOwnPropertyDescriptor, $n = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Za(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && Ua(e, t, i), i;
};
let Mt = class extends fe {
  constructor() {
    super(...arguments), this.label = "", this.svgIcon = "", this.url = "";
  }
  render() {
    return b`
      <a title="${this.label}" href="${this.url}" target="_blank" rel="noopener noreferrer">
        ${_n(this.svgIcon)}
      </a>
    `;
  }
};
Mt.styles = [Ya];
$n([
  T({ type: String })
], Mt.prototype, "label", 2);
$n([
  T({ type: String })
], Mt.prototype, "svgIcon", 2);
$n([
  T({ type: String })
], Mt.prototype, "url", 2);
Mt = $n([
  Pe("link-icon")
], Mt);
const Qa = De`
  .chat-stage__header {
    display: flex;
    width: var(--width-base);
    margin: 0 auto var(--d-large);
    justify-content: center;
    align-items: center;

    @media (min-width: 1024px) {
      width: var(--width-narrow);
    }
  }
  .chat-stage__link svg {
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: relative;
    z-index: 1;
  }
  .chat-stage__link {
    flex-shrink: 0;
    border-radius: calc(var(--radius-large) * 3);
    border: var(--border-thicker) solid transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-size: cover;
    background-image: linear-gradient(to right, var(--c-accent-light), var(--c-accent-high));
    width: calc(var(--d-xlarge) * 2);
    height: calc(var(--d-xlarge) * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--d-large);
    overflow: hidden;
    padding: var(--d-small);
    position: relative;
  }
  .chat-stage__link::after {
    content: '';
    border-radius: calc(var(--radius-large) * 3);
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: absolute;
    background-color: var(--c-secondary);
  }
`;
var Ja = Object.defineProperty, Ka = Object.getOwnPropertyDescriptor, es = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Ka(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && Ja(e, t, i), i;
};
let Ft = class extends fe {
  constructor() {
    super(...arguments), this.pagetitle = "", this.url = "", this.svgIcon = "";
  }
  render() {
    return b`
      <header class="chat-stage__header" data-testid="chat-branding">
        <link-icon url="${this.url}" svgIcon="${this.svgIcon}"></link-icon>
        <h1 class="chat-stage__hl">${this.pagetitle}</h1>
      </header>
    `;
  }
};
Ft.styles = [Qa];
es([
  T({ type: String })
], Ft.prototype, "pagetitle", 2);
es([
  T({ type: String })
], Ft.prototype, "url", 2);
es([
  T({ type: String })
], Ft.prototype, "svgIcon", 2);
Ft = es([
  Pe("chat-stage")
], Ft);
const _a = De`
  @keyframes spinneranimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  p {
    display: flex;
    align-items: center;
    margin: 0;
  }
  svg {
    width: var(--d-large);
    height: 30px;
    fill: var(--c-accent-light);
    animation: spinneranimation 1s linear infinite;
    margin-right: 10px;
  }
`, $a = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\r
  <path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" />\r
</svg>`;
var el = Object.defineProperty, tl = Object.getOwnPropertyDescriptor, Yr = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? tl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && el(e, t, i), i;
};
let Yn = class extends fe {
  constructor() {
    super(...arguments), this.label = "";
  }
  render() {
    return b`
      <p data-testid="loading-indicator" class="loading-spinner" aria-label="${this.label}">
        <span>${_n($a)}</span>
        <span>${this.label}</span>
      </p>
    `;
  }
};
Yn.styles = [_a];
Yr([
  T({ type: String })
], Yn.prototype, "label", 2);
Yn = Yr([
  Pe("loading-indicator")
], Yn);
const nl = De`

  button {
    color: var(--alt_blu);
    font-weight: bold;    
    background: transparent;
    transition: background 0.3s ease-in-out;
    box-shadow: none;
    border: none;
    cursor: pointer;      
    width: 100%;
    height: 100%;
    padding: 0;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: var(--text-muted, #888);
  }
  button:disabled:hover {
    color: var(--text-muted, #888);
  }
  button:hover:not(:disabled) {    
    color: #fff;
  }
  :host{
    box-sizing: border-box;
    display: inline-flex !important;
    align-items: center;
  }
  :host(:hover) button:not(:disabled){
    color: #fff;
  }
  :host(:hover) button:disabled{
    color: var(--text-muted, #888);
  }
  button:hover:not(:disabled) svg,
  button:focus:not(:disabled) svg {
    opacity: 0.8;
  }
  .not-recording svg {
    color: var(--alt_blu);
  }
  button:disabled .not-recording svg,
  button:disabled .recording svg {
    color: var(--text-muted, #888);
    opacity: 0.5;
  }
  .recording svg {
    
  }
  .simple-icon-close{
    font-size: 10px;
  }
`;
var sl = Object.defineProperty, il = Object.getOwnPropertyDescriptor, pn = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? il(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && sl(e, t, i), i;
};
let pt = class extends fe {
  constructor() {
    super(...arguments), this.showVoiceInput = !0, this.enableVoiceListening = !1, this.label = null, this.disabled = !1;
  }
  async connectedCallback() {
    super.connectedCallback(), await dn.bind(this)();
  }
  handleVoiceInput(s) {
    if (s.preventDefault(), this.disabled)
      return;
    this.enableVoiceListening = !this.enableVoiceListening;
    const e = new CustomEvent("chat:audio:record", {
      detail: {
        isRecording: this.enableVoiceListening
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(e);
  }
  renderVoiceButton() {
    return b`
      <button
        title="${this.label}"
        class="${this.enableVoiceListening ? "recording" : "not-recording"}"
        @click="${this.handleVoiceInput}"
        ?disabled="${this.disabled}"
      >
        ${this.enableVoiceListening ? b`<i class="simple-icon-microphone"></i><i class="simple-icon-close"></i>` : b`<i class="simple-icon-microphone"></i>`}
      </button>
    `;
  }
  render() {
    return this.showVoiceInput ? this.renderVoiceButton() : b``;
  }
};
pt.styles = [nl];
pn([
  O()
], pt.prototype, "showVoiceInput", 2);
pn([
  O()
], pt.prototype, "enableVoiceListening", 2);
pn([
  T({ type: String })
], pt.prototype, "label", 2);
pn([
  T({ type: Boolean })
], pt.prototype, "disabled", 2);
pt = pn([
  Pe("voice-input-button")
], pt);
function ui() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let mt = ui();
function qr(s) {
  mt = s;
}
const Gr = /[&<>"']/, rl = new RegExp(Gr.source, "g"), Ur = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, ol = new RegExp(Ur.source, "g"), al = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, yr = (s) => al[s];
function xe(s, e) {
  if (e) {
    if (Gr.test(s))
      return s.replace(rl, yr);
  } else if (Ur.test(s))
    return s.replace(ol, yr);
  return s;
}
const ll = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function cl(s) {
  return s.replace(ll, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
const ul = /(^|[^\[])\^/g;
function B(s, e) {
  s = typeof s == "string" ? s : s.source, e = e || "";
  const t = {
    replace: (n, i) => (i = typeof i == "object" && "source" in i ? i.source : i, i = i.replace(ul, "$1"), s = s.replace(n, i), t),
    getRegex: () => new RegExp(s, e)
  };
  return t;
}
function wr(s) {
  try {
    s = encodeURI(s).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return s;
}
const qn = { exec: () => null };
function xr(s, e) {
  const t = s.replace(/\|/g, (r, o, a) => {
    let l = !1, u = o;
    for (; --u >= 0 && a[u] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), n = t.split(/ \|/);
  let i = 0;
  if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), e)
    if (n.length > e)
      n.splice(e);
    else
      for (; n.length < e; )
        n.push("");
  for (; i < n.length; i++)
    n[i] = n[i].trim().replace(/\\\|/g, "|");
  return n;
}
function Dn(s, e, t) {
  const n = s.length;
  if (n === 0)
    return "";
  let i = 0;
  for (; i < n; ) {
    const r = s.charAt(n - i - 1);
    if (r === e && !t)
      i++;
    else if (r !== e && t)
      i++;
    else
      break;
  }
  return s.slice(0, n - i);
}
function hl(s, e) {
  if (s.indexOf(e[1]) === -1)
    return -1;
  let t = 0;
  for (let n = 0; n < s.length; n++)
    if (s[n] === "\\")
      n++;
    else if (s[n] === e[0])
      t++;
    else if (s[n] === e[1] && (t--, t < 0))
      return n;
  return -1;
}
function Tr(s, e, t, n) {
  const i = e.href, r = e.title ? xe(e.title) : null, o = s[1].replace(/\\([\[\]])/g, "$1");
  if (s[0].charAt(0) !== "!") {
    n.state.inLink = !0;
    const a = {
      type: "link",
      raw: t,
      href: i,
      title: r,
      text: o,
      tokens: n.inlineTokens(o)
    };
    return n.state.inLink = !1, a;
  }
  return {
    type: "image",
    raw: t,
    href: i,
    title: r,
    text: xe(o)
  };
}
function dl(s, e) {
  const t = s.match(/^(\s+)(?:```)/);
  if (t === null)
    return e;
  const n = t[1];
  return e.split(`
`).map((i) => {
    const r = i.match(/^\s+/);
    if (r === null)
      return i;
    const [o] = r;
    return o.length >= n.length ? i.slice(n.length) : i;
  }).join(`
`);
}
class Gn {
  constructor(e) {
    U(this, "options");
    // TODO: Fix this rules type
    U(this, "rules");
    U(this, "lexer");
    this.options = e || mt;
  }
  space(e) {
    const t = this.rules.block.newline.exec(e);
    if (t && t[0].length > 0)
      return {
        type: "space",
        raw: t[0]
      };
  }
  code(e) {
    const t = this.rules.block.code.exec(e);
    if (t) {
      const n = t[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: t[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? n : Dn(n, `
`)
      };
    }
  }
  fences(e) {
    const t = this.rules.block.fences.exec(e);
    if (t) {
      const n = t[0], i = dl(n, t[3] || "");
      return {
        type: "code",
        raw: n,
        lang: t[2] ? t[2].trim().replace(this.rules.inline._escapes, "$1") : t[2],
        text: i
      };
    }
  }
  heading(e) {
    const t = this.rules.block.heading.exec(e);
    if (t) {
      let n = t[2].trim();
      if (/#$/.test(n)) {
        const i = Dn(n, "#");
        (this.options.pedantic || !i || / $/.test(i)) && (n = i.trim());
      }
      return {
        type: "heading",
        raw: t[0],
        depth: t[1].length,
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  hr(e) {
    const t = this.rules.block.hr.exec(e);
    if (t)
      return {
        type: "hr",
        raw: t[0]
      };
  }
  blockquote(e) {
    const t = this.rules.block.blockquote.exec(e);
    if (t) {
      const n = Dn(t[0].replace(/^ *>[ \t]?/gm, ""), `
`), i = this.lexer.state.top;
      this.lexer.state.top = !0;
      const r = this.lexer.blockTokens(n);
      return this.lexer.state.top = i, {
        type: "blockquote",
        raw: t[0],
        tokens: r,
        text: n
      };
    }
  }
  list(e) {
    let t = this.rules.block.list.exec(e);
    if (t) {
      let n = t[1].trim();
      const i = n.length > 1, r = {
        type: "list",
        raw: "",
        ordered: i,
        start: i ? +n.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      n = i ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = i ? n : "[*+-]");
      const o = new RegExp(`^( {0,3}${n})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      let a = "", l = "", u = !1;
      for (; e; ) {
        let h = !1;
        if (!(t = o.exec(e)) || this.rules.block.hr.test(e))
          break;
        a = t[0], e = e.substring(a.length);
        let p = t[2].split(`
`, 1)[0].replace(/^\t+/, (S) => " ".repeat(3 * S.length)), g = e.split(`
`, 1)[0], y = 0;
        this.options.pedantic ? (y = 2, l = p.trimStart()) : (y = t[2].search(/[^ ]/), y = y > 4 ? 1 : y, l = p.slice(y), y += t[1].length);
        let f = !1;
        if (!p && /^ *$/.test(g) && (a += g + `
`, e = e.substring(g.length + 1), h = !0), !h) {
          const S = new RegExp(`^ {0,${Math.min(3, y - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), N = new RegExp(`^ {0,${Math.min(3, y - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), K = new RegExp(`^ {0,${Math.min(3, y - 1)}}(?:\`\`\`|~~~)`), A = new RegExp(`^ {0,${Math.min(3, y - 1)}}#`);
          for (; e; ) {
            const F = e.split(`
`, 1)[0];
            if (g = F, this.options.pedantic && (g = g.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), K.test(g) || A.test(g) || S.test(g) || N.test(e))
              break;
            if (g.search(/[^ ]/) >= y || !g.trim())
              l += `
` + g.slice(y);
            else {
              if (f || p.search(/[^ ]/) >= 4 || K.test(p) || A.test(p) || N.test(p))
                break;
              l += `
` + g;
            }
            !f && !g.trim() && (f = !0), a += F + `
`, e = e.substring(F.length + 1), p = g.slice(y);
          }
        }
        r.loose || (u ? r.loose = !0 : /\n *\n *$/.test(a) && (u = !0));
        let x = null, P;
        this.options.gfm && (x = /^\[[ xX]\] /.exec(l), x && (P = x[0] !== "[ ] ", l = l.replace(/^\[[ xX]\] +/, ""))), r.items.push({
          type: "list_item",
          raw: a,
          task: !!x,
          checked: P,
          loose: !1,
          text: l,
          tokens: []
        }), r.raw += a;
      }
      r.items[r.items.length - 1].raw = a.trimEnd(), r.items[r.items.length - 1].text = l.trimEnd(), r.raw = r.raw.trimEnd();
      for (let h = 0; h < r.items.length; h++)
        if (this.lexer.state.top = !1, r.items[h].tokens = this.lexer.blockTokens(r.items[h].text, []), !r.loose) {
          const p = r.items[h].tokens.filter((y) => y.type === "space"), g = p.length > 0 && p.some((y) => /\n.*\n/.test(y.raw));
          r.loose = g;
        }
      if (r.loose)
        for (let h = 0; h < r.items.length; h++)
          r.items[h].loose = !0;
      return r;
    }
  }
  html(e) {
    const t = this.rules.block.html.exec(e);
    if (t)
      return {
        type: "html",
        block: !0,
        raw: t[0],
        pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
        text: t[0]
      };
  }
  def(e) {
    const t = this.rules.block.def.exec(e);
    if (t) {
      const n = t[1].toLowerCase().replace(/\s+/g, " "), i = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline._escapes, "$1") : t[3];
      return {
        type: "def",
        tag: n,
        raw: t[0],
        href: i,
        title: r
      };
    }
  }
  table(e) {
    const t = this.rules.block.table.exec(e);
    if (t) {
      if (!/[:|]/.test(t[2]))
        return;
      const n = {
        type: "table",
        raw: t[0],
        header: xr(t[1]).map((i) => ({ text: i, tokens: [] })),
        align: t[2].replace(/^\||\| *$/g, "").split("|"),
        rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (n.header.length === n.align.length) {
        let i = n.align.length, r, o, a, l;
        for (r = 0; r < i; r++) {
          const u = n.align[r];
          u && (/^ *-+: *$/.test(u) ? n.align[r] = "right" : /^ *:-+: *$/.test(u) ? n.align[r] = "center" : /^ *:-+ *$/.test(u) ? n.align[r] = "left" : n.align[r] = null);
        }
        for (i = n.rows.length, r = 0; r < i; r++)
          n.rows[r] = xr(n.rows[r], n.header.length).map((u) => ({ text: u, tokens: [] }));
        for (i = n.header.length, o = 0; o < i; o++)
          n.header[o].tokens = this.lexer.inline(n.header[o].text);
        for (i = n.rows.length, o = 0; o < i; o++)
          for (l = n.rows[o], a = 0; a < l.length; a++)
            l[a].tokens = this.lexer.inline(l[a].text);
        return n;
      }
    }
  }
  lheading(e) {
    const t = this.rules.block.lheading.exec(e);
    if (t)
      return {
        type: "heading",
        raw: t[0],
        depth: t[2].charAt(0) === "=" ? 1 : 2,
        text: t[1],
        tokens: this.lexer.inline(t[1])
      };
  }
  paragraph(e) {
    const t = this.rules.block.paragraph.exec(e);
    if (t) {
      const n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
      return {
        type: "paragraph",
        raw: t[0],
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  text(e) {
    const t = this.rules.block.text.exec(e);
    if (t)
      return {
        type: "text",
        raw: t[0],
        text: t[0],
        tokens: this.lexer.inline(t[0])
      };
  }
  escape(e) {
    const t = this.rules.inline.escape.exec(e);
    if (t)
      return {
        type: "escape",
        raw: t[0],
        text: xe(t[1])
      };
  }
  tag(e) {
    const t = this.rules.inline.tag.exec(e);
    if (t)
      return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: t[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: t[0]
      };
  }
  link(e) {
    const t = this.rules.inline.link.exec(e);
    if (t) {
      const n = t[2].trim();
      if (!this.options.pedantic && /^</.test(n)) {
        if (!/>$/.test(n))
          return;
        const o = Dn(n.slice(0, -1), "\\");
        if ((n.length - o.length) % 2 === 0)
          return;
      } else {
        const o = hl(t[2], "()");
        if (o > -1) {
          const l = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + o;
          t[2] = t[2].substring(0, o), t[0] = t[0].substring(0, l).trim(), t[3] = "";
        }
      }
      let i = t[2], r = "";
      if (this.options.pedantic) {
        const o = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(i);
        o && (i = o[1], r = o[3]);
      } else
        r = t[3] ? t[3].slice(1, -1) : "";
      return i = i.trim(), /^</.test(i) && (this.options.pedantic && !/>$/.test(n) ? i = i.slice(1) : i = i.slice(1, -1)), Tr(t, {
        href: i && i.replace(this.rules.inline._escapes, "$1"),
        title: r && r.replace(this.rules.inline._escapes, "$1")
      }, t[0], this.lexer);
    }
  }
  reflink(e, t) {
    let n;
    if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
      let i = (n[2] || n[1]).replace(/\s+/g, " ");
      if (i = t[i.toLowerCase()], !i) {
        const r = n[0].charAt(0);
        return {
          type: "text",
          raw: r,
          text: r
        };
      }
      return Tr(n, i, n[0], this.lexer);
    }
  }
  emStrong(e, t, n = "") {
    let i = this.rules.inline.emStrong.lDelim.exec(e);
    if (!i || i[3] && n.match(/[\p{L}\p{N}]/u))
      return;
    if (!(i[1] || i[2] || "") || !n || this.rules.inline.punctuation.exec(n)) {
      const o = [...i[0]].length - 1;
      let a, l, u = o, h = 0;
      const p = i[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (p.lastIndex = 0, t = t.slice(-1 * e.length + o); (i = p.exec(t)) != null; ) {
        if (a = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !a)
          continue;
        if (l = [...a].length, i[3] || i[4]) {
          u += l;
          continue;
        } else if ((i[5] || i[6]) && o % 3 && !((o + l) % 3)) {
          h += l;
          continue;
        }
        if (u -= l, u > 0)
          continue;
        l = Math.min(l, l + u + h);
        const g = [...i[0]][0].length, y = e.slice(0, o + i.index + g + l);
        if (Math.min(o, l) % 2) {
          const x = y.slice(1, -1);
          return {
            type: "em",
            raw: y,
            text: x,
            tokens: this.lexer.inlineTokens(x)
          };
        }
        const f = y.slice(2, -2);
        return {
          type: "strong",
          raw: y,
          text: f,
          tokens: this.lexer.inlineTokens(f)
        };
      }
    }
  }
  codespan(e) {
    const t = this.rules.inline.code.exec(e);
    if (t) {
      let n = t[2].replace(/\n/g, " ");
      const i = /[^ ]/.test(n), r = /^ /.test(n) && / $/.test(n);
      return i && r && (n = n.substring(1, n.length - 1)), n = xe(n, !0), {
        type: "codespan",
        raw: t[0],
        text: n
      };
    }
  }
  br(e) {
    const t = this.rules.inline.br.exec(e);
    if (t)
      return {
        type: "br",
        raw: t[0]
      };
  }
  del(e) {
    const t = this.rules.inline.del.exec(e);
    if (t)
      return {
        type: "del",
        raw: t[0],
        text: t[2],
        tokens: this.lexer.inlineTokens(t[2])
      };
  }
  autolink(e) {
    const t = this.rules.inline.autolink.exec(e);
    if (t) {
      let n, i;
      return t[2] === "@" ? (n = xe(t[1]), i = "mailto:" + n) : (n = xe(t[1]), i = n), {
        type: "link",
        raw: t[0],
        text: n,
        href: i,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  url(e) {
    let t;
    if (t = this.rules.inline.url.exec(e)) {
      let n, i;
      if (t[2] === "@")
        n = xe(t[0]), i = "mailto:" + n;
      else {
        let r;
        do
          r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])[0];
        while (r !== t[0]);
        n = xe(t[0]), t[1] === "www." ? i = "http://" + t[0] : i = t[0];
      }
      return {
        type: "link",
        raw: t[0],
        text: n,
        href: i,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  inlineText(e) {
    const t = this.rules.inline.text.exec(e);
    if (t) {
      let n;
      return this.lexer.state.inRawBlock ? n = t[0] : n = xe(t[0]), {
        type: "text",
        raw: t[0],
        text: n
      };
    }
  }
}
const z = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: qn,
  lheading: /^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
z._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
z._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
z.def = B(z.def).replace("label", z._label).replace("title", z._title).getRegex();
z.bullet = /(?:[*+-]|\d{1,9}[.)])/;
z.listItemStart = B(/^( *)(bull) */).replace("bull", z.bullet).getRegex();
z.list = B(z.list).replace(/bull/g, z.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + z.def.source + ")").getRegex();
z._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
z._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
z.html = B(z.html, "i").replace("comment", z._comment).replace("tag", z._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
z.lheading = B(z.lheading).replace(/bull/g, z.bullet).getRegex();
z.paragraph = B(z._paragraph).replace("hr", z.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex();
z.blockquote = B(z.blockquote).replace("paragraph", z.paragraph).getRegex();
z.normal = { ...z };
z.gfm = {
  ...z.normal,
  table: "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
z.gfm.table = B(z.gfm.table).replace("hr", z.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex();
z.gfm.paragraph = B(z._paragraph).replace("hr", z.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", z.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", z._tag).getRegex();
z.pedantic = {
  ...z.normal,
  html: B(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", z._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: qn,
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: B(z.normal._paragraph).replace("hr", z.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", z.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const E = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: qn,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
    //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
    rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: qn,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^((?![*_])[\spunctuation])/
};
E._punctuation = "\\p{P}$+<=>`^|~";
E.punctuation = B(E.punctuation, "u").replace(/punctuation/g, E._punctuation).getRegex();
E.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
E.anyPunctuation = /\\[punct]/g;
E._escapes = /\\([punct])/g;
E._comment = B(z._comment).replace("(?:-->|$)", "-->").getRegex();
E.emStrong.lDelim = B(E.emStrong.lDelim, "u").replace(/punct/g, E._punctuation).getRegex();
E.emStrong.rDelimAst = B(E.emStrong.rDelimAst, "gu").replace(/punct/g, E._punctuation).getRegex();
E.emStrong.rDelimUnd = B(E.emStrong.rDelimUnd, "gu").replace(/punct/g, E._punctuation).getRegex();
E.anyPunctuation = B(E.anyPunctuation, "gu").replace(/punct/g, E._punctuation).getRegex();
E._escapes = B(E._escapes, "gu").replace(/punct/g, E._punctuation).getRegex();
E._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
E._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
E.autolink = B(E.autolink).replace("scheme", E._scheme).replace("email", E._email).getRegex();
E._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
E.tag = B(E.tag).replace("comment", E._comment).replace("attribute", E._attribute).getRegex();
E._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
E._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
E._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
E.link = B(E.link).replace("label", E._label).replace("href", E._href).replace("title", E._title).getRegex();
E.reflink = B(E.reflink).replace("label", E._label).replace("ref", z._label).getRegex();
E.nolink = B(E.nolink).replace("ref", z._label).getRegex();
E.reflinkSearch = B(E.reflinkSearch, "g").replace("reflink", E.reflink).replace("nolink", E.nolink).getRegex();
E.normal = { ...E };
E.pedantic = {
  ...E.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: B(/^!?\[(label)\]\((.*?)\)/).replace("label", E._label).getRegex(),
  reflink: B(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", E._label).getRegex()
};
E.gfm = {
  ...E.normal,
  escape: B(E.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
E.gfm.url = B(E.gfm.url, "i").replace("email", E.gfm._extended_email).getRegex();
E.breaks = {
  ...E.gfm,
  br: B(E.br).replace("{2,}", "*").getRegex(),
  text: B(E.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
class je {
  constructor(e) {
    U(this, "tokens");
    U(this, "options");
    U(this, "state");
    U(this, "tokenizer");
    U(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || mt, this.options.tokenizer = this.options.tokenizer || new Gn(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const t = {
      block: z.normal,
      inline: E.normal
    };
    this.options.pedantic ? (t.block = z.pedantic, t.inline = E.pedantic) : this.options.gfm && (t.block = z.gfm, this.options.breaks ? t.inline = E.breaks : t.inline = E.gfm), this.tokenizer.rules = t;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: z,
      inline: E
    };
  }
  /**
   * Static Lex Method
   */
  static lex(e, t) {
    return new je(t).lex(e);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(e, t) {
    return new je(t).inlineTokens(e);
  }
  /**
   * Preprocessing
   */
  lex(e) {
    e = e.replace(/\r\n|\r/g, `
`), this.blockTokens(e, this.tokens);
    let t;
    for (; t = this.inlineQueue.shift(); )
      this.inlineTokens(t.src, t.tokens);
    return this.tokens;
  }
  blockTokens(e, t = []) {
    this.options.pedantic ? e = e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e = e.replace(/^( *)(\t+)/gm, (a, l, u) => l + "    ".repeat(u.length));
    let n, i, r, o;
    for (; e; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((a) => (n = a.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.space(e)) {
          e = e.substring(n.raw.length), n.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += `
` : t.push(n);
          continue;
        }
        if (n = this.tokenizer.code(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.fences(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.heading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.hr(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.blockquote(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.list(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.html(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.def(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + n.raw, i.text += `
` + n.raw, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : this.tokens.links[n.tag] || (this.tokens.links[n.tag] = {
            href: n.href,
            title: n.title
          });
          continue;
        }
        if (n = this.tokenizer.table(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.lheading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startBlock) {
          let a = 1 / 0;
          const l = e.slice(1);
          let u;
          this.options.extensions.startBlock.forEach((h) => {
            u = h.call({ lexer: this }, l), typeof u == "number" && u >= 0 && (a = Math.min(a, u));
          }), a < 1 / 0 && a >= 0 && (r = e.substring(0, a + 1));
        }
        if (this.state.top && (n = this.tokenizer.paragraph(r))) {
          i = t[t.length - 1], o && i.type === "paragraph" ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n), o = r.length !== e.length, e = e.substring(n.raw.length);
          continue;
        }
        if (n = this.tokenizer.text(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && i.type === "text" ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n);
          continue;
        }
        if (e) {
          const a = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(a);
            break;
          } else
            throw new Error(a);
        }
      }
    return this.state.top = !0, t;
  }
  inline(e, t = []) {
    return this.inlineQueue.push({ src: e, tokens: t }), t;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(e, t = []) {
    let n, i, r, o = e, a, l, u;
    if (this.tokens.links) {
      const h = Object.keys(this.tokens.links);
      if (h.length > 0)
        for (; (a = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          h.includes(a[0].slice(a[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, a.index) + "[" + "a".repeat(a[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (a = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, a.index) + "[" + "a".repeat(a[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (a = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, a.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; e; )
      if (l || (u = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((h) => (n = h.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.escape(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.tag(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && n.type === "text" && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.link(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.reflink(e, this.tokens.links)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && n.type === "text" && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.emStrong(e, o, u)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.codespan(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.br(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.del(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.autolink(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (!this.state.inLink && (n = this.tokenizer.url(e))) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startInline) {
          let h = 1 / 0;
          const p = e.slice(1);
          let g;
          this.options.extensions.startInline.forEach((y) => {
            g = y.call({ lexer: this }, p), typeof g == "number" && g >= 0 && (h = Math.min(h, g));
          }), h < 1 / 0 && h >= 0 && (r = e.substring(0, h + 1));
        }
        if (n = this.tokenizer.inlineText(r)) {
          e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (u = n.raw.slice(-1)), l = !0, i = t[t.length - 1], i && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (e) {
          const h = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(h);
            break;
          } else
            throw new Error(h);
        }
      }
    return t;
  }
}
class Un {
  constructor(e) {
    U(this, "options");
    this.options = e || mt;
  }
  code(e, t, n) {
    var r;
    const i = (r = (t || "").match(/^\S*/)) == null ? void 0 : r[0];
    return e = e.replace(/\n$/, "") + `
`, i ? '<pre><code class="language-' + xe(i) + '">' + (n ? e : xe(e, !0)) + `</code></pre>
` : "<pre><code>" + (n ? e : xe(e, !0)) + `</code></pre>
`;
  }
  blockquote(e) {
    return `<blockquote>
${e}</blockquote>
`;
  }
  html(e, t) {
    return e;
  }
  heading(e, t, n) {
    return `<h${t}>${e}</h${t}>
`;
  }
  hr() {
    return `<hr>
`;
  }
  list(e, t, n) {
    const i = t ? "ol" : "ul", r = t && n !== 1 ? ' start="' + n + '"' : "";
    return "<" + i + r + `>
` + e + "</" + i + `>
`;
  }
  listitem(e, t, n) {
    return `<li>${e}</li>
`;
  }
  checkbox(e) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph(e) {
    return `<p>${e}</p>
`;
  }
  table(e, t) {
    return t && (t = `<tbody>${t}</tbody>`), `<table>
<thead>
` + e + `</thead>
` + t + `</table>
`;
  }
  tablerow(e) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e, t) {
    const n = t.header ? "th" : "td";
    return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>
`;
  }
  /**
   * span level renderer
   */
  strong(e) {
    return `<strong>${e}</strong>`;
  }
  em(e) {
    return `<em>${e}</em>`;
  }
  codespan(e) {
    return `<code>${e}</code>`;
  }
  br() {
    return "<br>";
  }
  del(e) {
    return `<del>${e}</del>`;
  }
  link(e, t, n) {
    const i = wr(e);
    if (i === null)
      return n;
    e = i;
    let r = '<a href="' + e + '"';
    return t && (r += ' title="' + t + '"'), r += ">" + n + "</a>", r;
  }
  image(e, t, n) {
    const i = wr(e);
    if (i === null)
      return n;
    e = i;
    let r = `<img src="${e}" alt="${n}"`;
    return t && (r += ` title="${t}"`), r += ">", r;
  }
  text(e) {
    return e;
  }
}
class hi {
  // no need for block level renderers
  strong(e) {
    return e;
  }
  em(e) {
    return e;
  }
  codespan(e) {
    return e;
  }
  del(e) {
    return e;
  }
  html(e) {
    return e;
  }
  text(e) {
    return e;
  }
  link(e, t, n) {
    return "" + n;
  }
  image(e, t, n) {
    return "" + n;
  }
  br() {
    return "";
  }
}
class Ne {
  constructor(e) {
    U(this, "options");
    U(this, "renderer");
    U(this, "textRenderer");
    this.options = e || mt, this.options.renderer = this.options.renderer || new Un(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new hi();
  }
  /**
   * Static Parse Method
   */
  static parse(e, t) {
    return new Ne(t).parse(e);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(e, t) {
    return new Ne(t).parseInline(e);
  }
  /**
   * Parse Loop
   */
  parse(e, t = !0) {
    let n = "";
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type]) {
        const o = r, a = this.options.extensions.renderers[o.type].call({ parser: this }, o);
        if (a !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(o.type)) {
          n += a || "";
          continue;
        }
      }
      switch (r.type) {
        case "space":
          continue;
        case "hr": {
          n += this.renderer.hr();
          continue;
        }
        case "heading": {
          const o = r;
          n += this.renderer.heading(this.parseInline(o.tokens), o.depth, cl(this.parseInline(o.tokens, this.textRenderer)));
          continue;
        }
        case "code": {
          const o = r;
          n += this.renderer.code(o.text, o.lang, !!o.escaped);
          continue;
        }
        case "table": {
          const o = r;
          let a = "", l = "";
          for (let h = 0; h < o.header.length; h++)
            l += this.renderer.tablecell(this.parseInline(o.header[h].tokens), { header: !0, align: o.align[h] });
          a += this.renderer.tablerow(l);
          let u = "";
          for (let h = 0; h < o.rows.length; h++) {
            const p = o.rows[h];
            l = "";
            for (let g = 0; g < p.length; g++)
              l += this.renderer.tablecell(this.parseInline(p[g].tokens), { header: !1, align: o.align[g] });
            u += this.renderer.tablerow(l);
          }
          n += this.renderer.table(a, u);
          continue;
        }
        case "blockquote": {
          const o = r, a = this.parse(o.tokens);
          n += this.renderer.blockquote(a);
          continue;
        }
        case "list": {
          const o = r, a = o.ordered, l = o.start, u = o.loose;
          let h = "";
          for (let p = 0; p < o.items.length; p++) {
            const g = o.items[p], y = g.checked, f = g.task;
            let x = "";
            if (g.task) {
              const P = this.renderer.checkbox(!!y);
              u ? g.tokens.length > 0 && g.tokens[0].type === "paragraph" ? (g.tokens[0].text = P + " " + g.tokens[0].text, g.tokens[0].tokens && g.tokens[0].tokens.length > 0 && g.tokens[0].tokens[0].type === "text" && (g.tokens[0].tokens[0].text = P + " " + g.tokens[0].tokens[0].text)) : g.tokens.unshift({
                type: "text",
                text: P + " "
              }) : x += P + " ";
            }
            x += this.parse(g.tokens, u), h += this.renderer.listitem(x, f, !!y);
          }
          n += this.renderer.list(h, a, l);
          continue;
        }
        case "html": {
          const o = r;
          n += this.renderer.html(o.text, o.block);
          continue;
        }
        case "paragraph": {
          const o = r;
          n += this.renderer.paragraph(this.parseInline(o.tokens));
          continue;
        }
        case "text": {
          let o = r, a = o.tokens ? this.parseInline(o.tokens) : o.text;
          for (; i + 1 < e.length && e[i + 1].type === "text"; )
            o = e[++i], a += `
` + (o.tokens ? this.parseInline(o.tokens) : o.text);
          n += t ? this.renderer.paragraph(a) : a;
          continue;
        }
        default: {
          const o = 'Token with "' + r.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return n;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(e, t) {
    t = t || this.renderer;
    let n = "";
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type]) {
        const o = this.options.extensions.renderers[r.type].call({ parser: this }, r);
        if (o !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(r.type)) {
          n += o || "";
          continue;
        }
      }
      switch (r.type) {
        case "escape": {
          const o = r;
          n += t.text(o.text);
          break;
        }
        case "html": {
          const o = r;
          n += t.html(o.text);
          break;
        }
        case "link": {
          const o = r;
          n += t.link(o.href, o.title, this.parseInline(o.tokens, t));
          break;
        }
        case "image": {
          const o = r;
          n += t.image(o.href, o.title, o.text);
          break;
        }
        case "strong": {
          const o = r;
          n += t.strong(this.parseInline(o.tokens, t));
          break;
        }
        case "em": {
          const o = r;
          n += t.em(this.parseInline(o.tokens, t));
          break;
        }
        case "codespan": {
          const o = r;
          n += t.codespan(o.text);
          break;
        }
        case "br": {
          n += t.br();
          break;
        }
        case "del": {
          const o = r;
          n += t.del(this.parseInline(o.tokens, t));
          break;
        }
        case "text": {
          const o = r;
          n += t.text(o.text);
          break;
        }
        default: {
          const o = 'Token with "' + r.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return n;
  }
}
class en {
  constructor(e) {
    U(this, "options");
    this.options = e || mt;
  }
  /**
   * Process markdown before marked
   */
  preprocess(e) {
    return e;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(e) {
    return e;
  }
}
U(en, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
var cn, _s, Jn, Zr;
class pl {
  constructor(...e) {
    Ts(this, cn);
    Ts(this, Jn);
    U(this, "defaults", ui());
    U(this, "options", this.setOptions);
    U(this, "parse", An(this, cn, _s).call(this, je.lex, Ne.parse));
    U(this, "parseInline", An(this, cn, _s).call(this, je.lexInline, Ne.parseInline));
    U(this, "Parser", Ne);
    U(this, "Renderer", Un);
    U(this, "TextRenderer", hi);
    U(this, "Lexer", je);
    U(this, "Tokenizer", Gn);
    U(this, "Hooks", en);
    this.use(...e);
  }
  /**
   * Run callback for every token
   */
  walkTokens(e, t) {
    var i, r;
    let n = [];
    for (const o of e)
      switch (n = n.concat(t.call(this, o)), o.type) {
        case "table": {
          const a = o;
          for (const l of a.header)
            n = n.concat(this.walkTokens(l.tokens, t));
          for (const l of a.rows)
            for (const u of l)
              n = n.concat(this.walkTokens(u.tokens, t));
          break;
        }
        case "list": {
          const a = o;
          n = n.concat(this.walkTokens(a.items, t));
          break;
        }
        default: {
          const a = o;
          (r = (i = this.defaults.extensions) == null ? void 0 : i.childTokens) != null && r[a.type] ? this.defaults.extensions.childTokens[a.type].forEach((l) => {
            n = n.concat(this.walkTokens(a[l], t));
          }) : a.tokens && (n = n.concat(this.walkTokens(a.tokens, t)));
        }
      }
    return n;
  }
  use(...e) {
    const t = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return e.forEach((n) => {
      const i = { ...n };
      if (i.async = this.defaults.async || i.async || !1, n.extensions && (n.extensions.forEach((r) => {
        if (!r.name)
          throw new Error("extension name required");
        if ("renderer" in r) {
          const o = t.renderers[r.name];
          o ? t.renderers[r.name] = function(...a) {
            let l = r.renderer.apply(this, a);
            return l === !1 && (l = o.apply(this, a)), l;
          } : t.renderers[r.name] = r.renderer;
        }
        if ("tokenizer" in r) {
          if (!r.level || r.level !== "block" && r.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const o = t[r.level];
          o ? o.unshift(r.tokenizer) : t[r.level] = [r.tokenizer], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [r.start] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [r.start]));
        }
        "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
      }), i.extensions = t), n.renderer) {
        const r = this.defaults.renderer || new Un(this.defaults);
        for (const o in n.renderer) {
          const a = n.renderer[o], l = o, u = r[l];
          r[l] = (...h) => {
            let p = a.apply(r, h);
            return p === !1 && (p = u.apply(r, h)), p || "";
          };
        }
        i.renderer = r;
      }
      if (n.tokenizer) {
        const r = this.defaults.tokenizer || new Gn(this.defaults);
        for (const o in n.tokenizer) {
          const a = n.tokenizer[o], l = o, u = r[l];
          r[l] = (...h) => {
            let p = a.apply(r, h);
            return p === !1 && (p = u.apply(r, h)), p;
          };
        }
        i.tokenizer = r;
      }
      if (n.hooks) {
        const r = this.defaults.hooks || new en();
        for (const o in n.hooks) {
          const a = n.hooks[o], l = o, u = r[l];
          en.passThroughHooks.has(o) ? r[l] = (h) => {
            if (this.defaults.async)
              return Promise.resolve(a.call(r, h)).then((g) => u.call(r, g));
            const p = a.call(r, h);
            return u.call(r, p);
          } : r[l] = (...h) => {
            let p = a.apply(r, h);
            return p === !1 && (p = u.apply(r, h)), p;
          };
        }
        i.hooks = r;
      }
      if (n.walkTokens) {
        const r = this.defaults.walkTokens, o = n.walkTokens;
        i.walkTokens = function(a) {
          let l = [];
          return l.push(o.call(this, a)), r && (l = l.concat(r.call(this, a))), l;
        };
      }
      this.defaults = { ...this.defaults, ...i };
    }), this;
  }
  setOptions(e) {
    return this.defaults = { ...this.defaults, ...e }, this;
  }
  lexer(e, t) {
    return je.lex(e, t ?? this.defaults);
  }
  parser(e, t) {
    return Ne.parse(e, t ?? this.defaults);
  }
}
cn = new WeakSet(), _s = function(e, t) {
  return (n, i) => {
    const r = { ...i }, o = { ...this.defaults, ...r };
    this.defaults.async === !0 && r.async === !1 && (o.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), o.async = !0);
    const a = An(this, Jn, Zr).call(this, !!o.silent, !!o.async);
    if (typeof n > "u" || n === null)
      return a(new Error("marked(): input parameter is undefined or null"));
    if (typeof n != "string")
      return a(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
    if (o.hooks && (o.hooks.options = o), o.async)
      return Promise.resolve(o.hooks ? o.hooks.preprocess(n) : n).then((l) => e(l, o)).then((l) => o.walkTokens ? Promise.all(this.walkTokens(l, o.walkTokens)).then(() => l) : l).then((l) => t(l, o)).then((l) => o.hooks ? o.hooks.postprocess(l) : l).catch(a);
    try {
      o.hooks && (n = o.hooks.preprocess(n));
      const l = e(n, o);
      o.walkTokens && this.walkTokens(l, o.walkTokens);
      let u = t(l, o);
      return o.hooks && (u = o.hooks.postprocess(u)), u;
    } catch (l) {
      return a(l);
    }
  };
}, Jn = new WeakSet(), Zr = function(e, t) {
  return (n) => {
    if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
      const i = "<p>An error occurred:</p><pre>" + xe(n.message + "", !0) + "</pre>";
      return t ? Promise.resolve(i) : i;
    }
    if (t)
      return Promise.reject(n);
    throw n;
  };
};
const ft = new pl();
function V(s, e) {
  return ft.parse(s, e);
}
V.options = V.setOptions = function(s) {
  return ft.setOptions(s), V.defaults = ft.defaults, qr(V.defaults), V;
};
V.getDefaults = ui;
V.defaults = mt;
V.use = function(...s) {
  return ft.use(...s), V.defaults = ft.defaults, qr(V.defaults), V;
};
V.walkTokens = function(s, e) {
  return ft.walkTokens(s, e);
};
V.parseInline = ft.parseInline;
V.Parser = Ne;
V.parser = Ne.parse;
V.Renderer = Un;
V.TextRenderer = hi;
V.Lexer = je;
V.lexer = je.lex;
V.Tokenizer = Gn;
V.Hooks = en;
V.parse = V;
V.options;
V.setOptions;
V.use;
V.walkTokens;
V.parseInline;
Ne.parse;
je.lex;
var fl = Object.defineProperty, gl = Object.getOwnPropertyDescriptor, ts = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? gl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && fl(e, t, i), i;
};
let ln = class extends fe {
  constructor() {
    super(...arguments), this.url = void 0, this.previewContent = void 0, this.loading = !1;
  }
  retrieveMarkdown() {
    this.url && fetch(this.url).then((s) => s.text()).then((s) => {
      this.previewContent = V.parse(s);
    }).finally(() => {
      this.loading = !1;
    });
  }
  willUpdate(s) {
    this.url && s.has("url") && s.get("url") !== this.url && this.url.endsWith(".md") && (this.loading = !0, this.retrieveMarkdown());
  }
  renderContent() {
    return this.url ? b`
        ${this.previewContent ? b` ${Fn(this.previewContent)}` : b` <iframe title="Preview" src="${this.url}" width="100%" height="850px" sandbox />`}
      ` : b``;
  }
  render() {
    return b`
      ${this.loading ? b`<loading-indicator label="${Xe.LOADING_TEXT}"></loading-indicator>` : this.renderContent()}
    `;
  }
};
ts([
  T({ type: String })
], ln.prototype, "url", 2);
ts([
  O()
], ln.prototype, "previewContent", 2);
ts([
  O()
], ln.prototype, "loading", 2);
ln = ts([
  Pe("document-previewer")
], ln);
const ml = De`
  .subheadline--small {
    font-size: 12px;
    display: block;
  }
  .items__list {
    border-top: none;
    padding: 0 var(--d-base);
    margin: var(--d-small) 0;
    display: block;
  }
  .items__listItem {
    display: inline-block;
    background-color: var(--c-accent-light);
    border-radius: var(--radius-small);
    text-decoration: none;
    padding: var(--d-xsmall);
    margin-top: 5px;
    font-size: var(--font-small);

    &.highlighted {
      animation: blink 1s infinite;
    }
  }

  @keyframes blink {
    0%, 50% {
      background-color: var(--c-accent-light);
    }
    51%, 100% {
      background-color: transparent;
    }
  }
  .items__listItem.active {
    background-color: var(--c-accent-high);
  }
  .items__listItem:not(first-child) {
    margin-left: 5px;
  }
  .items__link {
    text-decoration: none;
    color: var(--text-color);
  }
  .items__listItem.active .items__link {
    color: var(--c-white);
  }
`;
var bl = Object.defineProperty, vl = Object.getOwnPropertyDescriptor, fn = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? vl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && bl(e, t, i), i;
};
let gt = class extends fe {
  constructor() {
    super(...arguments), this.label = void 0, this.citations = void 0, this.selectedCitation = void 0, this.highlightedCitation = null;
  }
  handleCitationClick(s, e) {
    e.preventDefault(), this.selectedCitation = s;
    const t = new CustomEvent("on-citation-click", {
      detail: {
        citation: s
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  compareCitation(s, e) {
    return !!(s && e && s.text === e.text);
  }
  highlight(s) {
    this.highlightedCitation = s;
  }
  renderCitation(s) {
    return s && s.length > 0 ? b`
        <ol class="items__list">
          ${this.label ? b`<h3 class="subheadline--small">${this.label}</h3>` : ""}
          ${s.map(
      (e, t) => b`
              <li class="items__listItem${t === this.highlightedCitation ? " highlighted" : ""}">
                <a
                  class="items__link"
                  href="${e.url}"
                  target="_blank"
                  data-testid="citation"                  
                  >${t + 1}. ${e.text}</a>
              </li>
            `
    )}
        </ol>
      ` : "";
  }
  render() {
    return this.renderCitation(this.citations);
  }
};
gt.styles = [ml];
fn([
  T({ type: String })
], gt.prototype, "label", 2);
fn([
  T({ type: Array })
], gt.prototype, "citations", 2);
fn([
  T({ type: Object })
], gt.prototype, "selectedCitation", 2);
fn([
  O()
], gt.prototype, "highlightedCitation", 2);
gt = fn([
  Pe("citation-list")
], gt);
const yl = De`
  :host {
    display: block;
    height: 100%;
    width: 100%;
  }
  
  ul {
    margin-block-start: 0;
    margin-block-end: 0;
  }
  @keyframes chatmessageanimation {
    0% {
      opacity: 0.5;
      top: 150px;
    }
    100% {
      opacity: 1;
      top: 0;
    }
  }
  .chat__header--button {
    display: flex;
    align-items: center;
  }
  .chat__header {
    display: flex;
    align-items: top;
    justify-content: flex-end;
    padding: 0;
  }
  .chat__header--button {
    margin-right: var(--d-base);
  }
  .chat__footer {
    width: 100%;
    height: 0;
  }
  .chat__listItem {
    display: flex;
    margin-bottom: 1rem;
    align-items: flex-end;
    width: 100%;
  }
  .chat__listItem.user-message {
    justify-content: flex-end;
  }
  .chat__listItem:not(.user-message) {
    justify-content: flex-start;
  }
  .chat__txt {
    display: block;
    animation: chatmessageanimation 0.5s ease-in-out;
    background-color: white;
    color: #333;
    border-radius: 1rem;
    margin-top: 8px;
    word-wrap: break-word;
    margin-block-end: 0;
    position: relative;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border: 1px solid var(--chat_header_color, #e3e6f0);
    border-bottom-left-radius: 0.25rem;
    padding: 0.75rem 1rem;
    max-width: 100%;

    .chat__files {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin-bottom: 10px;
      flex-wrap: wrap;

      .file-item {
        max-width: 230px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .file-item.non-image-file {
        background: #FFF;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 12px;
        min-width: 120px;
        max-width: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .file-item__icon {
        font-size: 24px;
        color: #666;
        margin-bottom: 8px;
      }

      .file-item__info {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .file-item__name {
        font-size: 12px;
        font-weight: 500;
        color: #333;
        margin-bottom: 4px;
        word-break: break-word;
        max-width: 100%;
      }

      .file-item__size {
        font-size: 10px;
        color: #888;
      }
    }    

    p + br {
      display: none;
    }

    h1 {
      font-size: 1.5em;
    }

    h2 {
      font-size: 1.3em;
    }

    h3 {
      font-size: 1.1em;
    }

    h1,h2,h3 {      
      & + br {
        display: none;
      }

      & + br + br {
        display: none;
      }
    }

    /* Bootstrap table styles for parsed content */
    .table-responsive {
      margin: 1rem 0;
      border: 1px solid #dee2e6;
      border-radius: 0.375rem;
      overflow-x: auto;

      br {
        display: none;
      }
      
      .table {
        margin-bottom: 0;
        background-color: white;
        border-collapse: collapse;
        width: 100%;
        
        th, td {
          padding: 0.75rem;
          vertical-align: top;
          border-top: 1px solid #dee2e6;
          border-bottom: 1px solid #dee2e6;

          br {
            display: block;
          }
        }
        
        thead th {
          vertical-align: bottom;
          border-bottom: 2px solid #dee2e6;
          background-color: #f8f9fa;
          font-weight: 600;
          border-top: 0;
        }
        
        tbody + tbody {
          border-top: 2px solid #dee2e6;
        }
        
        &.table-striped tbody tr:nth-of-type(odd) {
          background-color: rgba(0, 0, 0, 0.05);
        }
        
        &.table-hover tbody tr:hover {
          background-color: rgba(0, 0, 0, 0.075);
        }
        
        &.table-bordered {
          border: 1px solid #dee2e6;
          
          th, td {
            border: 1px solid #dee2e6;
          }
          
          thead th, thead td {
            border-bottom-width: 2px;
          }
        }
        
        &.table-sm th, &.table-sm td {
          padding: 0.3rem;
        }
        
        .thead-dark th {
          color: #fff;
          background-color: #343a40;
          border-color: #454d55;
        }
        
        .thead-light th {
          color: #495057;
          background-color: #e9ecef;
          border-color: #dee2e6;
        }
        
        .badge {
          display: inline-block;
          padding: 0.25em 0.4em;
          font-size: 75%;
          font-weight: 700;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 0.375rem;
          
          &.badge-success {
            color: #fff;
            background-color: #198754;
          }
          
          &.badge-danger {
            color: #fff;
            background-color: #dc3545;
          }
          
          &.badge-warning {
            color: #000;
            background-color: #ffc107;
          }
          
          &.badge-info {
            color: #fff;
            background-color: #0dcaf0;
          }
          
          &.badge-primary {
            color: #fff;
            background-color: #0d6efd;
          }
          
          &.badge-secondary {
            color: #fff;
            background-color: #6c757d;
          }
        }
        
        .btn {
          display: inline-block;
          padding: 0.375rem 0.75rem;
          margin-bottom: 0;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.5;
          text-align: center;
          text-decoration: none;
          vertical-align: middle;
          cursor: pointer;
          border: 1px solid transparent;
          border-radius: 0.375rem;
          transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          
          &.btn-sm {
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            border-radius: 0.25rem;
          }
          
          &.btn-primary {
            color: #fff;
            background-color: #0d6efd;
            border-color: #0d6efd;
            
            &:hover {
              background-color: #0b5ed7;
              border-color: #0a58ca;
            }
          }
          
          &.btn-danger {
            color: #fff;
            background-color: #dc3545;
            border-color: #dc3545;
            
            &:hover {
              background-color: #bb2d3b;
              border-color: #b02a37;
            }
          }
          
          &.btn-success {
            color: #fff;
            background-color: #198754;
            border-color: #198754;
            
            &:hover {
              background-color: #157347;
              border-color: #146c43;
            }
          }
          
          &.btn-warning {
            color: #000;
            background-color: #ffc107;
            border-color: #ffc107;
            
            &:hover {
              background-color: #ffca2c;
              border-color: #ffc720;
            }
          }
          
          &.btn-info {
            color: #000;
            background-color: #0dcaf0;
            border-color: #0dcaf0;
            
            &:hover {
              background-color: #31d2f2;
              border-color: #25cff2;
            }
          }
          
          &.btn-secondary {
            color: #fff;
            background-color: #6c757d;
            border-color: #6c757d;
            
            &:hover {
              background-color: #5c636a;
              border-color: #565e64;
            }
          }
          
          & + .btn {
            margin-left: 0.5rem;
          }
        }
      }
    }
  }

  .search-ref {
    color: var(--primary-color);
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
  
  .message-content {
    max-width: 70%;
    display: flex;
    flex-direction: column;
  }
  
  .user-message .message-content {
    align-items: flex-end;
  }
  
  .chat__listItem:not(.user-message) .message-content {
    align-items: flex-start;
  }
  
  .message-avatar {
    margin: 0 0.5rem;
  }
  
  .message-avatar img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  
  .ai-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #28a745;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
  }
  .chat__txt loading-indicator {
    // position: absolute;
    // bottom: 0;
    // right: 0;
  }
  .chat__txt.error {
    border: var(--border-base) solid var(--error-color);
    color: var(--error-color);
    padding: var(--d-base);
    background: var(--c-error-background);
  }
  .chat__txt.user-message {
    background: #007bff;
    color: white;
    border: 1px solid #007bff;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 1rem;
  }
  .chat__listItem.user-message {
    align-self: flex-end;
  }
  .chat__txt--entry {
    padding: 0;
    margin: 0;
  }

  .chat__txt--entry file-card {
    margin-bottom: 15px;   
    display: block; 
  }
  .chat__txt--info {
    font-size: 0.75rem;
    color: #6c757d;
    margin: 0;
    margin-top: 0.25rem;
  }
  .user-message .chat__txt--info {
    text-align: right;
  }
  .chat__txt--footer {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
  }
  .items__listWrapper {
    border-top: var(--border-thin) solid var(--c-light-gray);
    display: grid;
    padding: 0 var(--d-base);
    grid-template-columns: 1fr 18fr;
  }
  .items__listWrapper svg {
    fill: var(--c-accent-high);
    width: var(--d-large);
    margin: var(--d-large) auto;
  }
  svg {
    height: auto;
    fill: var(--text-color);
  }
  .items__list.followup {
    display: flex;
    flex-direction: row;
    padding: var(--d-base);
    list-style-type: none;
    flex-wrap: wrap;
  }
  .items__list.steps {
    padding: 0 var(--d-base) 0 var(--d-xlarge);
    list-style-type: disc;
  }
  .chat__citations {
    margin-top: 15px;
    border-top: var(--border-thin) solid var(--c-light-gray);
  }
  .items__list {
    margin: var(--d-small) 0;
    display: block;
    padding: 0 var(--d-base);
  }
  .items__listItem--followup {
    cursor: pointer;
    padding: 0 var(--d-xsmall);
    border-radius: var(--radius-base);
    border: var(--border-thin) solid var(--c-accent-high);
    margin: var(--d-xsmall);
    transition: background-color 0.3s ease-in-out;
  }
  .items__listItem--followup:hover,
  .items__listItem--followup:focus {
    background-color: var(--c-accent-light);
    cursor: pointer;
  }
  .items__link {
    text-decoration: none;
    color: var(--text-color);
  }
  .steps .items__listItem--step {
    padding: var(--d-xsmall) 0;
    font-size: var(--font-base);
    line-height: 1;
  }
  .followup .items__link {
    color: var(--c-accent-high);
    display: block;
    padding: var(--d-xsmall) 0;
    border-bottom: var(--border-thin) solid var(--c-light-gray);
    font-size: var(--font-small);
  }
  .citation {
    background-color: var(--c-accent-light);
    border-radius: 3px;
    padding: calc(var(--d-small) / 5);
    margin-left: 3px;
    cursor: pointer;
  }
  .citation:hover {
    background-color: var(--c-accent-high);
    color: var(--c-white);
  }

  .tool-entry {
    margin: var(--d-base) 0;
    padding: 10px;
    background-color: var(--c-light-gray);
    border-radius: var(--radius-base);
    box-shadow: var(--shadow);
    border: var(--border-thin) solid var(--c-accent-light);
  }

  .tool-name {
    font-weight: bold;
    color: var(--c-accent-dark);
    margin-bottom: var(--d-small);
  }

  .tool-info {
    font-size: var(--font-small);
    color: var(--text-color);
  }

  .web-search-info {
        
  }

  .web-search-info strong {
    display: block;
    font-weight: bold;
    color: #3a3a3a;
    margin-bottom: var(--d-small);
  }

  .web-search-result {
    font-size: var(--font-small);
    color: var(--text-color);
    margin-bottom: var(--d-small);
  }
  .speech-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: var(--d-xsmall);

    svg {
      width: 20px;
      height: 20px;
      fill: var(--c-accent-dark); 
    }
  }
  #chat__thread-container {    
    margin: 0;
    border: 1px solid var(--chat_header_color, #e3e6f0);
    border-radius: 0.35rem;
    background: #f8f9fc;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }  
  .chat-topic {    
    padding: 1rem;
    border-bottom: 1px solid var(--chat_header_color, #e3e6f0);
    background: #f8f9fc;
    border-radius: 0.35rem 0.35rem 0 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 1rem;
  }  
  .chat-topic h5 {  
    margin: 0;
    font-size: 1.1rem;
    color: #000;
    margin-right: 1rem;
  }

  .talking-indicator {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-left: 15px;
    border-radius: 15px;
    border: 1px solid var(--alt_blu);
    color: var(--alt_blu);
    background-color: #FFF;
    padding: 5px;

    .talking-icon {
      margin-top: 4px;
    }
    

    &.talking .talking-icon {
      animation: pulse-opacity 1.5s ease-in-out infinite;
    }    
  }

  @keyframes pulse-opacity {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }  

  /* Fullscreen toggle button styles */
  .fullscreen-toggle-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    padding: 5px;
    flex-shrink: 0;
    margin-left: auto;
  }

  .fullscreen-toggle-btn:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  .fullscreen-toggle-btn:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }

  .fullscreen-toggle-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .chat__list {
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    list-style-position: inside;
    padding-inline-start: 0;    
    padding: 1rem;
    flex: 1;
    overflow-y: auto;
    background: white;
  }

  .cost-info {
    font-size: 0.75rem;
    color: #666;    
    opacity: 0.8;
  }

  .chat__txt--info {
    display: flex;
    align-items: center;
  }

  .timestamp {
    font-size: 0.75rem;
    color: #999;
    margin-right: 0.5rem;
  }

  .model-info {
    margin-left: 0.5rem;
  }

  .share-link {
    color: #73236b;
    text-decoration: none;
  }

  .file-item.is-userborn {
    .file-item__actions {
      position: absolute;
      left: 20px;
      top: 35px;
    }
  }

  p.from-rag{
      border-top: 3px solid #F00;
      position: relative;
      padding-top: 25px;

      &::after{
        background-color: #FFF;
        border-radius: 5px;
        content: 'RAG';
        position: absolute;
        top: -15px;
        right: 10px;
        padding: 3px;
        border: 1px solid #F00;
    }      
  }

  p.from-ai-network{
    border-top: 3px solid #0F0;
    position: relative;
    padding-top: 25px;

    &::after{
      background-color: #FFF;
      border-radius: 5px;
      content: 'AI';
      position: absolute;
      top: -15px;
      right: 10px;
      padding: 3px;
      border: 1px solid #0F0;
    }
  }

  .stopTalking {
    background-color: var(--danger);
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 5px;    
    border: none;
    box-shadow: none;
    padding: 4px 2px;

    i {
      color: #FFF;
    }
  }

  .chat__list.is-mini {

    padding-left: 0;
    padding-right: 0;

    .chat__listItem.ai-message {

        .message-avatar {
          display: none;
        }

        .message-content {
          width: 100%;
          max-width: 100%;
        }

        rws-tools {
          display: none;
        }

        reasoning-viewer {
          display: none;     
        }

        .chat__txt--footer {
          display: none;
        }

    }
  }
  
`, wl = De`
  button {
    color: var(--text-color);
    text-decoration: underline;
    border: var(--border-thin) solid var(--c-accent-dark);
    text-decoration: none;
    border-radius: var(--radius-small);
    background: var(--c-white);
    display: flex;
    align-items: center;
    margin-left: 5px;
    opacity: 1;
    padding: 2px;
    transition: all 0.3s ease-in-out;
    position: relative;
    cursor: pointer;

    &.alt-color {
      background: var(--c-accent-dark);
    }
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  button:disabled:hover,
  button:disabled:focus {
    background-color: var(--c-white);
    cursor: not-allowed;
  }
  button:disabled:hover > svg,
  button:disabled:focus > svg {
    background-color: transparent;
  }
  button:disabled > span {
    display: none !important;
  }
  span {
    font-size: smaller;
    transition: all 0.3s ease-out 0s;
    position: absolute;
    text-align: right;
    top: -135%;
    background: var(--c-accent-dark);
    color: var(--c-white);
    opacity: 0;
    right: 0;
    padding: var(--d-xsmall) var(--d-small);
    border-radius: var(--radius-small);
    font-weight: bold;
    word-wrap: nowrap;
  }
  span::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: var(--border-thick) solid var(--c-accent-dark);
    bottom: -8px;
    right: 5px;
  }
  svg {
    fill: currentColor;
    padding: var(--d-xsmall);
    width: 15px;
    height: 15px;
  }
  button:hover > span,
  button:focus > span {
    display: inline-block;
    opacity: 1;
  }
  button:hover,
  button:focus,
  button:hover > svg,
  button:focus > svg {
    background-color: var(--c-light-gray);
    border-radius: var(--radius-small);
    transition: background 0.3s ease-in-out;
  }

  button > i {
    margin: 6px;
  }
`;
var xl = Object.defineProperty, Tl = Object.getOwnPropertyDescriptor, Ve = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Tl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && xl(e, t, i), i;
};
let Oe = class extends fe {
  constructor() {
    super(...arguments), this.label = "", this.svgIcon = "", this.simpleIcon = "", this.isDisabled = !1, this.altColor = !1, this.actionId = "", this.tooltip = void 0, this.injectCss = [];
  }
  async connectedCallback() {
    super.connectedCallback(), await dn.bind(this)();
    for (const s of this.injectCss)
      await an.bind(this)(s);
  }
  render() {
    return b`
      <button title="${this.label}" class="action-button${this.altColor ? " alt-color" : ""}" data-testid="${this.actionId}" ?disabled="${this.isDisabled}">
        <span>${this.tooltip ?? this.label}</span>
        ${this.svgIcon ? _n(this.svgIcon) : b`<i class="simple-icon-${this.simpleIcon}"></i>`}
      </button>
    `;
  }
};
Oe.styles = [wl];
Ve([
  T({ type: String })
], Oe.prototype, "label", 2);
Ve([
  T({ type: String })
], Oe.prototype, "svgIcon", 2);
Ve([
  T({ type: String })
], Oe.prototype, "simpleIcon", 2);
Ve([
  T({ type: Boolean })
], Oe.prototype, "isDisabled", 2);
Ve([
  T({ type: Boolean })
], Oe.prototype, "altColor", 2);
Ve([
  T({ type: String })
], Oe.prototype, "actionId", 2);
Ve([
  T({ type: String })
], Oe.prototype, "tooltip", 2);
Ve([
  T({ type: Array })
], Oe.prototype, "injectCss", 2);
Oe = Ve([
  Pe("chat-action-button")
], Oe);
const El = De`
  .reasoning-container {
    margin: 16px 0;
    border: 1px solid var(--chat_header_color, #e3e6f0);
    border-radius: 8px;
    background: #f8f9fc;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    animation: scaleIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.95) translateY(10px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  .reasoning-container:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  .reasoning-container.streaming {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    50% {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
    100% {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .reasoning-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }

  .reasoning-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  .reasoning-header:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  .reasoning-header:hover::before {
    left: 100%;
  }

  .reasoning-header:active {
    transform: translateY(0);
    transition: transform 0.1s ease;
  }

  .header-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .reasoning-icon {
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .reasoning-icon::before {
    font-family: 'simple-line-icons';
    font-size: 20px;
    content: '\e0b6'; /* icon-bulb */
  }

  .reasoning-title {
    font-weight: 600;
    font-size: 14px;
    margin: 0;
  }

  .step-counter {
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
  }

  .toggle-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: center;
  }

  .toggle-icon::before {
    font-family: 'simple-line-icons';
    font-size: 16px;
    content: '\e09b'; /* icon-arrow-down */
    transition: all 0.3s ease;
  }

  .toggle-icon.collapsed {
    transform: rotate(180deg);
  }

  .toggle-icon.collapsed::before {
    content: '\e09b'; /* Keep same icon, just rotate it */
  }

  .reasoning-content {    
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 1000px; /* Large enough for content */
    opacity: 1;
    transform: translateY(0);
  }

  .reasoning-content.collapsed {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
    padding-top: 0;
    padding-bottom: 0;
  }

  .reasoning-steps {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .reasoning-step {
    padding: 12px 16px;
    border-bottom: 1px solid var(--chat_header_color, #e3e6f0);
    position: relative;
  }

  .reasoning-step:last-child {
    border-bottom: none;
  }

  .step-indicator {
    position: absolute;
    left: 16px;
    top: 12px;
    width: 24px;
    height: 24px;
    background: #28a745;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    z-index: 1;
  }

  .step-content {
    margin-left: 40px;
    font-size: 14px;
    line-height: 1.5;
    color: #2d3748;
    padding: 15px;
    animation: fadeInUp 0.5s ease-out;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .step-content strong {
    color: #1a202c;
    font-weight: 600;
  }

  .step-content code {
    background: #f1f3f4;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 13px;
  }

  .step-content em {
    font-style: italic;
    color: #4a5568;
  }

  .reasoning-step:not(:last-child) .step-indicator::after {
    content: '';
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 20px;
    background: var(--chat_header_color, #e3e6f0);
    z-index: 0;
  }

  @media (max-width: 768px) {
    .reasoning-container {
      margin: 12px 0;
    }
    
    .reasoning-header {
      padding: 10px 12px;
    }
    
    .reasoning-step {
      padding: 10px 12px;
    }
    
    .step-content {
      margin-left: 32px;
      font-size: 13px;
    }
    
    .step-indicator {
      width: 20px;
      height: 20px;
      font-size: 10px;
    }

    .reasoning-icon::before {
      font-size: 16px;
    }

    .toggle-icon::before {
      font-size: 14px;
    }
  }
`;
class ns {
  constructor() {
    this.exclusiveBuffering = !1, this.allowedRulesWhileBuffering = [];
  }
  /**
   * Continue buffering when we're in the middle of a rule's processing
   * Override this method to handle continuation of buffering with special logic
   */
  continueBuffering(e, t, n, i, r) {
    return null;
  }
  /**
   * Handle completion of buffering when finisher is found
   * Override this method to handle special completion logic (like partial sequences)
   */
  handleBufferingCompletion(e, t, n, i, r) {
    return null;
  }
  /**
   * Detect if buffering should finish based on the current chunk
   * Override this method when finisher is undefined in BufferingResult
   * @param chunk - Current chunk being processed
   * @param currentBuffer - Current buffer content
   * @param bufferState - Current buffer state
   * @returns true if buffering should finish, false otherwise
   */
  detectFinish(e, t, n) {
    return !1;
  }
  /**
   * Extract and transform content that should be buffered
   * Override this method to process content before adding it to buffer
   */
  processBufferContent(e) {
    return e;
  }
  /**
   * Process full text with regex patterns (for non-streaming scenarios)
   * Override this method to provide full-text processing for each rule
   */
  processFullText(e) {
    const t = this.getFullTextPattern();
    return t ? e.replace(t.pattern, t.replacement) : e;
  }
  /**
   * Get the full text pattern for this rule
   * Override this method to provide regex patterns for full text processing
   */
  getFullTextPattern() {
    return null;
  }
  createCompleteMatch(e, t, n) {
    return {
      match: !0,
      fullMatch: e,
      content: t,
      replacement: n
    };
  }
}
class kl extends ns {
  constructor() {
    super(...arguments), this.name = "header", this.priority = 1, this.partialSequence = "", this.detectedLevel = 0;
  }
  // Track the detected header level
  detect(e, t) {
    const n = this.partialSequence + e;
    return /#/.test(n) ? (this.partialSequence = "", !0) : (this.partialSequence = "", !1);
  }
  tryCompleteMatch(e, t) {
    const i = (this.partialSequence + e).match(/(#{1,6})\s*([^#\n]*?)(?:\n|$)/);
    if (i) {
      const [r, o, a] = i, l = o.length, u = a.trim();
      if (u && l >= 1 && l <= 6)
        return this.detectedLevel = l, this.createCompleteMatch(
          r,
          u,
          `<h${l}>${u}</h${l}>`
        );
    }
    return null;
  }
  startBuffering(e, t) {
    const n = e.match(/^(#{1,6})/), i = n ? n[1].length : this.detectedLevel || 1;
    return this.detectedLevel = i, {
      processedChunk: e.replace(/^(#{1,6}\s*)/, `<h${i}>`),
      finisher: `
`,
      closure: `</h${i}>`
    };
  }
  getFullTextPattern() {
    return {
      pattern: /^(#{1,6})\s+(.+)$/gm,
      replacement: (e, t, n) => {
        const i = t.length;
        return `<h${i}>${n}</h${i}>`;
      }
    };
  }
}
class Cl extends ns {
  constructor() {
    super(...arguments), this.name = "text-formatting", this.priority = 5, this.partialMarker = "", this.bufferingType = null;
  }
  detect(e, t) {
    if ((t == null ? void 0 : t.currentRule) === "text-formatting" && (t != null && t.buffering))
      return !1;
    const n = this.partialMarker + e;
    return n.includes("**") ? (this.partialMarker = "", !0) : new RegExp("(?<!\\*)\\*(?!\\*)").test(n) ? (this.partialMarker = "", !0) : e.endsWith("*") ? (this.partialMarker = "*", null) : e.startsWith("*") && this.partialMarker === "*" ? (this.partialMarker = "", !0) : (this.partialMarker = "", !1);
  }
  tryCompleteMatch(e, t) {
    const i = /\*\*([^*]+?)\*\*/g.exec(e);
    if (i)
      return {
        match: !0,
        fullMatch: i[0],
        content: i[1],
        replacement: `<strong>${i[1]}</strong>`
      };
    const o = new RegExp("(?<!\\*)\\*([^*\\n]+?)\\*(?!\\*)", "g").exec(e);
    return o ? {
      match: !0,
      fullMatch: o[0],
      content: o[1],
      replacement: `<em>${o[1]}</em>`
    } : null;
  }
  startBuffering(e, t) {
    let n = -1, i = 0;
    const r = e.indexOf("**");
    if (r !== -1)
      n = r, i = 2, this.bufferingType = "bold";
    else {
      const y = new RegExp("(?<!\\*)\\*(?!\\*)").exec(e);
      y && (n = y.index, i = 1, this.bufferingType = "italic");
    }
    const o = e.substring(0, n), a = e.substring(n + i);
    t && a && (t.contentAfterMarker = a, t.isFirstBufferingChunk = !0);
    const l = this.bufferingType === "bold" ? "**" : "*", u = this.bufferingType === "bold" ? "</strong>" : "</em>", h = this.bufferingType === "bold" ? "<strong>" : "<em>";
    return {
      processedChunk: o + h,
      finisher: l,
      closure: u
    };
  }
  detectFinish(e, t, n) {
    let i = e;
    return n != null && n.isFirstBufferingChunk && (n != null && n.contentAfterMarker) && (i = n.contentAfterMarker + e), this.bufferingType === "bold" ? i.includes("**") : new RegExp("(?<!\\*)\\*(?!\\*)").test(i);
  }
  continueBuffering(e, t, n, i, r) {
    let o = e;
    return r != null && r.isFirstBufferingChunk && (r.isFirstBufferingChunk = !1, r != null && r.contentAfterMarker && (o = r.contentAfterMarker + e, delete r.contentAfterMarker)), this.detectFinish(o, t, r) ? (r && (r.finalChunkToProcess = o), null) : {
      processedChunk: o,
      finisher: n,
      closure: i
    };
  }
  handleBufferingCompletion(e, t, n, i, r) {
    let o = (r == null ? void 0 : r.finalChunkToProcess) || e;
    r != null && r.contentAfterMarker && (o = r.contentAfterMarker + o, delete r.contentAfterMarker);
    let a = -1;
    if (this.bufferingType === "bold")
      a = o.indexOf("**");
    else {
      const u = new RegExp("(?<!\\*)\\*(?!\\*)").exec(o);
      u && (a = u.index);
    }
    if (a !== -1) {
      const l = this.bufferingType === "bold" ? 2 : 1, u = o.substring(0, a), h = o.substring(a + l);
      return r != null && r.finalChunkToProcess && delete r.finalChunkToProcess, r != null && r.isFirstBufferingChunk && delete r.isFirstBufferingChunk, this.bufferingType = null, this.partialMarker = "", {
        finalChunk: u,
        remainingChunk: h,
        shouldContinue: !0
      };
    }
    return {
      finalChunk: o,
      remainingChunk: "",
      shouldContinue: !0
    };
  }
  getFullTextPattern() {
    return {
      pattern: new RegExp("(\\*\\*([^*]+?)\\*\\*)|(?<!\\*)\\*([^*\\n]+?)\\*(?!\\*)", "g"),
      replacement: (e, t, n, i) => t ? `<strong>${n}</strong>` : i ? `<em>${i}</em>` : e
    };
  }
}
class Qr extends ns {
  constructor() {
    super(...arguments), this.name = "line-break", this.priority = 10;
  }
  // Lowest priority - process after all other rules
  detect(e, t) {
    return t != null && t.linebreakProof || (t == null ? void 0 : t.currentRule) === "code-block" || this.containsCodeBlockPattern(e) || t != null && t.insideCodeViewer || t != null && t.insideListViewer || t != null && t.buffering || (t == null ? void 0 : t.currentRule) === "code-block" || this.containsCodeBlockPattern(e) || e.includes("<code-viewer") && !e.includes("</code-viewer>") || e.includes("<list-viewer") && !e.includes("</list-viewer>") ? !1 : e.includes(`
`);
  }
  tryCompleteMatch(e, t) {
    if (t != null && t.linebreakProof || t != null && t.insideCodeViewer || t != null && t.insideListViewer || t != null && t.buffering || (t == null ? void 0 : t.currentRule) === "code-block" || this.containsCodeBlockPattern(e) || e.includes("<code-viewer") && !e.includes("</code-viewer>") || e.includes("<list-viewer") && !e.includes("</list-viewer>"))
      return null;
    if (e.match(/(\n)/g)) {
      const i = e.replace(/\n/g, (r, o) => {
        const a = e.substring(0, o);
        return /<\/li>\s*$/.test(a) || /<\/code-viewer>\s*$/.test(a) || /<\/list-viewer>\s*$/.test(a) || /<li[^>]*>\s*$/.test(a) || /<(?:code-viewer|list-viewer)[^>]*>\s*$/.test(a) ? `
` : "<br/>";
      });
      return this.createCompleteMatch(
        e,
        e,
        i
      );
    }
    return null;
  }
  startBuffering(e) {
    throw new Error("LineBreakRule should never start buffering");
  }
  /**
   * Check if chunk contains patterns that should be handled by code-block rule
   * This prevents line-break rule from processing chunks before code-block rule can detect them
   */
  containsCodeBlockPattern(e) {
    return !!e.includes("```");
  }
  processFullText(e) {
    const t = /(<(?:code-viewer|list-viewer)[^>]*>[\s\S]*?<\/(?:code-viewer|list-viewer)>)/g, n = [];
    let i = 0, r;
    for (; (r = t.exec(e)) !== null; ) {
      if (r.index > i) {
        const o = e.substring(i, r.index);
        n.push(this.smartLineBreakReplacement(o));
      }
      n.push(r[1]), i = r.index + r[1].length;
    }
    if (i < e.length) {
      const o = e.substring(i);
      n.push(this.smartLineBreakReplacement(o));
    }
    return n.join("");
  }
  smartLineBreakReplacement(e) {
    return e.replace(/\n/g, (t, n) => {
      const i = e.substring(0, n);
      return /<\/li>\s*$/.test(i) || /<\/code-viewer>\s*$/.test(i) || /<\/list-viewer>\s*$/.test(i) || /<li[^>]*>\s*$/.test(i) || /<(?:code-viewer|list-viewer)[^>]*>\s*$/.test(i) || /<\/(?:ol|ul|div|p|h[1-6])\s*>\s*$/.test(i) ? `
` : "<br/>";
    });
  }
  getFullTextPattern(e = !1) {
    return {
      pattern: /\n/g,
      replacement: (t) => e ? `
` : "<br/>"
    };
  }
}
var Pl = Object.defineProperty, zl = Object.getOwnPropertyDescriptor, bt = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? zl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && Pl(e, t, i), i;
};
let We = class extends fe {
  constructor() {
    super(...arguments), this.streaming = !1, this.closed = !1, this.label = "Reasoning", this.componentId = "", this.reasoningText = "", this.dropdownShown = !0;
  }
  /**
   * Parse reasoning text using header and text formatting rules
   * @param text - The raw reasoning text to parse
   * @returns Parsed HTML string
   */
  parseReasoningText(s) {
    if (!s)
      return "";
    const e = new kl(), t = new Cl(), n = new Qr();
    let i = s;
    return i = e.processFullText(i), i = t.processFullText(i), i = n.processFullText(i), i;
  }
  async connectedCallback() {
    super.connectedCallback(), await dn.bind(this)(), this.closed && (this.dropdownShown = !1);
  }
  close() {
    this.dropdownShown && (this.dropdownShown = !1, this.requestUpdate());
  }
  render() {
    return b`
      <div class="reasoning-container ${this.streaming ? "streaming" : ""}">
        <div class="reasoning-header" @click="${this.toggleDropdown}">
          <div class="header-content">
            <i class="simple-icon-bulb"></i>
            <h4 class="reasoning-title">${this.label}</h4>          
          </div>
          <i class="simple-icon-arrow-${this.dropdownShown ? "up" : "down"}"></i>
        </div>
        
        <div class="reasoning-content ${this.dropdownShown ? "" : "collapsed"}">
             ${b`<div class="step-content" .innerHTML="${this.parseReasoningText(this.reasoningText)}"></div>`}
        </div>
      </div>
    `;
  }
  toggleDropdown() {
    this.dropdownShown = !this.dropdownShown, this.requestUpdate();
  }
  updateReasoning(s) {
    s && s.trim() && (this.reasoningText += s, this.requestUpdate());
  }
  clearReasoning() {
    this.reasoningText = "", this.requestUpdate();
  }
};
We.styles = [El];
bt([
  T({ attribute: "streaming", type: Boolean })
], We.prototype, "streaming", 2);
bt([
  T({ attribute: "closed", type: Boolean })
], We.prototype, "closed", 2);
bt([
  T({ attribute: "label", type: String })
], We.prototype, "label", 2);
bt([
  T({ attribute: "component-id" })
], We.prototype, "componentId", 2);
bt([
  T({ type: String })
], We.prototype, "reasoningText", 2);
bt([
  O()
], We.prototype, "dropdownShown", 2);
We = bt([
  Pe("reasoning-viewer")
], We);
const Ll = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M1491 595l90 90-749 749-365-365 90-90 275 275 659-659zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" />\r
</svg>`, Al = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M1920 805v1243H640v-384H128V0h859l384 384h128l421 421zm-384-37h165l-165-165v165zM640 384h549L933 128H256v1408h384V384zm1152 512h-384V512H768v1408h1024V896z" />\r
</svg>`, Ol = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\r
  <path d="M12.5001 3C6.70106 3 2.00005 7.70101 2.00005 13.5C2.00005 14.7989 2.23632 16.044 2.66849 17.1938C2.79635 17.534 2.94135 17.8658 3.10245 18.1881L2.0527 22.1058C1.75384 23.2212 2.77447 24.2418 3.88982 23.943L7.80465 22.894C9.2185 23.6019 10.8141 24 12.5001 24C18.299 24 23.0001 19.299 23.0001 13.5C23.0001 7.70101 18.299 3 12.5001 3ZM5.04572 17.5882C4.37944 16.3761 4.00005 14.9839 4.00005 13.5C4.00005 8.80558 7.80563 5 12.5001 5C17.1945 5 21.0001 8.80558 21.0001 13.5C21.0001 18.1944 17.1945 22 12.5001 22C11.0137 22 9.61924 21.6193 8.4058 20.951C8.1796 20.8264 7.91397 20.7941 7.66452 20.861L4.2087 21.787L5.13533 18.3287C5.2021 18.0796 5.16999 17.8142 5.04572 17.5882ZM14.4549 25.3417C13.8187 25.446 13.1657 25.5002 12.5 25.5002C12.2132 25.5002 11.9287 25.4901 11.647 25.4703C13.5704 27.6358 16.3758 29.0002 19.5 29.0002C21.186 29.0002 22.7815 28.6021 24.1954 27.8941L28.1102 28.9431C29.2255 29.242 30.2462 28.2214 29.9473 27.106L28.8976 23.1883C29.0587 22.8659 29.2037 22.5341 29.3315 22.194C29.7637 21.0442 30 19.799 30 18.5002C30 14.1361 27.3376 10.3939 23.5485 8.80908C23.9114 9.6628 24.1783 10.5672 24.3355 11.5087C26.5498 13.0431 28 15.6023 28 18.5002C28 19.984 27.6206 21.3763 26.9543 22.5883C26.83 22.8144 26.7979 23.0797 26.8647 23.3289L27.7913 26.7871L24.3355 25.8611C24.086 25.7943 23.8204 25.8266 23.5942 25.9511C22.3808 26.6195 20.9863 27.0002 19.5 27.0002C17.611 27.0002 15.866 26.384 14.4549 25.3417ZM11.5 15C11.5 15.55 11.95 16 12.5 16C13.05 16 13.5 15.55 13.5 15C13.5 14.0992 14.0096 13.5217 14.6019 12.8505L14.62 12.83C15.27 12.09 16 11.21 16 10C16 8.79 15.07 7 12.5 7C9.93 7 9 8.79 9 10C9 10.55 9.45 11 10 11C10.55 11 11 10.55 11 10C11 9.83 11.07 9 12.5 9C13.82 9 13.99 9.71 14 10C14 10.48 13.68 10.86 13.12 11.5L13.1009 11.5217C12.3842 12.3378 11.5 13.3447 11.5 15ZM13.75 18.75C13.75 19.4404 13.1904 20 12.5 20C11.8096 20 11.25 19.4404 11.25 18.75C11.25 18.0596 11.8096 17.5 12.5 17.5C13.1904 17.5 13.75 18.0596 13.75 18.75Z" />\r
</svg>`, { replace: Dl } = "", Hl = /[&<>'"]/g, Sl = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  "'": "&#39;",
  '"': "&quot;"
}, Ml = (s) => Sl[s], Fl = (s) => Dl.call(s, Hl, Ml), jl = (s) => {
  if (!s || s.length === 0)
    return "";
  const e = JSON.stringify(s);
  return `<rws-tools data='${Fl(e)}'></rws-tools>`;
};
class se {
  static renderMainThread(e, t = 0, n = !1) {
    return b`
    <div id="chat__thread-container">
      <div class="chat-topic">
        <h5 class="mr-3">
          ${this.conversationTitle}
        </h5>
        ${this.conversationUid ? b`<share-window convoUid="${this.conversationUid}"></share-window>` : ""}        
        ${n ? b`<app-loader block="true" indicatorWidth="2px" width="15px" height="15px" style="margin-left: 15px;"></app-loader>` : ""}
        
        ${this.fullscreenEnabled ? b`<button 
            type="button"
            class="fullscreen-toggle-btn ${this.isFullscreen ? "simple-icon-close" : "simple-icon-size-fullscreen"}"
            @click="${this.handleFullscreenToggle}"
            title="${this.isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}"
            ?disabled="${this.isDisabled}"
        ></button>` : ""}
      </div>
      <ul class="chat__list${this.mini ? " is-mini" : ""}" aria-live="assertive">
      ${this.chatThread.length === 1 && this.chatThread[0] === void 0 ? b`` : this.chatThread.map(
      (i, r) => i.hidden ? "" : se.renderMessage.bind(this)(i, r, t, e)
    )}
        
        ${se.renderPendingReasoning.bind(this)()}
        </ul>
      </div>
      <div class="chat__footer" id="chat-list-footer">
        <!-- Do not delete this element. It is used for auto-scrolling -->
      </div>
    `;
  }
  static renderMessage(e, t, n, i, r = !1) {
    const o = t === this.chatThread.length - 1, a = this.isProcessingResponse && o && !e.isUserMessage, l = !e.isUserMessage && e.id === this.currentStreamingMessageId;
    return this.showLoadingIndicator && !a && (this.showLoadingIndicator = !1), b`<li class="chat__listItem ${e.isUserMessage ? "user-message" : "ai-message"}">
        ${e.isUserMessage ? "" : se.renderAiAvatar()}
        
        <div class="message-content">
          <div class="chat__txt ${e.isUserMessage ? "user-message" : ""}">
            ${e.isUserMessage ? "" : se.renderReasoningViewer.bind(this)(t, i)}
${e.tools && e.tools.length > 0 ? Fn(jl(e.tools)) : ""}
            ${se.renderFiles.bind(this)(e, i)}
            ${e.text.map((u) => se.renderTextEntry.bind(this)(u, e.isUserMessage, a, e.id))}                      
            ${se.renderCitation.bind(this)(e, i)}
            ${se.renderFollowupQuestions.bind(this)(e)} 
            ${e.error ? se.renderError(e.error) : ""}
            ${this.showLoadingIndicator ? b`<loading-indicator label=""></loading-indicator>` : ""}
          </div>
          <div class="chat__txt--footer">
            <div class="chat__txt--info">                              
              <span class="timestamp">${se.formatTo24Hour(e.timestamp)}</span>
              ${se.renderUserInfo(e)}                       
              ${se.renderCostInfo(e)}
              ${se.renderModelInfo(e)}   
              ${l && n > 0 ? b`<div class="talking-indicator${n === 2 ? " talking" : ""}">
                <i class="talking-icon simple-icon-earphones-alt"></i>
                ${n === 2 ? b`<button class="stopTalking" @click="${this.handleStopTalking}"><i class="simple-icon-close"></i></button>` : ""}
                ${n === 1 ? b`<app-loader block="true" indicatorWidth="2px" width="15px" height="15px"></app-loader>` : ""}
              </div>` : ""}  
            </div>
            <div class="chat__response-actions">                  
              ${e.isUserMessage ? "" : se.renderResponseActions.bind(this)(e, i)}                                              
            </div>
          </div>
        </div>
        
        ${e.isUserMessage ? se.renderUserAvatar() : ""}
      </li>`;
  }
  static renderAiAvatar() {
    return b`
      <div class="message-avatar">
        <div class="ai-avatar">AI</div>
      </div>
    `;
  }
  static renderUserAvatar() {
    return b`
      <div class="message-avatar">
        <img src="/assets/images/avatar.jpg" alt="User" style="width: 32px; height: 32px; border-radius: 50%;">
      </div>
    `;
  }
  static renderResponseActions(e, t) {
    return b`
      <header class="chat__header">
        <div class="chat__header--button">
          ${this.actionButtons.map(
      (n) => b`
                <chat-action-button
                  .label="${n.label}"
                  .svgIcon="${n.svgIcon}"
                  .isDisabled="${n.isDisabled}"
                  .actionId="${n.id}"
                  .injectCss="${this.injectCss}"
                  @click="${(i) => this.actionButtonClicked(n, e, i)}"
                ></chat-action-button>
              `
    )}
          <chat-action-button
            .label="${t.COPY_RESPONSE_BUTTON_LABEL_TEXT}"
            .svgIcon="${this.isResponseCopied ? Ll : Al}"
            .isDisabled="${this.isDisabled}"
            actionId="copy-to-clipboard"
            .injectCss="${this.injectCss}"
            .tooltip="${this.isResponseCopied ? t.COPIED_SUCCESSFULLY_MESSAGE : t.COPY_RESPONSE_BUTTON_LABEL_TEXT}"
            @click="${() => this.copyResponseToClipboard(e)}"
          ></chat-action-button>
          <chat-action-button
            .label="${t.ADD_KDB_BUTTON_LABEL_TEXT}"
            simpleIcon="book-open"            
            .isDisabled="${this.isDisabled}"
            actionId="add-to-kdb"
            .injectCss="${this.injectCss}"
            .tooltip="${t.ADD_KDB_BUTTON_LABEL_TEXT}"
            @click="${() => this.addToKDB(e)}"
          ></chat-action-button>
        </div>
      </header>
    `;
  }
  static renderTextEntry(e, t = !1, n = !1, i) {
    const r = `typing-target-${i || "unknown"}`;
    if (!e.value || e.value.trim() === "")
      return b`<div class="chat_txt--entry-container"><p class="chat__txt--entry" id="${r}"></p></div>`;
    let o = e.value;
    if (t && (o = e.value.replace(/\n/g, "<br/>")), n && this.isTyping && !t)
      return b`<div class="chat_txt--entry-container"><p class="chat__txt--entry" id="${r}"></p></div>`;
    const a = [b`<p class="chat__txt--entry">${Fn(o)}</p>`];
    return e.followingSteps && e.followingSteps.length > 0 && a.push(b`
        <ol class="items__list steps">
          ${e.followingSteps.map(
      (l) => b` <li class="items__listItem--step">${Fn(l)}</li> `
    )}
        </ol>
      `), this.isProcessingResponse && this.debounceScrollIntoView(), b`<div class="chat_txt--entry-container">${a}</div>`;
  }
  static renderFiles(e, t) {
    if (!e.files || e.files.length === 0)
      return "";
    const n = e.files.filter((r) => {
      const o = r.mimeType;
      return o && o.startsWith("image/");
    }), i = e.files.filter((r) => {
      const o = r.mimeType;
      return o && !o.startsWith("image/");
    });
    return b`
      <div class="chat__files">
        ${n.map((r) => se.renderImageFile.bind(this)(r, t))}
        ${i.map((r) => se.renderNonImageFile.bind(this)(r, t))}
      </div>
    `;
  }
  static renderImageFile(e, t) {
    const n = e.mimeType;
    return e.tmp ? b`
        <div class="file-item">
          <gen-image 
            tmp="true"
            imageFormat="${n && n.split("/")[1] || "png"}"
          >${e.base64}</gen-image>          
        </div>
      ` : b`
        <div class="file-item is-userborn">
          <gen-image 
            fileId="${e.id}"
            imageFormat="${n && n.split("/")[1] || "png"}"
          ></gen-image>
          <div class="file-item__actions">
            <chat-action-button
            .label="${t.ADD_KDB_BUTTON_LABEL_TEXT}"
            simpleIcon="book-open"                        
            actionId="add-to-kdb"
            .injectCss="${this.injectCss}"
            .altColor="${!0}"
            .tooltip="${t.ADD_KDB_BUTTON_LABEL_TEXT}"
            @click="${() => this.addFileToKDB(e)}"
          ></chat-action-button>
          </div>
        </div>
      `;
  }
  static renderNonImageFile(e, t) {
    return b`
      <file-card 
        fileId="${e.id}" 
        showDownload="true" 
        showAddToKdb="true"
        @add-to-kdb="${() => this.addFileToKDB(e)}"
      ></file-card>
    `;
  }
  static renderCitation(e, t) {
    const n = e.citations;
    return n && n.length > 0 ? b`
        <div class="chat__citations">
          <citation-list
            .citations="${n}"
            .label="${t.CITATIONS_LABEL}"
            .selectedCitation=${this.selectedCitation}            
            @on-citation-click="${(i) => this.handleCitationClick(i.detail.citation, e, i)}"
          ></citation-list>
        </div>
      ` : "";
  }
  static renderFollowupQuestions(e) {
    const t = e.followupQuestions;
    return t && t.length > 0 ? b`
        <div class="items__listWrapper">
          ${_n(Ol)}
          <ul class="items__list followup">
            ${t.map(
      (n) => b`
                <li class="items__listItem--followup">
                  <a
                    class="items__link"
                    href="#"
                    data-testid="followUpQuestion"
                    @click="${(i) => this.handleFollowupQuestionClick(n, e, i)}"
                    >${n}</a
                  >
                </li>
              `
    )}
          </ul>
        </div>
      ` : "";
  }
  static renderError(e) {
    return b`<p class="chat__txt error">${e.message}</p>`;
  }
  static renderReasoningViewer(e, t) {
    const n = this.chatThread[e];
    if (!n || !n.reasoning && !n.thoughts)
      return "";
    const i = n.reasoning || n.thoughts, r = this.isProcessingResponse ? this.isReasoningClosed : this.showInitialMessagesReasoningClosed;
    return this.mini ? r ? "" : b`<app-loader block="true" width="50" height="50"></app-loader>` : b`
      <reasoning-viewer
        component-id="${n.id}"
        label="${t.REASONING_LABEL}"
        .reasoningText="${i || ""}"
        .closed="${r}"
      ></reasoning-viewer>
    `;
  }
  static renderPendingReasoning() {
    return "";
  }
  static formatTo24Hour(e) {
    const t = new Date(e), n = t.getHours(), i = t.getMinutes();
    return `${n}:${i.toString().padStart(2, "0")}`;
  }
  static renderCostInfo(e) {
    if (e.isUserMessage)
      return "";
    let t = null;
    if (e.cost ? t = e.cost : e.costs && e.costs.length > 0 && (e.costs.length === 1 ? t = e.costs[0] : t = e.costs.reduce((a, l) => ({
      prompt_tokens: a.prompt_tokens + l.prompt_tokens,
      completion_tokens: a.completion_tokens + l.completion_tokens,
      total_tokens: a.total_tokens + l.total_tokens,
      cost: a.cost + l.cost,
      reasoning_tokens: (a.reasoning_tokens || 0) + (l.reasoning_tokens || 0)
    }))), !t)
      return "";
    const { prompt_tokens: n, completion_tokens: i, total_tokens: r, cost: o } = t;
    return b`
      <span class="cost-info" title="Tokens: ${n} + ${i} = ${r}">
        💰 $${o.toFixed(4)}
      </span>
    `;
  }
  static renderModelInfo(e) {
    return e.isUserMessage || !e.model ? "" : b`
      <span class="model-info" title="AI Model: ${e.model}">
        🤖 ${e.model}
      </span>
    `;
  }
  static renderUserInfo(e) {
    if (!e.isUserMessage)
      return "";
    let t = e.user;
    if (!t)
      try {
        const i = localStorage.getItem("jwt_user");
        i && (t = JSON.parse(i));
      } catch {
      }
    if (!t)
      return "";
    const n = t.name && t.last_name ? `${t.name} ${t.last_name}` : t.username;
    return b`
      <span class="user-info">
        ${n}
      </span>
    `;
  }
}
var Nl = Object.defineProperty, Xl = Object.getOwnPropertyDescriptor, G = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Xl(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && Nl(e, t, i), i;
};
let Ns = Xe, Y = class extends fe {
  constructor() {
    super(...arguments), this.chatThread = [], this.actionButtons = [], this.isDisabled = !1, this.isProcessingResponse = !1, this.isTyping = !1, this.showInitialMessagesReasoningClosed = !0, this.isFullscreen = !1, this.customConfig = {}, this.customHeaders = {}, this.isResponseCopied = !1, this.mini = !1, this.fullscreenEnabled = !0, this.isReasoningClosed = !1, this.injectCss = [], this.aiAssistantSignal = null, this.currentStreamingMessageId = null, this.isTalking = 0, this.upperLoader = !1, this.isUserScrolledUp = !1, this.autoTalkEnabled = !1, this.scrollTimeout = null, this.debounceScrollTimeout = null, this.streamingScrollTimeout = null, this.isProgrammaticScroll = !1, this.appChatSignal = null, this.showLoadingIndicator = !0, this.selectedCitation = void 0;
  }
  async connectedCallback() {
    super.connectedCallback(), await dn.bind(this)();
    for (const s of this.injectCss)
      await an.bind(this)(s);
    this.overrideConfig(), this.updateComplete.then(() => {
      this.setupScrollListener(), this.setupCitationClickListener();
    }), this.addEventListener("code-viewer:close-others", this.handleCloseOtherCodeViewers.bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeScrollListener(), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.debounceScrollTimeout && clearTimeout(this.debounceScrollTimeout), this.streamingScrollTimeout && clearTimeout(this.streamingScrollTimeout), this.removeEventListener("code-viewer:close-others", this.handleCloseOtherCodeViewers.bind(this));
  }
  setupScrollListener() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    if (s) {
      s.addEventListener("scroll", this.handleScroll.bind(this));
      const t = 10, n = s.scrollHeight - s.scrollTop - s.clientHeight < t;
      this.isUserScrolledUp = !n;
    }
  }
  removeScrollListener() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    s && s.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll(s) {
    const e = s.target, t = 10, n = e.scrollHeight - e.scrollTop - e.clientHeight < t;
    if (e.scrollHeight - e.scrollTop - e.clientHeight, this.isProgrammaticScroll) {
      this.isProgrammaticScroll = !1;
      return;
    }
    if (this.scrollTimeout && clearTimeout(this.scrollTimeout), this.isProcessingResponse) {
      this.isUserScrolledUp = !n;
      return;
    }
    this.scrollTimeout = setTimeout(() => {
      this.isUserScrolledUp = !n;
    }, 100);
  }
  overrideConfig() {
    this.customConfig && Object.keys(this.customConfig).length > 0 ? Ns = { ...Xe, ...this.customConfig } : Ns = Xe;
  }
  willUpdate(s) {
    if (super.willUpdate(s), s.has("customConfig") && this.overrideConfig(), s.has("chatThread") && this.chatThread.length) {
      const e = s.get("chatThread") || [];
      this.chatThread.length > e.length && !this.isProcessingResponse ? (this.isUserScrolledUp = !1, this.requestStreamingScroll(!0)) : this.requestStreamingScroll();
    }
    s.has("isProcessingResponse") && this.isProcessingResponse && this.requestStreamingScroll();
  }
  updated(s) {
    super.updated(s), s.has("chatThread") && this.requestStreamingScroll();
  }
  /**
   * Single method to handle all scrolling during streaming.
   * Debounces scroll requests and is immediately interruptible by user scroll up.
   */
  requestStreamingScroll(s = !1) {
    this.isUserScrolledUp && !s || (this.streamingScrollTimeout && clearTimeout(this.streamingScrollTimeout), this.streamingScrollTimeout = setTimeout(() => {
      (!this.isUserScrolledUp || s) && this.performActualScroll(), this.streamingScrollTimeout = null;
    }, 50));
  }
  performActualScroll() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    s && (this.isProgrammaticScroll = !0, s.scrollTop = s.scrollHeight);
  }
  scrollToBottom(s = !1) {
    this.requestStreamingScroll(s);
  }
  /**
   * Reset the scroll state to allow auto-scrolling again
   * Should be called when starting a new conversation turn (new user message)
   */
  resetScrollState() {
    this.isUserScrolledUp = !1, this.requestStreamingScroll(!0);
  }
  /**
   * Call this when a new user message is sent to reset auto-scroll behavior
   */
  onNewUserMessage() {
    this.isUserScrolledUp = !1;
  }
  /**
   * Ensure auto-scrolling is working properly for streaming
   */
  ensureAutoScroll() {
    this.requestStreamingScroll();
  }
  /**
   * Debug method to check scroll state - can be called from browser console
   */
  debugScrollState() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    if (s) {
      const n = s.scrollHeight - s.scrollTop - s.clientHeight < 10;
      return {
        isUserScrolledUp: this.isUserScrolledUp,
        isAtBottom: n,
        scrollHeight: s.scrollHeight,
        scrollTop: s.scrollTop,
        clientHeight: s.clientHeight,
        distanceFromBottom: s.scrollHeight - s.scrollTop - s.clientHeight,
        isProcessingResponse: this.isProcessingResponse
      };
    }
    return null;
  }
  /**
   * Force scroll to bottom regardless of user scroll state
   * Can be called when explicitly wanting to scroll to bottom
   */
  forceScrollToBottom() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    s && (this.isProgrammaticScroll = !0, s.scrollTop = s.scrollHeight);
  }
  /**
   * Clear all chat thread data and reset component state
   * Should be called when starting a new conversation
   */
  clearAllReasoning() {
    console.log("[clearAllReasoning]"), this.chatThread = [], this.isResponseCopied = !1, this.isReasoningClosed = !1, this.selectedCitation = void 0, this.isTalking = 0, this.upperLoader = !1, this.isUserScrolledUp = !1, this.isTyping = !1, this.scrollTimeout && (clearTimeout(this.scrollTimeout), this.scrollTimeout = null), this.debounceScrollTimeout && (clearTimeout(this.debounceScrollTimeout), this.debounceScrollTimeout = null), this.streamingScrollTimeout && (clearTimeout(this.streamingScrollTimeout), this.streamingScrollTimeout = null), this.requestUpdate();
  }
  // Copy response to clipboard
  async copyResponseToClipboard(s) {
    const e = Js(s), t = Va(s);
    try {
      const n = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; line-height: 1.6; }
h1, h2, h3, h4, h5, h6 { margin-top: 0; margin-bottom: 0.5em; }
p { margin: 0.5em 0; }
strong { font-weight: bold; }
em { font-style: italic; }
blockquote { margin: 1em 0; padding-left: 1em; border-left: 3px solid #ccc; }
pre { background: #f4f4f4; padding: 1em; border-radius: 4px; }
code { background: #f4f4f4; padding: 0.2em 0.4em; border-radius: 3px; }
a { color: #0066cc; text-decoration: underline; }
</style>
</head>
<body>
${t}
</body>
</html>`;
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": new Blob([e], { type: "text/plain" }),
          "text/html": new Blob([n], { type: "text/html" })
        })
      ]), this.isResponseCopied = !0;
    } catch {
      await navigator.clipboard.writeText(e), this.isResponseCopied = !0;
    }
  }
  actionButtonClicked(s, e, t) {
    t.preventDefault();
    const n = new CustomEvent("on-action-button-click", {
      detail: {
        id: s.id,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  handleCloseOtherCodeViewers(s) {
    var i;
    const t = s.detail.excludeId, n = (i = this.shadowRoot) == null ? void 0 : i.querySelectorAll("code-viewer");
    n == null || n.forEach((r) => {
      r.getAttribute("componentId") !== t && r.isCodeVisible && r.hideCode();
    });
  }
  setupCitationClickListener() {
    var e;
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__thread-container ul.chat__list");
    s && s.addEventListener("click", (t) => {
      const n = t.target;
      if (!n.matches("sup.citation"))
        return;
      const i = parseInt(n.textContent || "", 10);
      if (isNaN(i))
        return;
      const r = n.closest("li.chat__listItem");
      if (!r)
        return;
      const o = r.querySelector("citation-list");
      o && (o.highlight(i - 1), o.scrollIntoView({ behavior: "smooth", block: "nearest" }), setTimeout(() => {
        o.highlight(-1);
      }, 3e3));
    });
  }
  // debounce dispatching must-scroll event
  debounceScrollIntoView() {
    this.requestStreamingScroll();
  }
  handleFollowupQuestionClick(s, e, t) {
    t.preventDefault();
    const n = new CustomEvent("on-followup-click", {
      detail: {
        question: s,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  handleFullscreenToggle(s) {
    s.preventDefault();
    const e = new CustomEvent("on-fullscreen-toggle", {
      detail: {
        isFullscreen: !this.isFullscreen
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(e);
  }
  handleCitationClick(s, e, t) {
    t.preventDefault(), this.selectedCitation = s;
    const n = new CustomEvent("on-citation-click", {
      detail: {
        citation: s,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  async addToKDB(s) {
    var t, n;
    if (s.files && ((t = s.files) != null && t.length)) {
      this.addFileToKDB(s.files[0]);
      return;
    }
    const e = await this.detectTextFile(s);
    if (e) {
      this.addFileToKDB(e);
      return;
    }
    (n = this.aiAssistantSignal) == null || n.setValue({
      command: "add_file",
      payload: {
        title: "",
        content: s.text.map((i) => i.value).join(", "),
        contentType: "text"
      }
    });
  }
  async detectTextFile(s) {
    const e = s.text.map((r) => r.value).join(" "), t = /<gen-image[^>]+fileid="([^"]+)"[^>]*>/i, n = e.match(t);
    let i;
    if (!n || !n[1]) {
      const r = /<file-card[^>]+fileid="([^"]+)"[^>]*>/i, o = e.match(r);
      if (!o || !o[1])
        return null;
      i = o[1];
    } else
      i = n[1];
    try {
      const r = {
        Accept: "application/json",
        ...this.customHeaders
      }, o = await fetch(`/api/file/${i}`, {
        headers: r
      });
      return o.ok ? (await o.json()).data : null;
    } catch {
      return null;
    }
  }
  addFileToKDB(s) {
    var e;
    (e = this.aiAssistantSignal) == null || e.setValue({
      command: "add_file",
      payload: {
        title: s.originalName,
        content: "",
        contentType: "file",
        file: s
      }
    });
  }
  handleStopTalking() {
    this.dispatchEvent(new CustomEvent("chat:stop-talking", {
      bubbles: !0,
      composed: !0
    }));
  }
  renderPendingReasoning() {
    return "";
  }
  render() {
    return se.renderMainThread.bind(this)(Ns, this.isTalking, this.upperLoader);
  }
};
Y.styles = [yl];
G([
  T({ type: Array })
], Y.prototype, "chatThread", 2);
G([
  T({ type: Array })
], Y.prototype, "actionButtons", 2);
G([
  T({ type: Boolean })
], Y.prototype, "isDisabled", 2);
G([
  T({ type: Boolean })
], Y.prototype, "isProcessingResponse", 2);
G([
  T({ type: Boolean })
], Y.prototype, "isTyping", 2);
G([
  T({ type: Boolean })
], Y.prototype, "showInitialMessagesReasoningClosed", 2);
G([
  T({ type: String })
], Y.prototype, "conversationTitle", 2);
G([
  T({ type: String })
], Y.prototype, "conversationUid", 2);
G([
  T({ type: Boolean })
], Y.prototype, "isFullscreen", 2);
G([
  T({ type: Object })
], Y.prototype, "customConfig", 2);
G([
  T({ type: Object })
], Y.prototype, "customHeaders", 2);
G([
  O()
], Y.prototype, "isResponseCopied", 2);
G([
  O()
], Y.prototype, "mini", 2);
G([
  O()
], Y.prototype, "fullscreenEnabled", 2);
G([
  O()
], Y.prototype, "isReasoningClosed", 2);
G([
  O()
], Y.prototype, "injectCss", 2);
G([
  O()
], Y.prototype, "aiAssistantSignal", 2);
G([
  hn("#chat-list-footer")
], Y.prototype, "chatFooter", 2);
G([
  T({ type: String })
], Y.prototype, "currentStreamingMessageId", 2);
G([
  T({ type: Number })
], Y.prototype, "isTalking", 2);
G([
  T({ type: Boolean })
], Y.prototype, "upperLoader", 2);
G([
  O()
], Y.prototype, "isUserScrolledUp", 2);
G([
  O()
], Y.prototype, "autoTalkEnabled", 2);
G([
  O()
], Y.prototype, "appChatSignal", 2);
G([
  T({ type: Object })
], Y.prototype, "selectedCitation", 2);
Y = G([
  Pe("chat-thread-component")
], Y);
async function Rl({ question: s, type: e, approach: t, overrides: n, messages: i, files: r }, { method: o, url: a, stream: l, signal: u, headers: h = {} }) {
  const g = {
    ...{
      "Content-Type": "application/json"
    },
    ...h
  };
  let y = i ?? [];
  if ((s || r) && (!i || i.length === 0)) {
    const f = {
      role: "user"
    }, x = [];
    s && s.trim() && x.push({
      type: "text",
      text: s
    }), r && r.length > 0 && r.forEach((P) => {
      x.push({
        type: "image",
        image: `data:${P.mimeType};base64,${P.base64}`
      });
    }), x.length > 1 || x.length === 1 && x[0].type !== "text" ? f.content = x : x.length === 1 && x[0].type === "text" ? f.content = x[0].text : f.content = "", y = [f];
  }
  return console.log({ mergedHeaders: g }), await fetch(`${a}/${e}`, {
    method: o,
    headers: g,
    signal: u,
    body: JSON.stringify({
      messages: y,
      context: {
        ...n,
        approach: t
      },
      stream: e === "chat" ? l : !1
    })
  });
}
async function Il(s, e) {
  const t = await Rl(s, e);
  if (s.type === "ask" ? !1 : e.stream)
    return t;
  const i = await t.json();
  if (t.status > 299 || !t.ok)
    throw new dt(t.statusText, t.status) || "API Response Error";
  return i;
}
const Ie = /* @__PURE__ */ Object.create(null);
Ie.open = "0";
Ie.close = "1";
Ie.ping = "2";
Ie.pong = "3";
Ie.message = "4";
Ie.upgrade = "5";
Ie.noop = "6";
const jn = /* @__PURE__ */ Object.create(null);
Object.keys(Ie).forEach((s) => {
  jn[Ie[s]] = s;
});
const $s = { type: "error", data: "parser error" }, Jr = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", Kr = typeof ArrayBuffer == "function", _r = (s) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(s) : s && s.buffer instanceof ArrayBuffer, di = ({ type: s, data: e }, t, n) => Jr && e instanceof Blob ? t ? n(e) : Er(e, n) : Kr && (e instanceof ArrayBuffer || _r(e)) ? t ? n(e) : Er(new Blob([e]), n) : n(Ie[s] + (e || "")), Er = (s, e) => {
  const t = new FileReader();
  return t.onload = function() {
    const n = t.result.split(",")[1];
    e("b" + (n || ""));
  }, t.readAsDataURL(s);
};
function kr(s) {
  return s instanceof Uint8Array ? s : s instanceof ArrayBuffer ? new Uint8Array(s) : new Uint8Array(s.buffer, s.byteOffset, s.byteLength);
}
let Xs;
function Bl(s, e) {
  if (Jr && s.data instanceof Blob)
    return s.data.arrayBuffer().then(kr).then(e);
  if (Kr && (s.data instanceof ArrayBuffer || _r(s.data)))
    return e(kr(s.data));
  di(s, !1, (t) => {
    Xs || (Xs = new TextEncoder()), e(Xs.encode(t));
  });
}
const Cr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $t = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let s = 0; s < Cr.length; s++)
  $t[Cr.charCodeAt(s)] = s;
const Wl = (s) => {
  let e = s.length * 0.75, t = s.length, n, i = 0, r, o, a, l;
  s[s.length - 1] === "=" && (e--, s[s.length - 2] === "=" && e--);
  const u = new ArrayBuffer(e), h = new Uint8Array(u);
  for (n = 0; n < t; n += 4)
    r = $t[s.charCodeAt(n)], o = $t[s.charCodeAt(n + 1)], a = $t[s.charCodeAt(n + 2)], l = $t[s.charCodeAt(n + 3)], h[i++] = r << 2 | o >> 4, h[i++] = (o & 15) << 4 | a >> 2, h[i++] = (a & 3) << 6 | l & 63;
  return u;
}, Vl = typeof ArrayBuffer == "function", pi = (s, e) => {
  if (typeof s != "string")
    return {
      type: "message",
      data: $r(s, e)
    };
  const t = s.charAt(0);
  return t === "b" ? {
    type: "message",
    data: Yl(s.substring(1), e)
  } : jn[t] ? s.length > 1 ? {
    type: jn[t],
    data: s.substring(1)
  } : {
    type: jn[t]
  } : $s;
}, Yl = (s, e) => {
  if (Vl) {
    const t = Wl(s);
    return $r(t, e);
  } else
    return { base64: !0, data: s };
}, $r = (s, e) => {
  switch (e) {
    case "blob":
      return s instanceof Blob ? s : new Blob([s]);
    case "arraybuffer":
    default:
      return s instanceof ArrayBuffer ? s : s.buffer;
  }
}, eo = String.fromCharCode(30), ql = (s, e) => {
  const t = s.length, n = new Array(t);
  let i = 0;
  s.forEach((r, o) => {
    di(r, !1, (a) => {
      n[o] = a, ++i === t && e(n.join(eo));
    });
  });
}, Gl = (s, e) => {
  const t = s.split(eo), n = [];
  for (let i = 0; i < t.length; i++) {
    const r = pi(t[i], e);
    if (n.push(r), r.type === "error")
      break;
  }
  return n;
};
function Ul() {
  return new TransformStream({
    transform(s, e) {
      Bl(s, (t) => {
        const n = t.length;
        let i;
        if (n < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, n);
        else if (n < 65536) {
          i = new Uint8Array(3);
          const r = new DataView(i.buffer);
          r.setUint8(0, 126), r.setUint16(1, n);
        } else {
          i = new Uint8Array(9);
          const r = new DataView(i.buffer);
          r.setUint8(0, 127), r.setBigUint64(1, BigInt(n));
        }
        s.data && typeof s.data != "string" && (i[0] |= 128), e.enqueue(i), e.enqueue(t);
      });
    }
  });
}
let Rs;
function Hn(s) {
  return s.reduce((e, t) => e + t.length, 0);
}
function Sn(s, e) {
  if (s[0].length === e)
    return s.shift();
  const t = new Uint8Array(e);
  let n = 0;
  for (let i = 0; i < e; i++)
    t[i] = s[0][n++], n === s[0].length && (s.shift(), n = 0);
  return s.length && n < s[0].length && (s[0] = s[0].slice(n)), t;
}
function Zl(s, e) {
  Rs || (Rs = new TextDecoder());
  const t = [];
  let n = 0, i = -1, r = !1;
  return new TransformStream({
    transform(o, a) {
      for (t.push(o); ; ) {
        if (n === 0) {
          if (Hn(t) < 1)
            break;
          const l = Sn(t, 1);
          r = (l[0] & 128) === 128, i = l[0] & 127, i < 126 ? n = 3 : i === 126 ? n = 1 : n = 2;
        } else if (n === 1) {
          if (Hn(t) < 2)
            break;
          const l = Sn(t, 2);
          i = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), n = 3;
        } else if (n === 2) {
          if (Hn(t) < 8)
            break;
          const l = Sn(t, 8), u = new DataView(l.buffer, l.byteOffset, l.length), h = u.getUint32(0);
          if (h > Math.pow(2, 53 - 32) - 1) {
            a.enqueue($s);
            break;
          }
          i = h * Math.pow(2, 32) + u.getUint32(4), n = 3;
        } else {
          if (Hn(t) < i)
            break;
          const l = Sn(t, i);
          a.enqueue(pi(r ? l : Rs.decode(l), e)), n = 0;
        }
        if (i === 0 || i > s) {
          a.enqueue($s);
          break;
        }
      }
    }
  });
}
const to = 4;
function te(s) {
  if (s)
    return Ql(s);
}
function Ql(s) {
  for (var e in te.prototype)
    s[e] = te.prototype[e];
  return s;
}
te.prototype.on = te.prototype.addEventListener = function(s, e) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + s] = this._callbacks["$" + s] || []).push(e), this;
};
te.prototype.once = function(s, e) {
  function t() {
    this.off(s, t), e.apply(this, arguments);
  }
  return t.fn = e, this.on(s, t), this;
};
te.prototype.off = te.prototype.removeListener = te.prototype.removeAllListeners = te.prototype.removeEventListener = function(s, e) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var t = this._callbacks["$" + s];
  if (!t)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + s], this;
  for (var n, i = 0; i < t.length; i++)
    if (n = t[i], n === e || n.fn === e) {
      t.splice(i, 1);
      break;
    }
  return t.length === 0 && delete this._callbacks["$" + s], this;
};
te.prototype.emit = function(s) {
  this._callbacks = this._callbacks || {};
  for (var e = new Array(arguments.length - 1), t = this._callbacks["$" + s], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  if (t) {
    t = t.slice(0);
    for (var n = 0, i = t.length; n < i; ++n)
      t[n].apply(this, e);
  }
  return this;
};
te.prototype.emitReserved = te.prototype.emit;
te.prototype.listeners = function(s) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + s] || [];
};
te.prototype.hasListeners = function(s) {
  return !!this.listeners(s).length;
};
const ss = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, t) => t(e, 0))(), Ce = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())(), Jl = "arraybuffer";
function no(s, ...e) {
  return e.reduce((t, n) => (s.hasOwnProperty(n) && (t[n] = s[n]), t), {});
}
const Kl = Ce.setTimeout, _l = Ce.clearTimeout;
function is(s, e) {
  e.useNativeTimers ? (s.setTimeoutFn = Kl.bind(Ce), s.clearTimeoutFn = _l.bind(Ce)) : (s.setTimeoutFn = Ce.setTimeout.bind(Ce), s.clearTimeoutFn = Ce.clearTimeout.bind(Ce));
}
const $l = 1.33;
function ec(s) {
  return typeof s == "string" ? tc(s) : Math.ceil((s.byteLength || s.size) * $l);
}
function tc(s) {
  let e = 0, t = 0;
  for (let n = 0, i = s.length; n < i; n++)
    e = s.charCodeAt(n), e < 128 ? t += 1 : e < 2048 ? t += 2 : e < 55296 || e >= 57344 ? t += 3 : (n++, t += 4);
  return t;
}
function so() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function nc(s) {
  let e = "";
  for (let t in s)
    s.hasOwnProperty(t) && (e.length && (e += "&"), e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]));
  return e;
}
function sc(s) {
  let e = {}, t = s.split("&");
  for (let n = 0, i = t.length; n < i; n++) {
    let r = t[n].split("=");
    e[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
  }
  return e;
}
class ic extends Error {
  constructor(e, t, n) {
    super(e), this.description = t, this.context = n, this.type = "TransportError";
  }
}
class fi extends te {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(e) {
    super(), this.writable = !1, is(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(e, t, n) {
    return super.emitReserved("error", new ic(e, t, n)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(e) {
    this.readyState === "open" && this.write(e);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(e) {
    const t = pi(e, this.socket.binaryType);
    this.onPacket(t);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(e) {
    super.emitReserved("packet", e);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(e) {
    this.readyState = "closed", super.emitReserved("close", e);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(e) {
  }
  createUri(e, t = {}) {
    return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
  }
  _hostname() {
    const e = this.opts.hostname;
    return e.indexOf(":") === -1 ? e : "[" + e + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(e) {
    const t = nc(e);
    return t.length ? "?" + t : "";
  }
}
class rc extends fi {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(e) {
    this.readyState = "pausing";
    const t = () => {
      this.readyState = "paused", e();
    };
    if (this._polling || !this.writable) {
      let n = 0;
      this._polling && (n++, this.once("pollComplete", function() {
        --n || t();
      })), this.writable || (n++, this.once("drain", function() {
        --n || t();
      }));
    } else
      t();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(e) {
    const t = (n) => {
      if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(n);
    };
    Gl(e, this.socket.binaryType).forEach(t), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const e = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? e() : this.once("open", e);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(e) {
    this.writable = !1, ql(e, (t) => {
      this.doWrite(t, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "https" : "http", t = this.query || {};
    return this.opts.timestampRequests !== !1 && (t[this.opts.timestampParam] = so()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.createUri(e, t);
  }
}
let io = !1;
try {
  io = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const oc = io;
function ac() {
}
class lc extends rc {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(e) {
    if (super(e), typeof location < "u") {
      const t = location.protocol === "https:";
      let n = location.port;
      n || (n = t ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data - data to send.
   * @param {Function} fn - called upon flush.
   * @private
   */
  doWrite(e, t) {
    const n = this.request({
      method: "POST",
      data: e
    });
    n.on("success", t), n.on("error", (i, r) => {
      this.onError("xhr post error", i, r);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const e = this.request();
    e.on("data", this.onData.bind(this)), e.on("error", (t, n) => {
      this.onError("xhr poll error", t, n);
    }), this.pollXhr = e;
  }
}
class Re extends te {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(e, t, n) {
    super(), this.createRequest = e, is(this, n), this._opts = n, this._method = n.method || "GET", this._uri = t, this._data = n.data !== void 0 ? n.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var e;
    const t = no(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    t.xdomain = !!this._opts.xd;
    const n = this._xhr = this.createRequest(t);
    try {
      n.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let i in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(i) && n.setRequestHeader(i, this._opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = () => {
        var i;
        n.readyState === 3 && ((i = this._opts.cookieJar) === null || i === void 0 || i.parseCookies(
          // @ts-ignore
          n.getResponseHeader("set-cookie")
        )), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this._data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this._onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Re.requestsCount++, Re.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(e) {
    this.emitReserved("error", e, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(e) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = ac, e)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Re.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const e = this._xhr.responseText;
    e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Re.requestsCount = 0;
Re.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", Pr);
  else if (typeof addEventListener == "function") {
    const s = "onpagehide" in Ce ? "pagehide" : "unload";
    addEventListener(s, Pr, !1);
  }
}
function Pr() {
  for (let s in Re.requests)
    Re.requests.hasOwnProperty(s) && Re.requests[s].abort();
}
const cc = function() {
  const s = ro({
    xdomain: !1
  });
  return s && s.responseType !== null;
}();
class uc extends lc {
  constructor(e) {
    super(e);
    const t = e && e.forceBase64;
    this.supportsBinary = cc && !t;
  }
  request(e = {}) {
    return Object.assign(e, { xd: this.xd }, this.opts), new Re(ro, this.uri(), e);
  }
}
function ro(s) {
  const e = s.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!e || oc))
      return new XMLHttpRequest();
  } catch {
  }
  if (!e)
    try {
      return new Ce[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const oo = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class hc extends fi {
  get name() {
    return "websocket";
  }
  doOpen() {
    const e = this.uri(), t = this.opts.protocols, n = oo ? {} : no(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(e, t, n);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (e) => this.onClose({
      description: "websocket connection closed",
      context: e
    }), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(e) {
    this.writable = !1;
    for (let t = 0; t < e.length; t++) {
      const n = e[t], i = t === e.length - 1;
      di(n, this.supportsBinary, (r) => {
        try {
          this.doWrite(n, r);
        } catch {
        }
        i && ss(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "wss" : "ws", t = this.query || {};
    return this.opts.timestampRequests && (t[this.opts.timestampParam] = so()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
  }
}
const Is = Ce.WebSocket || Ce.MozWebSocket;
class dc extends hc {
  createSocket(e, t, n) {
    return oo ? new Is(e, t, n) : t ? new Is(e, t) : new Is(e);
  }
  doWrite(e, t) {
    this.ws.send(t);
  }
}
class pc extends fi {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (e) {
      return this.emitReserved("error", e);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((e) => {
      this.onError("webtransport error", e);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((e) => {
        const t = Zl(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = e.readable.pipeThrough(t).getReader(), i = Ul();
        i.readable.pipeTo(e.writable), this._writer = i.writable.getWriter();
        const r = () => {
          n.read().then(({ done: a, value: l }) => {
            a || (this.onPacket(l), r());
          }).catch((a) => {
          });
        };
        r();
        const o = { type: "open" };
        this.query.sid && (o.data = `{"sid":"${this.query.sid}"}`), this._writer.write(o).then(() => this.onOpen());
      });
    });
  }
  write(e) {
    this.writable = !1;
    for (let t = 0; t < e.length; t++) {
      const n = e[t], i = t === e.length - 1;
      this._writer.write(n).then(() => {
        i && ss(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var e;
    (e = this._transport) === null || e === void 0 || e.close();
  }
}
const fc = {
  websocket: dc,
  webtransport: pc,
  polling: uc
}, gc = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, mc = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function ei(s) {
  if (s.length > 8e3)
    throw "URI too long";
  const e = s, t = s.indexOf("["), n = s.indexOf("]");
  t != -1 && n != -1 && (s = s.substring(0, t) + s.substring(t, n).replace(/:/g, ";") + s.substring(n, s.length));
  let i = gc.exec(s || ""), r = {}, o = 14;
  for (; o--; )
    r[mc[o]] = i[o] || "";
  return t != -1 && n != -1 && (r.source = e, r.host = r.host.substring(1, r.host.length - 1).replace(/;/g, ":"), r.authority = r.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), r.ipv6uri = !0), r.pathNames = bc(r, r.path), r.queryKey = vc(r, r.query), r;
}
function bc(s, e) {
  const t = /\/{2,9}/g, n = e.replace(t, "/").split("/");
  return (e.slice(0, 1) == "/" || e.length === 0) && n.splice(0, 1), e.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function vc(s, e) {
  const t = {};
  return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, i, r) {
    i && (t[i] = r);
  }), t;
}
const ti = typeof addEventListener == "function" && typeof removeEventListener == "function", Nn = [];
ti && addEventListener("offline", () => {
  Nn.forEach((s) => s());
}, !1);
let ao = class At extends te {
  constructor(e, t = {}) {
    var n, i;
    if (super(), this.binaryType = Jl, this.writeBuffer = [], this._prevBufferLen = 0, this._upgrades = [], this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (t = e, e = null), e) {
      const r = ei(e);
      t.hostname = r.host, t.secure = r.protocol === "https" || r.protocol === "wss", t.port = r.port, r.query && (t.query = r.query);
    } else
      t.host && (t.hostname = ei(t.host).host);
    if (is(this, t), this.secure = t.secure != null ? t.secure : typeof location < "u" && location.protocol === "https:", t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), t.transportImplementations && t.transports)
      throw new Error("specifying both 'transportImplementations' and 'transports' options is not supported");
    t.transportImplementations || !((n = t.transports) === null || n === void 0) && n.length && typeof t.transports[0] == "function" ? (this.transports = [], this._transportsByName = /* @__PURE__ */ Object.create(null), ((i = t.transportImplementations) !== null && i !== void 0 ? i : t.transports).forEach((r) => {
      const o = r.prototype.name;
      this.transports.push(o), this._transportsByName[o] = r;
    })) : (this.transports = t.transports ? [...t.transports] : ["polling", "websocket", "webtransport"], this._transportsByName = fc), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = sc(this.opts.query)), ti && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, Nn.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(e) {
    const t = Object.assign({}, this.opts.query);
    t.EIO = to, t.transport = e, this.id && (t.sid = this.id);
    const n = Object.assign({}, this.opts, {
      query: t,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[e]);
    return new this._transportsByName[e](n);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const e = this.opts.rememberUpgrade && At.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const t = this.createTransport(e);
    t.open(), this.setTransport(t);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(e) {
    this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (t) => this._onClose("transport close", t));
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(e) {
    let t = this.createTransport(e), n = !1;
    At.priorWebsocketSuccess = !1;
    const i = () => {
      n || (t.send([{ type: "ping", data: "probe" }]), t.once("packet", (p) => {
        if (!n)
          if (p.type === "pong" && p.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", t), !t)
              return;
            At.priorWebsocketSuccess = t.name === "websocket", this.transport.pause(() => {
              n || this.readyState !== "closed" && (h(), this.setTransport(t), t.send([{ type: "upgrade" }]), this.emitReserved("upgrade", t), t = null, this.upgrading = !1, this.flush());
            });
          } else {
            const g = new Error("probe error");
            g.transport = t.name, this.emitReserved("upgradeError", g);
          }
      }));
    };
    function r() {
      n || (n = !0, h(), t.close(), t = null);
    }
    const o = (p) => {
      const g = new Error("probe error: " + p);
      g.transport = t.name, r(), this.emitReserved("upgradeError", g);
    };
    function a() {
      o("transport closed");
    }
    function l() {
      o("socket closed");
    }
    function u(p) {
      t && p.name !== t.name && r();
    }
    const h = () => {
      t.removeListener("open", i), t.removeListener("error", o), t.removeListener("close", a), this.off("close", l), this.off("upgrading", u);
    };
    t.once("open", i), t.once("error", o), t.once("close", a), this.once("close", l), this.once("upgrading", u), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(() => {
      n || t.open();
    }, 200) : t.open();
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    if (this.readyState = "open", At.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade)
      for (let e = 0; e < this._upgrades.length; e++)
        this._probe(this._upgrades[e]);
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(e) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const t = new Error("server error");
          t.code = e.data, this._onError(t);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(e) {
    this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._upgrades = this._filterUpgrades(e.upgrades), this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const e = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const e = this._getWritablePackets();
      this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let t = 1;
    for (let n = 0; n < this.writeBuffer.length; n++) {
      const i = this.writeBuffer[n].data;
      if (i && (t += ec(i)), n > 0 && t > this._maxPayload)
        return this.writeBuffer.slice(0, n);
      t += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const e = Date.now() > this._pingTimeoutTime;
    return e && (this._pingTimeoutTime = 0, ss(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), e;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(e, t, n) {
    return this._sendPacket("message", e, t, n), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(e, t, n) {
    return this._sendPacket("message", e, t, n), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type - packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(e, t, n, i) {
    if (typeof t == "function" && (i = t, t = void 0), typeof n == "function" && (i = n, n = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    n = n || {}, n.compress = n.compress !== !1;
    const r = {
      type: e,
      data: t,
      options: n
    };
    this.emitReserved("packetCreate", r), this.writeBuffer.push(r), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const e = () => {
      this._onClose("forced close"), this.transport.close();
    }, t = () => {
      this.off("upgrade", t), this.off("upgradeError", t), e();
    }, n = () => {
      this.once("upgrade", t), this.once("upgradeError", t);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? n() : e();
    }) : this.upgrading ? n() : e()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(e) {
    if (At.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", e), this._onClose("transport error", e);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(e, t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), ti && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const n = Nn.indexOf(this._offlineEventListener);
        n !== -1 && Nn.splice(n, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(e) {
    const t = [];
    for (let n = 0; n < e.length; n++)
      ~this.transports.indexOf(e[n]) && t.push(e[n]);
    return t;
  }
};
ao.protocol = to;
function yc(s, e = "", t) {
  let n = s;
  t = t || typeof location < "u" && location, s == null && (s = t.protocol + "//" + t.host), typeof s == "string" && (s.charAt(0) === "/" && (s.charAt(1) === "/" ? s = t.protocol + s : s = t.host + s), /^(https?|wss?):\/\//.test(s) || (typeof t < "u" ? s = t.protocol + "//" + s : s = "https://" + s), n = ei(s)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  const r = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + r + ":" + n.port + e, n.href = n.protocol + "://" + r + (t && t.port === n.port ? "" : ":" + n.port), n;
}
const wc = typeof ArrayBuffer == "function", xc = (s) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(s) : s.buffer instanceof ArrayBuffer, lo = Object.prototype.toString, Tc = typeof Blob == "function" || typeof Blob < "u" && lo.call(Blob) === "[object BlobConstructor]", Ec = typeof File == "function" || typeof File < "u" && lo.call(File) === "[object FileConstructor]";
function gi(s) {
  return wc && (s instanceof ArrayBuffer || xc(s)) || Tc && s instanceof Blob || Ec && s instanceof File;
}
function Xn(s, e) {
  if (!s || typeof s != "object")
    return !1;
  if (Array.isArray(s)) {
    for (let t = 0, n = s.length; t < n; t++)
      if (Xn(s[t]))
        return !0;
    return !1;
  }
  if (gi(s))
    return !0;
  if (s.toJSON && typeof s.toJSON == "function" && arguments.length === 1)
    return Xn(s.toJSON(), !0);
  for (const t in s)
    if (Object.prototype.hasOwnProperty.call(s, t) && Xn(s[t]))
      return !0;
  return !1;
}
function kc(s) {
  const e = [], t = s.data, n = s;
  return n.data = Rn(t, e), n.attachments = e.length, { packet: n, buffers: e };
}
function Rn(s, e, t) {
  if (!s)
    return s;
  if (gi(s)) {
    const n = { _placeholder: !0, num: e.length };
    return e.push(s), n;
  } else if (Array.isArray(s)) {
    const n = new Array(s.length);
    for (let i = 0; i < s.length; i++)
      n[i] = Rn(s[i], e);
    return n;
  } else if (typeof s == "object" && !(s instanceof Date)) {
    if (s.toJSON && typeof s.toJSON == "function" && !t)
      return Rn(s.toJSON(), e, !0);
    const n = {};
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && (n[i] = Rn(s[i], e));
    return n;
  }
  return s;
}
function Cc(s, e) {
  return s.data = ni(s.data, e), delete s.attachments, s;
}
function ni(s, e) {
  if (!s)
    return s;
  if (s && s._placeholder === !0) {
    if (typeof s.num == "number" && s.num >= 0 && s.num < e.length)
      return e[s.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(s))
    for (let t = 0; t < s.length; t++)
      s[t] = ni(s[t], e);
  else if (typeof s == "object")
    for (const t in s)
      Object.prototype.hasOwnProperty.call(s, t) && (s[t] = ni(s[t], e));
  return s;
}
const co = [
  "connect",
  // used on the client side
  "connect_error",
  // used on the client side
  "disconnect",
  // used on both sides
  "disconnecting",
  // used on the server side
  "newListener",
  // used by the Node.js EventEmitter
  "removeListener"
  // used by the Node.js EventEmitter
], Pc = 5;
var H;
(function(s) {
  s[s.CONNECT = 0] = "CONNECT", s[s.DISCONNECT = 1] = "DISCONNECT", s[s.EVENT = 2] = "EVENT", s[s.ACK = 3] = "ACK", s[s.CONNECT_ERROR = 4] = "CONNECT_ERROR", s[s.BINARY_EVENT = 5] = "BINARY_EVENT", s[s.BINARY_ACK = 6] = "BINARY_ACK";
})(H || (H = {}));
class zc {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(e) {
    this.replacer = e;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(e) {
    return (e.type === H.EVENT || e.type === H.ACK) && Xn(e) ? this.encodeAsBinary({
      type: e.type === H.EVENT ? H.BINARY_EVENT : H.BINARY_ACK,
      nsp: e.nsp,
      data: e.data,
      id: e.id
    }) : [this.encodeAsString(e)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(e) {
    let t = "" + e.type;
    return (e.type === H.BINARY_EVENT || e.type === H.BINARY_ACK) && (t += e.attachments + "-"), e.nsp && e.nsp !== "/" && (t += e.nsp + ","), e.id != null && (t += e.id), e.data != null && (t += JSON.stringify(e.data, this.replacer)), t;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(e) {
    const t = kc(e), n = this.encodeAsString(t.packet), i = t.buffers;
    return i.unshift(n), i;
  }
}
class mi extends te {
  /**
   * Decoder constructor
   */
  constructor(e) {
    super(), this.opts = Object.assign({
      reviver: void 0,
      maxAttachments: 10
    }, typeof e == "function" ? { reviver: e } : e);
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(e) {
    let t;
    if (typeof e == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      t = this.decodeString(e);
      const n = t.type === H.BINARY_EVENT;
      n || t.type === H.BINARY_ACK ? (t.type = n ? H.EVENT : H.ACK, this.reconstructor = new Lc(t)) : super.emitReserved("decoded", t);
    } else if (gi(e) || e.base64)
      if (this.reconstructor)
        t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + e);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(e) {
    let t = 0;
    const n = {
      type: Number(e.charAt(0))
    };
    if (H[n.type] === void 0)
      throw new Error("unknown packet type " + n.type);
    if (n.type === H.BINARY_EVENT || n.type === H.BINARY_ACK) {
      const r = t + 1;
      for (; e.charAt(++t) !== "-" && t != e.length; )
        ;
      const o = e.substring(r, t);
      if (o != Number(o) || e.charAt(t) !== "-")
        throw new Error("Illegal attachments");
      const a = Number(o);
      if (!uo(a) || a < 1)
        throw new Error("Illegal attachments");
      if (a > this.opts.maxAttachments)
        throw new Error("too many attachments");
      n.attachments = a;
    }
    if (e.charAt(t + 1) === "/") {
      const r = t + 1;
      for (; ++t && !(e.charAt(t) === "," || t === e.length); )
        ;
      n.nsp = e.substring(r, t);
    } else
      n.nsp = "/";
    const i = e.charAt(t + 1);
    if (i !== "" && Number(i) == i) {
      const r = t + 1;
      for (; ++t; ) {
        const o = e.charAt(t);
        if (o == null || Number(o) != o) {
          --t;
          break;
        }
        if (t === e.length)
          break;
      }
      n.id = Number(e.substring(r, t + 1));
    }
    if (e.charAt(++t)) {
      const r = this.tryParse(e.substr(t));
      if (mi.isPayloadValid(n.type, r))
        n.data = r;
      else
        throw new Error("invalid payload");
    }
    return n;
  }
  tryParse(e) {
    try {
      return JSON.parse(e, this.opts.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(e, t) {
    switch (e) {
      case H.CONNECT:
        return Zn(t);
      case H.DISCONNECT:
        return t === void 0;
      case H.CONNECT_ERROR:
        return typeof t == "string" || Zn(t);
      case H.EVENT:
      case H.BINARY_EVENT:
        return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && co.indexOf(t[0]) === -1);
      case H.ACK:
      case H.BINARY_ACK:
        return Array.isArray(t);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class Lc {
  constructor(e) {
    this.packet = e, this.buffers = [], this.reconPack = e;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(e) {
    if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
      const t = Cc(this.reconPack, this.buffers);
      return this.finishedReconstruction(), t;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
function Ac(s) {
  return typeof s == "string";
}
const uo = Number.isInteger || function(s) {
  return typeof s == "number" && isFinite(s) && Math.floor(s) === s;
};
function Oc(s) {
  return s === void 0 || uo(s);
}
function Zn(s) {
  return Object.prototype.toString.call(s) === "[object Object]";
}
function Dc(s, e) {
  switch (s) {
    case H.CONNECT:
      return e === void 0 || Zn(e);
    case H.DISCONNECT:
      return e === void 0;
    case H.EVENT:
      return Array.isArray(e) && (typeof e[0] == "number" || typeof e[0] == "string" && co.indexOf(e[0]) === -1);
    case H.ACK:
      return Array.isArray(e);
    case H.CONNECT_ERROR:
      return typeof e == "string" || Zn(e);
    default:
      return !1;
  }
}
function Hc(s) {
  return Ac(s.nsp) && Oc(s.id) && Dc(s.type, s.data);
}
const Sc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: mi,
  Encoder: zc,
  get PacketType() {
    return H;
  },
  isPacketValid: Hc,
  protocol: Pc
}, Symbol.toStringTag, { value: "Module" }));
function Ae(s, e, t) {
  return s.on(e, t), function() {
    s.off(e, t);
  };
}
const Mc = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class ho extends te {
  /**
   * `Socket` constructor.
   */
  constructor(e, t, n) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const e = this.io;
    this.subs = [
      Ae(e, "open", this.onopen.bind(this)),
      Ae(e, "packet", this.onpacket.bind(this)),
      Ae(e, "error", this.onerror.bind(this)),
      Ae(e, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...e) {
    return e.unshift("message"), this.emit.apply(this, e), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(e, ...t) {
    var n, i, r;
    if (Mc.hasOwnProperty(e))
      throw new Error('"' + e.toString() + '" is a reserved event name');
    if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(t), this;
    const o = {
      type: H.EVENT,
      data: t
    };
    if (o.options = {}, o.options.compress = this.flags.compress !== !1, typeof t[t.length - 1] == "function") {
      const h = this.ids++, p = t.pop();
      this._registerAckCallback(h, p), o.id = h;
    }
    const a = (i = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || i === void 0 ? void 0 : i.writable, l = this.connected && !(!((r = this.io.engine) === null || r === void 0) && r._hasPingExpired());
    return this.flags.volatile && !a || (l ? (this.notifyOutgoingListeners(o), this.packet(o)) : this.sendBuffer.push(o)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(e, t) {
    var n;
    const i = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[e] = t;
      return;
    }
    const r = this.io.setTimeoutFn(() => {
      delete this.acks[e];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === e && this.sendBuffer.splice(a, 1);
      t.call(this, new Error("operation has timed out"));
    }, i), o = (...a) => {
      this.io.clearTimeoutFn(r), t.apply(this, a);
    };
    o.withError = !0, this.acks[e] = o;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(e, ...t) {
    return new Promise((n, i) => {
      const r = (o, a) => o ? i(o) : n(a);
      r.withError = !0, t.push(r), this.emit(e, ...t);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(e) {
    let t;
    typeof e[e.length - 1] == "function" && (t = e.pop());
    const n = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: e,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    e.push((i, ...r) => (this._queue[0], i !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), t && t(i)) : (this._queue.shift(), t && t(null, ...r)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(e = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const t = this._queue[0];
    t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(e) {
    e.nsp = this.nsp, this.io._packet(e);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((e) => {
      this._sendConnectPacket(e);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(e) {
    this.packet({
      type: H.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, e) : e
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(e) {
    this.connected || this.emitReserved("connect_error", e);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(e, t) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((e) => {
      if (!this.sendBuffer.some((n) => String(n.id) === e)) {
        const n = this.acks[e];
        delete this.acks[e], n.withError && n.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(e) {
    if (e.nsp === this.nsp)
      switch (e.type) {
        case H.CONNECT:
          e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case H.EVENT:
        case H.BINARY_EVENT:
          this.onevent(e);
          break;
        case H.ACK:
        case H.BINARY_ACK:
          this.onack(e);
          break;
        case H.DISCONNECT:
          this.ondisconnect();
          break;
        case H.CONNECT_ERROR:
          this.destroy();
          const n = new Error(e.data.message);
          n.data = e.data.data, this.emitReserved("connect_error", n);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(e) {
    const t = e.data || [];
    e.id != null && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
  }
  emitEvent(e) {
    if (this._anyListeners && this._anyListeners.length) {
      const t = this._anyListeners.slice();
      for (const n of t)
        n.apply(this, e);
    }
    super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(e) {
    const t = this;
    let n = !1;
    return function(...i) {
      n || (n = !0, t.packet({
        type: H.ACK,
        id: e,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(e) {
    const t = this.acks[e.id];
    typeof t == "function" && (delete this.acks[e.id], t.withError && e.data.unshift(null), t.apply(this, e.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(e, t) {
    this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this._drainQueue(!0), this.emitReserved("connect");
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
      this.notifyOutgoingListeners(e), this.packet(e);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((e) => e()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: H.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(e) {
    return this.flags.compress = e, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(e) {
    return this.flags.timeout = e, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(e) {
    if (!this._anyListeners)
      return this;
    if (e) {
      const t = this._anyListeners;
      for (let n = 0; n < t.length; n++)
        if (e === t[n])
          return t.splice(n, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(e) {
    if (!this._anyOutgoingListeners)
      return this;
    if (e) {
      const t = this._anyOutgoingListeners;
      for (let n = 0; n < t.length; n++)
        if (e === t[n])
          return t.splice(n, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(e) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const t = this._anyOutgoingListeners.slice();
      for (const n of t)
        n.apply(this, e.data);
    }
  }
}
function Xt(s) {
  s = s || {}, this.ms = s.min || 100, this.max = s.max || 1e4, this.factor = s.factor || 2, this.jitter = s.jitter > 0 && s.jitter <= 1 ? s.jitter : 0, this.attempts = 0;
}
Xt.prototype.duration = function() {
  var s = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var e = Math.random(), t = Math.floor(e * this.jitter * s);
    s = Math.floor(e * 10) & 1 ? s + t : s - t;
  }
  return Math.min(s, this.max) | 0;
};
Xt.prototype.reset = function() {
  this.attempts = 0;
};
Xt.prototype.setMin = function(s) {
  this.ms = s;
};
Xt.prototype.setMax = function(s) {
  this.max = s;
};
Xt.prototype.setJitter = function(s) {
  this.jitter = s;
};
class si extends te {
  constructor(e, t) {
    var n;
    super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (t = e, e = void 0), t = t || {}, t.path = t.path || "/socket.io", this.opts = t, is(this, t), this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor((n = t.randomizationFactor) !== null && n !== void 0 ? n : 0.5), this.backoff = new Xt({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(t.timeout == null ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
    const i = t.parser || Sc;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = t.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(e) {
    return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(e) {
    return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
  }
  reconnectionDelay(e) {
    var t;
    return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (t = this.backoff) === null || t === void 0 || t.setMin(e), this);
  }
  randomizationFactor(e) {
    var t;
    return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (t = this.backoff) === null || t === void 0 || t.setJitter(e), this);
  }
  reconnectionDelayMax(e) {
    var t;
    return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (t = this.backoff) === null || t === void 0 || t.setMax(e), this);
  }
  timeout(e) {
    return arguments.length ? (this._timeout = e, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(e) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new ao(this.uri, this.opts);
    const t = this.engine, n = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = Ae(t, "open", function() {
      n.onopen(), e && e();
    }), r = (a) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), e ? e(a) : this.maybeReconnectOnOpen();
    }, o = Ae(t, "error", r);
    if (this._timeout !== !1) {
      const a = this._timeout, l = this.setTimeoutFn(() => {
        i(), r(new Error("timeout")), t.close();
      }, a);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(i), this.subs.push(o), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(e) {
    return this.open(e);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const e = this.engine;
    this.subs.push(
      Ae(e, "ping", this.onping.bind(this)),
      Ae(e, "data", this.ondata.bind(this)),
      Ae(e, "error", this.onerror.bind(this)),
      Ae(e, "close", this.onclose.bind(this)),
      // @ts-ignore
      Ae(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(e) {
    try {
      this.decoder.add(e);
    } catch (t) {
      this.onclose("parse error", t);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(e) {
    ss(() => {
      this.emitReserved("packet", e);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(e) {
    this.emitReserved("error", e);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(e, t) {
    let n = this.nsps[e];
    return n ? this._autoConnect && !n.active && n.connect() : (n = new ho(this, e, t), this.nsps[e] = n), n;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(e) {
    const t = Object.keys(this.nsps);
    for (const n of t)
      if (this.nsps[n].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(e) {
    const t = this.encoder.encode(e);
    for (let n = 0; n < t.length; n++)
      this.engine.write(t[n], e.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(e, t) {
    var n;
    this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const e = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const t = this.backoff.duration();
      this._reconnecting = !0;
      const n = this.setTimeoutFn(() => {
        e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((i) => {
          i ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", i)) : e.onreconnect();
        }));
      }, t);
      this.opts.autoUnref && n.unref(), this.subs.push(() => {
        this.clearTimeoutFn(n);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const e = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
  }
}
const Jt = {};
function In(s, e) {
  typeof s == "object" && (e = s, s = void 0), e = e || {};
  const t = yc(s, e.path || "/socket.io"), n = t.source, i = t.id, r = t.path, o = Jt[i] && r in Jt[i].nsps, a = e.forceNew || e["force new connection"] || e.multiplex === !1 || o;
  let l;
  return a ? l = new si(n, e) : (Jt[i] || (Jt[i] = new si(n, e)), l = Jt[i]), t.query && !e.query && (e.query = t.queryKey), l.socket(t.path, e);
}
Object.assign(In, {
  Manager: si,
  Socket: ho,
  io: In,
  connect: In
});
class Fc {
  constructor() {
    this._socket = null, this._isConnected = !1, this._conversationId = null, this._websocketEvents = {};
  }
  get socket() {
    return this._socket;
  }
  get isConnected() {
    return this._isConnected;
  }
  get conversationId() {
    return this._conversationId;
  }
  get websocketEvents() {
    return this._websocketEvents;
  }
  set conversationId(e) {
    this._conversationId = e;
  }
  configure(e) {
    this._websocketEvents = e;
  }
  connect(e) {
    const t = In(e);
    return this._socket = t, new Promise((n, i) => {
      t.on("connect", () => {
        this._isConnected = !0, n(t);
      }), t.on("connect_error", () => {
        this._isConnected = !1, i(new dt("WebSocket connection failed", 500));
      }), t.on("error", (r) => {
        i(new dt(r.message || "WebSocket error", 500));
      }), t.on("disconnect", () => {
        this._isConnected = !1;
      });
    });
  }
  disconnect() {
    this._socket && (this._socket.disconnect(), this._socket = null, this._isConnected = !1, this._conversationId = null);
  }
  sendMessage(e) {
    if (!this._socket || !this._isConnected)
      throw new Error("WebSocket not connected");
    this._websocketEvents.sendMessage ? this._socket.emit(this._websocketEvents.sendMessage, e) : this._socket.emit("sendMessage", e);
  }
  cancel() {
    this._socket && this._isConnected && (this._socket.emit("cancel"), this.disconnect());
  }
}
const re = new Fc();
async function jc({ question: s, type: e, approach: t, overrides: n, messages: i }, { url: r, signal: o, websocketEvents: a }) {
  re.configure(a);
  const l = await re.connect(r), u = {
    messages: [
      ...i ?? [],
      {
        content: s,
        role: "user"
      }
    ],
    context: {
      ...n,
      approach: t
    },
    stream: e === "chat"
  };
  return re.sendMessage(u), o && o.addEventListener("abort", () => {
    re.cancel();
  }), l;
}
async function Nc(s, e) {
  return await jc(s, e);
}
class Xc extends TransformStream {
  constructor() {
    let e;
    super({
      start: (t) => {
        e = t;
      },
      transform: (t) => {
        const n = t.split(`
`).filter(Boolean);
        for (const i of n)
          try {
            this.buffer += i, e.enqueue(JSON.parse(this.buffer)), this.buffer = "";
          } catch {
          }
      }
    }), this.buffer = "";
  }
}
function Rc(s) {
  return s == null ? void 0 : s.pipeThrough(new TextDecoderStream()).pipeThrough(new Xc()).getReader();
}
async function* Ic(s) {
  if (!s)
    throw new Error("No response body or body is not readable");
  let e, t;
  for (; { value: e, done: t } = await s.read(), !t; )
    yield new Promise((n) => {
      setTimeout(() => {
        n(e);
      }, Xe.BOT_TYPING_EFFECT_INTERVAL);
    });
}
function mu(s) {
  s && s.cancel();
}
var Bc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wc(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var po = { exports: {} };
(function(s, e) {
  (function() {
    function t(f, x) {
      return Math.floor(Math.random() * (x - f + 1)) + f;
    }
    function n(f) {
      return f[t(0, f.length - 1)];
    }
    function i(f, x, P) {
      return f.unique_charset[Math.floor(x / Math.pow(f.unique_charset.length, f.length - P - 1)) % f.unique_charset.length];
    }
    function r(f) {
      var x = {
        numbers: "0123456789",
        alphabetic: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
        alphanumeric: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
      };
      return x[f];
    }
    function o(f, x) {
      for (var P = "", S = 0; S < x; S++)
        P += f;
      return P;
    }
    function a(f) {
      f = f || {}, this.count = f.count || 1, this.length = f.length || 8, this.charset = f.charset || r("alphanumeric"), this.unique_charset = l(this.charset), this.prefix = f.prefix || "", this.postfix = f.postfix || "", this.pattern = f.pattern || o("#", this.length), f.pattern && (this.length = (f.pattern.match(/#/g) || []).length);
    }
    function l(f) {
      for (var x = {}, P = [], S = 0; S < f.length; S++) {
        const N = f[S];
        x[N] || (P.push(N), x[N] = !0);
      }
      return P.join("");
    }
    function u(f, x) {
      var P = 0, S = f.pattern.split("").map(function(N) {
        return N === "#" ? isNaN(x) ? n(f.charset) : i(f, x, P++) : N;
      }).join("");
      return f.prefix + S + f.postfix;
    }
    function h(f) {
      return Math.pow(f.unique_charset.length, f.length);
    }
    function p(f) {
      return h(f) >= f.count;
    }
    function g(f, x) {
      f = new a(f);
      var P = f.count;
      if (!p(f))
        throw new Error("Not possible to generate requested number of codes.");
      x = +x, isNaN(x) || (x < 0 ? x = 0 : x >= h(f) && (x = h(f) - 1));
      for (var S = {}, N = []; P > 0; ) {
        var K = u(f, x);
        S[K] || (N.push(K), S[K] = !0, P--), x++;
      }
      return N;
    }
    var y = {
      generate: g,
      charset: r
    };
    s.exports && (s.exports = y);
  }).call(Bc);
})(po);
var Vc = po.exports;
const Bs = /* @__PURE__ */ Wc(Vc);
class Yc extends ns {
  constructor() {
    super(...arguments), this.name = "code-block", this.priority = 1, this.exclusiveBuffering = !0, this.allowedRulesWhileBuffering = [], this.languageBuffer = "", this.isDetectingLanguage = !1, this.partialBackticks = "", this.supportedLanguages = /* @__PURE__ */ new Set([
      "javascript",
      "js",
      "typescript",
      "ts",
      "python",
      "py",
      "java",
      "c",
      "cpp",
      "c++",
      "csharp",
      "cs",
      "php",
      "ruby",
      "go",
      "rust",
      "swift",
      "kotlin",
      "scala",
      "html",
      "css",
      "scss",
      "sass",
      "json",
      "xml",
      "yaml",
      "yml",
      "sql",
      "bash",
      "sh",
      "shell",
      "powershell",
      "cmd",
      "dockerfile",
      "docker",
      "markdown",
      "md",
      "text",
      "plaintext",
      "diff",
      "git",
      "makefile",
      "r",
      "matlab",
      "perl",
      "lua",
      "haskell",
      "clojure",
      "erlang",
      "elixir"
    ]);
  }
  // Track partial ``` sequences across chunks
  detect(e, t) {
    if ((t == null ? void 0 : t.currentRule) === "code-block" && (t != null && t.buffering))
      return !1;
    const n = this.partialBackticks + e;
    let i = 0, r = -1;
    for (; i < n.length; ) {
      const o = n.indexOf("```", i);
      if (o === -1)
        break;
      const a = o > 0 ? n[o - 1] : "", l = o + 3 < n.length ? n[o + 3] : "";
      if (a !== "`" && l !== "`") {
        r = o;
        break;
      }
      i = o + 3;
    }
    if (r !== -1) {
      const o = n.substring(0, r), a = n.substring(r + 3);
      this.partialBackticks = "", t && (t.currentRule = "code-block", o && (t.textBeforeCodeBlock = o));
      const l = a.match(/^([a-zA-Z][a-zA-Z0-9_-]*)\n?(.*)$/s);
      return l && l[1] ? (t && (t.detectedLanguage = l[1], l[2] && (t.contentAfterLanguage = l[2])), !0) : (this.isDetectingLanguage = !0, this.languageBuffer = a, null);
    }
    if (e.endsWith("``") || e.endsWith("`"))
      return e.endsWith("``") ? this.partialBackticks = "``" : e.endsWith("`") && (this.partialBackticks = "`"), null;
    if (this.partialBackticks = "", this.isDetectingLanguage) {
      this.languageBuffer += e;
      const o = this.languageBuffer.match(/^([a-zA-Z][a-zA-Z0-9_-]*)\n?(.*)$/s);
      return o && o[1] ? (this.isDetectingLanguage = !1, t && (t.detectedLanguage = o[1], o[2] && (t.contentAfterLanguage = o[2])), this.languageBuffer = "", !0) : null;
    }
    return !1;
  }
  tryCompleteMatch(e, t) {
    var l;
    let n = -1, i = 0;
    for (; i < e.length; ) {
      const u = e.indexOf("```", i);
      if (u === -1)
        break;
      const h = u > 0 ? e[u - 1] : "", p = u + 3 < e.length ? e[u + 3] : "";
      if (h !== "`" && p !== "`") {
        n = u;
        break;
      }
      i = u + 3;
    }
    if (n === -1)
      return null;
    let r = -1;
    for (i = n + 3; i < e.length; ) {
      const u = e.indexOf("```", i);
      if (u === -1)
        break;
      const h = u > 0 ? e[u - 1] : "", p = u + 3 < e.length ? e[u + 3] : "";
      if (h !== "`" && p !== "`") {
        r = u;
        break;
      }
      i = u + 3;
    }
    if (r === -1)
      return null;
    const a = e.substring(n + 3, r).match(/^(\w+)\n?([\s\S]*)$/);
    if (a && ((l = a[1]) != null && l.trim())) {
      const u = a[1], h = a[2] || "", p = e.substring(n, r + 3), g = this.normalizeLanguage(u), f = `<code-viewer componentId="${Bs.generate({ count: 1, length: 8 })[0].toLowerCase()}" language="${g}" streaming="false">${h}</code-viewer>`;
      return this.createCompleteMatch(e, p, e.replace(p, f));
    }
    return null;
  }
  startBuffering(e, t) {
    const n = Bs.generate({ count: 1, length: 8 })[0].toLowerCase();
    let i = "plaintext";
    if (t != null && t.detectedLanguage)
      i = this.normalizeLanguage(t.detectedLanguage);
    else {
      const a = e.match(/```([a-zA-Z][a-zA-Z0-9_-]*)/);
      i = a ? this.normalizeLanguage(a[1]) : "plaintext";
    }
    let r = "";
    t != null && t.textBeforeCodeBlock && (r = t.textBeforeCodeBlock, delete t.textBeforeCodeBlock);
    const o = `<code-viewer componentId="${n}" language="${i}" streaming="true"></code-viewer>`;
    return r += o, t && (t.isFirstChunk = !0), {
      processedChunk: r,
      finisher: "```",
      closure: "</code-viewer>"
    };
  }
  continueBuffering(e, t, n, i, r) {
    if (i !== "</code-viewer>")
      return null;
    let o = e;
    return r != null && r.isFirstChunk && (r.isFirstChunk = !1, r.contentAfterLanguage && (o = r.contentAfterLanguage + e, delete r.contentAfterLanguage)), {
      processedChunk: o,
      finisher: n,
      closure: i
    };
  }
  detectFinish(e, t, n) {
    const i = ((n == null ? void 0 : n.partialClosingBackticks) || "") + e;
    let r = 0;
    for (; r < i.length; ) {
      const o = i.indexOf("```", r);
      if (o === -1)
        break;
      const a = o > 0 ? i[o - 1] : "", l = o + 3 < i.length ? i[o + 3] : "";
      if (a !== "`" && l !== "`")
        return n && (n.partialClosingBackticks = ""), !0;
      r = o + 3;
    }
    return e.endsWith("``") || e.endsWith("`") ? (n && (e.endsWith("``") ? n.partialClosingBackticks = "``" : n.partialClosingBackticks = "`"), !1) : (n && (n.partialClosingBackticks = ""), !1);
  }
  handleBufferingCompletion(e, t, n, i, r) {
    var u;
    if (i !== "</code-viewer>" || n !== "```")
      return null;
    const o = ((r == null ? void 0 : r.partialClosingBackticks) || "") + e;
    let a = 0, l = -1;
    for (; a < o.length; ) {
      const h = o.indexOf("```", a);
      if (h === -1)
        break;
      const p = h > 0 ? o[h - 1] : "", g = h + 3 < o.length ? o[h + 3] : "";
      if (p !== "`" && g !== "`") {
        l = h;
        break;
      }
      a = h + 3;
    }
    if (l !== -1) {
      const h = ((u = r == null ? void 0 : r.partialClosingBackticks) == null ? void 0 : u.length) || 0, p = o.substring(0, l), g = o.substring(l + 3);
      return r && (r.currentRule = void 0, r.partialClosingBackticks = "", delete r.detectedLanguage, delete r.contentAfterLanguage, delete r.isFirstChunk), this.partialBackticks = "", this.languageBuffer = "", this.isDetectingLanguage = !1, {
        finalChunk: p.substring(h),
        // Remove partial backticks from final content
        remainingChunk: g,
        shouldContinue: !0
      };
    }
    if (e.endsWith("``") || e.endsWith("`")) {
      r && (e.endsWith("``") ? r.partialClosingBackticks = "``" : r.partialClosingBackticks = "`");
      const h = e.endsWith("``") ? e.length - 2 : e.length - 1;
      return {
        finalChunk: e.substring(0, h),
        remainingChunk: "",
        shouldContinue: !0
      };
    }
    return r && (r.partialClosingBackticks = ""), {
      finalChunk: e,
      remainingChunk: "",
      shouldContinue: !0
    };
  }
  getFullTextPattern() {
    return {
      // More precise pattern that looks for word boundaries around ```
      pattern: /(?:^|[^`])(```(\w+)?\n?([\s\S]*?)```)(?:[^`]|$)/g,
      replacement: (e, t, n, i) => {
        const r = n ? this.normalizeLanguage(n) : "plaintext", a = `<code-viewer fullTextRendered="true" componentId="${Bs.generate({ count: 1, length: 8 })[0].toLowerCase()}" language="${r}">${i}</code-viewer>`;
        return e.replace(t, a);
      }
    };
  }
  normalizeLanguage(e) {
    if (!e)
      return "plaintext";
    const t = e.toLowerCase().trim();
    if (this.supportedLanguages.has(t))
      return t;
    const n = {
      node: "javascript",
      js: "javascript",
      ts: "typescript",
      py: "python",
      cs: "csharp",
      "c++": "cpp",
      shell: "bash",
      sh: "bash",
      yml: "yaml",
      md: "markdown"
    };
    return n[t] ? n[t] : /^[a-z][a-z0-9_-]*$/i.test(t) ? t : "plaintext";
  }
}
class fo {
  constructor(e) {
    this.rules = [], e ? this.rules = [...e] : this.initializeDefaultRules(), this.sortRulesByPriority();
  }
  initializeDefaultRules() {
    this.rules = [
      new Yc(),
      // Highest priority - should detect code blocks first
      // new HeaderRule(),
      // new TextFormattingRule(),
      new Qr()
    ];
  }
  sortRulesByPriority() {
    this.rules.sort((e, t) => e.priority - t.priority);
  }
  /**
   * Add a new rule to the manager
   */
  addRule(e) {
    this.rules.push(e), this.sortRulesByPriority();
  }
  /**
   * Remove a rule by name
   */
  removeRule(e) {
    const t = this.rules.findIndex((n) => n.name === e);
    return t !== -1 ? (this.rules.splice(t, 1), !0) : !1;
  }
  /**
   * Process a chunk and apply all applicable rules in priority order
   * Each rule gets the processed content from previous rules
   * 
   * Rules that can complete immediately (like headers, bold, italic) are applied sequentially.
   * When a rule requires buffering (like code blocks), processing stops and buffering begins.
   * This ensures that a chunk like "**bold text** ```javascript" will:
   * 1. First apply bold formatting to get "**bold text** ```javascript"
   * 2. Then detect code block and start buffering
   */
  processChunk(e, t) {
    if (t.buffering && (t.ruleProcessingMode === "buffering-exclusive" || !(t.allowedRulesWhileBuffering && t.allowedRulesWhileBuffering.length > 0)))
      return null;
    const n = this.getRule("code-block");
    if (n && !t.buffering) {
      const l = n.detect(e, t);
      if (l === !0) {
        const u = e.indexOf("```");
        if (u > 0) {
          const h = e.substring(0, u), p = e.substring(u);
          let g = h;
          for (const f of this.rules) {
            if (f.name === "code-block")
              continue;
            if (f.detect(g, t) === !0) {
              const P = f.tryCompleteMatch(g, t);
              P && (f.name === "text-formatting" ? g = f.processFullText(g) : g = g.replace(P.fullMatch, P.replacement));
            }
          }
          t && (t.textBeforeCodeBlock = g);
          const y = n.startBuffering(p, t);
          return t.buffering = !0, t.bufferingFinisher = y.finisher || null, t.bufferingClosure = y.closure, t.bufferText = t.bufferText || "", this.setRuleProcessingMode(
            t,
            "buffering-exclusive",
            n.name,
            n.allowedRulesWhileBuffering
          ), t.skipOne = !0, t.insideCodeViewer = !0, t.codeViewerDepth = (t.codeViewerDepth || 0) + 1, t.linebreakProof = !0, {
            processedChunk: y.processedChunk,
            bufferState: t,
            ruleApplied: n.name
          };
        } else {
          const h = n.startBuffering(e, t);
          return t.buffering = !0, t.bufferingFinisher = h.finisher || null, t.bufferingClosure = h.closure, t.bufferText = t.bufferText || "", this.setRuleProcessingMode(
            t,
            "buffering-exclusive",
            n.name,
            n.allowedRulesWhileBuffering
          ), t.skipOne = !0, t.insideCodeViewer = !0, t.codeViewerDepth = (t.codeViewerDepth || 0) + 1, t.linebreakProof = !0, {
            processedChunk: h.processedChunk,
            bufferState: t,
            ruleApplied: n.name
          };
        }
      } else if (l === null)
        return {
          processedChunk: "",
          bufferState: t
        };
    }
    let i = e, r = !1, o, a = this.rules.filter((l) => l.name !== "code-block");
    for (const l of a) {
      if (l.name === "line-break" && t.linebreakProof)
        continue;
      const u = l.detect(i, t);
      if (u === !0) {
        const h = l.tryCompleteMatch(i, t);
        if (h)
          l.name === "text-formatting" ? i = l.processFullText(i) : i = i.replace(h.fullMatch, h.replacement), r = !0, o = l.name;
        else {
          const p = l.startBuffering(i, t);
          return t.buffering = !0, t.bufferingFinisher = p.finisher || null, t.bufferingClosure = p.closure, t.bufferText = t.bufferText || "", l.exclusiveBuffering ? this.setRuleProcessingMode(
            t,
            "buffering-exclusive",
            l.name,
            l.allowedRulesWhileBuffering
          ) : this.setRuleProcessingMode(t, "sequential"), l.name === "code-block" && (t.skipOne = !0, t.insideCodeViewer = !0, t.codeViewerDepth = (t.codeViewerDepth || 0) + 1, t.linebreakProof = !0), l.name === "list" && (t.insideListViewer = !0, t.listViewerDepth = (t.listViewerDepth || 0) + 1, t.linebreakProof = !0), {
            processedChunk: p.processedChunk,
            bufferState: t,
            ruleApplied: l.name
          };
        }
      } else if (u === null)
        return {
          processedChunk: "",
          bufferState: t
        };
    }
    return r ? {
      processedChunk: i,
      bufferState: t,
      ruleApplied: o
    } : null;
  }
  /**
   * Continue buffering with rule-specific logic
   */
  continueBuffering(e, t, n) {
    const i = this.getRule(n);
    if (!i)
      return null;
    const r = i.continueBuffering(
      e,
      t.bufferText,
      t.bufferingFinisher || "",
      t.bufferingClosure || "",
      t
    );
    return r ? (t.bufferingFinisher = r.finisher, t.bufferingClosure = r.closure, {
      processedChunk: r.processedChunk,
      shouldContinue: !0
    }) : null;
  }
  /**
   * Handle completion with rule-specific logic
   */
  handleCompletion(e, t, n) {
    const i = this.getRule(n);
    if (!i)
      return null;
    const r = i.handleBufferingCompletion(
      e,
      t.bufferText,
      t.bufferingFinisher || "",
      t.bufferingClosure || "",
      t
    );
    return r ? {
      finalChunk: r.finalChunk,
      remainingChunk: r.remainingChunk,
      shouldReset: !r.shouldContinue
    } : null;
  }
  /**
   * Process content for buffering using rule-specific logic
   */
  processContentForBuffer(e, t) {
    const n = this.getRule(t);
    return n ? n.processBufferContent(e) : e;
  }
  /**
   * Check if buffering should finish using rule-specific logic when no finisher is set
   */
  detectFinish(e, t, n) {
    const i = this.getRule(n);
    return i ? i.detectFinish(e, t.bufferText, t) : !1;
  }
  /**
   * Process full text using all rules sequentially in priority order
   * Each rule processes the output from the previous rule
   * Content inside <code-viewer> tags is protected from further processing
   */
  processFullText(e) {
    let t = e;
    for (const n of this.rules)
      n.name === "code-block" ? t = n.processFullText(t) : t = this.processTextWithProtectedContent(t, n);
    return t;
  }
  /**
   * Process text with a rule while protecting content inside <code-viewer> tags
   */
  processTextWithProtectedContent(e, t) {
    const n = /<code-viewer[^>]*>([\s\S]*?)<\/code-viewer>/g, i = [];
    let r;
    for (; (r = n.exec(e)) !== null; )
      i.push({
        start: r.index,
        end: r.index + r[0].length,
        content: r[0]
      });
    if (i.length === 0)
      return t.processFullText(e);
    let o = "", a = 0;
    for (const u of i) {
      const h = e.substring(a, u.start);
      h && (o += t.processFullText(h)), o += u.content, a = u.end;
    }
    const l = e.substring(a);
    return l && (o += t.processFullText(l)), o;
  }
  /**
   * Get all rule names for debugging
   */
  getRuleNames() {
    return this.rules.map((e) => e.name);
  }
  /**
   * Get rule by name for debugging
   */
  getRule(e) {
    return this.rules.find((t) => t.name === e);
  }
  /**
   * Get all rules (for advanced usage)
   */
  getAllRules() {
    return [...this.rules];
  }
  /**
   * Set rule processing mode for buffering
   */
  setRuleProcessingMode(e, t, n, i) {
    e.ruleProcessingMode = t, t === "buffering-exclusive" ? (e.exclusiveBufferingRule = n, e.allowedRulesWhileBuffering = i || []) : (e.exclusiveBufferingRule = void 0, e.allowedRulesWhileBuffering = void 0);
  }
  /**
   * Reset rule processing mode to sequential
   */
  resetRuleProcessingMode(e) {
    e.ruleProcessingMode = "sequential", e.exclusiveBufferingRule = void 0, e.allowedRulesWhileBuffering = void 0;
  }
}
function Qn() {
  return {
    buffering: !1,
    bufferingFinisher: null,
    bufferingClosure: null,
    bufferText: "",
    skipOne: !1,
    insideCodeViewer: !1,
    codeViewerDepth: 0,
    insideListViewer: !1,
    listViewerDepth: 0,
    linebreakProof: !1,
    partialClosing: void 0,
    currentRule: void 0,
    ruleManager: new fo()
    // Create once per message stream
  };
}
function ii(s) {
  return s && new fo().processFullText(s);
}
function qc(s, e = 10, t = () => {
}) {
  if (!s)
    return s;
  const n = Qn();
  let i = "";
  for (let r = 0; r < s.length; r += e) {
    const o = s.substring(r, r + e), { processedChunk: a } = Dt(o, n, t);
    a !== null && (i += a);
  }
  return n.buffering && n.bufferText && (n.bufferingClosure ? i += n.bufferText + n.bufferingClosure : i += n.bufferText), i;
}
function Gc(s, e = { mode: "full" }) {
  switch (e.mode) {
    case "full":
      return ii(s);
    case "chunked-full":
      return qc(
        s,
        e.chunkSize || 10,
        e.duringBuffering || (() => {
        })
      );
    case "chunk":
    default:
      throw new Error("Chunk mode requires external buffer state management. Use processChunkWithBuffering directly.");
  }
}
function Dt(s, e, t = () => {
}) {
  let n = s;
  const i = e.ruleManager;
  if (!e.buffering) {
    const o = i.processChunk(n, e);
    if (o)
      return e.currentRule = o.ruleApplied, e.buffering ? { processedChunk: o.processedChunk, bufferState: o.bufferState } : { processedChunk: o.processedChunk, bufferState: o.bufferState };
  }
  if (!e.buffering)
    return { processedChunk: n, bufferState: e };
  if (e.currentRule && e.bufferingClosure) {
    let o = !1;
    if (e.bufferingFinisher ? i.detectFinish(n, e, e.currentRule) === !0 ? o = !0 : o = ((e.partialClosing || "") + n).includes(e.bufferingFinisher) : o = i.detectFinish(n, e, e.currentRule) === !0, o) {
      const a = e.currentRule === "code-block", l = i.handleCompletion(
        n,
        e,
        e.currentRule
      );
      if (l) {
        a && l.finalChunk && t(e, l.finalChunk);
        let u = "", h = "";
        if (e.currentRule === "text-formatting" ? (u = e.bufferText + l.finalChunk + e.bufferingClosure, h = u) : u = e.bufferText + l.finalChunk, l.remainingChunk) {
          const p = Dt(
            l.remainingChunk,
            {
              ...e,
              buffering: !1,
              bufferingClosure: null,
              bufferingFinisher: null,
              bufferText: "",
              skipOne: !1,
              partialClosing: void 0,
              currentRule: void 0,
              currentCodeViewerId: void 0,
              // Explicitly clear this
              waitingForLanguage: void 0,
              linebreakProof: !1,
              // CRITICAL: Ensure line breaks are allowed for remaining content
              insideCodeViewer: !1,
              // Reset code viewer state for remaining content
              codeViewerDepth: 0,
              // Reset depth for remaining content
              ruleManager: e.ruleManager
              // Preserve rule manager instance
            },
            void 0
            // NO duringBuffering callback - process as normal text
          );
          p.processedChunk && (e.currentRule === "text-formatting" ? h = h + p.processedChunk : h = p.processedChunk), Object.assign(e, p.bufferState);
        }
        return a && l.finalChunk, e.bufferingFinisher = null, e.bufferingClosure = null, e.bufferText = "", e.buffering = !1, e.skipOne = !1, e.linebreakProof = !1, e.partialClosing = void 0, e.currentRule = void 0, e.currentCodeViewerId = void 0, e.waitingForLanguage = void 0, a && (e.codeViewerDepth = Math.max(0, (e.codeViewerDepth || 1) - 1), e.insideCodeViewer = e.codeViewerDepth > 0), { processedChunk: h, bufferState: e };
      }
      if (e.bufferingFinisher) {
        const u = n.indexOf(e.bufferingFinisher), h = n.substring(0, u), p = n.substring(u + e.bufferingFinisher.length), g = e.bufferText + h + e.bufferingClosure + p;
        return e.bufferingFinisher = null, e.bufferingClosure = null, e.bufferText = "", e.buffering = !1, e.skipOne = !1, e.linebreakProof = !1, e.partialClosing = void 0, e.currentRule = void 0, e.currentCodeViewerId = void 0, e.waitingForLanguage = void 0, { processedChunk: g, bufferState: e };
      } else {
        const u = e.bufferText + e.bufferingClosure + n;
        return e.bufferingFinisher = null, e.bufferingClosure = null, e.bufferText = "", e.buffering = !1, e.skipOne = !1, e.linebreakProof = !1, e.partialClosing = void 0, e.currentRule = void 0, e.currentCodeViewerId = void 0, e.waitingForLanguage = void 0, { processedChunk: u, bufferState: e };
      }
    } else {
      const a = i.continueBuffering(
        n,
        e,
        e.currentRule
      );
      if (a)
        return a.shouldContinue ? (a.processedChunk && (e.bufferText += a.processedChunk, t(e, a.processedChunk)), { processedChunk: null, bufferState: e }) : { processedChunk: a.processedChunk, bufferState: e };
    }
  }
  let r = n;
  return e.currentRule && (r = i.processContentForBuffer(n, e.currentRule)), e.bufferText += r, e.skipOne || t(e, r), e.skipOne = !1, { processedChunk: null, bufferState: e };
}
function Uc(s) {
  if (s.endsWith("<"))
    return {
      hasIncompleteTag: !0,
      bufferContent: "<",
      processableContent: s.slice(0, -1)
    };
  if (s.endsWith("</"))
    return {
      hasIncompleteTag: !0,
      bufferContent: "</",
      processableContent: s.slice(0, -2)
    };
  const e = s.match(/<\/[^>]*$/);
  if (e) {
    const t = e[0];
    return {
      hasIncompleteTag: !0,
      bufferContent: t,
      processableContent: s.slice(0, s.length - t.length)
    };
  }
  return {
    hasIncompleteTag: !1,
    bufferContent: "",
    processableContent: s
  };
}
function Zc(s, e) {
  const t = s + e, n = t.match(/^<\/[^>]*>/);
  if (n) {
    const r = n[0], o = t.slice(r.length);
    return {
      isComplete: !0,
      completeTag: r,
      remainingContent: o
    };
  }
  return t.match(/^<\/[^>]*$/) ? {
    isComplete: !1,
    completeTag: "",
    remainingContent: ""
  } : {
    isComplete: !0,
    completeTag: t,
    remainingContent: ""
  };
}
function Qc() {
  return {
    htmlTagBuffer: "",
    isBufferingHtmlTag: !1
  };
}
function Jc(s, e) {
  let t = s, n = !1;
  if (e.isBufferingHtmlTag) {
    const i = e.htmlTagBuffer + s, { isComplete: r, completeTag: o, remainingContent: a } = Zc(e.htmlTagBuffer, s);
    r ? (t = o + a, e.isBufferingHtmlTag = !1, e.htmlTagBuffer = "") : (e.htmlTagBuffer = i, n = !0);
  } else {
    const { hasIncompleteTag: i, bufferContent: r, processableContent: o } = Uc(s);
    i && (e.isBufferingHtmlTag = !0, e.htmlTagBuffer = r, t = o, o === "" && (n = !0));
  }
  return {
    finalChunkValue: t,
    shouldSkip: n,
    bufferState: e
  };
}
function Kc(s) {
  if (s.isBufferingHtmlTag && s.htmlTagBuffer) {
    const e = s.htmlTagBuffer;
    return s.htmlTagBuffer = "", s.isBufferingHtmlTag = !1, {
      hasRemainingContent: !0,
      remainingContent: e
    };
  }
  return {
    hasRemainingContent: !1,
    remainingContent: ""
  };
}
function ri({
  citations: s,
  chatEntry: e
}) {
  const t = e, n = (r, o) => {
    const a = s.find((l) => l.text === o);
    return a ? `<sup class="citation">${a.ref}</sup>` : r;
  }, i = t.text.map((r) => {
    var l;
    const o = r.value.replaceAll(/\[(.*?)]/g, n), a = (l = r.followingSteps) == null ? void 0 : l.map(
      (u) => u.replaceAll(/\[(.*?)]/g, n)
    );
    return {
      value: o,
      followingSteps: a
    };
  });
  return {
    ...t,
    text: i,
    citations: s
  };
}
function _c(s) {
  const e = /\[(.*?)]/g, t = {};
  let n = 1;
  return s.replaceAll(e, (i, r) => {
    const o = r.trim();
    return t[o] || (t[o] = n++), "";
  }), Object.keys(t).map((i, r) => ({
    ref: r + 1,
    text: i
  }));
}
function oi({
  chunkValue: s,
  textBlockIndex: e,
  chatEntry: t
}) {
  const { text: n } = t, i = n[e] ?? {
    value: "",
    followingSteps: []
  }, r = (i.value || "") + s;
  return {
    ...t,
    text: lt(n, e, {
      ...i,
      value: r
    })
  };
}
function go({
  tool: s,
  chatEntry: e
}) {
  const t = e.tools || [];
  return {
    ...e,
    tools: [...t, s]
  };
}
function Ws(s, e) {
  var n, i;
  return (i = (n = s.renderRoot) == null ? void 0 : n.querySelector("chat-thread-component").renderRoot) == null ? void 0 : i.querySelector('code-viewer[componentId="' + e + '"]');
}
function $c(s) {
  if (typeof s == "string")
    return s;
  if (Array.isArray(s)) {
    const e = s.find((t) => t.type === "text");
    return (e == null ? void 0 : e.text) || "";
  }
  return "";
}
async function eu({
  chatEntry: s,
  apiResponseBody: e,
  signal: t,
  onChunkRead: n,
  onCancel: i,
  onReasoningStep: r
}, o) {
  var He, vt, It, Ye, Bt, Be, gn, mn;
  const a = Rc(e), l = Ic(a);
  let u = !1, h = null, p = [], g = "";
  const y = Qn();
  let f = 0, x = Qc(), P = !1, S = "";
  const N = (D = !1) => {
    const W = S;
    return S = "", P = !1, W || null;
  }, K = (D) => {
    let W = D;
    if (P) {
      const le = W.indexOf(">"), ze = W.indexOf(`
`);
      let X = -1;
      if (le !== -1 && ze !== -1 ? X = Math.min(le, ze) : X = Math.max(le, ze), X === -1)
        return null;
      W = W.slice(X + 1), P = !1;
    }
    W = W.replace(/<[^>]*>/g, "");
    const ae = W.lastIndexOf("<");
    if (ae !== -1 && W.indexOf(">", ae) === -1) {
      const le = W.indexOf(`
`, ae);
      le !== -1 ? W = W.slice(0, ae) + W.slice(le + 1) : (W = W.slice(0, ae), P = !0);
    }
    if (!W)
      return null;
    S += W;
    const be = S.match(/\.(\s|$)/);
    if (be) {
      const le = be.index + be[0].length, ze = S.slice(0, le);
      return S = S.slice(le), ze;
    }
    return null;
  };
  let A = {
    ...s
  };
  const F = {
    prompt_tokens: 0,
    completion_tokens: 0,
    total_tokens: 0,
    cost: 0,
    reasoning_tokens: 0
  };
  let $ = null, he = null;
  for await (const D of l) {
    if (t.aborted) {
      i();
      return;
    }
    if (D.cost) {
      F.prompt_tokens += ((He = D.cost) == null ? void 0 : He.prompt_tokens) || 0, F.completion_tokens += ((vt = D.cost) == null ? void 0 : vt.completion_tokens) || 0, F.total_tokens += ((It = D.cost) == null ? void 0 : It.total_tokens) || 0, F.cost += ((Ye = D.cost) == null ? void 0 : Ye.cost) || 0, F.reasoning_tokens += ((Bt = D.cost) == null ? void 0 : Bt.reasoning_tokens) || 0, A = {
        ...A,
        cost: F
      }, n(A), o.dispatchEvent(new CustomEvent("credit:balance:updated", {
        bubbles: !0,
        composed: !0
      }));
      continue;
    }
    if ("error" in D)
      throw new dt(D.message, D.statusCode);
    if (D.progress && D.status !== "rws_progress")
      continue;
    if (D.conversationId) {
      const q = new CustomEvent("chat:conversation:start", {
        detail: {
          conversationId: D.conversationId,
          conversationUid: D.conversationUid
        },
        bubbles: !0,
        composed: !0
      });
      o.dispatchEvent(q);
      continue;
    }
    if (D.requestId) {
      he = D.requestId;
      const q = new CustomEvent("chat:request:id", {
        detail: { requestId: he },
        bubbles: !0,
        composed: !0
      });
      o.dispatchEvent(q);
      continue;
    }
    if (D.reasoning) {
      if ($ || ($ = "reasoning-" + Math.random().toString(36).substring(2, 15)), r) {
        const q = Qn(), ce = Dt(Gc(D.reasoning, { mode: "full" }), q);
        r($, ce.processedChunk);
      }
      continue;
    }
    if (D.tool) {
      try {
        A = go({ tool: D.tool, chatEntry: A }), n(A), o.dispatchEvent(new CustomEvent("chat:tool:detected", {
          bubbles: !0,
          composed: !0,
          detail: { tool: D.tool }
        }));
      } catch {
      }
      continue;
    }
    if (D.citations) {
      p = [...p, ...D.citations];
      continue;
    }
    if (D.status === "rws_progress") {
      if (D.progress) {
        const q = D.progress, ce = new CustomEvent("chat:progress", {
          detail: {
            stage: q.stage || "",
            message: q.message || "",
            percentage: ((Be = q.details) == null ? void 0 : Be.percentage) || 0,
            details: q.details
          },
          bubbles: !0,
          composed: !0
        });
        o.dispatchEvent(ce);
      }
      continue;
    }
    if (D.choices[0].finish_reason === "content_filter")
      throw new dt("Content filtered", 400);
    const { content: W, context: ae } = D.choices[0].delta;
    if (ae != null && ae.data_points) {
      A.dataPoints = ae.data_points ?? [], A.thoughts = ae.thoughts ?? "";
      continue;
    }
    let be = $c(W ?? "");
    if (be === "")
      continue;
    if (g += be, o.autoTalkEnabled) {
      const q = K(be);
      q !== null && (console.log("AutoTalk chunk:", q), o.dispatchEvent(new CustomEvent("autotalk:stream-chunk", {
        detail: { chunk: q, isFinal: !1 },
        bubbles: !0,
        composed: !0
      })));
    }
    const { finalChunkValue: le, shouldSkip: ze, bufferState: X } = Jc(be, x);
    if (x = X, ze)
      continue;
    const Wt = y.buffering && y.currentRule === "code-block", { processedChunk: qe, bufferState: Ge } = Dt(le, y, (q, ce) => {
      var tt, nt, I;
      q.buffering && q.currentRule === "code-block" && h ? (tt = Ws(o, h)) == null || tt.updateRenderer(ce) : q.currentRule === "code-block" && h ? (nt = Ws(o, h)) == null || nt.updateRenderer(ce) : Wt && h && ((I = Ws(o, h)) == null || I.updateRenderer(ce));
    });
    if (Wt && !Ge.buffering && u) {
      try {
        const ce = (mn = (gn = o.renderRoot) == null ? void 0 : gn.querySelector("chat-thread-component").renderRoot) == null ? void 0 : mn.querySelector('code-viewer[componentId="' + h + '"]');
        ce && typeof ce.stopCodeGeneration == "function" && ce.stopCodeGeneration();
      } catch {
      }
      u = !1, h = null;
    }
    const os = Ge.buffering && Ge.currentRule === "code-block" && u;
    if (qe !== null && !os) {
      if (qe.includes("<code-viewer") && !u) {
        u = !0;
        const q = qe.match(/componentId="([^"]+)"/);
        q && (h = q[1], requestAnimationFrame(() => {
          var ce, tt;
          try {
            const I = (tt = (ce = o.renderRoot) == null ? void 0 : ce.querySelector("chat-thread-component").renderRoot) == null ? void 0 : tt.querySelector('code-viewer[componentId="' + h + '"]');
            I && typeof I.startCodeGeneration == "function" && I.startCodeGeneration();
          } catch {
          }
        }));
      }
      A = oi({ chunkValue: qe, textBlockIndex: f, chatEntry: A });
    }
    Object.assign(y, Ge), A = ri({ citations: [], chatEntry: A }), n(A);
  }
  const { hasRemainingContent: Rt, remainingContent: de } = Kc(x);
  if (Rt) {
    const { processedChunk: D } = Dt(de, y);
    D !== null && (A = oi({ chunkValue: D, textBlockIndex: f, chatEntry: A }));
  }
  if (o.autoTalkEnabled) {
    const D = N(!0);
    D !== null && o.dispatchEvent(new CustomEvent("autotalk:stream-chunk", {
      detail: { chunk: D, isFinal: !0 },
      bubbles: !0,
      composed: !0
    }));
  }
  A = ri({ citations: p, chatEntry: A }), A.rawContent = g, n(A), p.length && setTimeout(() => {
    var ae, be;
    const D = (ae = o.renderRoot) == null ? void 0 : ae.querySelector("chat-thread-component"), W = (be = D == null ? void 0 : D.shadowRoot) == null ? void 0 : be.querySelectorAll(".search-ref");
    if (W && W.length) {
      const le = W[0].closest(".chat__txt ");
      for (const ze of W)
        ze.addEventListener("click", (X) => {
          const qe = X.target.innerText.replace("[", "").replace("]", ""), Ge = parseInt(qe, 10) - 1;
          (le == null ? void 0 : le.querySelector("citation-list")).highlight(Ge), D == null || D.scrollToBottom(!0);
        });
    }
  }, 500), $ = null;
}
async function tu({
  chatEntry: s,
  chunk: e,
  onChunkRead: t
}, n) {
  var y, f, x;
  const i = [];
  let r = s.rawContent || "";
  const o = Qn();
  let a = 0, l = {
    ...s
  };
  if ("error" in e)
    throw new dt(e.message, e.statusCode || 500);
  if (e.conversationId) {
    const P = new CustomEvent("chat:conversation:start", {
      detail: {
        conversationId: e.conversationId,
        conversationUid: e.conversationUid
      },
      bubbles: !0,
      composed: !0
    });
    n.dispatchEvent(P);
    return;
  }
  if (e.finish_reason === "content_filter")
    throw new dt("Content filtered", 400);
  if ((y = e.context) != null && y.data_points) {
    l.dataPoints = e.context.data_points ?? [], l.thoughts = e.context.thoughts ?? "", t(l);
    return;
  }
  if (e.status === "rws_progress") {
    const { progress: P } = e;
    if (P) {
      const S = new CustomEvent("chat:progress", {
        detail: {
          stage: P.stage || "",
          message: P.message || "",
          percentage: ((f = P.details) == null ? void 0 : f.percentage) || 0,
          details: P.details
        },
        bubbles: !0,
        composed: !0
      });
      n.dispatchEvent(S);
    }
    return;
  }
  if (e.status === "rws_cost") {
    const P = new CustomEvent("credit:balance:updated", {
      detail: {
        userId: e.userId,
        previousBalance: e.previousBalance,
        newBalance: e.newBalance,
        transaction: e.transaction
      },
      bubbles: !0,
      composed: !0
    });
    n.dispatchEvent(P);
    return;
  }
  if (e.status === "rws_tool" && e.tool) {
    try {
      l = go({ tool: e.tool, chatEntry: l }), t(l);
    } catch {
    }
    return;
  }
  let u = e.content ?? ((x = e.delta) == null ? void 0 : x.content) ?? "";
  if (u === "")
    return;
  r += u, i.push(u);
  const { processedChunk: h, bufferState: p } = Dt(u, o);
  Object.assign(o, p), h !== null && (l = oi({ chunkValue: h, textBlockIndex: a, chatEntry: l }));
  const g = _c(i.join(""));
  l = ri({ citations: g, chatEntry: l }), l.rawContent = r, t(l);
}
class nu {
  constructor(e) {
    this._generatingAnswer = !1, this._isAwaitingResponse = !1, this._isProcessingResponse = !1, this._processingMessage = void 0, this._abortController = new AbortController(), this._useWebSocket = !1, this._hasReceivedFirstTextContent = !1, this._currentRequestId = null, (this.host = e).addController(this);
  }
  get isAwaitingResponse() {
    return this._isAwaitingResponse;
  }
  get isProcessingResponse() {
    return this._isProcessingResponse;
  }
  get processingMessage() {
    return this._processingMessage;
  }
  get generatingAnswer() {
    return this._generatingAnswer;
  }
  get signal() {
    return this._abortController.signal;
  }
  set generatingAnswer(e) {
    this._generatingAnswer = e, this.host.requestUpdate();
  }
  set processingMessage(e) {
    var n;
    const t = this._processingMessage;
    this._processingMessage = e ? {
      ...e,
      // Preserve existing reasoning if it exists
      reasoning: ((n = this._processingMessage) == null ? void 0 : n.reasoning) || e.reasoning
    } : void 0, e && t && !this._hasReceivedFirstTextContent && t.reasoning && e.text && e.text.length > 0 && e.text[0].value && e.text[0].value.trim() !== "" && (this._hasReceivedFirstTextContent = !0, this.closeReasoningViewer(e.id)), this.host.requestUpdate();
  }
  addReasoningToProcessingMessage(e) {
    this._processingMessage && (this._processingMessage = {
      ...this._processingMessage,
      reasoning: (this._processingMessage.reasoning || "") + e
    }, this.host.requestUpdate());
  }
  closeReasoningViewer(e) {
    const i = this.host.shadowRoot.querySelector("chat-thread-component").shadowRoot.querySelector(`reasoning-viewer[component-id="${e}"]`);
    i && typeof i.close == "function" && i.close();
  }
  setReasoningCallback(e) {
    this._onReasoningStep = e;
  }
  set isAwaitingResponse(e) {
    this._isAwaitingResponse = e, this.host.requestUpdate();
  }
  set isProcessingResponse(e) {
    this._isProcessingResponse = e, this.host.requestUpdate();
  }
  configureWebSocket(e, t) {
    this._useWebSocket = e, re.configure(t);
  }
  extractTextFromMultimodalContent(e) {
    return typeof e == "string" ? e : Array.isArray(e) ? e.filter((n) => n.type === "text" && n.text).map((n) => n.text).join(" ") : "";
  }
  extractFilesFromMultimodalContent(e) {
    if (!Array.isArray(e))
      return [];
    const t = [];
    return e.forEach((n, i) => {
      if (n.type === "image" && n.image) {
        const r = n.image, o = r.match(/^data:([^;]+);base64,/), a = o ? o[1] : "image/jpeg", l = a.split("/")[1] || "jpg", u = `image_${i + 1}.${l}`;
        t.push({
          id: crypto.randomUUID(),
          filename: u,
          originalName: u,
          mimeType: a,
          size: 0,
          // We don't have size info from data URI, backend can handle this
          base64: r,
          tmp: !0
        });
      }
    }), t;
  }
  hostConnected() {
    const e = this.host;
    e.addEventListener && e.addEventListener("chat:request:id", this.handleRequestId.bind(this));
  }
  hostDisconnected() {
    const e = this.host;
    e.removeEventListener && e.removeEventListener("chat:request:id", this.handleRequestId.bind(this)), this.disconnectWebSocket();
  }
  handleRequestId(e) {
    this._currentRequestId = e.detail.requestId;
  }
  disconnectWebSocket() {
    re.disconnect();
  }
  clear() {
    this._isAwaitingResponse = !1, this._isProcessingResponse = !1, this._generatingAnswer = !1, this._hasReceivedFirstTextContent = !1, this._currentRequestId = null, this.host.requestUpdate();
  }
  reset() {
    this._processingMessage = void 0, re.conversationId = null, this.disconnectWebSocket(), this.clear();
  }
  async processWebSocketResponse(e) {
    this.isProcessingResponse = !0, re.websocketEvents.start && e.on(re.websocketEvents.start, (t) => {
      if (t.conversationId) {
        re.conversationId = t.conversationId;
        const n = new CustomEvent("chat:conversation:start", {
          detail: {
            conversationId: t.conversationId,
            conversationUid: t.conversationUid
          },
          bubbles: !0,
          composed: !0
        });
        this.host.dispatchEvent(n);
      }
    }), re.websocketEvents.chunk && e.on(re.websocketEvents.chunk, async (t) => {
      if (this._processingMessage)
        try {
          await tu({
            chatEntry: this._processingMessage,
            chunk: t,
            onChunkRead: (n) => {
              this.processingMessage = n;
            },
            onCancel: () => {
              this.clear();
            }
          }, this.host);
        } catch {
        }
    }), re.websocketEvents.end && e.on(re.websocketEvents.end, () => {
      this.clear();
    }), e.on("error", () => {
      const t = {
        message: Xe.API_ERROR_MESSAGE
      };
      this.processingMessage && (this.processingMessage = {
        ...this.processingMessage,
        error: t
      }), this.clear();
    });
  }
  async processResponse(e, t = !1, n = !1, i, r, o) {
    var x, P, S;
    const a = vr(), l = [];
    let u = [], h = [], p, g;
    const y = i || ((x = this._currentRequestOptions) == null ? void 0 : x.overrides), f = async (N, K) => {
      if (K) {
        let A, F = r;
        t ? (A = N, F = (r || []).map((he) => ({ ...he, tmp: !0 }))) : A = "";
        const $ = {
          id: crypto.randomUUID(),
          text: [
            {
              value: A,
              followingSteps: []
            }
          ],
          followupQuestions: [],
          citations: [],
          timestamp: a,
          isUserMessage: t,
          thoughts: void 0,
          dataPoints: void 0,
          rawContent: A,
          // Will be populated by the parser for AI responses
          model: !t && (y != null && y.selectedModel) ? y.selectedModel.model.value : void 0,
          // Add files if this is a user message and files are provided (though streaming is typically for AI responses)
          ...t && F && F.length > 0 ? { files: F } : {},
          // Add hidden property if specified
          ...o !== void 0 ? { hidden: o } : {}
        };
        this.isProcessingResponse = !0, this._abortController = new AbortController(), this._hasReceivedFirstTextContent = !1, this.processingMessage = $, await eu({
          chatEntry: $,
          signal: this._abortController.signal,
          apiResponseBody: N.body,
          onChunkRead: (he) => {
            this.processingMessage = he;
          },
          onCancel: () => {
            this.clear();
          },
          onReasoningStep: this._onReasoningStep
        }, this.host), this.clear();
      } else {
        let A, F = r;
        t ? (A = N, F = (r || []).map(($) => ({ ...$, tmp: !0 }))) : A = N, this.processingMessage = {
          id: crypto.randomUUID(),
          text: [
            {
              value: A,
              followingSteps: h
            }
          ],
          followupQuestions: u,
          citations: [...new Set(l)],
          timestamp: a,
          isUserMessage: t,
          thoughts: p,
          dataPoints: g,
          // For user messages, rawContent is the same as the message content
          // For AI responses in non-streaming mode, we don't have true rawContent, so use the message
          rawContent: t ? A : N,
          model: !t && (y != null && y.selectedModel) ? y.selectedModel : void 0,
          // Add files if this is a user message and files are provided
          ...t && F && F.length > 0 ? { files: F } : {},
          // Add hidden property if specified
          ...o !== void 0 ? { hidden: o } : {}
        };
      }
    };
    if (t || typeof e == "string")
      await f(e, !1);
    else if (n)
      await f(e, !0), this.host.autoTalkEnabled && this.host.dispatchEvent(new CustomEvent("autotalk:stream-chunk", {
        detail: { chunk: "", isFinal: !0 },
        bubbles: !0,
        composed: !0
      }));
    else {
      const N = e.choices[0].message, K = typeof N.content == "string" ? N.content : N.content.map(($) => $.text || "").join(" "), A = Ba(K, [l, h, u]), F = A.replacedText;
      l.push(...A.arrays[0]), h.push(...A.arrays[1]), u.push(...A.arrays[2]), p = ((P = N.context) == null ? void 0 : P.thoughts) ?? "", g = ((S = N.context) == null ? void 0 : S.data_points) ?? [], await f(F, !1);
    }
  }
  async generateAnswer(e, t, n, i) {
    var p, g, y;
    const { question: r, messages: o, files: a } = e, l = a && a.length > 0 || (o == null ? void 0 : o.some((f) => f.files && f.files.length > 0)), u = o && o.length > 0 && ((p = o[o.length - 1]) == null ? void 0 : p.role) === "user" && Array.isArray((g = o[o.length - 1]) == null ? void 0 : g.content), h = o && o.length > 0;
    if (r || l || u || h)
      try {
        if (this._currentRequestOptions = e, this.generatingAnswer = !0, this._abortController = new AbortController(), e.type === "chat" && !h)
          r ? await this.processResponse(r, !0, !1, e.overrides, a) : l && await this.processResponse("[File attachment]", !0, !1, e.overrides, a);
        else if (e.type === "chat" && h) {
          const f = o[o.length - 1];
          if (f.role === "user") {
            const x = this.extractTextFromMultimodalContent(f.content), P = this.extractFilesFromMultimodalContent(f.content), S = (f.files || []).filter((K) => {
              const A = K.mimeType;
              return A && !A.startsWith("image/");
            }), N = [...P, ...S];
            await this.processResponse(x || "", !0, !1, e.overrides, N, f.hidden);
          }
        }
        if (this.isAwaitingResponse = !0, this.processingMessage = void 0, n && this._useWebSocket && i) {
          const f = {
            id: crypto.randomUUID(),
            text: [
              {
                value: "",
                followingSteps: []
              }
            ],
            followupQuestions: [],
            citations: [],
            timestamp: vr(),
            isUserMessage: !1,
            thoughts: void 0,
            dataPoints: void 0,
            rawContent: "",
            // Will be populated by WebSocket parser
            model: ((y = e.overrides) == null ? void 0 : y.selectedModel) || void 0
          };
          this._hasReceivedFirstTextContent = !1, this.processingMessage = f;
          const x = {
            url: i,
            signal: this._abortController.signal,
            websocketEvents: re.websocketEvents
          }, P = await Nc(e, x);
          this.isAwaitingResponse = !1, await this.processWebSocketResponse(P);
        } else {
          const f = {
            ...t,
            signal: this._abortController.signal
          };
          this.host.autoTalkEnabled && (this.host.dispatchEvent(new CustomEvent("autotalk:start-session", {
            detail: null,
            bubbles: !0,
            composed: !0
          })), this.host.toggleTalk(1));
          const x = await Il(e, f);
          this.isAwaitingResponse = !1, await this.processResponse(x, !1, t.stream, e.overrides);
        }
      } catch (f) {
        const x = f, P = {
          message: (x == null ? void 0 : x.code) === 400 ? Xe.INVALID_REQUEST_ERROR : Xe.API_ERROR_MESSAGE
        };
        this.processingMessage || await this.processResponse("", !1, !1, e.overrides), this.processingMessage && (this.processingMessage = {
          ...this.processingMessage,
          error: P
        });
      } finally {
        this.clear();
      }
  }
  async cancelRequest() {
    const e = this._currentRequestId;
    this._abortController.abort();
    const t = this.host, n = new CustomEvent("chat:cancel-request", {
      detail: { requestId: e },
      bubbles: !0,
      composed: !0
    });
    t.dispatchEvent && t.dispatchEvent(n), this._currentRequestId = null, re.socket && re.isConnected && re.cancel();
  }
}
class su {
  static setStyleColors(e, t) {
    e.setProperty("--c-accent-high", t.AccentHigh), e.setProperty("--c-accent-lighter", t.AccentLight), e.setProperty("--c-accent-dark", t.AccentDark), e.setProperty("--c-text-color", t.TextColor), e.setProperty("--c-light-gray", t.BackgroundColor), e.setProperty("--c-dark-gray", t.ForegroundColor), e.setProperty("--c-base-gray", t.FormBackgroundColor), e.setProperty("--radius-base", t.BorderRadius), e.setProperty("--border-base", t.BorderWidth), e.setProperty("--font-base", t.FontBaseSize);
  }
}
class iu {
  static fillInitMessages(e) {
    let t = [];
    return t = e.map((n) => {
      const i = {
        ...n,
        // Preserve all properties including files
        text: n.text.map((r) => ({
          ...r,
          value: ii(r.value)
        }))
      };
      return i.thoughts && (i.thoughts = ii(i.thoughts)), i.tools && i.tools.length > 0, i;
    }), t;
  }
}
const jt = class ke {
  // 5MB total
  static fileToBase64(e) {
    return new Promise((t, n) => {
      const i = new FileReader();
      i.onload = () => {
        if (typeof i.result == "string") {
          const r = i.result.split(",")[1];
          t(r);
        } else
          n(new Error("Failed to read file as base64"));
      }, i.onerror = () => n(i.error), i.readAsDataURL(e);
    });
  }
  static formatFileSize(e) {
    if (e === 0)
      return "0 Bytes";
    const t = 1024, n = ["Bytes", "KB", "MB", "GB"], i = Math.floor(Math.log(e) / Math.log(t));
    return parseFloat((e / Math.pow(t, i)).toFixed(2)) + " " + n[i];
  }
  static removeFile(e) {
    this.promptFiles = this.promptFiles.filter((t, n) => n !== e);
  }
  static async uploadFiles(e) {
    try {
      const t = e.map((i) => ({
        name: i.filename,
        type: i.mimeType,
        base64: i.base64
      })), n = await fetch(`${this.apiUrl}/upload-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...this.customHeaders
        },
        body: JSON.stringify({ files: t })
      });
      if (!n.ok)
        throw new Error(`Upload failed: ${n.statusText}`);
      return await n.json();
    } catch {
      return { success: !1, files: [] };
    }
  }
  static async onPaste(e) {
    const t = e.clipboardData;
    if (!t)
      return;
    const n = t.items, i = [];
    for (let r = 0; r < n.length; r++) {
      const o = n[r];
      if (o.type.indexOf("image") !== -1) {
        const a = o.getAsFile();
        a && i.push(a);
      }
    }
    i.length > 0 && (e.preventDefault(), await ke.processFiles.bind(this)(i));
  }
  /**
   * Handle drop event to process dropped files
   */
  static async onDrop(e) {
    var i;
    e.preventDefault(), e.stopPropagation(), this.isDragOver = !1;
    const t = (i = e.dataTransfer) == null ? void 0 : i.files;
    if (!t || t.length === 0)
      return;
    const n = Array.from(t).filter((r) => r.type.startsWith("image/") || r.type === "application/pdf" || r.type === "text/plain" || r.type === "text/markdown" || r.type.includes("document") || r.type.includes("text") || r.type === "application/zip" || r.type === "application/x-zip-compressed" || r.type.includes("compressed") || r.type.includes("archive") || r.type.includes("excel") || r.type.includes("spreadsheet") || r.type === "application/vnd.ms-excel" || r.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || r.type.includes("powerpoint") || r.type.includes("presentation") || r.type === "audio/mp3" || r.type === "audio/mpeg");
    n.length > 0 ? await ke.processFiles.bind(this)(n) : t.length > 0 && this.dispatchEvent(new CustomEvent("popup:show", {
      detail: {
        message: "file.upload.error.unsupported_type",
        type: "error"
      },
      bubbles: !0,
      composed: !0
    }));
  }
  /**
   * Handle drag over event specifically for the form area
   */
  static onFormDragOver(e) {
    var t;
    e.preventDefault(), e.stopPropagation(), (t = e.dataTransfer) != null && t.types.includes("Files") && (this.isDragOver = !0);
  }
  /**
   * Handle drag leave event specifically for the form area
   */
  static onFormDragLeave(e) {
    var n;
    e.preventDefault(), e.stopPropagation();
    const t = (n = this.renderRoot) == null ? void 0 : n.querySelector("#chat-form");
    t && e.relatedTarget && !t.contains(e.relatedTarget) && (this.isDragOver = !1);
  }
  static async processFiles(e) {
    const t = this.promptFiles.reduce((i, r) => i + r.size, 0);
    let n = 0;
    for (const i of e)
      try {
        if (i.type.startsWith("image/") && i.size > 5 * ke.MB) {
          this.dispatchEvent(new CustomEvent("popup:show", {
            detail: {
              message: "file.upload.error.image_too_large",
              type: "error",
              params: {
                filename: i.name,
                size: ke.formatFileSize(i.size),
                maxSize: "5MB"
              }
            },
            bubbles: !0,
            composed: !0
          }));
          continue;
        }
        if (i.size > ke.MAX_FILE_SIZE) {
          const a = await ke.fileToBase64(i);
          this.dispatchEvent(new CustomEvent("big_file:confirm:kdb", {
            detail: {
              payload: {
                title: i.name,
                content: a,
                mimeType: i.type,
                originalName: i.name,
                size: i.size,
                isBase64Content: !0,
                // Flag to indicate base64 content for file upload
                contentType: "file"
                // Specify this is file content, not text
              }
            },
            bubbles: !0,
            composed: !0
          }));
          continue;
        }
        if (t + n + i.size > ke.MAX_TOTAL_SIZE) {
          this.dispatchEvent(new CustomEvent("popup:show", {
            detail: {
              message: "file.upload.error.total_size_exceeded",
              type: "error",
              params: {
                currentSize: ke.formatFileSize(t),
                newSize: ke.formatFileSize(n + i.size)
              }
            },
            bubbles: !0,
            composed: !0
          }));
          break;
        }
        n += i.size;
        const r = await ke.fileToBase64(i), o = {
          id: crypto.randomUUID(),
          filename: i.name,
          originalName: i.name,
          size: i.size,
          mimeType: i.type,
          base64: r,
          tmp: !0
        };
        this.promptFiles = [...this.promptFiles, o];
      } catch (r) {
        this.dispatchEvent(new CustomEvent("popup:show", {
          detail: {
            message: "file.upload.error.processing_failed",
            type: "error",
            params: {
              fileName: i.name,
              error: r instanceof Error ? r.message : "Unknown error"
            }
          },
          bubbles: !0,
          composed: !0
        }));
      }
  }
  static handleAddFile(e) {
    e && (e.preventDefault(), e.stopPropagation());
    const t = document.createElement("input");
    t.type = "file", t.accept = "image/*,.pdf,.doc,.docx,.txt,.md,.zip,.tar,.tar.gz,.bz2,.xls,.xlsx,.ppt,.pptx,.mp3", t.multiple = !0, t.addEventListener("change", async (n) => {
      const r = n.target.files;
      !r || r.length === 0 || await ke.processFiles.bind(this)(Array.from(r));
    }), t.click();
  }
};
jt.MB = 1024 * 1024;
jt.MAX_FILE_SIZE = 2 * jt.MB;
jt.MAX_TOTAL_SIZE = 5 * jt.MB;
let $e = jt;
class Z {
  static handleQuestionInputClick(e) {
    var t;
    e == null || e.preventDefault(), this.setQuestionInputValue((t = e == null ? void 0 : e.detail) == null ? void 0 : t.question);
  }
  static handleCitationClick(e) {
    var t, n, i;
    e == null || e.preventDefault(), this.selectedCitation = (t = e == null ? void 0 : e.detail) == null ? void 0 : t.citation, this.showCode || ((n = e == null ? void 0 : e.detail) != null && n.chatThreadEntry && (this.selectedChatEntry = (i = e == null ? void 0 : e.detail) == null ? void 0 : i.chatThreadEntry), this.handleCodeExpandAside());
  }
  static handleAdvancedPromptingChange(e) {
    this.advancedPromptingEnabled = !this.advancedPromptingEnabled;
  }
  static handleVoiceChatEnd(e) {
    this.showControls = !0, this.liveChatOn = !1, this.requestUpdate();
  }
  static handleWebSearchChange(e) {
    const t = e.target;
    this.webSearchEnabled = t.checked, this.dispatchEvent(new CustomEvent("websearch-change", {
      detail: { checked: this.webSearchEnabled },
      bubbles: !0,
      composed: !0
    }));
  }
  static handleDeepSearchChange(e) {
    const t = e.target;
    this.deepSearchEnabled = t.checked, this.dispatchEvent(new CustomEvent("deepsearch-change", {
      detail: { checked: this.deepSearchEnabled },
      bubbles: !0,
      composed: !0
    }));
  }
  static handleFullscreenToggle() {
    var e, t;
    this.isFullscreen = !this.isFullscreen, this.isFullscreen ? (e = this.requestFullscreen) == null || e.call(this) : (t = document.exitFullscreen) == null || t.call(document), this.dispatchEvent(new CustomEvent("fullscreen-change", {
      detail: { isFullscreen: this.isFullscreen },
      bubbles: !0,
      composed: !0
    }));
  }
  static handleFullscreenChange() {
    this.isFullscreen = !!document.fullscreenElement;
  }
  static handleChatEntryActionButtonClick(e) {
    var t, n, i, r, o, a;
    ((t = e.detail) == null ? void 0 : t.id) === "chat-show-thought-process" && (this.selectedChatEntry = (n = e.detail) == null ? void 0 : n.chatThreadEntry, this.handleCodeExpandAside(e)), ((i = e.detail) == null ? void 0 : i.id) === "speak" && (this.selectedChatEntry = (r = e.detail) == null ? void 0 : r.chatThreadEntry, Z.speak.bind(this)(e, this.selectedChatEntry)), ((o = e.detail) == null ? void 0 : o.id) === "download-speech" && (this.selectedChatEntry = (a = e.detail) == null ? void 0 : a.chatThreadEntry, Z.speak.bind(this)(e, this.selectedChatEntry, !0));
  }
  static speak(e, t, n = !1) {
    e.preventDefault();
    const i = new CustomEvent(n ? "chat:download" : "chat:speak", {
      detail: {
        message: (() => {
          const r = document.createElement("p");
          return r.innerHTML = t.text.map((o) => o.value).join(" "), r.textContent;
        })()
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(i);
  }
  static handleDiscussionLLMTurn() {
    var n, i;
    const e = this.getMessageContext();
    this.aiAssist && ((i = (n = this.currentUser) == null ? void 0 : n.accountGrade) != null && i.promptAssist) && typeof this.aiAssist.updateContextFromMessages == "function" && this.aiAssist.updateContextFromMessages(e);
    const t = new CustomEvent("chat:llm-turn", {
      detail: {
        messageContext: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  static handleDiscussionUserTurn(e) {
    const t = new CustomEvent("chat:user-turn", {
      detail: {
        messageContext: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  static handleModelSelected(e) {
    const t = e.detail;
    this.overrides = {
      ...this.overrides,
      selectedModel: t,
      avatar: t == null ? void 0 : t.avatar
    };
    const n = new CustomEvent("model:selected", {
      detail: t,
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
    try {
      const r = (window.parent !== window ? window.parent : window).document.querySelector("default-layout");
      r && r.signalService && r.signalService.getSignal("selected_model", { initialValue: null }).setValue(t);
    } catch {
    }
  }
}
class Vs {
  static listenToEvents() {
    this.addEventListener("chat:progress", this.handleProgressEvent.bind(this)), this.addEventListener("rws_modal:chat_settings:close", () => {
      this.showSettings = !1;
    }), this.addEventListener("rws_modal:force_close", () => {
      this.showSettings = !1;
    }), this.addEventListener("rws_modal:ai-assist-suggestions:close", () => {
      var e;
      this.activeAssist = null, (e = this.aiAssistantSignal) == null || e.setValue({
        command: "pass_entry",
        payload: null
      });
    }), this.addEventListener("code:show", (e) => {
      const t = e;
      this.handleCodeExpandAside(e, t.detail);
    }), this.addEventListener("code:stream:ended", (e) => {
      this.showCode && (this.showCode = { ...this.showCode, preview: this.showCode.language === "html", ended: !0 });
    }), this.addEventListener("fullscreen:disable", () => {
      var e;
      this.isFullscreen = !1, (e = document.exitFullscreen) == null || e.call(document), this.dispatchEvent(new CustomEvent("fullscreen-change", {
        detail: { isFullscreen: this.isFullscreen },
        bubbles: !0,
        composed: !0
      }));
    }), this.addEventListener("code:preview", (e) => {
      const t = e;
      this.showCode && this.showCode.id === t.detail.codeId && (this.showCode = this.showCode ? { ...this.showCode, preview: !0 } : null);
    }), this.addEventListener("chat:conversation:start", (e) => {
      var n, i;
      const t = e;
      this.convoId = Number(((n = t == null ? void 0 : t.detail) == null ? void 0 : n.conversationId) || null), (i = t == null ? void 0 : t.detail) != null && i.conversationUid && (this.overrides = {
        ...this.overrides,
        conversationUid: t.detail.conversationUid
      });
    }), this.addEventListener("code:update", (e) => {
      const t = e;
      this.showCode && this.showCode.id === t.detail.componentId && (this.showCode = { ...this.showCode, code: this.showCode.code + t.detail.chunk, preview: !1 });
    }), this.addEventListener("code:close", (e) => {
      this.collapseAside(e);
    }), this.addEventListener("chat_settings:submit", (e) => {
      const t = e;
      this.chatSettings = t.detail;
    }), this.addEventListener("voice-chat:conversation-end", () => {
      this.liveChatOn = !1, this.showControls = !0, this.initialMessages = [];
    }), this.addEventListener("chat_settings:close", (e) => {
      this.collapseAside(e);
    }), this.addEventListener("add-file", (e) => {
      const t = e;
      $e.handleAddFile.bind(this)(t.detail.event);
    });
  }
  static listenForFullScreenEvents() {
    document.addEventListener("fullscreenchange", Z.handleFullscreenChange.bind(this)), document.addEventListener("webkitfullscreenchange", Z.handleFullscreenChange.bind(this)), document.addEventListener("mozfullscreenchange", Z.handleFullscreenChange.bind(this)), document.addEventListener("MSFullscreenChange", Z.handleFullscreenChange.bind(this));
  }
  static removeFullScreenEventListeners() {
    document.removeEventListener("fullscreenchange", Z.handleFullscreenChange.bind(this)), document.removeEventListener("webkitfullscreenchange", Z.handleFullscreenChange.bind(this)), document.removeEventListener("mozfullscreenchange", Z.handleFullscreenChange.bind(this)), document.removeEventListener("MSFullscreenChange", Z.handleFullscreenChange.bind(this));
  }
}
const zr = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="533.37976"
   height="479.4425"
   viewBox="0 0 141.12339 126.8525"
   version="1.1"
   id="svg8"
   inkscape:version="1.0.1 (c497b03c, 2020-09-10)"
   sodipodi:docname="brand-logo.svg">
  <defs
     id="defs2" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.4654497"
     inkscape:cx="303.64057"
     inkscape:cy="106.60712"
     inkscape:document-units="mm"
     inkscape:current-layer="layer1"
     inkscape:document-rotation="0"
     showgrid="false"
     inkscape:window-width="1187"
     inkscape:window-height="541"
     inkscape:window-x="119"
     inkscape:window-y="131"
     inkscape:window-maximized="0"
     units="px"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0" />
  <metadata
     id="metadata5">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-18.235046,-25.370501)">
    <text
       xml:space="preserve"
       style="font-style:normal;font-weight:normal;font-size:18.7575px;line-height:1.25;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.468938"
       x="76.622147"
       y="77.940918"
       id="text837"
       transform="scale(0.95147583,1.0509988)"><tspan
         sodipodi:role="line"
         id="tspan835"
         x="76.622147"
         y="77.940918"
         style="stroke-width:0.468938">YOUR</tspan><tspan
         sodipodi:role="line"
         x="76.622147"
         y="101.38779"
         style="stroke-width:0.468938"
         id="tspan885">BRAND</tspan></text>
    <path
       sodipodi:type="star"
       style="opacity:0.99;fill:#eec4e6;fill-opacity:0.835294;fill-rule:evenodd;stroke-width:4.99999;stroke-linejoin:round"
       id="path887"
       sodipodi:sides="5"
       sodipodi:cx="55.752526"
       sodipodi:cy="87.899637"
       sodipodi:r1="26.130005"
       sodipodi:r2="13.065002"
       sodipodi:arg1="0.77001476"
       sodipodi:arg2="1.3983333"
       inkscape:flatsided="false"
       inkscape:rounded="0"
       inkscape:randomized="0"
       d="M 74.511266,106.08993 57.994602,100.77082 44.249297,111.36137 44.204142,94.009392 29.884399,84.209489 46.373155,78.804488 51.268372,62.157267 61.504139,76.168769 78.849293,75.680123 68.686589,89.744708 Z"
       inkscape:transform-center-x="1.3856798"
       inkscape:transform-center-y="-1.1403183" />
  </g>
</svg>
`, ru = `<svg version="1.1" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 120 120"
	 style="enable-background:new 0 0 120 120;" xml:space="preserve">
<switch>
	<foreignObject requiredExtensions="&ns_ai;" x="0" y="0" width="1" height="1">
		<i:pgfRef  xlink:href="#adobe_illustrator_pgf">
		</i:pgfRef>
	</foreignObject>
	<g i:extraneous="self">
		<g>
			<g>
				<path d="M98.3,75.3v-5c9.2,0,16.7-7.5,16.7-16.7s-7.5-16.7-16.7-16.7v-5c11.9,0,21.7,9.7,21.7,21.7S110.3,75.3,98.3,75.3z"/>
			</g>
			<g>
				<path d="M100.8,107.2H83.1V0h17.8V107.2z M88,102.2h7.8V5H88V102.2z"/>
			</g>
			<g>
				<path d="M88,101.9L12.8,74.5V32.7L88,5.3V101.9z M17.8,71l65.3,23.8V12.4L17.8,36.2V71z"/>
			</g>
			<g>
				<polygon points="50.2,120 25.9,120 19.5,75.6 24.4,74.9 30.2,115 44.3,115 38.9,82.7 43.8,81.8 				"/>
			</g>
			<g>
				<path d="M17.8,68.9H0V38.3h17.8V68.9z M5,63.9h7.8V43.3H5V63.9z"/>
			</g>
			<g>
				<rect x="26.2" y="102.2" width="18.9" height="5"/>
			</g>
			<g>
				<rect x="25.6" y="29.8" width="5" height="47.7"/>
			</g>
		</g>
	</g>
</switch>
<i:pgf  id="adobe_illustrator_pgf">
	<![CDATA[
	eJzsvemOJbmVJvgE9g53fhQgDVq3uJOmaQzga7V6pJKgVHXXoNAIREW6pGhFRiQiI6XRPP183zmk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==
	]]>
	<![CDATA[
	W8kuXt0as5mc7+sJuj7fae9cupDO3kfQhe/rFfYP+Sb747O//B2bg//ii0F3xn9W9mVrBveLx0Jj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==
	]]>
	<![CDATA[
	HftN3K+PT9vz3a+7vf19oIrsD8n39QS5T3ErBRe4cA7XEnv31uILBNuws0tL52kL5GLCFi52M9jv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==
	]]>
	<![CDATA[
	xYCDLiCeoPrgYWjjwmnEpWmoGAN7EIVxme3OYfGQccl2x91UxiWUc54jGBFMIhiIUyaZCXqOx0pC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==
	]]>
	<![CDATA[
	CL9bewGvWMwyjax+RpvFXkCdtyVsVSLKAN622QtoWFP/gYJTYtPOXjDY65u9YDCvNxsAXXjQFO3p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==
	]]>
	<![CDATA[
	FcSZQYA+EadhKGiQZ7mccVvQ+DW8Ud9C36ibmLGbfm7HkTy1RssdH0qVLQlWTomDbDOpM+HnIG8u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==
	]]>
	<![CDATA[
	YajGx6lLDKyyahbHzU6uBXwr2FXm9G0GefJNZGdyxjmiPdvOjXUgipqLYq3HapxC0n0gZnyOGhIM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==
	]]>
	<![CDATA[
	YC+oCx3gNsbqVeIDsZU8A94xd7HkOkBdZT0JSZoeTofqUmSZ/kzG86nNcQLEdVdvaDvB7bIyzsDJ
RrR0aZjRET6MFOozDaLKxOgHMG5noD0G3J6+q3EG1Dm+GSDNbDhFFx4KGTKXj0IljR4dGzXcvBRo
ALSGx2Qlt7bvG1kYDdca2Sg6lbnEMpM2UGrcp8HuQv5y/Irj6OGoOv9mi2mKK2BuC+zHXpy31o36
xf4TlT3DMi2lqk5v1jzmz2rjiBxwwEMztaf5BShiAFTB1i+vSAH9E8Kal8RuzzqUgBtVxnI2Mpv5
cckMoHmT6eJElB4NaCYVEAALp5vJUBH330AmerE60Uv3HIwSu6t6AhjhF6PuBsj9sr6CsUzQ4a4y
4gqU2sbx9MirR/yA4zq2ICElF29Ed2MaOfKTYJOsKb+krv0Lm/C6hDbyIentbKFqr2vn3AACIWF0
WsGOPXiLOYWaWxH8bRYQGDUPbnh6YGaXedCeVkpcVPJ8n6HQk/tGlmU+TUZKgH3P5IyYWB3ih8xl
k0CuIIPSI/kzqNoPpFlyvMHzdwPnx6dneTgHaDihjfMrW1pv8/6VWoNjyJJLGJpaud8sauyoIham
lWtlJagaDtA+IBisuqODgTMW2xfPEz0AYNhjYL48e1gNo8fYb518gezH9UGgEUQZeawT4rY9gHnT
o4yI3OfqdWr1o6XEX8qF3UkzYhN3+HOBnTfFTHtqy7d9se3mLnVGPY0C1HGMAFIqVAP09pSI6qZ6
PhiEbnpH2XUHJGltkHkUsy912ohiklxf0GJ9fThCOPaJzYKuahn7LGFk26382ZhWaAUkga+keuDf
7jXmy3LE191JQu0QQAkxu5A+ojxGHAbgUYDO7EoBluJkuIUe6pP+IpXUNyZWpIHFOG0IxWmzBs+3
hjR2p24yYlMTKL3U9L3bDYb++BMRrHAdZKzuT2GCwa2lcMB96eQ7wjQkRPvn4teplKrwsOGAJmka
W5w5jbYjaOlA1fQW63i/N8urLWQUg0qPDjiog+NOCdFm0NnmhnreD9qiHDxyVFNnQ8P6aH1ILKLA
OSQgZke+nAEUZ2vLp60h+J+kMguJOI+ombS57ycF0AK6Cwo+8FVzQgSPuY7HbqnEDgWITn+1qeGM
wj2isqfF0NCA+jhO9nbf/c8mJpQRLgHGwnMZHZRlS4/dCiD2yIfPZX5G43dDPMsieOTVmb0QtwTs
X3H0nJYIPxsq+IjrHhDvbUTeI4gBwd+eKyObUehaOeROLIVjekEtr143dJU252z4TgwT2tpCe3dx
ZXPaBpcMslDpKRp87rPBw6/CF03CQ9FjnUstOIS8PoP9NA0z7BGgENo0GExo84c9ZfJ0L+DGWRfg
nMILSISLVywEN4idKdOj/zO3zfM/UDgqIUZWg4VkrCUNSGmkJhDy4Zp2DYnjKglynIoqWfAzbPSq
mKYalkWwjsb2OR0mEjh2qoI1/w42BcHePEvLS7RAUDOvDgjsGZrRsPdeNAb6trL/CK0X8ZvjWow6
sr5AFIjjUvzE4I5UodGc7dgDYsQOocKnYg358s/psbvkvjEFsslCG+QP68WrDmRACySVStT5lGwU
0tvRo5mDlg1dWlqO0gPmBEumgbu9OQUAb4QpzrYc2A0h335I4RC047ODNvelLcvSyN/X6yQBy9UQ
0LaSemiCCSgnEEOVWp/LOJwOD+ce3/lCQPYwjGngkkGolVUMBAAtV2ogHU+ZDYTaiCfqkJxPlBRj
NT/cb1Rw0/NPek76JaxtCZEF+wdtjDnMxL/VuLjcVaLVBm2e7hKXtn+pmxt+EPku8KmlB2T5yKEq
RP6BTy0R33eBTV796+EaHw6RJPfmSEft5FrKnuydOQ50NoSh6k/fws/a17ahqP1wxw2OEmQjN0iQ
WsOEZ74fx/dkfCwqzRF1m6bD9VxufoupLR7inKL0COjQ0cIrINRYiTqF2kVDzMOsneArjxnrXo9P
XWMl8tgzzJUXm8PG82SjZMoswWUo84lQq3/YFVOZAmF2sWwHftDjSFAiziRgFf9cVsIrcEcrJr1P
omFKo2I6X3FK6erssf4IOQSpnDl7CbAem3jpbliOzydQTKDsVQskB8mHy+KdgwH+a2SGMc0AeDav
8oq883cDeK+x02yfbdfi5prDYsVmj1J94dF1NAoxvQQ09TK7H4oXEcswG5xkZgFR4gceUhdkA517
KxgJiDibL5FQKZGpA4j/tNA92otCE3mehihz+bXqoxxX7QZqzfBtnDM5oT1AOSbl2ZCE4owXCjVc
oa6sK1T4La89uhapVswNJvyb6RXp8OF7Nt/1c59lQfHnRv9k1aKkk2RXfVhpajsyxiJKMb55/nPB
xTGetXLfsXN03QQaoT0CZ1Z39dbkOTeYb8reOMagSumSSZJlsfU85l1kb2wWJcI5GoJXBkised9N
fEm4MoU474T4cnY3O/1AJRwVrtnYE5iReCv8VA01U5BIFFEkaeVF7WWXw/wMepqhFydDSI8fMt+y
ucUDD+Sqnhe+bm7pRKH93s7hD3/zF3T7jFVHhaFSAfsfzuXI+M1dFUq7IU4AY+JTePT+C4FSKPbX
h1HAkt6esem7DcAINULqsIlIuAcg80+78dBYLLhsszGoWRZnSX6SDZ47aBpYti2qnvefO/EXZCGq
VtG3Aoxz/PnVEB6IWotKXSH8z+g+KWYrAspMvBKmaeW5cTuaO1yAvRYBP9OViLORy1SEH4FKRPgx
oK1nkNQi21bdxVSCvxpuBiN+8QB5614GdrsddUk9uCg3fK9icY0azWwjNU9bjgmlBlK9YqdlxGUG
OAcaPKswCznIhnMnccui4hXYNDaK7ONlJu0gyGCZCZC8x7S63bfnfftJfF3yetNI2VbqNoN3U0A+
Q9plBkgVdGESrXtF/KnRdyIv0AyOsgREMBmiZH0En63O50xkIsUhv/TzMZehcQ7wZqPsMM1LKRXi
mkX4dgX5wAandNLTTBRXoPn+uDLncgwMlZ1UnERkMloMbpER1qmBJG5KkRfDYnnebWa1tDH0lOqi
8Dqoq4qIi8Qie1g/Nd+jgzTsCEyMLgwWGoNlgQhf2iej1An7koyKWeqVHCCV5vyw540jjNVw9VTJ
EVxWfdVmBksz9Qprm0yANcwNBWVSM+Fh5jUL+wkXE7ASbt6ZBfrrdObbRatUVSPrygtEfX1+T9S7
gv/r1UVOAC79aUPZBoVWSKVVzmC6+l0GCvzGgC2QnZSv+Bs5L+5wjjvcMTCKs+3fCmMZubK5dnBP
pQERg7IdNcs5t6PoSqpcKf+ECpJ8hYPp2rEhZNU4DFFdSm5oARByMXBEd2F9o0txnptZ7iV84rLM
xmU1zbNb/S6vCh6Nrmx4eGjZWHB3KX4qWPhzigD4mfNvl3DJM6YV/j5v8e4aKKSGkXKPQZFDsRvX
4FbkRXPYtZbjBrEF/IgNeQOEtMhuwWUAe+OoZE7VWl2pyoI6Z2EcB93lZJMHnmiOUuohIAj73hNx
uuSORyitTvDURBvyzJc6dXKIxqolNggJIaInh3fnRw5r0N3Mt43KmYxVzwQVDBGeOdYATI35Fhrz
I07n5uI+XVZefsbo5BVa3C+ugUHCNVBhLmt1oCEYSZ2FI45vYN4Ye4eI/+tFY6DmTwqGiFDMGTcd
KqDOWCVs7kEJ1SNmMG8T7DJ5lZRXUP1rUbcBRXjKd0pyfkRpAy4HRRjsvvloW3Aambq9JtqwFp9t
yG3JLRROCfRQIsuMBNmhyuOtcTaT97OBWIYPXNvRvPWFnj8CYEWje+C2dnCogOSgTgaIkAYdvw4U
g1oQf/e+tuGXCwCOy59PuJUg7cnmA8BGcYpomhR01V+kBhuA9eIsUgecd+POnYHXAh+MNTaZGjMb
Qaik1kV5oarQLckLPlIow8wRAe89PRIlNMI7TkupgL8v/w7eTN/irpKOPX7uV0fqKNR0EM+wZlNU
xZKkz+altHNOXM+zzWVH8Vro+fG1Nwe3K/7dGjPO9WvnJlpefI0xIqAMjTh5THOe26matK6lo1te
VUFU0QF6sYoOFG17JtVpGMIQJMUKn7/txCTHnJ4cTKZZTezSYEiEmARlckj9shRJEnh6OMtZ7YAX
1plfdAbFrEdfoZ2NKl2cPQi7NAy50YBrVCZoO1Q2C2ASF7YLd/lgfr3M67ivmkP7Ildjoc5czRlq
9nNDeYCFaldkw2OrGFmovqqdrMqi4BFbpwjeg/UrNz7nkAFGyIUJumz0FY2Ct86kqDzTelOBoC1l
hpO50U+xEtkgJGY2sLhzfFfHD8i+gjQOYBY0dYOyDZQ4EVDXCk5STAQMXtqcMYsNCBzfq2ngJYdx
laQ6ARmfsA5qOTvHuRRrqZ8PokJvcKx/vHskgVD+6XIkLtUkAkXD1UWNiXSbIMBj1/R5ZPCNrhdI
mg2cL0BFpiny7leEZ1oGouB5BTl6BXRLkIgoliSnMrttbwfyAmYWuBg2+mIT9x4QVypLdYyntcFj
YmLvjP5dj4ZN66RR+S68GyiT02gwNBtCLnoGAHEcoGEcVxykwPgPQY0dBX59U0cqqvuLKjuwOsdP
m0MA5VBzCSCvyf2juka1dN4b2UyBWtiKHzOmQLaExrT8xaQpzz2ujHnutjWbgvuXsNOUyNS3B/Td
TZcAlgMMY7IxEho7tDqCTtFWyvd3N3e7xPWDNtzf/p2WoXMM/4df//F//vd/++d/+d9//e3f//1/
+uMf/9uf/suf//0f6fshCvff7QAaSgE/9Ggh1jSvQb2gSvXyT6vXCYwCneItiZrh9VDiFVh3jMj3
MYPlVT9mM2GPFgochj5ojhwtqsSoktCBVMd6oc4gMcxe81VZvc7QjkruF+nRvGCeQl3aUZBiZlNa
kWxscgd7yuix8GMHkNwXmJD+c7oPSwwAZXi3DhSj2bX4kw5/dA+MJCk8YIDH3O+OcEM3LUqBL2qe
Hz0igkcUQo2Y+UvL+Ok815pjQIf25Q7RD1FaAXH4Anh11Nz25rGTmCEZZXU89MiutHTNVipHA4UZ
IjVK3EgxwQOeX9BM5VjTvKwjXgJkwdyJlcusTuNV+XRC6Syr3V7jiI/rscGNEFV8qLyrjvl5XVEb
VeqAij7ss9/5gmNB6PqIiPaQKwTZaj4jpnZ6tNhdBXX3GEu9Kp8916i6hpYQiKDoUJKKX7Bh70Rc
zHSNK6bAr0gBdzJ2yAg+ANNJliq/jiPIwfq09+5VQPqiUZ3ywJpgU7lElVLDyMLaWg79nXGq+CLl
Tl2nnV6lMfKe3DtMMEfwTWmACc/f7ifJI8T4pChvx75dK9zOQf8FvAKcRW/SGmcJhPzcgrIFIS8N
F9oGh+n8BBps16IJxQ0ja+cDnoHloSHqiDtWomxQe6JQO6zrL10fwoI5ZecUIcCxxerU9nHyn6dM
hGw5GO1+ygE2PwWRngCxjVADKiE2xJZZd5e7OuGeNm7EAcDYxsi0wCXyt85FYITSig==
	]]>
	<![CDATA[
	GQoEOdlPV15BVpn8Cg3Ne8b7Ch0xwy133YSEGTlJnZpYZeKqWWU0YS/EGyLJJCn+YSdGew6PEV7F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==
	]]>
	<![CDATA[
	p/7q059Zd86dDR+AoRzlEqXZUdXDjdweJ4xvNgQLzhwaYu6CogdYXEUXb1TvkSN+RT82nV6uHy1Z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==
	]]>
	<![CDATA[
	w0MOW59t/Zo0ryQozccRNI8Qudabjrs1j+Pv9rR+jUaCldlITnBbv/o1RYUDTA7O2/qVhgwvC2w9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==
	]]>
	<![CDATA[
	1ac3O7/fTW38VbMo80ZrlPF07wtpu3Sb9pEVMa+2vfoobvb6btFHxUCmxHLm68Eqvg35ztDRe/Ph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==
	]]>
	<![CDATA[
	+5wbnd4idVTYauL+EHkPdiQBrL9kH0jimNfLag/k7y8nqXbFOoivbllzCMnDI4JBMwiL/rQaRT/P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==
	]]>
	<![CDATA[
	KQX1pPgpFw6xRZfa+CkAb+hxbEUj4k8rKkWUTguilKChREKE4O9ak0qObOucDA4im0zxPoKXivhU
BSW+qq60daHdLCDOM/3I60NKfhZgRStYacxMZ4jZ2WHGF3aoK7JS7I/gqS82SfQi1qzgwyKkOUFV
EX+R2/YKRrcHgpT2IEfiZTckeiAaX6shfkAd2zvDXTyLy9yc9GbMRN7GuTADA+C2iJopSPGxNKLP
6f4QDjjvd4Wxwz4Znbkz5pp1iqGwa+zzz4B4FqzVPA8vq6jkObqINbWSjHUqEgDomBM2av7Botrk
/4tIpv7NZi5d+4cggs0+HFRjXr0u47pEEOVpLjRwChq1IruvDevHzKLZ47zaCoN5w+Y4K3ve0Chm
rkN8fPdqxsaoMbJ8cp0Ae2ePs7pyk7hvBo4ljAEbmirzVs0Zrkb8MmfXbIe+IEi5pZBcnu8HeVY6
oWhsHR5eEjdclzTWR/fNRAhViDbzET1ySMTrkcxwlHrQF/VgSWmRemGGMz/jkEG+x3C8A0maT5Iq
Lxv7+YubqjWsvNKDyMFyLZTTQbLOvUv2LiddGVgPGryq+EkdsYyISHHitlF6WpfaF1ucLrNl/o4R
5wXywe0f5nQSCw/BMWX8jbmmF9EGvfSCystHmzeVJ8AXNx4JOKEUDChLAQFGiisoGT/NuU8/8uoR
P2AuZ1ulqi3DB75H/8OcQkq01qPLDqprt0oWJiKbeE9hjvKDCuA+gqFDFfKIqcBIkS4vC3TLdtvZ
ErSCokhpZbcps0kBqWKwzfaEEyIlu26yTWuz+TBP0zakQ7MqxOjE7rGlCA4dUsoK0hW1ktjsDNXo
ACLhpOwS3iNQCM5YgT8wR4lILZI7ADtZrRC52/MsZdjTqqShZiSjLkgtgA8IoURqzWV8fkQL1fh4
9Cjeuy5cLtPD8j095uJASuo89rZNLmn2NM23Dx09p405fhxTemad0QNbTwNL9h+oXLAt+8up0Dtp
SmBpYmduP6hmWNMqlq4yPGNzpigX8uJWzK7EKiFpTFbzSMpU0UMvwUrSpwtiN7tCHABGQlIcdaPR
EQEF1AQdbcetaaVMqNHx8dFXVJoUJORvrD/4FKg3GyKQx3S9LQQN6aIGFGdnOEJ/yl5XYKcVZav2
uhxjYQjsZTH+UYAbI0LzoBqgLLwuyYmmsRquO8gXyHhkH1quIAIHYgg5hR47D8GxdZgDCsRGV+P/
UvpHFoiwwDMm7Y51w15cqD5ffYESU4ASW4rFSk3zSn6OutlQsuUA6oE6ulvRoB7Mr5Sd+tnDrShK
PkUQMo/8h15AQHy07LQ1JgcdD61sTpxnWhwL3fuQOOpBs62S2cmhb6ZljgQiIH4lv1C0NAqGDZQC
Uu5M1NDv7IEoC4ScGLkAMc2VHLRKTX2B20xm8kLfmvHITbLFaWparF4CDuFGlGtj4wPZLs/p8zyC
1yUAUAAXoxiiY+K5N1wMgzgSzLifqdmBSJeAPUwQNviLMmozDRHYxwWfQBQlWJ+BwZ5jVmLMZ4/I
F5TYowOW7T/1IlLWIWfuXfIZSF0yVVJxBVZ8dsDAiQQsgIS63WO/OinTcIjaQ4SWiN/NW8OHmqiY
IsQIWP0cjkWWWRSeyGOc47tHjLoSWMrvj+cwB5UNUeKtqGGsNUMmWbCfPQQiygxnzL6G9Ucv1EEv
b/iB+sDcfNSQ+sdmzhuRquc/AwE1lzcV+Hn1gqqEXsXNsj1jUWTfITSQXpeFkbmLjNN0Ae1zFpUx
wvKTxJ2fTazGufxidW0Q1hbUq4vNVLm/pkvqmX0kPgN+cwtwQTFvsQFKsQEa7MDpAVGEHt1ndp4x
uTa4QqmtHjl63ASSsy5GJok9cXDaQMh/6cfCOrrrQ3b2GAJZy2Ifjp7Ew8JOFUEXEOZE2nghEsHt
kkpsVX1OgVuWro+qpqgd2OfYYcQdLfJcAA8ykoZq2ABgqA0HkqhuQzoaSxxrJcjvl0Li0ETkQ7Nb
GItEL8h0Xk6qQSQJvDphwBnwdAu6pFZvYcZxLZ4WOLUaRIJg2FxIncU3hYjHXELkn+hmWPymsK8Y
56KKh8Oal8K6zaVschqcdNF1QM0BMcMVHHLmYMJAemeqOoMIYJYIbIc5jHOtZhrTrvuOQhtvLIC5
HKD+BW4oBelbIF260fA4hCGCTpUqQyjvwnEsNi+FDsWOeX2pP6vBsq/7iOwWvQTjtxJ8x9mrmvjg
PJCL+SbTDxGFw5CY48dBcIT4Eg0lviCVDRaD9iW7q1ONX71agNJkWhLJN28d+l1W0Of+Z8Q3a6U1
e+Qenwx2CZ545SXQcBxRDu91geUDFgHQa027Sf2FudEtogSVQRN7VoNmGq8aXlojnN2sPo0lWhKP
ZPmEN8UAkr08yyA340haBYBG4pS3hR5kVAbAjyDA4cLTZAYstSiQnjDWb/8hb4vT/2HW3V4txPtL
+Kpj4yWn7yC/GT3Q8Zf5fgUAQD+lxlYwEAJt+3jR5oKNO8PSmCIuAIcrmJQOZNDokJZ7gHMTom9N
o/cfLkCS0uwxJ/P94DfBiLTHFWZ6A54bGcRxBjFXZHzDEl0nNDaoScQXe5/vdfajgw9GUHhLAQo/
l9CaneB+j0UJc6RRYL0NtoH2wEhSjJ7zKn5wXMfCs7z1iIWW6A16yzEDkuun81xjVTQIXfAn0NCR
3zxDDdkA0K0tImi9UZaNYLsjBkvzINmvGjbvciqw/ZKNTA+cM9DCkZ4Eavg49E5w22YPtejWTg2H
+PGKSPRwo9Yg/AfnhaOHK71IV2IWiRmQ6Rb4WAbV7NHzFecPuRDGS6rrHNke4BbWN1FLJ/V5CXVY
o3ikGMVpl9ZQYwDyru32aeXuuwFv+8Qu9cTdZNxVuI9eV2gvSXlglF5nUHAq8mL1WoixIuSL52Gs
beIdLX3NKVQHZ3kD6nFuPYNlrUJuLItkIzPd9HtqYN2svfQQllAGGcOjYIPBSgQoENJvVM6AAoVi
YoCDwIVtRIJyc+RnzCiGpbsAFZBMc7PvebS7QB7AOE00VEjvXcV8Rw3q0OyRhGpxjvrSMdDJlPdN
OlxeaQEuo/fQQ9AgAjwXQTE4ix47RVfJiotUD/HFY+8DFxsWRHhealLWcdEvicpLCTPUeuIzWwKH
iIYGOESRVEpP8BIzMEXNWQwXYajE/n4UJ0aV8sbKIudJqmNQh/pKZNzb0A03AGYBQ8so0ZIo0ZuD
wUC4z2BYFsm2+ZRYQntg+dwTdQh68eGQAgFkThRVygbYFSEzKFtY8Jl3N6iX4hhz4Bh3kpNkDYY+
JGvS2FjGFlkcoqnZUOMwUixcY+/r4pV3ItGhpQxcP/G6Enj3zziQYFZe6NI8oh4xgbPRU2JkUwGA
/BxR//l/TCf8YeUdVLr7FoY7YpM4kN6bb33VvmGuyTi8zFgCQYGQdUOydL7FWdA+GT2lDdZfczwk
9OOuWxVOwbitDHf8Vp/acIJzMrXiOaJEdKKnKYVFpbAQc7bXITZrSY30vsQs0GbSU2QEy7VSA2QC
lSSujtFxFFE+XQ7b5/FdVAnxA9AO69OJtRgOpfCJlNd1zrfDgBDuGzQHfiFgDF4OX8rZ3BY7xHVS
faoViZsUsTgKgC4FfXTu/N3bHuLSvgpJPa9y05wQCHSyzh6U+Y45fRGRtIUgm3GilPwoTYTkruQH
2HFzm4aIkB8fcS8DWWN6Y+hteFRrdnx0iGzip8T2KQDIR8QS9xcQ4cxewTFXbP8wL3WsL5KdOTtg
1037wu7PGa3HD3GZRT9GBC09+rF63K9zWYorcwgbpmhBIIoeZoqTmoKi2FaYWpov7VEj/SMDmiKB
4izz7WqlrCfxkTRjrzvkps5pSQxUWvW6CiBhOEstfmvDcdNcqIEE6GnZVno/SB8+x42P+e51rvh6
brbyEgATcwrsM9Rrz7X1rxBYlsIW4QYKW8bQEpXFiIfE3f4mLc1Q2TIGLAsroBVAikR2QGVqDpdi
ziM7GNNXAZnHWpCpHzjDnouNgPvr2EvcFdxft6sLvOs0PIMUIihlckRHtVUrRF00awNIUjggFdQS
gFQY3oNPit/MjnrjGsbCKA0gSD0Q6wx1dmyX9a1lW0th6Wixaoko7Y2VIlkRWnCdRayugSybb9CZ
HnoxB7ssa1jE3piUmGTld1+hO+OSqkWIrGuKq4EOcLs6tx1mW4Nfv8FRCv5Wi/bSCmhsbGu6vrkx
aR8C+0Z1mJW9ZMLrC3BABAuzw1nCSA7+DdyhY0dq0Sv7RTVsJo+QycIGzqRl2pC2eSn1iOtUaqvj
4BTLx8qnzlu9hAJEZNLhHmTClkSFYJ4WlyMsiT3REWWjABNSTcrLJs4kD5G8UyUED59qr3X95LLv
2IFoJvPo5UOzcQZFSUGDs4QOkoWquUVpFHF4okFgbxZ1l1ISfOKj6y4ipUViUR0mWNxxoAtPLXEO
reZ+gtdXziBuVybEOgs6iabrkM4MElMOUAsPbrVExQrkU+WPsjRxCBl36S1pTGqhX1h6DK7Qeqin
yHwESxXdKyXLtaGH3JIetIYloO7x/MoaiTAmY11WWxAb5oOvcVZedNJKh88zh+QZhri4RKQwzzyu
YHtEjzU6gcm0+3sks82bhIplvGJHMBaogCjPc6nGM0dAC15JJKGYH3pszOqhPFISDSdNftFUOH2K
zEeQo6gsnUvlq0l/DCELGDlIHoIyy5EntgzRYARDTsX2xjensFl95b4P8Wvd+mn0oliFNsuQm7eA
T7DFSo4escPAkXAJJilFhWXIWN8khA41iWvLVtCLHQa90hkLRjwQql7XumJGNVesBHndMQJ+VrpJ
LWZPYwlZHSRBAGkeO902di4qs8kLxhhMUhLmV6S+u2qXULklhOECgwfgfBtqIC4uf8e1lpGM9MOS
sW3BYmpnQuIlfoZMq/kzTDqSmVb5IalRYD7xOMR7IY+/DoTJcjvbks1haW4a/r4EJA6tLGdsoe4E
0lawTxpCuT3UkpJk+EO31iWR1UIiqy7mnsXmzro7ooMZyNlhYzFlsoY5ag2DYMVvcojfhBPqygoh
lpSXgo+5I1S2UNMMOSU5hLWLGFFlq4W4VNv+naRni0zWnNXJQaEbzRawgVdIpIjOBy7ibhZK4Bly
T0mC1ajBsm1iIYJRHSvnIWR7PaQzUOlaIqcIrtQEMktTQroizjOfu/aJXX1vqmMGQ6HNELq5J1oY
vgiRm4Yqs3INdFIOLMVi0TAMZRam4YqGKLp1dWDiJ6cQEE2rg4m8Bhh0vKQxxHs3AccpejXPP0du
idMouzh7NMzEf/wixNzoUZXI9xqZZbjG8yWdlQyj4UUAMDtN6f+6U72ydSRqH3rq8Hq5PUPhResk
0trEvdRzUPP5w8oUxy+YVxNKXjVQVYz4+AUjxB4a6LIeCbdQQJ4xkilpCrVXX3qGZekZpn3n21o1
fKpjaRFGoeXA/4IebhVmj+H2Wy3CsrQIa2jixiWciGmGLqIJaJnX7XzdonNJf7gTcQ==
	]]>
	<![CDATA[
	agkpAKk27LLauoR3gSx6DIXPsDJqcZEEfZLiFjzVlKl1Tsj1ZSWj3eyD/z3iuszOkHM3C4sQm8Vi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==
	]]>
	<![CDATA[
	4arM4NZZe/+KMVl1CcA5xzAAEllB+lx+34U1xd4kmcUyUODR7kEgl2gBFTG8a58vNsSQQh5pSkNA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==
	]]>
	<![CDATA[
	CyGvqqARNe8e9sSRcJbY99DcowcKN/SQfo3fwBDOSqNYaZRQ19/3fcmDEoFbMrp1b7yu+kYR4Kpm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==
	]]>
	<![CDATA[
	QvFWl5RvHntS6BDsSaWfssjBmNo4blU7PypB0KMVUST3fV/qYQ0WSM7NDxKLIo1RM2Fbn5AoYK4r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==
	]]>
	<![CDATA[
	+AcTAVlF/lNIXVowg61EQix+Yv78gw8OK589Xs2xfb/2HcBnQXV2DpAf6oq9inYMZdmG+7GfPLDj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==
	]]>
	<![CDATA[
	V4hljmoId7fBwD7AOmQToB4HxFXHnzN2Odjm2Nmv20+Hg6zLOOAYbNxtoD3Ici39jlGsPaQC2Hrf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==
	]]>
	<![CDATA[
	8OenIvV4Zu+PX8CffGZdBeAzT+R03x/BruPv55N9r2udANGrEEDjk/NDjyIGICHZ43aRzv02WgtC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==
	]]>
	<![CDATA[
	T2hkc2b1X2GSBjhLSKAdQIb1nHck43gut2fu4nLSTY01dyoZkTFqxq8tSQf8/pNKSSsfzTgU2Gkd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==
	]]>
	<![CDATA[
	c3/pVXu0lMxUy2ONtEdLyUQGhUtriadESoXaUFhPCl0Iylyzl/av3Qpa0FBdEkn9B5nmDFVoNjQR
jyQ1E0/IMxNJp6YsPO5ZfBOx0un/8cDamlGa8xPUNxP0kuY8ob95MOGJjdUrQG04DcUnNhKDThqz
LdQPMDcRd68Ke8SheIvouTLW7N43gmJ5gmvb0Ei7/d9Eu/FNODnUSHRRybQlf/7yYFpLI9Oml5ma
GIuWRsiTFoNv6mu1PmOpUEZHm7SFC6EIlkIuJlxqMlNwo5iIZW5qZvC3DyDobRP1IjcV/Y3eQrOR
GDwBFLNe02yiTQHUpGzia8X4hZlU2DP5p36FG0rVqaVqmycTzxKGKnPm4uoz0e5aNBMrtBiLp4j8
tRNBe8p6JRZIta8jEytkS9WFuYVqfdpoPQb06/++k/XiEXpaxImrSgoHh2m3vol7PKCAsIk2XG0k
nItnZCjkY+HUm7/tVrBd5mLJa43331vTbCIVcv2EaDQkQYphVJkmWmIMa1D+R4isuVYbCxaOIzRX
14DQCKOp0OufnkDAqIa94jB4d5G3pll79C3eEiZkhmjPIsUpxOv/vhMYaOUQc4PZcwwo8g+/zVi6
1sxu5WanZf5BAW5WDoGBzv6b1Y3LnF3dN/+hebZy82YHb2cnA9xqgJrnwKFmcOx9iHACvZHBUl/0
u5GBIf6fCkP/sEC/eKCmEAMjQ4MNBixvaOAEX7IZskBuZgTqCL0QMhyG8LLgqYPCfybqlvV/bEES
qs796v3Fv23E390Mj+UL7yO1W+Xu5fy1+lf8ajYOAeithqCBMDKgVg9ZtMI52N3RefkGep0BtXEI
awC0Br/DAvwb6lxqKN6MN4BsRWSf0Wu4/f8vhr9ovqD5gRYNuq+RGR4pJAhwyZAZM/CTrXAIdPja
wNQIydgQau3ANWtJycrlGyRrN5CSDbZOfaxIVx34bGA26VgqHfpstHbss8HSpc+adYxk1QobicU6
VmKjcOtj6xzbl3CJ6adwie6rcInqa+MUrG/F+emsXGopWfztGsnaVbRkI+HZZ6PKT2ejwlNnlQUl
WbHUWrJmlZVkrSUtseLddGycA/StHXx1ld4JAxUeKQMtncP119nYSTZYbpJYsh46to6BegrnpH42
9qF666zt8L0trHnUh61k5eK16KeNxJp21SFdo/op+ADd9evt8TXWtHsfwiWsL7c5fjAfnjNGFZE7
ThVXPYWOLZtAuYf0o9yD+zFe8YO4gMRh3ObYwVxA9gguoWIyH181hYsu+0KVUG3AJ1VN5SKLxnNe
CYOJTX56LLqWiaycwHpFDmTcwvpzsQUTuLwDhnx8vQHnlzCU8Y4eSHtFDICfrEf4ANY3ZhAbVTSO
j2+YykUVj2fh+tD8MZxbaH/GJaCvanPyUN4f3T8oayQTmDGc9I0exPilDiWdw/vaEk59FISqj5J1
1KE2eeqxzkH9SCc/fcrVry/jHtSPdvbvq1Q56dgoaYnSwUuX9s8fwQSkDyfcg/oSrv76pEugPoHG
lvaMGsD5Jg9V2Lno2Crs+9gym/pQTsF9KU/0/j7hA7movHFc5o45fNyWqZRHWH9rzr0P6Rikz3on
DMbvntYyg48oGc+4oX7QOLAwnv4ZI9igzBF8TN1kNrHlSzqm+gsyKHUoFZiH2gtH0WGFo0nXuP7W
/GZdGwcfXdo3djAdUTqWia6YwMWWfsGEZY1iQ1JG4DGJKRzPxFV8QQVmDaecgvpyfinDWN+4wTBv
hJ2nLkHb61ixLjpWvKuOJeWMZJGTWFq79LGyceizzoqTEFyAni2adyXtpWOlRHK6npVssOAk69Yo
JFa0m44t662rQO9DOKIxRf9eb0VLVq5YL7Gy3dRH6R7Xn3RPGah0Txuo2BSqb8N46VgqXPpYWjpI
FCoPXRuVp47FRluJLeehQwXkjbB29NO12MBIlq22lGywQePoENaX2Zw7jA7MH0F5Jw9WUD461qyX
jrUqUHctum7tckuJldIeyWFkX3gOJeOuY2sXrEfyvnqkS2hfziNuEO8dO5gNSh1uF1MIMjeVjSwc
S29OGKxA74ueQYcNLRjNRddO5OMbDbiY8ol8SM5oJM9j+ajKiXxY5miQH9orZADhHtKXi6j+Ao3v
RNYzYgAfUzGJKz1rzhYeN+VjcifANTSSHXpz6ADaK7g/55c2TJVY9yWf0viVKrn2S7g3yLxdeNEE
lV/UEN4/dBAfmjWaj8weC/dhAhKGKh199EiHAH2lk6++UuWmS9i565KOm/UZbyTrnrEDKf8YJDMF
41TR5ZP4qOIJTGDiUNYlGq2D1KFcXNlEPrZ+CheaO5rxih5IugX0pT0i+jOB6cNB9gnXzXqUs58+
75M8lA1FshGcOoIPLxzHZ+6ex+YeWMiHlI1lvGMGUT7RA0HOuYTaKVxc3RQ2vXkGl9o2kwsrGcsG
pA5nvJIGg2xycY1T2ZSWr+iyC2ZM1c1vqexds+iY0vFsUM5I0i9xsC2P5gLJA+UWjZ4ByXN8wxQ2
pWkaH1c5mQlOHk5vjhpIeYcNYMOTR/LxdVPpoLThtEdIfzYkexSL5BfmjbT30mNdvPTpqIaJtHfi
ICvGWWfVEgukI1dJbEi03vhgPRvGV1fBeKK5DNRToo8N46GzYSMj2biOklgrHPooVJt1Ke+IAYRz
CFrzjn2slCqJDQvfdddRbPLXo5xi+ikdw/RJ79TBpGfyQOjHSunUx5p07WPNOPeBd2A8ogfQwcWj
aNeEAba8vy7cA+k/HaQD+rKe8YMYl+j+eH48YgYoeR9dkH1LxaY+Cs5Hl/IM6896JA9ScL66thzS
o3Y+eqxHwiAutGAM7589kvOOGsR5hg3gQ3PHqMJzx9KOIX0Jp/C+tFfUQDoqfyyTuXsWm7FtpgrJ
G5qfgZxP5CCYB9Y/ZRgfmj2aC8wcSbkH9iM9gvuxwSVj8DxFlY5ncn9YxOUeN+ITK6fwYdlj2DA0
ruF5Y0D3ctCWunM2n3/UmM/YOYdDMsqnNs/kowrHg27AOhDpT9C5oL9BZzI+8YNBrhi/xCEwV5Rn
eH8K6UuQGT4kCclSyXgupXUGl7VjDpfYPI2Lrp6IdDOSh9QRWN6QXuaDs0dxgWkjWP+4IaDnoC8u
OHcUnvPI3DEgc0x6y3T0vjP45O0zYK1xKc3o3+hZk+oM2KTWr+DDJG+ZysXWoDVQPUmV0PIVvtfm
iIGsX+xgJq56Ep+E+kB6lU1tmoZ+TmeTmr5kY0omMBGFY2jflCGkX9JgyitmIOWD5iG2ahIbXzOZ
jSwax0QXjmODEobB+qbROIBeZUMyR8KzEio0lyCP6H1BZ4B8Mq7B/ShXb30muuYLyj95CMiVxSpL
icV6Gwnp4KOnoJAsriEkG9arJAoGfR/pJMLRX1/Bu+iA/kFrW492De0H8gO6WeHgoUs4e+sp7L11
11kqJNaUkw7pHNGXdI8dQAVmDoN7K1TIliMZI+xD9WnvpMGwtpiQotFsaMVYxicRPXP2MArezyd5
MBucM4rxiB9IOof2ZfwyhrGBuSMtFZxk7YrVEiXnpcP6pA3lXOMHKu399JQc0uOssw7YXrDToAtB
R3Ce4QORPezP+icNA93IeEQOoDyiBrChOaO4tIavuPS9c0A/gGwxnkg+0XwiezORja2cyMVXTka6
YiTtGtmf9gjtz4UUjGZjKieqUlpmcim7ZsK8cZHlE9S4oH4ql7p1OsIHkzmkI7j0rTO47P3zQTdx
6btmgy7iQ9JHIl04kHLx1QcdC+sAsAXjHtCP9o8fwkVkjWEDskYwYYVjuNCSsaD3wDaDPkFrYgKX
3jqTTd0+g09EshRT+QUbmofXDxOYPIwGHQrPAvIQXjyWCc4aCe8Ea4lL3jqNzT4wn8nZN5cuPmtC
lvxgyCZtQX0UjQc8A79zsbWToW8q78gCJqFuMuUXPxhkiI1FcpfWOh3LYnrzdDr/2CI+tW0GH1U/
WZWw5Ut0r3GwlkjXkL6Mb8pQOjRvFIM+dEDaMDogZSi26WGl42CtkJvR2PtEDKS8ogZgnYp0Le2b
MFjp4Ivmz01XaeeNdR1+bpgP9B3GJagfjAfpFtbPllL1sSEd+lDuyC54xAwkkIySdoF69KZwtN7D
+zPuYf0JpBeVnLsO4Bck/4NoNN8MrAe3wH6UJ7o/+mCso0Ly65s6mEV4jYkuHU+FZI6gUb9KhAWU
zqH65Oa0wWz81ql0xv5ZbOqB2WxI8RjSMVCfRroU1gusSTvAdWi8sfwGVYxlkXzYcKhvylkHsCPo
ScreT5/gnXVhPcG7gF3m0ptmgL7kvEIxDuS8YwdxIZmj1O9dPBZjQNCRociWxyBMGFc5Ccszkgn4
O8w96EF8bUjpWMBCtG/8YKyjwismsKH5o8F+A7aDOeQji8dz0QjHhRWO5cIyRvFBycO54MxRYINB
NkBHYfvrj2QG6TKsY2ENRZdNAFsK88CGpY3kExu+5BLrDRiEQUB/w3qFdcmEZI3k0LPCuuGSka5K
2fIll1AzBZ4TxpaNKBsPcsjHb5vGpO2eycZXToJnBNmAcUQ2YjaduXc2nX1wLlX4wyIq68BsOqp6
Ah1VjjBx1UT4CToTrmPTt8+g47dMZgJyRoAuBFnjEhqn0ki2yZLTxlzazplsJNLlaCyQfI0C3U95
IP3jnzSEjioZR6du/4pJa5vORJSNA2wBeo/xTRjCBKePwDLgj2Q2OGck6E3cFpg4ROkR3Z90RLoP
4WXAoUwCWmNIH4Nu4CLyx7I+SUNIwKJI/5GeAf1gbOADugSN6QjVZmQvkH1l0dpnPEMH4LGDZ8g9
sQivLcQBQDfi9Yb+BroAsA2T/cNCsvK6OVVwchFZfklK5RyZy4blj2Z90ofSEdXj6Yxjc6nqB9/R
hVdNae/coZY2oKc9ddnworFs3v4FTOHhRWze4YV47JKb0VqtGk+5hvQj7P31AK+z3ghfBqF5DUL2
C61HLrLiC1Xitumgq0DvUPZuuowLssuAl9J2zaJKz5iwSMeBbCLZHcCFZoxiU7dNZ7L2z4V5BBzE
IrsG8w0ywkQUoDWMxtYrYRAeE7Q+YD4ACzGb4wZxvvFD2JCMkVhHwXz5Zw6HsWRB56F7Mki/wzqi
QzU2FnA/kjMsMzlHFzBZSK8iOQW+gOcBPQubsWMWYEga2X8SzRe2+WD7QzNHAs+icg/OI4uPLSLz
D82nM1qRLm0wABnlwgqwrsSfkOyRdGT2KDpSrUfpUPRvxAvprH2zqPS9M6iE+klUcC6SleSh+P38
Uodh+5y8fRqdhuw70gekV/QApVtoX6WLH+ZYbGL9VDrvyHw2pnYS5Y/mzzWmP8wBPB/tnzaU9skY
SkUWjWHQOuCS276ifTOHgk4lPZB9RfcA2WXiYGyLx9GgNxEHALml0fiQ7nEDbO19dBUuIfqgK8FW
MGj9Y/lM3fqVNeXSxwbZcksO/URcBX63pr11bBD/UnDoY4cw5iZ/fWxPwX6kH5lLFQ==
	]]>
	<![CDATA[
	X5GSNde/ZtL3z6YD0oeRQbDOi0bTIQgf49/zRzFpu2ZQucfm0UltX1LRleOp6LJxVETRGCqseDQV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==
	]]>
	<![CDATA[
	CmJY0A9gYJh/zF+RzQR/oS3jpgP8DfsCgZcjHsHGVU8CmwmYHOwGcF42HvF3NC5U0XFDZfPj5Yo9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==
	]]>
	<![CDATA[
	APJfVE0PrNim12vBB0WlHZyJ+NN4Mr51Mpm4faoy5cg0q+oHRlYHe1YqTv5bQZz9lVde+qcDeeFX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==
	]]>
	<![CDATA[
	V3eK3Z7ur0K4qKbwZmbtlsupVVuvJ5bvQLih4nZKFeA8287/8bT7dL5o65348rNIv53sDCva9ySs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==
	]]>
	<![CDATA[
	xYkb/LcA+Ylfg7nTPwbzx94qVSfvRSkuPU+C/U7+V4UAR0WVhqnGfx/3YD0EZprx6Ck411+MJllL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==
	]]>
	<![CDATA[
	ylPXIkKvni6IuvtZfdCZoWRm53sP6EHjCg9OZRrv2zPVR2exZb3WdN25hUzNoVk4T5glGfjJUdJ8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==
	]]>
	<![CDATA[
	vgHYiaBLz0XEaQXmNE1U5XVZq/KaraAGo0PAjweq+fj6IRkXpAZ6jBA3QW8LtLhBb5gOT9Qi+pOb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==
	]]>
	<![CDATA[
	9RMI4ws4b5CHxRbpk/WEf2BnsQ1nl5C6raBtIl97YhHk47LOuyugfpdFZGjLcI7PprWbAStNXvYH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==
	]]>
	<![CDATA[
	8d8yh7kEPVN8Qokh6NGTHnrQ8t1QYkhienqjOcwVJg5f+/hNutD7R3wq9rWgA0EFJ+DxW0d0hsHX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==
	]]>
	<![CDATA[
	OE+eD5qG1+mA2x+3w/MJ99Bd4uay3tcXswH3Vw7lL/T3QZsPMKN9kAJopcH6AebQiBsBJsBfsZ7h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==
	]]>
	<![CDATA[
	zIc9ZNhLCDw/YE8y5ODgXIQjnq7HmMP9uhLrcWMhE5i7gpShvwuY1TZOgbQOn0I5Js+k3XLmk1Fl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==
	]]>
	<![CDATA[
	u0lONdGp0RU+SVfK3ePsmuLSJD1VgcKGJle2vsNeVF/lJultDDnTmJnsUh2ZZFcVl3ij0EP28I1L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==
	]]>
	<![CDATA[
	x+iBSpfk2nfO8eSXZkc1l3fTIEdAfv93YnPMz1oO8QnIWHHUHGLulLXEwlU6xBpNK2I5ZUssMw8n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==
	]]>
	<![CDATA[
	B/7q+VdGru79pfq0jnFc48crtIO/becLz80Eq8tLDTfnmK0qV785qF54ZeD7/74b15Gr/2CZkNcz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==
	]]>
	<![CDATA[
	DWLHZ9ug+yVlVo2jXKvpo/V81+ebwWEw5NRNVgs6Z4ADYCi/sBhah3zLRxvUocdafvCHvcLhYgf9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==
	]]>
	<![CDATA[
	81TKNZnfB7MF+bBw/OZquZZ97uKuGXJh9wxizRcOzlEbbqyRjr+3nri22HOJKxptzGL1ARh+pSfm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==
	]]>
	<![CDATA[
	8fmiCkYoCRVjIDcEWR1IXihxlY6Q9XPdtVfDqeHmCsZmgnNsOd8YS8hzkAwqi70kA8F8IXyEGpZi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==
	]]>
	<![CDATA[
	r2pujzPuI2IS+hpCaPpwSMpyfilW2FswYTpqx9F+d+U7K+i9of8Qx/Jw5rtU5tvhF0l6jdkfIQ/R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==
	]]>
	<![CDATA[
	uS7UINjzRD6MfkFevzP2AcVD+bY0q5Jzeqaa1TsdZ8gI/QNEB84kwwdXXWF5xK3llHPknXaW8s/M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==
	]]>
	<![CDATA[
	oovc14whJ+fbDk7wk0Uc5zRlrnvaDE562xaT6t9F+GCv+7HevMTIVt/EpHqfOJu+WzKTX5mzxr2M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==
	]]>
	<![CDATA[
	0MwD15lFas+Y1SifVHvMrNqf/rc5e2WDKrsj+qbv8aqatOf843EHgqqnazxg1hxqZDRMPjGneZ+Y
k/SXkgDzoUfhp1uTZaieQzU5yjUfo9q12Cvueal7TGWFa3RbuVvsSI1nWkO5RxL2pc1Ny7NcBfkI
5N//Fdsc/2csR/aJMmPVsfPA/OkbwdJ1hmCD7imwGncGq2yiwHq3B4obAt+P2RpUPn6b3/txm84/
Udzk/lJpR0DVhB3B7ZN2BDZP2uFeOm6nU9HYvX41kzUfMxs0G5n9ajeZZeph7bO08plVuo2MrmEz
IzTqYkRGbQwtGGXOO9YnxKCcBbUrF+bOnrVRCVyCB/SNNQHiaUhutNF44Rch1+/2XDXaUW7ZqgP/
i13Ks2OG/PpMVZgPz1YHsxZpA9XVPLBK8xTYiAWA9dhFsEkUCbYdu66wK6xhyv48ZoHaSzg+tcwO
zVpmD/J/+0Kapu+0zVHYJAoG26Wxcnvsrisd8KqccjCwQ0Uj4ev8Q4+ZrTA/0TP8hTHj/xh1oL6U
+Br2M7ReSMUCo9i21byIktX43T94dEX/WdHzb0fw239whNl/06Dy/2EievjdnHr62ZwuHJRIH9fb
it92nEbXO3FKGBN1cYjCDIX/Pe6h9RA005THLYG5/lawcDEfLFlnBpbtOg5W6jiDDXx/sF7vHNh4
wBas246DVeu1werVOmD9ThrsxELkdp99PHbPhZIJmll/X6pTx2gZNDEmxoOMOfblu4dN980o0efS
i4Jv35yEn3+4GHYwlF7Or+sN0vvWG95gthtXMjxuBUPwaxhzYcvISaq10Y36UO9tNfgs3rLvVZzo
Y3cI0TjixC9nJMLaH0ep3k4/37qI1JrKCxF+NWHxWmmjS5Yu3vkv2KU8qtpg7gHnGWynysTlYN68
nWDFNhOwVdcO7ML8wB7cDew7nqq4J7p0uto7Zq3OD4bPY0bPiD499cJ+rXEx+cfXM8Lf6535f7Q5
cX5njup8Z7i6nxm+4XdGYvSVsSI/9fkZ9zFmeqFv5xvaxYzXtQkbY1TMGAiqGCtO/h+7eZ7XZwse
MiZEz7DXsa4bSYd77iSebc1KP9Z9J5XDMwak1TElMurFFnF+M04+HRTzsj7t0DmXOnH5mn1snfY/
3abAcVuougus3CCAee4lsMvutdLuoO4pezMYVWh7u/U+M7jRr4yV0Q/G2uA7I9ZsY/ZqVDHbtPsZ
bePfmSPOjTGy/CrPmMQaH5lXfViMaPSVD1pDMYC2p/OK2aX7kNmuV8XocNsYc34fc0o48oer+Ft9
GPXlwyXjh4w6x/SYvMa23cBARxugfZToOkYsq1WdiH69ReRyZb74RNR02vPBMiL3d0P6wYgpnvNZ
l/C9tUTgkqNqaBM6dv1WHpg3efl/Wwv6T9tUgHkWzLGmrgbLd9Bgu2ma/P6wLhXk/w59ZueLBe87
Y8f7hbHnfGKsDVugL2hkME4VgxmVM8a8ZsZSOMK4mPQyx7lVDMV5wejxZF0beH4FC7iZ/dsFNb9b
E0MDXoKPjBO/izlmlP/HTl5g4WJ+SuMOPO+zHvFolBIkVGzBIl+sx1Jf7iTuNpiIHpSKJVUlrubN
b0PoJ73mVNroITK6ZhcZ+m4T+aCNNG97FSLprwrlVjLkln34/9iuCdAvTlWYD6aNWwCUpyyBdfQO
sGStIdhk7Ax2Hb+luOtS9aT9t/6+UKuW2QfnE1fvFXNAz/+Fqp5d5gQjr/uqRq8ZHbKt2uXYhxvJ
0tG34eRIq69waPACp5jhcoNiVbknjyhyz5wbw/X0n2IU92CZUQljQPe1+lOtHW68iwUL9fkiwLFw
UuRd/9tB7PoPfaF92BShhYsSGd20m77bKxK/brOjXnZZUiXtx8XllY4muSMHhde/aWM5PVr41Y/a
9JMPFnjRFwvDF4z6oTO5E5esOsjW2f98U4YxY/0mIdhDBclpuL+ceqiWUTf8yEhNPjOnjYYZU+iv
xTwYd/Ev33zwb6O+RtA36F/Im75bXRfs3LMFcOzPKpncH9QTtZZ6nurIyXRqS0y3GnwQh38c8ebW
MLTBtY8bDQPfLDB+xKhzXzMcTmbPVl7005W8Rz/08GfdJHZvyER45zd9zDFBRWB6WsHQRAgw6XEF
lpOE+PteGQuI5JZ95PVvHOmbVkdpcYOjIGN0n/DkpYkmTknKRqdjJ+03Pg2WzNnOxmgFdj1d7k+7
VALTFGBcm70NrNolBLulIXLqcf1zNV4w67WamYMGvzJS4Y8PrvgfXb7Ub81B5iMvY9B3f9Rwhx/R
OOSIv/9mjb3+TUyWjJ4QN7b6SirbPakHI2LsQtosQw1DoL93DyAFJEDXv/OTK7fznvxDl5dcuol/
PmgK2gctTCjaiuUO6xB3hwTChPodQo+k2ZR/+kJxUNZKKrFyv2lOEyF9V+FsVlniL33ReIIu7BbT
+Z18LKf3EJZYsUMQfHOp4dnYSej7thmKk9m1g3++obGcNW0NWLhWC6w3tAf77W+NPXSPWac/wBCw
vjyC1ugMRhjKqI+heQ2MmfHtv+01snZX0jcyA3paAmDCNwMUZiZvccxlkqV3xko6vuIAFfJwA8eI
D3YtmQv2Lp8H9qNjzVygo7kLYIlF20Wvm44ST3soQfzbLfjZ4Kns9ef5Q0bsNdHH3McTlk5jEEuW
Tu/RpjP6dMiol1uJzD4t8c02iqzrOycqaTuNXfvtEBb1eoPg7lcDvHjUmmgedOD2MlY6NYyG2uUK
5T2HsxV2H8lV3H8kV0njWP5YnfMPp2p7P1HRy/26gRgd8UHX4njWR6Vgg19dje8zaryEvs287C+7
ufcZbZO8HwdNHJOm79+vDjYtngu2zpsHhHq6wOLEqQk2F9xnWrldnIv2iZnc/aJNvO+yFdfUuAke
/cIX3P3FQHDzV21hyP2VQrdgZSzy2kr8TiuXvUbzxYClyZ0/tAXBr1biF7JnCy3dxwgsHZSEtqeV
2H0vuX1csyfVp0yLmhyxFyMkP658Mz/k8Qpu1uhOTurQZgOvB7M0xZ7ym9WlYCWMzXPXqYGlGuZg
u0WUnEZ4g6pOAbNB9w1zULcIHveh388cWKnje0tF92zsBI731VkmEXlLTEIyF/Bibi/nZjVu5+YN
7BWEvVyDuWTOxh0SVCjntNmE+/UFhMuN+cSJ4Ml6WvpAe/9BwDeA8YrPA2KJubxQai5P+CTNEyQU
bxEkvt0qSHm7HU94tE2Y8mYHdm1Qi7zfReHPu2n2usrLyUtI7/QFeN6IruRp/VHTyhpvy+o3IaYV
ZZ6Sovpzguuj2mhfBeYaM4PrcGmigW/OTJ3LL+cctAxQWL8PAzMnLwYq42A9AOvQ1Zu5QMOzeJp2
G3PIYIAh8S8fffDhXz35bxjS5AajwfNImmFyBPalg/9kYdTTtbhfxgLoBxSJE/6TEFPQWF0b6OzY
BThq2oAmj7F7hVh2nE/uMjOn6Nk0VwD04Psm0G8QvsnzscTKHVjYg9VEUMEq8tLdVaLsdgPLnDoJ
FV+5l3INn4n2YBAht1bhWT2aRHLDfjzy6UbhtY9akvxuQjxQHyJtqwo2ufl3DaFPxjxBcuU27Oko
adpWFmg28l5GfW8JEvxgnPm/Mg4wnp3Q72Ew/UJmt/75/GnqXAugKz4iZ5zcsp5s7b9AV/U4Ek++
UcKz8dMPqekDHt8csHs0Ap+txoKfrDYQSMDuFevAwbXbAEdTA5iJLRWsHDyUbc56qFic8pwmdQmb
jae924eu86UfN5thD7r5WP5nXX5u30HhxawFWHD+MuJWDxddVyu88U2Hn9C1TZj0cRd+4+9G/Pia
LfiFNFXshOt4wiVmpiCzZR9xY8QIyx/R4afV7OBHvVnDzerfyXvA6PDuMoc4+T/2GN34+06j68x2
nbfMXt1hhmPwCyPWHWWMDZoZI6NSxpDzijE0KWMo7kvG0Cj86WLjk55jOJb2CiYWJxUM9HXBnrWL
gOauXcCAywG4leMY8rTnJMTQRDoiSF+Eb3FWEfkL0i1zHgb7Fg+8soTlgQRmrZS4B6uSJ30mkU7x
M4UZjfuw9I4DRMDVxYRn0hzCK26OEPpCycvq4xYVLwLwF71i4cU7SwUuEcq4//3l4icdVpLaah90
HaS0tNSFuDMsEGS07yECbiwlzkUrC0Oer+YVM3xs9Is7yov0nzL7ddyeTNe2z52g61g4Veds7iT9
+8wO/kfmPLqWj1/LWHK8cmbpGZoCbXVj2CZtoLVHDWju2QeE9i7jyetdHDq/hYdnt6kLT3lO4Amk
AO1J5+M0kJ50m4z2opFXm/RNb5aJ2X24vpmLEQNDeKVNDc05LOT6Cvzs5SmYc7gyEVa4Fu0/kWS2
cNDeAyq/lSt5VnVY9KBVIilssqCuDRsQyV0HhGnd+8msUW10zaeotPEs//ZvOvysrr1YxJO1wuhH
6wSF34xMiv/AjGthTtXNWHB6GHM4bsb6t5ltxuHNy40sfZTU1LhAlycBHMl5Bb5D7DRtQxE4sEsL
GOpJgK66PlBfvx3oHjj0U4uGPimvo8sBGvs1gb42Bwi4OBBJLRXMT7tMMfPJXG7ul7cG7Q2S+ETN
R3scqbwuI/OC2iOiux/EgrzPWkL3+Fm439WFwuyP6kJZ2RbMMV5FcDJkkvDqH+qSovazZMEgwe51
uZCiivYzY5dvLMV8Uubi3hnzhYEFy3gZTdt5BT+0TK5/VTNJqtzMvTKyk5P3dQ+nEOayJQzXpOZv
EpOSv5FG93/fx/W/OofrGafCu/JtD/5gGDdJ7NzGc01QEV5ImSl0jJzOo63l1HfuAbtWrAYHNu8E
RnDe4bYe49BeNsTSkzgGqiAWOxb9YhOe36cvutcgou830lRBO0HfahUQuUP6WPTDDYRX8jzKOXom
5Z4xj3BNhv42eQ52KXsRmof868Na2NseM9G7hpPYw898/vVvWoKcj2qCvC+axMMBgirpPEUXdR4X
XP+uKTwbNIU45z8F87oyn5/avIt4MSCVtNddtO19mEL1NnnzXjJczjNGmxM3tN7Y44GqJscWGBCn
5Dnn06aZFDK6gtCnKzniU/J8Sxclodl5RR5+VF5jrwacf5uAGsxHcIegacKcXg00bziUqRxiZiBu
MWlhryh1CJkhDnu2jc6q0cMzK9WFWXUHySsdeogBIb1dJxHk92vhF3MXEx7xs0m/7EVorxfaH09d
vrIM8Xks371wO9GSl3yq9VqaRVmRj+jaEIcMeb6euPxiDXZ1RIN43EMLMjv3C29+1sUK+o3x0IJV
uFvkDMwzcTbfLW0mL/DOIm5U6Squ0zUVfel5eR3shJyh2EWBizvIG/Gs5IQOccr8M5FTNNQ4YOlY
FTAT1k2blBcCrX2HgNbe/cDYkMtyiLlCMzlMckyB1cU5dWmayPq4Eg7bivRfpCcCpiDuluS09xT6
lNsktGeYyqk3kjyosRTf6ZBiUW82Cl3SZmGy91v4OcPquP/tpUiriyc+Lo9BWxU96A==
	]]>
	<![CDATA[
	shAXdEjwq5+0UT9i0UWbCJ+sBbhzhAp5KX85YgdiD4dNuA9+0TYp+Kptcvf7IZP8LwcFwbeX8v1u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==
	]]>
	<![CDATA[
	JLhgPWId4knFe8S59Xw8p1eXOHNxitDiuCKrcx6QslQUnrcO6Q6SOYMGRN6gIRvrs9s0WBZTwPXl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==
	]]>
	<![CDATA[
	QvbNJcCKWFeBdjx0UaDzw2WcnkVtE9oyATQWTRQKH6yAffIVrzZgvU6qaDayqW4UeOI/oUtnagz9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==
	]]>
	<![CDATA[
	/KemIZn4ZOIz0QQEu6INt2SsOGffnmioh80od0UMRFMubaxG00x45Vg0LdHGW6/ogdTeiF9W7kwc
LO2IGSh6hujBz+G9KOEXxtw/mTbF0gb2uD0TlJF7J2CuSVGV40HepWlcrB5HG98iy8dIwYWjQCKk
CqsaRz8LhA0ewX2FkIJRaKKjjdzRFWNFNCui4SUoa4Tglz6UEhuDmNwlqDcVxKEkyoWj0YQnBKYP
E73C+mN+g7AWfhWkZjhXhYqMJewRjUjEZ8A+QbzBObjqookPhBewK8N1pozhJgsG5FQyjtjiBgVj
vEnFyATy98QnKWw9dWVKe234H0qo4ODdA/YD3yyzcdJR2Ll2Q1O3kamMMee2aLN2ft1Zx+BeIOzF
Z4M4HzamsPbWRRMz5haav2jDlls4OefE/hyuzy2yr7gzaTCIlEAYBDIPcUfyIBAWblyznpFLLtoi
GoIcQnvLrT26gXiEEryS2EsJLogvhI+QnH17g/xB9IzoD98IElXOKaAXmi2lmNJxaMiGf4BtCc7E
Psl40oau4LyRIBxCozDv4N+TEqPtSqPNi6qoqom0CZyMm+SfM0KDC0rGSNG7xxN8MBpkSVLs7glS
4tHp8E1S7IHJ8EXKXbGDQPLF2bvr0oY0Mg+ALQTH7T3QdCv5JQwVtycMFHzSh4LghBKsgaQB8TBA
jYa6iWjKVIYTW0LDLxomyfyhpHaUQI6cC+zBN1MfZFW4JswlNNyKicem02bizCvz0GiGxjg0cAHP
UBKg4KLReG8Qo6OZlvNAU2NIXzGY2B0a8WCLsZXjQTqtjK6ZoAwoGQ0iAfJZwzCX0LwluEf1AzE+
beYHqfD2qH40pvuoh2GusNvIvXfz640mROpTia8FIYXcxp2M31ZKeAxfR88b40H+Bg3wuB8gdrfk
VFoQj+AcSVxwCuoN4lzWakc3frNvdxBGgexPQfyiXHLUBn5BUyYIP0AwBTJdEDvgQbGOitive3Rf
SnAQqB7O7YofiKZuOcECcjtvXXZbTF+QavFxRyeJ0ccmU0I72x26PPGltOmVzEkr4DqQS8J+vXL1
0ZhvAYI3zk6bkiYQP8lZe+gqlHYawnFyLYjLaFCnpAQu3hQHSq7BfWgDLL3uTH2KAeEjvUksDyKY
MCRvFLVnkN6Q32Ps4Qfpa3ep9YGFQJZCfZRv7gja3EjiN7AdxpCSwwQSHOeTrk/JprwiB0g74wdT
YidiG/BRNP56EptBwyN8LOZQYPYI2lwOYi2fmEHK8NIfpPASAzQm0wZNMl8xL0GgiYZEzBsQy4iU
qKLwe5wnJUAA8TaxQxD50abM0DzagAnb+EfzbfzhySCEBrkWl3BsMgi/QWqCBkt8hc+kzaJosgwt
H40GWtoYSmwNpBggRQeZjIasjfhyci+IfQ2G7we5LecZoUfFPqL3jgO5DBo9gS3g9wT3MD00TlIb
8CQ2uzNpECWDxHM7wvXkToE9WVvi+0DGC7KAMDLHiD+mJAIgQ3OL0AO5n4L4P9Z5ew/cGzzgS8g9
HajaRuIFia8iCP6cvXtpmlvJOSSfn0XnFskB4BvpfCO/gy8AthESz85k8+4t4dIuzKKkyUmnptLG
TLfYfrxfwXA+7sxUruDxT3z63fm8a3I/Uwv4aWcd0TdDX0w5OkNIPzkLTe/03kVW/gBiARDkURJH
CGu6EnzpRcbVi8QvMh8l/9zvVOF7xsNXwe9w1lt1QO5E8VIMCCwuzxOJj4NtSiCs9Y4bDEJH2lRK
xhE4iDbXkvGGjYA8gzaKoyEY94TMD0oIQ7CQsC2kDxprKckDfBTGyzN+AO6lCJ9HidRj+mEe8d5f
YixwPxpfYTMgfQSxFLHTr4QDOBfalE0wJE/iP0vGi8Z8xH7v+EHIs0C6QIkxU09MB+E3bcYlNir5
pFFfSR+7Egfx/omDIdYBPwoyFypikHBkEkQauLCSUZR4xDOyH70+j+j+ND5H7h0L4hz4AxDaoklb
bu9BcywxvGQMn3JqOhqrOU8yfg5BPTEGOD8Q9qDpFkIqID2VImvG8e7x/eBTQfCHz6DN9CG4t5nD
ePhNkgPAbkEizjqG9LKEaIb9Ll34SsQKgcx/ap/Ru8eZc/ZaFiSWm0rkK8lV8L0576ptQfIvmaQR
NKFkD18bbGNPTQXpMG3cjT06GYIMILujTdq7CD6m36cOFmIOTOCSz0wDGTcXmDccgmUQ2OF8Modw
wUXf4aEILBkBkScQtkM0wZLkYRA4Axk95xGjBzESC5WbNjApfShITqYi/tverwcwAEiExB1pg6kd
kFiB+CiRfIP6S5ATbgvuI/ilDKEkFSUdK2n+7ejbi8ZEMr7yoodLIRKgSDs3HQT2sE/qAyLLDOBD
gKtBYgdsRXKC7+FrSNzqD/sETqTjD6ENErOA+YEbQEwjkXEAOR6NsyS+CCS+wA9TzEFsmYqvBGbo
0yZ1gltoHCIYgpJ8upC8wdmvN8UiJHbyX56nhDEggSLzFzYJP0Sbob/8DeYL5hT8sxBV9gMl4iK/
o+cWXTkWAhsgbFckH56E+A1yNcx3fA7mDsgXQADEEVujcQ5E4Fu8dDHPKEkE+UwIDsi2kJzZykUH
OSNH4p0CgjEgDaA+tGAEclm5lQfN9WhzPZmfuH+iT+wgKsBAYizvSHIOEpNYZzIP7Hy6K0g8hmAY
7JPfnjQAohi4z2jKN5ORXEVhrYVaEnAhzo21Qt7uom3BO5A8xEkbxH0QMKJ1AuAzjDPxWYjJBAv3
EuOPTcX8QmwGuS3vmdCfEq8S3w98yNo4d5Pbu3eTbfHoRuPB9vj+ckef7iDzBUGjBcnLNYSFXt1Q
m2C3RfRRWHt1M0O+Lm7TMWW3aCMfQz6F+yazctcBOSUlwyV5Ou8Y0BNkgVTsCAQ3oSTHjSBjBJwW
vW8CxB7kxa3L6PyCHwtKHS4vbVrGVb8zlO37y1rL4mdLQPJJhQhgg75ZQ2V2nt3MeUkL4nSs+tp8
Pu36XN4reZB8i6cuajgg3MAcEDyC+sJv0nw4KAM1FJJL544CQaJqF8EE7gF9JTfv3sCfkl/sYOQz
EIMBcTvmFM0VSK5NMFJ3EDWAUFu5i2BLkBz5pOmDIAuCK5SI0ztzKPW1JGZBfIViA9g98dkaosHq
8XzaqVkCJZmO7E9JD+CPMq7M5ypfbuD3PTFX7OmkhKeUtMY9uj/wNSXI3R6uB/EJeu+J7cGugbvg
OxGvIbqB3IJ1Ia+Hr0RdyCO2n2KrXw+KQ4AJvDIGQbiC4oLA4tGURJtgHJDAUB+N1xFcDdEGSjS7
I6o/uy20N+YabJP6WDIXJOT7+EriwsZ1RgzGXWbto4v8GYK5mvmzUxcCByDLlvH22rxzSG/4bZ74
FNQ/QGZIMSPxHwIIKkCQ4ZOjT+ZSD5AOslsDe8pJXm1OchozSyvGXLDVooSZ5Hn4Pm4rsV07/+4g
xUS+DhJ7ueipA9JBkBMq7H27Yx7KrLd3o3OM+FjULeE7Sb7XjcY/Gucj9SAGiDoAMDLyDhKrvwdG
o74KJBtZVxZQAieQlyBnJDkuyCXY/U+MuSPvLeWH/tykyHwwH4IhmMfI40wtVVSgFUIzILRjU89M
53bE9EcsUmwhnw3yF+BW2GNomQFEtSQSb1F7UoUUjgEWhf8GCTLJ13tIHgQPgEgGuB/k2cQfIpZT
HwrSGpD70nw9ehBIeKlIQvz+yTT/DS4cLYUXjQGORc1Q8kvRV/pmaAgjA9NHULwcWzFOUVL/ExV1
2pUwEPVMSmwRnf+DGF81iVXfXqDY/WS1ovL5KipcmX93MZ92ZS7IGgXn6L6ItRDvkTsG9IDgEvAq
m3t3EZ9+Yz4fkDcc+JB19O8JQnU27/4SRVnbz5QsFuJhQSUjucBiDUaIOz2Vy6lbwhc9XiGUNK8W
iupXgohFQ8ZI4kpowSjkpZSUCGSciEsQd4nYbUDxMXmICSen8SnnZ3LZdxYamsgY1DJgF8ZGMk2+
TuwKc4oKjJC8n5LjO+3qCbwhIuck+RNI3ejcJHaPOg/qCbx7bD+B5C0gXEfdDrhXvpn4T1u/7sjp
QFYFciXeK5Nia8E9aQD8MvAOasIgpIdNgqBe8EgeAFF3S85Wm3cM6iV4xg0QtwT1hG2CuBI4VLk9
itbqQEKN2i6tdwZkDJfiD2uISpAHuhIMtzNiALAeJWXZEd6fEhRHFn8vL7yzSH7gk6Hi8EcTWdW7
FWxA+lDYn5nkrI26LMjGgeNwryg5PeY58RMUn4MAK1Q9itb0UUOK2z+F1pNo/Sf7O5Cdoi4DEmkB
tT4v1FII3iD5OgiWUBtXepGYCvzolzNcQ6RE8CvxkzSHigWh4aFJEBIC3qfkfcjX3YL7iCCvjNgz
jhKvUbKl8rEgogQxPMiZOb+0IbwPyV92xQ1EfZXbFTUABOdUuCfh2BQINdP8CUTaqadnQkxQ8Cv7
DlgQ44U4wSeemsaWPl/BZTcu5sIrv0dcFPwLR3BZZ2bLy1qWQ5iMj979A7czZZDCicQ8L4JzoioM
MA/EgoaVbFHzMkVJ80+8+uYiSiSzDfYRpScGpw0X0o/MhJAHCJMoMRxI6SAQgBwu+cJM3G9Zzv35
srL2HylZmnNQb3azmy7ydQ75OuIkwU2o4X8l7qdYyidjKJ0HZGyAteBDgIGBhTmPhP6iX74mX98Z
P4DWGInPRbwASbYQc2QSm3ZhphB/cqqwK0efs/fugd9TwQxybiq/fA05MLk30s5cfZD0yjZDfGeb
DoiPBOJvUSOTkRwe80V08OuFNSFl7O4v+XpAH9RraK2Q+DI+unocrREid3Pw6gGScdimgDreF7EL
hfr8bPbAs03iiVaVovrNepD5fhW74O2De7I2BIPYbu+GnE7YnjoIcUsZkAvCnWHIz7E2JRE7pORc
IIyG/wwv+wHkspRkFLUC3K+wIkoc+oVUsJ/oS/I6gj/gbylBlyZf10OOhXOj5JShBaOF2JoJJHee
QvPmIDJ+GnKtwbTGgJwPvibx4FTk9ELSyenwiYr8O4u4tKuzuCRgf9h0xAAFyR+4rb49KCFlZMUP
wCe8w84eVuElYxW5txZCMIeLPzaJdU/uh5iG2rW4jeTeYft+EEL2GSBO01ySxHQQtEHIjU0leSWJ
2SCFk0keOhC/gkCWVNC4Six+vBoiKMAY8CMQQgBpO53XJK5xmSR25V1byGVfpySGFN/65Q/DmEHg
BCKbsj2fVllUPlv2NV8H5lGRe4p8nYpmOJM57+rXmxKEEn8rpJ+eLUaUGEhhpWNIHjwOpJHAoCCa
p/UaCC5lXZnHJZ+dDsFHCFbTvI3kSiBhhMgRW/z4Z5KvL+DdUvvT+r7o9o98nU87PhPiTai/Aadj
rgIDafJ1zJfgPiDep+trZBxhJ1ahu8dKIbmjaL5uQ/J1CF6QsaV15+jq8TRfxnM7AvsJCXsnU+Im
1Jmo2EXNBKGsYa1Y88hMONwu56pebpQV315CxS4cyT3fQrC4PcE5oruOQvLU0ZC6kg==
	]]>
	<![CDATA[
	3J/4MMxNnAPEC5CvA1Mhf0QMoORPIOJCPQP1JGIPQvKZGWLCgSlSWM4okebrKTRfB5ktzpHm66gh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==
	]]>
	<![CDATA[
	czT3IHsEYio9Z+xBSjo/k1XXL4IoLs3niW+FXWOfqFVE6TialwL/Q9CE5MRi3KlpWFPU1AP2jIfY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==
	]]>
	<![CDATA[
	HL0frM6vi8x2erYvW/zUmSQ8a49WPWyKEW48dZXuP/IR77X6SPUPAzA31LUxxK4TcxLqE3Ij6tPz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==
	]]>
	<![CDATA[
	g/vNpGM12NGN2KAvM4zY4cg5OmbkLJH4lABm+DgfZvAwV2bwaA9m8KxgZtRiMucCa5k5McdM5m9+
bLO4xzB0xW3DHNfbBmflz/+IjXzSs77qWnVDyycV24jv3HGJ5NLERrc/u5u/85v7eW2vH+bt+vFh
btu3dwrbv76dj7WkLd7PDYqxTgv/rXEz+Rf/2Os/bMm5kOzDejLjNNKVGe3kTc7DhRk6yo34ihWM
wxDiP4Y4E59J5hmZayOGLmWGD1vOOA52YUaMUTCOEwVmzJxoZpL7OmYG287MXH3KeE7xrb6z655Z
Lj5jGLm087dhK68a5ni+MijYH5/lBL08XV52uaFh04WNW764UtZ17Wrh9rOXi7epb/4aqvjY4BN4
gtQXV38Nlb58URz4tSHO43PDcpfKawMH24z5X8+rN7ZZ0OwQXtKSZlmI0MOYAWScHPpNY4aTeDx+
diQzxSOTGe8cxoyfrGLGjFrGOBJ/OdxuOnkg5s1lRgxbSHJKBTN6msCMnqVhJrgmMzMCapkZQhMz
b/VHJnPqvrZe+KFhmOsbwwq3rwwrA94ZIhWvDTHSd9+XRT07XB/3sHt7+DcnGuOe7GvquFTZ1HZ5
fVP8056dId/d2Fr0oLHj1q3szd/fzqpruVG61et7Az/bL+l/PTdzej42NDb3ZwZT/2FFc34r+hM5
CPylvZkjyUFGkPk4mLEzw8OJsbedzgwd7cuMXUHy46Tzpsvqvh+07IBh1IqPDJOQT644Y5i4dNd/
DF285fXAhZtfDVhUdMt6UcaZvss2fDHA9ZRh8qoHBtfAPxuSlX82JMg/XSsP+f7DTclPWragnkNN
jlzzDGrXq0XbPr6e33jz89yGp5/lbX17u7Dt/mcFzdxPT/PcCj8bCB8B//7v2KbF77Ec9onMeHCf
4cyIATOYMVN9memeScwkPouZGFnPTMs7ZTq96lPzORs+s5hb+mnfmRlnTWfmXzCbX37Lcn71M+v5
VY+s5+df77sg80qfxaW3bVaeMUxf+cCwdMUhw1iXjc8c3PYbJno+MHj6PjKwfi8NGr+nBln9zpCR
fm9HI3IWnNc+kjsX3qnfoRCUjLf/SgY8Dd3BpzJ/8idWUXpk2Ao53WjsxGX/i10a0zGDXx80mOTD
Q1wYh1HuzOBJSmbiyiRmBlfOTOMqmJmaOmZuzAET5433bZf2GBxXXCDjc8cwf+UdwyL4vyU1Dwcs
iO42mampZubptxotijtgtqzopu3yqucDXXf8PGLVGcMckp94+f7FEKz67V2a9NO1Et9vDbJXzeeO
flufTlJuvjaJP/4Ppfz5tymaj39ZzR/5RwDb9R+u0v7/CtSc/jVEOvdjiHzytU5/5l609pPnydjv
FHDNEOiirTGxN/nf4x7WQzDT7PqOJrn+HGakk4oZPTWYGescy0zwyGKmq8qYaV6pzIxl0czUeTwz
cZo7M2mSBzNtgcws4GqMFqac6bMo+5rlys7/HONx1+Dm89AQ6P/aEML99GtB5JeH6jU/Xq9Q//JL
Jvvjbzm+zw2SV/dfp/nsejXN96Bhnv9Ng1LxuUFQ3TaEsI/fJkhPHuRJX91bF/76o+1hry5u0/zw
ZY3w4G2m6jODjr3z2xrpmxelJXc3t96+mb259PbG7W5t70aPcVrwb9ilMao2knuQeUbOc6DVOGb4
8AXM+LmBzBzPOMaZK2UW8XnMkthW00UN1wes+JNhisdvBpXS8G6t5s/niri/3s4J/K+f17J/v5el
+sfTzIC/G9Z4/GpQeP5oUPn+atD5/WwIF//8qtT/lSHYq/aTEb5xjRaekRvN/a4afNS3DOEB+/+x
UFl4YIj6tCFQ+PpNUczLg81RXx9tSnnSuSvmy6OtAUp/RgyPMRPrz8/W7n/Ei+dea5Wdf57vkdpq
NW7yElqn/U+HLRm3kYOdmQnT1STPrWSc4y6ZLdzwpe3idsNgYnsLvX408H5/NYT7/WaI8PnVoF35
1LDY9ZZhrvu3Bnf/vxtWZz1o3LL/VmFj0+3iLUX3NjZq3l0sxhqKD7E9j4sGZ8/ThnletwweiqeG
ENUrQxL79h+52l/ubZR++qrS/7TBJSAoxth17kLGx8OdQR8l9jFynU9chIZLszU5u0do4+sHyIWn
xgr7/u4rn3obxHf/6CmUHB6tzuke7BtZ22faHCUz3Gbc/7UW9N+2aULyLJJj9ZvEjJsvM/OC2oyX
bnw5EP5v1Y90voQqfzXEKf9iSAz4syHC9zHxBQ8MXMAtA+f3mcFf+cgQxr415AR+Y4hV3DJIAecN
XsotL6crS485Kjq+nae+/fcI4fvvitQ/GDJVLw0xfvv/sUBZddJJtfPBfL7nRy/hw3eSesfns7m6
89O41gsLhOP3AzWnrmt1t67lhjz6pEY++02I1PZuldhw21ms/dNM8dRTMeTpxRrdt7dqFTcN4uwl
/P94XpbEL/YzGcH07+vI2NmOJnX0fGb0FF9mpn8W4xx72NS58gvrpYf/c6TbHcMSMp8UXhcNy7zK
zg/2iuuw9Cs6MdjvksFDfPpFTsxXB1v07z7ZJL59UsJ+/zo74KpBodiwdbAiYbWpYm2quaKwzNZv
26mxftcMPvKrJ2XSk+d5yopjI71VGiYgNNNUeeA/lnMHfvNmEzfasqE5ZmLDw4Xy8W802ktP46QL
L8Oka89itZ/dTA/c93Y5e+AXd677azd+zw/u8tmvQvkrP4X6nje4rFq7z2r0xOW0zv7Xw47EjGkz
WWaRtMHINf9Cv1V3DC6+Pxj0gT8akv3eGIKIv9YqSdzlf/qlmP/lXYkf8Q3e2T0DFrp4MgsWzWYC
ElPMAk+89tI8uV6Y9Ly7I/Np067w16e28T+8Xae4bZB99v4ww7fqsqP/hwYXxSVDQEDH13OUDecm
KD/8zYv/6EuR++D7QPbo37y59B0D1UHJJr6BLMPpY00oJwn8/aJ2R6Hl8RLxwC8B+stP0vVX76er
298tYRMqrQIzm+38krdaL/VPZkYPnUdjtAldTzf63S7NmP4mJK4NmctMdGaZhfoaI5dt3w5zPW+Y
5vbIsNznrwY9+9tXufw/XpZIf3u0IeTthUbc+5PePC8VHnyfzn/6SwR36W9a8dq7eO2DJyW6m88K
pVNvtVx2m4Ovqy/jvXgRI6pFBvvfVS035ynP/pensuX6TFXGBlv0QbM7rszh9r3xEI5/r2Z33JvP
FjQPkcp2jdRu6JwgNd1cGtT9UND/6fOs4JvXyvTnH8TLJ7/UyvtfqLjub1ZxTZ/PV1cfGuObstUa
99vsTW3o2sG/HhhLh/6TmZFT3JhpvonM0sTDfVZ9YJjq/Z1BIPXlaqzR+bw1SH6vDLLyviHY/8h/
LPaLyDfz9gtmvNzUTKAqmJG4YOPQmBzrsHXtE+Ttny+Tak5PD/BTMc6jhzGLxw1nluIxeRjjsdKZ
4ZquzNNcerhGOPe1pN7+yWw+pbof3X++/3s/uic6Jt9CCMs0B0tW3vW1u9z+ykOsvzBH6Hjlpj30
VBLvvkrVXHuazO392yqu/tJ09fGfffir7yKER6/TFN8Ywj1uG1xXrP/cblFUl8nC1ftMl67eZ+Ya
s7+PR8bpfu7rzg702vfzdOHd22LsxSm8V7+Te/1zrv8JwwrljlezlF0/LVScMLgH9vy2PDC9ecDS
pS7MTKdhzJzhwxnWy5MJjU+yjMzOHxSeVzEMfWKBx39yFz59Ga29fTtP/eFfVOrjf/FRH/qrO1tz
YgKbV23H1e2dwB99oqB7NM9/FxZ49B/u6uqLE/jsriFsWL65OizNjI1ONqN9L/teKYLPfpEUdOVh
Onf+raja9tksVc2Z8YrOdwsCWr+f5VN0ymGlttB4louemUBi87CpK5gxriHMvNB6I9dN9wd7HDNM
97xsWO55hTxOEL/f8d0Ej5LDAz1TtloGrNvjELi5Z3RgTYejsvHIOEXng3mKnu8WqzdemMzldAzh
03YMlLLahgj5BxyFnIMjhPhqGy83b8Z96XJG5UPilUrJaHUhxqw+xFgobh6u3nF1trrpkznqnZ/M
43d8OJfdeXk+t/e1m3jipcR//KVM91WubxktrtvlyPe89dSdu7cm6ObtdWFfXK4J+vxGoe7KvVT1
gXfu6KvgchvtFWmVVj4l3YM81l8Yujys3GTaEo4ZZOPEDOxL6gFSh06apWBcC6/2d39qWOXznUHk
f/qhmH/z10LVZYMYeNDgqixotg9cTa5lWpkNW39uCl/a7kj8gKkQX2YNpqC/izvjMd+ZCVjhzshi
DO0Vouy44n1jgzMbhsgKNeNF/j2Q+A2hpGUE13RzPrfx1CRhw7GJYuXxiZquZz5h3Xd10vabi6Xc
TYPQgyHUHJ7Id369Umi5v5SvOzeD3fuDm27/l4L2u3s1+qe3qgMP/acrW9w+XN1ycy537p0Y9PRG
VfDbT7dIvz7eoP7NkKX6qyGNxLN4768NnPdJw0LvjP39XRShjKd2tZF/y+Np4pNvs+VbX6cLZ3+R
2JTtA1at8GaUqhCG9mhUfTSJqz47yUetYxaOn8osnzKXCVjpygRrw0zC0wrsIlMKBoYmFfbX52wc
wrf9aQn2+cpnHgVzp75Ucft/9FTte7Wcreh05Kr3jxUOf63Avlr24C8eqh0v57LNPzjzB//TT7X9
9mw+u20wF59rIeQ0DlJ3PF4iHHzrx+1/66Fquz1fVX95sqLz2wXKUwYP5XHDqoD9vy3yO/ifC/wO
GOZ5fGJY7PnGEODzF4PW853B3+eRwc/vusE34KLBN/CGQVJcMPj6bTrn5J9QaB4QlmgSGJpg4uPt
ySyaMopZ6ezM+CgCGD483VxMLrQGQxM6ItAXUYWmmMJfiHkdwzlybfmq3aMpD6Sqc4Iuv3qwmFBs
LWZuH8S2P1jC7Xq+TCjf4yQUNg8VirYNZYkv1F34Ijb08/Pl/PlvtGzF0THqnM12fNmJcdqzz8N1
d74oxj5I/fXrOcLRN2p1+7NFQvnBMUJqgx1b8/Ek5VWDinv3Uz7yIu9zhqUeeWcHuCfus/RMP9nP
I2WftfcJw3zVD4YM7OVT3TGEBRR1O3j5BjHuLv7knNwZt0UrmJWLljBsYo6FeOBlgLz/sZLveurC
JhVaKtV6Bj3pKl5m9Al5NuhFE/c89A46dENL+3BLOpzAwGB3P12BOcfVHBjPp6y35bI22QkbT05B
/4mu43EAeg+k/U8Uuo9uRWlOPdHpTj4Mlfa+8RFaXi5j275cKna+c8eeT831BymqI3/zUHW+XMxt
PjuFbfhwqvrkL36BV//B+d8hOdWXhtCArw0hZNz8vY8Y5vpvejTOL6zYbMUKBeOp1DEBugwTVdrW
/u6+GmaZsxvj66VjPF28GZdp8xjPZat6tWjkBGMPzwDGdelKxts9gFEreEajDzMJSc6xDS7uGBdS
2jMZvUG64voR6HGUel76hRy7s1pz/CutuudHNzZ/uwNfumck2/WDC7vlxmwufftAdQ==
	]]>
	<![CDATA[
	Qo01u+cfLrorz1LEY68F2uuSvXMw+pm59QfHcMU7h/Hr2kewVcfGKtsfzlMe+80t8MDPKwKbb85S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==
	]]>
	<![CDATA[
	pHqVxL7AhFKoZUYIjTGVk4mNpZX2F5PJXCpoHg49ArCLNJuOTadcZpJDi6GJZpRXtfHkTG3tkeng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==
	]]>
	<![CDATA[
	NOiSavfcD5C3fDQ/KL1soBgWa6pfk2NJ6rUR0o4bS5GDSaSW7dWX7NXOEqh21v3l8u6vfTU9zwKx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==
	]]>
	<![CDATA[
	OQYUBarkFp9rSbtMskrtdEWto6TUiv7SmvS+tIsEHa9k3GgnXmSsmZS7a7gUV2yllCOMPVx8iI/0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==
	]]>
	<![CDATA[
	uOmNTlHzRdcylmLuvJLjzfZ4/4amT03jcgzA+cDXeN9eBZxe5JO9BnwiGVm0jQ54vZ72AewPNu06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==
	]]>
	<![CDATA[
	JsFz/RKuXL6X+3eAt0Iu9dqd5Rzf8M1ezamWOEMfON7/69BrheMs8BtQ0cH2IfHL2Sj2zl4Lews1
a6jVc6oRkMeE+iXkC6HHF/L8rmmLuLwQ1Eyx7+Vq+ZDDgv8P4wzm8tUpnB8FdSSoNYONBjzawCkF
QD4d6lxuiYs5ZTLw14FPt4iDHm4EHjeUT4xaAArwdMYHPSKpSRXUG0UX/abSp+3HwWvGOGYPKL6K
IKZdDJzOrRXWg7kB2C74F8htk9ifEgmVqpBX4dbkiF8bKL/7Y/sJfrmFU8D2e7gGf28lcDboDwNl
GiqlZT+R3qIBuVDaLXUB45qsDH1WkOshYsp2iHxfbeTy0vhsQL8e8G0O5/rcXgG1Yk6ZPebdDvAN
YNvwvAf0i+C/sUZ07TbXLwv1BajzQk4D+nGosIItVEa3rjC2ZofovO8U0uIo1ysJOUWoXcN5F127
t0J8JXYup8piEzILckX4DCzl6kB2QdxzI1zt/3LQdE7FGfs3ieeNlVzs5/hH9Dzu58ddxzHH3LmL
61E/6jQWelEgjyY0PTbUU29xejjklgSmpxUhZ0ycsh9LHLYeCQrioFDCOCXMpwPzNlHhZdvgLIDy
GOb1CgLsYwEXQ28upz4H9bIr/jNB1Qn6UpiA3I1D9yBsNsRU7jVDD5LPs3VUaPk2UI3l+Dz2rWDX
0Cdq6hq/mOOlgP9B8QNzYvH1nNVQUxzKB6QuATUsiVfOWiakQIXDrIDDrIOVuIvrk3u4msNBkBfG
8ZLzC05xP4G9MIG5m0GFi8tfYrvH93UFKIOCog6okYC6GBXydBNXQ4H77ZO8lMsJQk0I6o6QM3ZP
WMDhJxzPyISyvVTEy61c3eq0x0RQOYM6v9j//nrIp9FBuZtBTZVTo48sUOGU+0KyN4BfJqOwn+Zi
HY6B19NxzL61ksO0oDABSkFe91ZysT+tQ0eY0qhKX01bCL8L+UNhXPNuqElRAQUbgb8Q0VU7RGkt
RlRatw4Z27Cbs3v/R6D2pkLGlu/CMUsF/DDUUTE/3gI5b7H7jSXgfyDmSDwfrGaCHq3ncqCgMH2z
wZiMKd9JXU9bxKk8QK7q2KkRXLwD9Zakzn1kYrcaHVSyFe4j+EfoYaWD3m6mLodNp21jZzEeNxdT
iW37xClNhqCMzuUb4bku4CBQ8wQ8DPkCl1RlqAPSR1zHcs+qON1aJHFIXgA9ZJzqD6hzQE8y+GC/
bIwjnm/gMIfLLWXG9fYi2id7JSHH/y5gVuvImcSFoCmkXdwsyjlzARFaupm4+UmHut1nJLj5VVOY
/cOIfP3NlMz7eIDK6WeoG5/0ifRP+8m0AU3mbpdA8qzpsPR13VnJm8ZT9OMOCZ3Src1EvNtlejVu
qeyk7TjIS3C9q/iegdojPqfLRX7PNzAJjRqyG3WkeUa5+EBSOWGeWMoXRxapcsrEF/yny+xjuHsM
vJKMrd4N+Rmx/8vN0JdBxlXvBtUfjnNibM+kfzCgM3r06aQ+TTq+bR/UTeACpSLOzyU1q1KgBprY
tJeIKOXy0oz/k/XgP8m0dk3wLXRcsxooPIJCDtiZxPPOKi6XyvWLZq0EPwYfGY9bS6mgZ+sp+XsV
IuXDPjKpaR+V1qQjzmjiidIaDEDhkYiv3wOvEfI38NqJmMqdYCdg12Riuxr0jlA3evToO818UImm
738gBEm9e4XRrTuJjO9a9PNuU3HRh5+Zwo6TkufNh+mHrbToDr7w70qzakyZe01C8b0m/P+1EuLs
RjPmYSdNBpZsJAPfbSAiGrbzMz6rUjmdjPR5zXFpTrUFYBlpZg1BpfXoCtNb1YErgQoS9BrQ8qId
kpiK/aKHrSLmXreQjqzcOaQwmr6Mjm/ZJwx9u4E8e30C8G4qvlnV9EHlQdOs6kNUylctKqBwAyjg
ir1erOPU12LqVLma1vUnayAec/nOQ9YjgQ8yQUUqEEM5HCIv2S72fLoW+l9kSXXG4qRuXchB0Vcf
LMP8aRbllD6fcrmxgHDPWWQcVbfR+AGrKXz+Q0i++iYlCn8zp/K/WQrf/+2AoJy1oFq/XBF1f7hG
t3yypyp6zjIFfSfg3snKS10kFTX2ope9ltTTATH1vF8ieVl/Qvas9qTp/WoLWUoNXxpdpSmNq9Oh
E5r2Y9+zC/aVDHi2ho5rVZOkNpuYpdaR4rg2LbH3s3XAFc1cYhZJ7fxnm/3sMdXUNW2pKBhqx7mc
UhMoeEKdDuIjfaudR9/uN2Gy2xgmu0XEPG8/IH5Wd1iU22YpvtlOkukDWmRs/S5hSqcac6udz9xv
o2m8h8T9AR6R9dWIvv3RhMwaMGGy2inqfpeAedwiFj9olkhzag6a5Rb/LH5UaUYnt2sJE2p3E8ld
6vhSA5ujA95sALsEG6NSO7VEKa16UK8VZbSDbRrJbtSQstsVIjqlRotMbFID38ckYf8X16QKNQsi
6YMqkdazT5A5uJ+60adL3e4yJO4NGJB3PhqS9z7y6Cf9MuZ5L/YD3Qz58qOUed1zRJzTeUB8F68x
q40U5dTLJI+aDzCPWiTU/U4+5JgFD78aCrO/GhFPP1NM3sfDwsK/mxEvv4pEpa0XJKWVV8xev7to
9uzdKWlWpYy+0WxIp/fowmtjgvO2QCzg4grGR2TuR6kou1vKJPZrMdgXHLhZbMbEtWnwD5xUNLG4
MBzUJ6EWappfaCV7UX5GfL/bVJTdK5PcaRdLM1pJ6Y16SpTUrCdO7zZi0rr1GK8nq0HNirl+fzkV
WqzCKYgG520F/CK+hs95YPFWcXK7njjpgy6V2K0hyPiiLozu38FP/raHn/FD1biQJfhN7HFhzx+X
Jf21vqL+zutEzZfTZPMXK7rvoyvV981ZOljsf7DnQeixttsRkoE6P3H3B29ZR72/WWdZ6JG23Bhp
XaU7vo8S6s3XA6K87mOS4nob2auGc+KsFqnsXo2ZeU7ZyQOv8qzMHxeflTyolhHpXzSFsa07RTc7
BbKcmiPMnV6CjKzeAfk/yBmL0luMsB8ylqVWC83vVh4yvV0tA75JJbVrMmALKR3a1L0WviS7yUyc
W3tMmttwUpj1uwHx+IuQetYvExW2nRXldR2jn/fKqMd9jOhFuwWT33aMzvt0iCrsP0yXdJ+l3/ee
od9+PkoW/H6IfPPNVPjqi4gs+GROl3WdkbaVXpe2v/cUV5ZdoV98MKeyeoRUxqAuEd+2h0j5tB/O
A/2gg2IetUskOU3mzIMGhs5o1SfSOjRE6a082eOKw2Dfsmdlx0X3WmjqbpcJdbPDUHSvjZI8bDQX
PW8zJ29/1SOyPhoyd9oIMrtdQDzuIsncPhmV9/UQ8677DFPW8TP9vus0XfHhPF3ZcY58OSChc7po
iE3ky14x+eCDkHjcJxQ9aBZR+U0H6fqWC6LOJg/T/vfBksEGP2Eze4Zfw1qSDZ8v0vUdNvSb3kNk
5iddKgjHUNvwWcDLoKbJ+XKMSyE+QL6KH1S9ln/z7xqi7A6ptLD8kuWT3EvS6Fot2v/xGsGd79rE
3W/6wlefaeLpACXI+FVdGNGrIoj9tlMcP6grS28hzO9XHZMVFlmblhY5H3hf6GqWV2IreVlzQnq3
SSzOaDfhsEpqrzbwNArHOSa5XxdjQhXJldT5wqiabcKcX4yJ4m8WVO9nR8mn976SwRJf0acPXswv
XZ6iTw1ezNe+a/RAn5tkoNT/WGtG6OnmJLlHuW9UcNnViCMdd+TkwG9Okr4m/8MfHkaadb8PlfS0
+Erbm7yp2o5L+H6eod8MWjKvBg8J07/vI5IG1KS5jWfMCsocZE9ajole9xymHg6S9LMuieR9o5VZ
S7GfpLT5iuhN80lxcevP0qJKa2lJlb1ZVf5V8fvmC9JXtWfEb2vPSPIazzGvOiypN50HJLn12B4r
TkrzS85KCirPYp9napLStVPg/XApP7JmE//ePzT5z1gTsqjvsLit3kPWVRYg66sKEHc1Xhf1NV+X
dDf6UK0fbAUlfzMXlPxhRpT8Yims+HKU+vDximiwwVP6qSrQsutRhORTkx9V8eEc9apbRt/q5RFB
bzdQAa/Xk2G1KuTNj/rwPfGLBkvTV+UXZbllZ2TZFYekWQ2msodVFqZZVeb04zYJ8/SDjHjexTCv
WizF+Q2nJbl1pyRPW4+Kn7RbEFnfDYlHA3wax1/mVaulpKLiiri22knWVHndvKso5NiHrNiTrTdj
j3Q+jDrU9ypCPFDtKWmp8BCX1lhRr/vMmPetZ5nmaiez7rchB3tzw4+33Yk505wUdaE+NupibZT8
XGN85PHWDLnpQF4APdjjJqz55QT/0e+GkP+R/Bw4TeyYtoBM+KBK3RjQY1L79cC3QewSOr1YYJzw
UYUuGDxi1v42wKItL9S8tsD7UMfz8IMdr8NFVU22wqLv5kYPWXWB+4tF/IO2Iw31TBFFWSqIHW4v
lGTXWVh0vJafbLsbd6ExOfloy6NY0/piT4hrzN1mUnyj0UScje/Tm/cXzeryvGSvK35mbjYZS++2
iMHPMO2NLifaMiKwzUXEvHeXe5V4h4MNHuq+H2Y6mB8k/VQYYNHzKPRKXShnkxklTmH3SxzDkt+7
ys80J4RLsd0e6soOO9p2J0LaX+kv6W/2Odj5Sk43DFjzc1gDMuO7tjC2axft9nQZlfpFx+xZzXnp
046jRNof+wn/9+v4IVXrhC++0bLWKi/LjhdRR9qfRpv2VgWLWhpcJJ311w90vwuTdlb50MUdJ4UF
n0wFT343Fj7vJul3rSfoitYLwppvR+iuOifYk4OdT+Xi6tIrJtm/avNSqjcbpw/sMHrwQ9Uoj9Xn
N/1+7GRLWmRiuUtETIVrlE/N9RjXGv/Y880JsZZdDyOkXyqCJJ9b/USf2nzE31p9DnY/Cvu5MSH6
WGum3LzvSbCg+scR43u/a9C3vvAk2a04zg9oizwfrWYCijYDdqUzuvW5mPugRSq6hfHfzRbCNK1O
KI1v02NiKvaS4e9UyBsftSWvWk+aVpS6SEsrHERPe8yF6b/uE4YUryf8C9fyQ9+vJ54NEtLaUtcj
H57HHO56ES3rKPUVf6jxMB0sDbnYGBvrXusb51brGxtf5RzpUeubKG0pvkbVtZ03738X6twQmHCt
/np4cINLeFqVY2hGjX3w7QqHELzesGvlXnKf915hPhXX5ZfrI8IP9DwKYXp63KiS/tP0iwFz6fOG
E9JXDWekhdWXJM8bjjL3mynmVrOJ+GOjl2CQtWa+dl472ZwZfa45Nf5M8424k8134qUd1V5U8efj
/JK/SYU1P44SlX8/xnvLGhvmslq8pK6txqkfd4rftV480FMsP9idK6dbeq7QxZ2n6JL2sxg/H5Wk
NBnTmR8MxA9rZKJ35efMGt54HW27F3Ww/WnYsbaHsReakpJtG0MjPaq9w+zq/UP8Kj1C0sqdQu/V
2oXk1VoFljZe8i+qsgkqqLANKqmxCqistgooxV+XV1oHlZRcCc4ptQ9JK3UO8yv1jA==
	]]>
	<![CDATA[
	PNOQFGHa/zpAPFDjbdH1NJSo++Os4CnLJx/+Q0Df+yagH/WKxY87DohufDSmE75qSm50UvSDb5So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==
	]]>
	<![CDATA[
	Cwl6/uh6bNUL9/i6N+7JeXlOcuAM/mWekRcaoyMLME+oL7vC5SHFH19dVbvHLp09e/2/HcuHc1gL
MCKOXsNxLBunjH3/YqQ0fBH28wuwRc7gbHMafp+uMBOvbyGaNW4xmjZuIfaN+Jq8Cs2cjv3/Yj2k
vNYcKa+zRAs3nkBL9jiiJUYhaKGeD1preVdhm0ftuL132UUaDawaxsEnpe0v3U9XJ/kHvvYNu/vS
LbTitbO8Hq+tJM8x+FmJXciHKuvAT7W20f3NtvFl1XaxcSWuISY/ui+uFVv9X/dsCAP/x9d/+ZIh
LDwG79Y4fNam4z2czV3TFX9CSpPWc3ulNF8D26A+moPt8KdNUvTTBhr7FCM0d4keUpqjjpQWaiGl
DWZowU585kx80abjWYpbAxom7LzBzlatYDepV7DbjL/+ccKy8cZ1zyLv4Oj8q3LsOyNeYyyNbTS8
uco+prPGLq63zi7+c92VuO5Kx4SOCnvIJYXqtrC8xcrb/619U/wX/zjkPybitWD0MX4lUv5JHS1U
1sXrUEOzF2hgX6GKZs7C/mPWNuwz8TnDZ23e7N1o7py9aL6SGpq3iIfmL6fQok1H0QpNZ7ROmIDW
H8lR2ORSNnpjYPPYnU/Yn3Yn/Zizr4DdpN3F8oSfm21N2x55uL8JDvbP9Qstz3NPLipwDH/6xkUu
KP1+gPeC1TN5iPlFwfcDTHuri0kHe1KrhN2rdq1omtKERf/juoZi2xgOHYKXHMuhLIjQc9AUvE8z
J61Bc3E8XrrREq3SskJLt1mgpSv5aNGCPWg+9pdzp67FF8S8zWjenO0YU/LQwjUUWrhBjJapn0Pr
jHzROioSbTnyXHFTYMf47Y/ZOer9rKrGB3af0SBryetljzM9fe6Hm+8EnaxLDz/Y+TDkZGNGZOLr
a5Fxb65Hnmq6EWPeUxzmVBuSWFZmE9BXYR0YXewWptPHkhsNzv6PaxvJrWcCF5snIyXOf4zjMP84
7iNgEPCX00fMxxhkHj6PSmjqCLiU0fSJa9HshfposSrGx2dfDt8T2Ddjz012gepzdgXgSdUn7PLd
8X+bvTO0d9r2gK4pO5zKxu+4/GT0Hq/yKeo57Mr9tay6ySf2nPEn9rToS5GHed9j/3ON0aHA54CT
A9Z8Aty1wEn+4p19SGnJleCm93ZhAxWOcTXvHaKIL012Go7vp4GPAP/+79jmmD9jOdgnIGOlUXPR
vCnr0KLV+mit9lm0grRGyy2D0Bq7nOFrPd+O3OT1fsxmt7ej119+Ony9fe6IrR5lY7d6N4/f6lk/
fqv9u9EqVnmjdrpVTNj3hF27r5bdrXqbXazm1zxTI5Ndrl3LauvXs0KDNlZs0MSKBIPs5UvVESGA
WWBdGRg7O1YGRfAoY6RruA/BPA3prSYRmf1FyHO7O0dVdGnY4uV7/ge7VOD2DPz6DCWMh2epoZkL
NJHSCmO0fN9ZtI7wQGuIq2i9OBBtPn5TcZtfzcTdN9j5qrl4fyrZrfsq2R3g/3b51E1ROZquuF7s
jbbIwobtOHlzxB6n0ol7PVumqUd8nbf/CbsJ4xMd/V9YM/6PwYvMlyJX/W5WpONTMt8grGmFcUDR
CvL+H8aiku7z4hffjpB3/zASJv9Nncn8h4n40Xdz5tlnc1F2r1T2pPqoJL/lHPQ7GRWxJmoSH8Xp
iv9z3IN8CJy0qaMXYqy/Cf2kzEcLV5uhxdtOoGVa1mgt3x2t0bmA1u05ilZvIdHyNZpoxQottEZF
hFQIn2Hbzz8ZtcOmaOy+pL8v0qpiNfTqWBPDXtac+PLdwbL9dpD487urgm/frISff9jqt7CMTvqv
a/Tiu9bo32K3GJayxrwSluJXsObChoHTTGOtHfOh2vlg7/Nwi65XcvHHdh+qdsCK/56VCit/HGM6
W91cqwJiK0ptAtwq/MI14gYXLlJW+TfsUgFYG8Ye+JzhdU4btwTNnauClm42QZu0T6JthBvaQdqh
XSdih+8IfjdFtZBdpfWD5Ruzgz+LPz1zIn6tsDX5x9efhb9XW/P/aLIy+p09pvWd5Wl/Zvn631mp
wVf2IP2py82wizXT8c2fp38yZIy2pd9IgwJWT1DGHjTK/GO7sePNWYJHrAnV0e90vO1W1OGOe5Hn
G5Pij7ffizUyNkT0weMj6KCXGyWZ9ST9rFdinPRpq9aF2HFLVu7ieNp/9zYR79tPStvQsrUCjHOv
oW0nX4/Y7tU+cWcCq4Rtb7vOZ5Y0+JU9aPCDPaT3nZXsa2J3qpexmzW7WU3D39kj1rUhoZlljiGR
FS6hTtV+IeLBVy6QQ9HDtqf1it2m/YjdolPGavGaWHN+F3tWOPDHFcm3aj/my4drho9YNSPT4wrq
m7cjPS1NBM9RQh8jkdSoRgW/3ii2TZknORU0ReSYs5jK+F1flDNgSqZ/1qZc7ywU2KYr6Vv6jlqz
yRjNnbDkv+SC/sM2FTHOwhhr0gq0ZKsIbTGNU9jt1zYN/N/+z9x5OWD8nT1p/At7xugTe0i/AfuC
WpYwKmMJg/esoXE9ayEcYG1NOtkTvDKWMXrJ6hiHtq01dsuaz0vs3iKo+P0Q1dfjJPjIWvHb2OMG
mX+oGHtmK/NjareSNz7rUI8HGUFEyUYi8OUaIjZXhbpfYyLOeSeRlhVdMa/P9xE97TRn4gb308EV
22jfwvV0ThNt3vTKR9pd5ssrZemNu8j/dl1jsV+cpDgPTR49H02duBDz6K1o4Sp9tN7QGm07cWf4
tmvl43ff+ftPGpXsLnyeeDqv2D067i+VdE4mjjVweqhk8JrVopvKbY9/uBUtG8z3pwcaXYV9vTZG
BSyP5xWmxDt9ZDjv5wsjeY7uEw3kOYsNilg9UVejO9PYYmd8NesnXb4YGR2wGm588297iZs/dIVn
/CYKD9iOoIPrtovud4olr5tOMrltFkxR8wnJ+9JLJhkDe4U3v2kS6R0aZOpHTdHTDwfIvC8H9F+y
avt/zhi3cPlejmf/69tUHDPWrBeiHYzXMHX73En7K1k1/Y+szOQze86gnzXF/lpijOMu+eWbC/lt
0NUA+wZdmxtTtqtpI5UdG5HRmfMjTB726ogb3zmebUlPtGqKjD/YmyMnPw448ypYkV7ax3X6nm/m
Gz5m1XivWSOjxI5NxsHPlhk//qFDPm+niQd9JsJ7v+kSlyKmCUzPKeqbCBEhO6HIzUmC+ftOCfOp
6IZd9M1vRrI3jZdkBTWXBAmDu4Snr40zsYqaanAubPxuw3No4ewtXIxW5PLpw/60yxFosiKOa7M2
o+XbhGi7zGeYmrx7jvpLdo1GPbtX71dWJvzx4Qr5R5sr81u9l/lAbgjU/pj+Fjeqtu8S+fbbIeL1
bxK6aPCUpLbRVVra7MjkDEgIm7iZ+ur6SHfnDkQLaAT97/zo0i3GT/+hbRz9bj3/stdEeA5aGJG3
icjo16Lu9wmEEdVbhQ5Rsxj3+J8kXknLmMjS3abpdZSssMTarLTIXfay9pQou10iymzlE+md+4nI
kq0C79uL9M+HjYd62/ThE7jcwb++wV7OnLwS/bRKA63RP4N2n7kzav8DdrVuD0thfnkEcnR6Ayxj
0MWKjGtYM8O7f9tpcMh+hK6BGdLRECATvhliCDOFA8dtx1s4JywThZfsYXwerTUy4KNtC+egnUvm
ot1wrZyDtPZtQ0Rk3hbx67pj1LMORhCev5E87z2J6z/P7DPgeqKP24+hLKxGwixZUXyHpiihS4sO
yt1EJXZpSG43MXRV1wVxUdM5Iu23/UTQ67WC+1/1yILBQ1R970VeJ3tQq4JVV71eMnXH4WTF7Ucy
hu8+kjFC/XjmKK3LjyZpOj+dppPxdS01OOACvTiO1UExRO/XK4YPWVXjiK4NxslftvMespomN37s
NbkUNWX3bjW0XnkO2jR3LhLqaKMDp86OtbSxn3HQ7uoceE7M5P4XTept21FJRYWd4PEvfMH9X/QE
t3/VFPo8XCa0855KBKYtI+818rgezZc9Fib3/tAUeL9aRtokzxJa2I8UWFwcITx6bgT33EtGF8/s
aflZ07y6S8TLAZovf7+B7/NkKS9pUMUotm+DnlPOzH0SR4UNajK0DMfmOatV0SJ1c7TlQNAwdf8a
Ja0sdq32G3avdh6+HmK/n9izTMv1zjTt82FjjZxTZ5oE3Fho4pM43zjk7hJeUu0W3o2enQK/3JWE
beIs8mLENMY6bhZlf3M+ZXtrHnXKe4KOhi7S3L0X8fVwvOIbI4nUXEEoM1egXKLmCiIKNgoi8zcJ
YvK3kBGPNwtj3mwl0no16IdtDPmiXcT1VV6PXkg7x88nbwxoS59VHzMtrXC2KH/jY1pS7CjNq74g
uDmoCc9VEFdCpvMuXhun55o+Q+t67uy9Fh6Ka3YRaMYEZTRtNOYDmIeu2MBD6o4FkzWb2P16PSxN
fvnoQvb/6sh/w9Imt1h1Y4eo6SZH8L286D5BGPRsFemWMB/7geHUKffxMFPQUE0TaW3dhoxUNZGI
Ps49K8TNjnPJWGxmFTxLxBMgHfxzE+w3KNfoeURk6VbCL2cF5ZW1nL52f7k4uVnPIr1KyoSX7mSu
+M+AZzAonzvLyaSOfVR0zW4y8Nk6YdpHDWlmOyXpqfaRNZV5m9z+u7rQJWGuILp0M/FskDZtKvY0
G3gbynxv8BL8YK35v7IXcTw7pdvBErrZ7Hbdy5mT1XgHkLbkyDDD6IY1dGO3jais4xL19BsjPB8+
Zb+qLjLmmyPuGQ3P5ysI76cr9ARStH3parR31WZktE8dmUksFA9edJhqed5h2oGzjpNltn6zyLjC
XdDnK3pSb0bktPOJzM/a/IyuvcKrSfMJ78zF1J0OHvTVCm990+JHtG0WRn3cRt76uwE/vGIjaROn
RJy6MoayDZkhSGzYRd0aMCAyB7T4cRVb+UFvVvKSulWMc1gt4/vsfqPMHzsMbv1dxeAmu0Urn92p
3c8a6f3CSrQHWUO9etbA4B2rb/SK1TcpZhleLqtv4P9M2fC040gjizOKJgdOK+rpaqMdqxagfdu2
IT2eESIPXhpJn3McDzM0QUcE9EX4B84PB39B2yXOJfC9JT1TFnLzQDyTlkntvZXo0y7jaavwGcKE
2l1EfMseyiNVmXKMmk05yWcLsS+U5pafOFDy0oN82SkRXr23SGAbMJV0f7hE8rTloLSy3AX6IGXv
3tlS9/oFgoTmHZTHrUXUheCpQp8XK4wLWD4x+MUecJHuM3a3lt3TKZpnMsZqX8qepHU+Y7zuQ3Yr
/yN7GXr5+JWshZFT+kwdfVOkqWaI16SJNHaoon07diHhGdsx9M02I1FmgzGZ3KQmPOs41lggQ/BM
Op8UIdlpuwnwLBqdWqdrertYwj2H65qoDDMwhClNqnDmCJ+bS8nz1ycS1v5TKb/sVfD8iTSxwQie
PWAyG3nS52WHxTmNUml23QEmrV+Pim7bI4xr300nDWpCz6f4Xe15/t3ftPhJbTuJgA==
	]]>
	<![CDATA[
	p6uEwY9XC7K/GZgU/EEYVmJM1c4eMOpgzfG+GereZTcb+tcvMbBwGaGqykPaxlJkJL2syL8YNllT
X4z2bNNA+jpSpK2mi9TWbEHae/YPadGITitoaRsh9d37kK6mERLwSCSWWSian7OdaOaSuMTc7cZK
eDZI6hI0D55xZG60GZhnVR4R3/8gEdz4rCG0D59JuqX+JEz+qCYMLd5IXAqfJjjtM16Y+oeaNK/5
PJ3VS3HPutjEKMHzzMT1W4sIl5g5pHPCPKFn1mLjhLotxlk/NExuflU1iSrdwEsZUDG68XWHUTbG
skUsz6Tib1KTor/RBg9/38VzT53Nc5RPM075toPM6SdNIls3G1+JmCa0iZkhvBQ4xVh0aJiayg60
bekKtGeDCjLA54486jAanmWDWXrSS57TYBY7EfxyPZnZpSt+UCMWPawVMVnNlOhOo4DK6NMlgh+t
pZyi5zLWwTMY+4S51JVo7G+jZxPXkhfAOeTf7Ncg8jvMxIU1p4lHn/n8m980BOkfVQU3vuyjHvVQ
TFHrWVFe6wnBze/7hOe9JlIX3CcSTinz+LH126iXPTJpc9XVo52PYpjOOmfjXJZn9JzVNJL3rTF0
yFHaZ3QU6VFnFYwux002yWa1Bb7PlhlJzirwLWxHCM0uDzcmjymo71TH5289UsV4hLzoNVmY3qkO
58aIMR0GMzNgbjF94Mxw2UWf6RK/55tFSRU6ZGKpmjCpai+d0qIDMyBkd6ukgsxuDfJqhjLlED6L
dkteAM96wfPxzPWUxTCfx6Lwpd2phhvRZxvT4g4U57mI0/qMaJ8Xa6jrL1cSqQPq1JMOkSCxdbfw
9mdtIqvbkPTNWk7aBU4nHCNn8e3iZhh73lvAC3q3nGeVNk1XdllBizg1TF9iq8gjLyoYGB8cJrwo
n8r/OXCiuqoRWjRqGpqBedP6qT8hjV37kcbO3chQn8fNIeYJzYYR0uOKnC7O2WuTxYdOjCDxWkH/
RXbKYyLM3ZKec54oOms3Hp4ZZtKrDaQ5FRaSey0yIujNOqFt3Ewi9O1Gfnq/Gul+dxFodRlLTigQ
2FbFOW0HJFktUjL1kybcRyI4bz3lkjSftA6YRl/LXAKzA4lH/Sa8nF80TbK+aprc/77fJPPLXoH3
3UV8t9vzBVeiZwhPe4yDfdEH/TFjMYJn87GtzyQ9c5YRF7wngt0THvcWwXOlgiM2I/UxDtPjSZFQ
fEmRckqaR0bV76Sjm9VgbjbMM+LmCWU1kcJb/VrwbBcVXbGLSG1UJ9KbNeB5cRL7FMopbh59OWAa
edlvCmkTOl0YhuN8xoCaIK56u8nNfjXhw35j4nWXjHrRJSVf9Zoxee2HiZx+Af/uDy3yWb+Yf+vX
fcRJ93GGjPkwY7OzivD8FpnxWVf6rO6YaflbZ9n7Unsqt1dqnP0PLcFj1ojn+3aJtuAwWqO0BK2e
sAB/nIe0DGjEP2ozUnDMZqSJxdnhxKHLIwWyC8PV9mmivdh/7lXZyemxEee9J1JnHMfxzS0VIFaI
Tl8aK7l4dSqnGXXUegxjcXq46OSlMTArQXSjwVhyr0FCZXWaEB5R80gr36mC5LqdVGqXNsw1pC77
TBHZBShRyXUa0qfvLC2KnjkfrXoQbPay9DyV2q8Nz6AxLncXUaE12yjfhyvpq4nKZNCrDZTfvZUY
J6zk3/iixpcXrzexDZvKd06bY+yTu1hwPnKKhibmC1t2od0qGkh9pw4y5B8cBs9Z8k94jNmybC1a
PHY6WjJhGlozeR7ag/EH4CtTp/iF4oD76+GZPOn1R2uZyMo9ph6ZK0Vmp4fzhSJEy44P52YRghbG
effJYpfguUzYo81Uwtu9woSKXRhLr4X9F0RVbhFkfdZl7vWQgtSWPaCjQJ3zmgS6C2TQs3VETN0u
Iq5uF53Sq8Oddb97K6hrKQuJ8NKt9J1WE+pBqxD2lnrdYU7ntx4in3RROCbuJFwz5gtOuI7hkccV
tLUopKXGQzyYc3/UaTR5LmAyaZc8B+ZGkZYOo3jUUew7TimQPwdPwbbwE+WKL7/8dfDcCnVjQJ/2
zFpOnHAYQ5xzG085JeJ4fg/jQflMyjp0yEf6Za8m4sp2UQnN+6hbHfr07Q88MqNbk5u3fbfLiHrQ
LYDnNIQJTbuFIS/X8jP71eA5IOCy0PNNveiXCVIG9/BD3q7lJ33dBa+ftHKfJDxtN4byvr9cmD6g
TqQO7oO5mYTPvWWE54OlwtB3G/hJ3TuNb31XFVyKnKptZI42L9+A1k5fhLYtWY92bdiE9u/fj3QN
jNB+HRzbMD7WM2GQnhGFdLR4SEfPGBlbnFYUWgVPhdmD4F/gGW2YtQiz/mjSQoHgY99DHFLg9OPC
36gwiU37yaRmdZjZTZxxGkd5ZyyhbzYZSe9UiMF2ac/0xYxj5ByYiSW6VSsU59RJRdktEupOD49I
/6hJZHzRhmfCyKjqHXAPRc6Bs0nv1MWCmHdbqLu9JqJnbQcFd37T5vu+WiH0LV1jnNi7zSSxb6fA
49YC44N2I4xFZxX0hAeHGR+4PJw4EzCRf+zKyB0bt6H1Py1Du7buQ9qqBthvChBoRMJseMm1myuk
ce+0xBFle0F3DebQwbxCvlCGTHgU4vQwHYNnw7P+MPdF5JWyDJ4jxXHgJ8o+VIlyjZ0vjGvaRd4e
1CcyP2qRgc/X0jZRShS+YF48fclnKvdMnn3kHA7fhBRu5OYKemevJMJebiCDn62jPDIXkp53lwhS
O/YSWT1GVFa3MZHyRYO4dn8xzMvgy84p8qgjCnwz6+HEcc9xJqDbIML++YzrOJipJzCzHgFz9mD+
I3nEeTRtHz+X9sxeQYTXqoB9wcxfjCt+os75TCLPek4kTzqOJU5cGQ2zI2m3/4+9N49vq7r2R51A
mM2YUmbEEEgAK2ceEqbYGQhxYmNZsxwj23KiRJaMLCdxSEgIIQMEEiAQpgQyAyHM0FIKndvbX1ta
bilDC6X09vbe2zv/3vu83+fz3h/3rbXOKEu2j4xjS+aoJdbZOnufvdbee017n/V97YrmZz9T6R3k
nd+tad7/GxXfrQT919rynd91RN7+rGXxjz7MRH76+6WBN//ltuanf82HQPc3P/zdafhuIr6/Fvzp
P7Q3vfR/zfKt2/dNX+6xM5s3Hr7Id+T/vtl39N9q0d6BuVnre/F/12IusOYl2UkY02iIdUykPC27
P+CbDnwqB9YfuuC22/uOr71+QdX116lVs2feAvOyqWqRL1Dli7VPbE6Ab9l9z2mB7jWnNC3JHo8Y
lJTjpWPlpEDfrsnhB9+7DnP6YF7XxSsfOze2pO+k1iWrT46GOya2LOk7efE9hy4P7flgJuZ6wtwY
gXVPfzOw7cXL/Yc+uzF44JObQy/+6VZ8zzW8/eWpmE8wcOjzWdFXPvEF3/hjk+/Fv81qevW/awPv
/msw+vPP09Ef/nFp6JV/avC9+NnNofuOXBG6e9d5/p1vXdP82n/Mp3eX3/3nWPOb/x/4HZ9wvpWP
neVfuets/8F/u7H58L/eFHjiV0LzA29NCazfe75v67cvb1719DmzZi2qkr1C1dwb6qsQxxOxvnw+
+Au6x7c4MZFyfmx+gXJ0BlMrT8ScqTQvQW6GHnuzJnjkH+b5D31wQ2TlpjPD3WtOjWx6+uLAru9N
Dz3ynjfwODzv6H/O8b3w15vCG3ZfGLxz5+Tw5tevRKyNwJpHJ4fWPPlN1JOhu58+n3Lq3An+4Cqw
xe99/tLQ+qfPp1ySq3d9I5BZc3Igc++plG/nge9Opb8rHjnLv2TtiZhrHuvge/iYo8q3dM0J+J40
5tsLP/CdaZHt3/cGuu897TZ/x4RFvtYqnM/+9MZTw+v3XYjrxffSf9b5Xvu3ef4X/rnWf+Tf5zQf
+OKG8H2vX4W53TFPQfDwn+swxxrmHgo8reWw9h/9x3nhI18uDL35p+bQu1+2BL/7p7DvhX+bFXz4
u9di3jnUG81P/y/e/8a/LvS/9l/zm594n/OvO3g+xtWa+548J7AdZObBL25AG8L/zMcqvj+O+fwx
d6QvBmutres4/52PnIOxgeZDf74h8Pgvef+Se0+6dV4E/KC5VfULIlXh3ANnhu87fDnmpgzfe/hS
4OW54VW7JiOPfam7TvK19h7f1J4+DjE7As98OAOxejAnUHT70WvCO7/PYW4dzPdJOa43HLoUc49S
Lm3QFb49P+d9hz6/HtbjjOCT77Kh3X+nBPZ+MDPy3Me3thz91Bc+/Pfzgs/9bk7wxX+5JfD6XxeF
3/uH1shHH69Z/Kf3H1z86S824fv38Z/9qC/8nc+iKHOD6548D9auEHzlb/X4Lm7g1f93gW/d0fPn
zAtU3SjfVNXc9eBpwQN/rQ0d+et8zC/m33DwguZtb1/ZvOKps9EWnVuLmK2tVZjfhvJGbnnxKsJj
TNx1YuSO7WcS1sOdj5+LOeURVwnx8FDXLf7Or5ZEXvvEh3lhgm1LoHzLmZgTPfDyv97qe+FvszC3
mf/p38s4vpiLDjELginwK+/Yenpww/4LgxtBz4J/EQJZEVz7+Lnh1Q9PDq594lz/BvCPVjx8VnDF
I2cHe3eeFUlvPC1wx+bqAOhgxMVF3BDCAY2lJ4b6Hp2M77f6D//bLP/hP9+MeTzCG/dfQlhFD4Gf
s/tXMuKLIT4e4vIiNhPmGAqt2HQG5nAJvvoP9ZF3Po/F3vpDS/jVT33oI2DOaIydUA6hB1+ZGtq6
34O5ngKP/4TD3DOIDRIAPynw0r/P97/0H/N8B/80E9cM5jALI/5M9u7TwhufuRjtFv/z/zw7tPm1
KxB39zbwZdAnQwyg0LYXLsc5ijk0/Ol1Jy9qakGZMBFzvjcvW3lC8/L1JwXueekSWNs3h+976+pF
je1Vc26cV1V/W6TK375iUuTeZy/BPOKYByiY3nAqYmBhfsJg99ZqX+eKSfMWhKsWhpITgBcXY+4h
zOkaiGePx1wyIcqf/cIVlEsF/9539KrItsNTItvfuJZypTzwxtX+J37EEqbIc/84L/bKp/72b/1d
svOdH+bib/06ET782XzKRwFjHf72H4Oxn/+hu+XPv7kv/uef7cR35TBXSez1j0P4Xj7iMTQ//n1v
M/ggzc/+WvYd+pcbmrf/4OqmZZtPqpvVWHX9tUrVfPAJMKcT6c07Np1Wj3jELZmJjW254xc0tIPc
bK8KtfedgLmnOnb/9NbWPT+bTbnTlt97KuaKQtwSzKEf6ts5ObBsxYmot1u+9dvFbd/+9fLwo+8y
mJcOcyr5d/+ED775703Bt/63r/H5/z0juPnNKzCHfXA72JSPfZ8Jrdh5zm2xxAS09UJbXr0C9Sz6
1b629PGY29/fc1815gj09z50pi+9HmTmxlNDXSDrVj5wdgTzTa7efV7zkpWTFi4EHdgcrsI8yYSx
BvMJcaww9ujHXEKghzSM0z0XIY5BeOXGMyJ3bjsH8zIiXYiDirm4I9teuRrz1YEOmw==
	]]>
	<![CDATA[
	peXIev5yzHWHuEWUM2rFjsmYxxBzfTQf+sONiC9AWLCIp7rrxzzaXeG3/kTjEMjec1rz7cnj/Len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==
	]]>
	<![CDATA[
	n79Kw13PHo9YiYg/gPFA3PNa6I9UNUQSExf6olWN4c4J6DtiPHuRL1aFmNhhkBmhnT9j0ZaMZLZW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==
	]]>
	<![CDATA[
	c52DHpeLmMz1Ztt6U4l0e8IpF7SqDofYeM4oU8U5JSbd29XQnouvSDiftfYqo04YDpdT2rKJnt6U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==
	]]>
	<![CDATA[
	lfCSynraqQ+irJfpjYpehZM4rQS6SiWsIIhWCdZjvKrCCba7VC8nAE+hhPNyrKcGmmEUfD6reFlW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==
	]]>
	<![CDATA[
	Q87GHJ2F9iKiEW0LFNAmG1gzhYbJPxAxoPzyBQ/G4/k8nuI7FByv2JZwXonOP1uZyb+8MiTRatzg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==
	]]>
	<![CDATA[
	mNPCKMHlIEk4JJhUmUXhAJOWTpdp4JEw3ALaWrjBhZ6nBh8jqGiWS15B5LUs3SDwNBucjnBBJdoF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==
	]]>
	<![CDATA[
	+WDtYe4M3hHloUQur8dD+eFlr5MB6+OdhkJSgHfjAo3PrHNakL49WDeaPEr5ioXc/v3sXW6Xl/Kh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==
	]]>
	<![CDATA[
	FQ7HywWQWGc2PR+FNsp5ERKdZ+D+fxcWnac7P2dgMT7ubO9ju24X7fyejUZUKesCNLqofx4aad81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==
	]]>
	<![CDATA[
	QFrafqvBJBDayy4Rz2h1x0e25WOZOqx04ahf8frBqppG8dFo1I3SW6IMeAdFcDo1ph3YY7ily/+4
kGzENHGn375FmvhjMwfhQBZHA4zhTzegMumG6SY1MZc78Mvy/lHCnFIR2oGw9CaIaR6TXcfbSoQ2
wJgEwn20kJ5ytBRI5iPB2IpjHe71CxW3miLBz3oZOrMtT9fAbwQ6Kbcjjx7iPZj20bWDEcwuom8S
6yS/baMZKJm8PdnuVMvID+DQEGv1ISoiMNH53OtgE2+9eJ48r+n4c7xBHS1vllZHuimQhV8DMtn1
BATrbSWGwxenCD7pyKONWCG9X5o2kIT184nl49gtNH/KHgZfYINWeyphZNIpgQC/NJ6mkcfwKnGn
AxEW9CXfet03zmidHq0GeGgwini3ZDMdHRddKcI0fRdt4hsHX+NUfb45RB4ZVPqn0WQt6vVXgMZA
HaV/ovlmrCjoAohF+44Wvhibl8JudTNlzTx+L9+AsVwI1YhyP4KKLAem+2XK2CKN/OvkGA5FuzNx
bhfh3zmw2YiI/D71Bjyghl3U112NjrzGrH7Nuy4afWld0kxz0B/K0zoy+55+ZN9mDXYGHYFncvYV
1ldD60dr69HqH39oV4l8bjjNhD5cTgG9IF35YpxEy+/hj2h1V9uxpprnhUz2emEqNvvpTw8L6otW
ZxFHtOQf+eJF+zuoJeOX65T236yINa1YlqJOXbD6fAYC42BriDyGpjWg/ief50Hj0Pl/fjsVpFO/
kWMzwCHn5FafJfbdfvujpXomFa0sQ19RdzbYxXtTRwfwTndEAto5iT2aHnQ9MA1JvedB26VT8ejn
KBV/Cno4vLg3gzwcAwt1AIKyAOvnJUf+n7XhVRwKarRgtnBCqUVdhMcMUW9Vn0sMo0mwJIZfoVNk
aadRd+YzizZ4SonPSUsrBqVojFZdX2mJLvTbaFUbz0UXGfNv6jHV26jhVET2B49PlvApsvWLBK6f
2VzoNZ8aAed34TGR/6zRKePyheI29kfnQEPNB9YUaef6oMXAMq2DdfGysy2stYPXhoPYG1sim319
QK7ELDF4bGuiL2ZHA0ThWIuMJMq9sDgS+5lyQxDkMBFxpSKj0Ct24E9pjKu260MAlTLxFxn1+ELj
B0GwWBqst+jJaKM+G2XgWUrE9LjHd9AvDJSZNmFx+ED9VepWEYViAxYwapDaekMj9KSSxYZPzgIw
pUHCDH6cO4nlPtgUvya0KVJ/SORKQb90O6CsT2hHj2FJliR/t1oIOx3PaBLaIMcGF3bWT/T2fCec
KVIodlOgaKHfo7Wa7uWgkTHHu6e/8efkyyg2LVoekE9ucJoe2o88CVs1wxhrhqjPmo0j7TpDuyAW
kjYbTeyhgu3rB6yp2xvzWApHyC7ki50ar6IWLCtBa8iOfF+ldanaKjabL318cTx0jAftbwE/HOZS
1ltC0ZLhM2nzeJfMJk20QqwxYniklKtz54clbaZWiT8nNm9IOcSC+YfERyIV1ecij5m4nQ/l5UML
ajnmA7FnSyCmMp+uy7cLxNpwFa0sHPrQRyKwTGT7L9tEzmhM4d3jxIBYWZEQ7u/PC+i+jpQcCsLg
H8F+atVL3vlnp6b2bfxuypjtvEY2plcN6Bf6E4RQbMVlQmAUVsLsHYPym7f2tVsgcRVKjNwezaN1
9zHxhH/NSaH0Ogiug8zaa2lWTm1YNxLW4k4Xing1CXyiAIbyGfdW+8vH9OqhbTuGBgP9fq8WcHbM
5djMRtXSr2+vi8TwZRs7hieZJs/t7i71/bkboxMYBhwLwWKLwZjH80v5q2DNVFOpCLntgKiwa0B6
2ZqAp7oxuuiOjgYKr8e2c56KD59ozrkLRhqynTaiVXd7h+VYS8eVluxzcDTq3toRd/5p5KcA8543
eS4zwvF3EwzDFbmJko/PK05wFhNuzPBYAwljnjh6YCHkY4jbUI/6SXQ5LpmP7COF+f3isGZHEkzS
WC9aymc6yPRpITw48ZBQ7ThmUC+aZK81eA92msufhCP5A5P0LyfJ9uu4Du6MrcWbAdP421Mvvf8w
KqFWSH0I+j42BoyZtsFlsucxuWNFk2niXWRfLKfxa0bUG4DjH96StpZvFHM1aRtn9Sdt6wgE5cbs
+c13noCbBkYQ/4+UcC6HfsyhYDcwDR3VtqAfb2NWAJaazyn+kA8d0C/xcaQPGnAWb0aX0aGRdxrq
KADKb9YlZ/48N9qDQhSGZG+nmRzdouNePQ/ymw9EdAY0MvZa9kHZN3+k+WLR44M7/Eh3ADzoH2t0
8USUwdb7dCJm+EjkiCHJGRzb91c7mC1lKp7Aa70LcxmkwEfObj6/04jUWHmRI0fIXDIBgA8bZ6ae
gPZT1XEjt//Lkixa/MB1FivwUA0spWQvDJZ3sK5fPfjryfcH/6i5hpFlXMjcbzPHZ2CM/3eYzTNE
KVy5Zfe+hDNVNvcJfHkrTlpAF7RxEr24rY7HDo3HBB/mSJ39Z9ldMs2EKYTcHk6PY6Jzg4KbS1eo
JqSqXDKx84CTxXS22dp7x/JZxv/nv/7H//s//+t//df/lD9Gyr656a2H69/DqUGc3JddTO9Rhch7
0TKD1c4fg+Jutp2sZoN9CudG+WghQRDJnb+ci30RrXCYTjhKGX8w1dGtQ7HqsKgt0MFnglg3SULv
ylQigVJk65+kih9/+0qt3TilTxdWf//9N0GYvhMEYTZoCMKYA0HgcxeSpb+P/wEUwhlZv2Qp+PKw
Rn/WUBhmBl90L/Ch8aVjkUEaj0c/Rs/dkcbnrwm+GAz4z+R3L5tDfwbxnzHaF3xCf5aYxrW3XgD9
2cN/Rn0v9Aq+GDWo78eor/wzhG+mEPoThG7aYI9a4bsZNdJU0rrpMw3frM/o7SQIm5oD/YkH6gaD
0raBLzYKP03FB+tf9Gcd/WlLfod/jehLBz787phz3F3jP/Fc/DAyj3t+fA6a5zP0N8iQ1RgEBKlJ
PSZ2UTtdeDLTMYetHK39bkAmx8xOwLXxM9l9CLyjMzu6RH5HtzHKMDJBoWPkW6JaYuxMZOmiM/Hw
HiC/G1Tl77+BA9cRjyc3GXlqttabM0nYYo7xPGzZr8edDn3iJUaLVx+yi2eevjE/cp4+rAE1Wg3C
s+UL/whvw885mKYh34afp5N9W00ArU7pC55kK8fRejG1xF6qTz7649lOpWOtt0q00n/Sx5IOrQuN
x2gf/bYtifA0lNQvX83p2IfnOzYN9K2R39YkxiGlY68loDPUL2f6ff30F3TNaAcGTLbk8eR76Bxp
JgCyqkAhZ99rSRZSzx76Ydf7+2/HNJcnLOHt2stiaJELsKd/Rv3tnQ5EX9iO5KQ3+TZMxXAcz5Ef
Wlze+TtVF4ymCEI2UwIdYN1F8y0t+Dm/P5aYzf/yjs0X5HyBARObuXVdnjT1fyL20LzkAHJhCXoF
JH4s6Rymo9Tahs6RdlnLxvZBJ2LFYli4pMxa/o1p+G9Ca6JshNbRmxOafuaHIBJNF9DsOk4QT7kt
GqeGXSuT+VNDmJ5ffwlzwG/GNI7XFVqwHGv8RH+Bcln6yL89TdvMAjbmyIce2RBtE3pCo/8MEFpr
4pl4cFq6hM4LrKsPldxA+4YAmSaMT7N3wpSsLglzPmgnLC+aGGFttBuE7SP5Q9i7NhPhGE1CBDkv
vxDUxjsgaO32gaB3dQ/h1j/mCI9V2ya81Nea8EWKNOFPuTJEoE60iWCvBytEhPRNLxEO50rEUyM0
IiILykLEAuYEEX/XfhFJ/fqBSJV/I0RGt/ogsqWVlsjbdlGi0NF9Ec9PFhNR1nuyxEs3OiGq2aKL
qJOvdaKx+9EQr0trknj7Co0Bysdr3Uu0X2YfxHfNbSW6jUqV6L+uHohhP1wgxsvOlpjqyQwxD7R+
iWXJniZ+e81fYmt1ZjREtrPTaFexokYf0+o1xvFrXWOJP5Ea20b3rSGLnaCGporzO53G/RPIaXzP
BqMmGFh8aMKGzqMmsm79auLjSlWTauddmuxndqYpfGRKmlK/6NJUZi8LTX3bqGlaJPTzEZ1pNF9V
4kvTnQPkYTDr1Ezq0MFcu/rUrMq+LEDZGuoeraa6ftDqXU9jrWnSbWptVfC1Kbrl07r1tEXrm3c2
2sfv4FAbqfy8aRPPuZI2UyVT2kJzGtKWP15c2tpPyKZtaU0G7ad/pdF2yp21djCqzrU/zvzPnU67
qMTH2o0+OnrQlJ6GDwZrfPRgaafHD2Qw//PgJurzB//H1+9DOL8iHuIJyvCQoaO2h6Kl6X6oWDeh
h6Y9kH74cDTKD52A9v1hWMyPH6bfm93Dapu264jgLgQujf71uaCz7AxgFz93FjrPNmrRPT7rw7oY
Oazq0uOXsa6YD5l0Va89omtptq+69mz6q+v/TDy6n6/vsm417M31RL/j0hum/Re9XT9f6V1eTVAf
KFPv+sgkCoagPu1p5PXF1+lCX9NbQ/q3l3RX3yEnLv1o4H7XLxJNu35nMzUN+k3TZrANHK8GV+PT
bgi+BD8MsfzSZciWqn1D+SP8ZGhOjCtDezcuGoaelsUwL2S/DNtp5AnknyEcIoz2of/V6PF7AsbQ
j29rTKaCr8YiSEVjbVHVGz8+Oj1jP7cqGGcx0mPcxvIakyE26JkccUvZ5C0Uwqan9sZuSv8mNqay
fdo3vebiTdP3ksibJuEaQDH9znxusy7xazHb9e9as+cz8Wt+yrim5gz9MDC/6Jcdc2s5aJu7s86H
eTr5fDdvl1/vFpNp9Glx+pZflmBG07Ukvsmh5dmamFmaxde1paPZ6Cw/RZ/dstVUvHc6q/FLG7M6
U9ln66Nt+W5NblITa6m30Vpbn2Xa2vumk9Z5d9q0aRa1qc2mC1ts3oAtaos+/zZt+dlwaWu4P2jb
90ezaJvaK2PbbvRG2i2x96Ldo+/O7JHxCqDY8w1j094oPD7YO/l6xj7LLWYOTY5+dNgqla7D19e6
HfFdpu0oBba0462eazuAEN2O33K7SxqN0UeSrmun5JO7kyJz27KWbIwSTbL7QrvJBcCldFkjOOcU
9WxyUKGqaUxlO2SRqi+9TqpLxZfUIlNuOHW/k6jTGTJYnOFlcubMx9st56vZnnaCded1/ha0BtqU
qC5oj8v0Tcfd33W67I2Bj+5/iNA/hZHPpWmWyDudy7GNW1yhR6/elWtZNK5X88PWNWg9bFwb+mHj
tkzNW7e/6dW40/G4zl13lEzunm1Eun+tZq/HbI49eXzUd8aTijmqnlql+uXpzowzz6+/pfeaP1we
r9/UBzfAm27nX72NsHPq7a+XZu+mj3RLsdT0PWYyK18+HnP53sLBZ98kH/nxa0sRp985yJf9MX1j
5X9Jjh/934MH4HffozVgnrReAoGUhgCZ9ZQOtAbjVWBSCyXA2XjIz5ZBVzydCiYShk2wlvgsBPvN
nCG47ZDNR9KodT9G4j+Tx/K4l33s+D5Mj7/Dt++Q7akVD4XNfVPouTPuhb4aD/nQKg==
	]]>
	<![CDATA[
	56bD1nR+HQ4lup/h57w5G/56K8Lqh1eTlf7JZotPn8LP68+n0qpQfuqkrImn9arjjzhKaUck6qUN
kapRR0T68+kqSrQ/p1G68z6JJvutUbQ5ag6jP4bOGPzw6U/M/7Kbx/Irch1rx9La2Grds9zp4vZn
Mx2POgvheHW7zcWH3XQj8fC66ye8pedNIley2xOfzXE0sfouVpMOfXiSjPnMpmT9g4gmJ+Z5K2Vo
/mxSQcfYn3oeTOupbmm7SRMBUyjttvna6azpGaCkP3W9YvrXYlpnSH8+nkmU19PM6zgZzszNs1HW
WsuHs1GT6Sdbf+/Fsz/+9Dpn2jmfc+GB1pKr1safuXFjEM4bS++bfOit3chXBh0/yMvJtmD0rVuF
0JczdqcrVA1Rc2HceP8pmiiiUQxPYvFirT5xFn9iQeLZ4h2Nn6Oe5Ptz0619fp4/fiRK9mIqWEq0
SWfpXbOzln6TU0PZOe5oy9mnj135a9vevhCfw92LL7XUvJT8Rt2d7mVo8ZgqRkeZrDzRP95Kw+d4
qsyf67mqY6CvV9OOSrfaLplWNULzYan5ak+PtXLAWKqNtsNu3dxraOux93yg/laNvNTXteC04W6H
qEZxHC42hvrkT9MUq7rudM3oaFhvvvl0muZ6GE6+ejKfP68lizH4OpoWey3L94O3lfisd1uf707f
G9GZDN8C48LTW80aWL7Nk6bCOzXcmN/z9Kj93m93wx+mUI/4iOsmbx8f3VX4k/i06+90n8HnQPez
/lItfC5rM2/b1fFo2yXibdieeM31L3u9nvzKGinvV+91bPk2ubK77/iCmn6337e9zkO2+9F5ijSa
nbdIudrZZcsv3WClXO42+o1yd23uVnq+523jTterbqj33jKf7fQ91tFP/6VHrvvzxrtp4MqR7kE5
9BYbzOLBypDO/PaGpebrbjgdRugR7aSzo1JV/zWabpbEmH5ZBMdlx7wxnk3X64nrwxScvNQD75PF
cwGszx9PuZf9qX5Y5j+rUTY09etn/WkjEfVONz+rzuwx+eKbtXbUYK55nYfnkcfqfN52pnILg9Fv
WCQN1Mei5yBDS6vXvl3mMnRzOe6GH1dOsqRdlatf36ulhcjd6X5932H3bzPb0awJ2j5YR+yfjfWX
2ZvemHRDP8/zP7m85ej+Gymbkzx1kyV83EpnMRIWAAIIbg6EyZ+DWXmwHg5E/GYnqarhSen0RUdY
z+SkyXj5r8ykf3qfjug0orMZ/34qXvUW5gqe9LrTn6CBolsemXxsuQIuzEsFlN0JYPBLuEDHSTYk
DxJzi9C5oJi3lGGdWy2G4rbH9ywJ6xa7hS1UXmrEv7bpeKuR8uVWJ+Gen2XXjsfUmc06/NiLUnPp
PF3Uaj1AlywMEPS1fEt0O9FJLXNho810sgLLbn8nj0JGM3pjP5v1kcmOkbWTOcHacRru41b4ggkU
gUM3sXCCV4p3NLH3Mt03B11HAxhp6WDubL/RRU2b7czOXi20Yu7AUIUW9BrbfqH2Hgr8zqo/h8ez
hepBrfqqO2cqmx7eECOA1WrNNpOGjtqw0NnUbpAhIonWqB2nsKDXL9mKW+JONGcbNZqgVHv77HAd
iELD7T6fX2Z0TMv1EbjMGJm2XU5euhFID6RC/777131iDQJd5B5TYS8L7o10p4B6ApxJN1JEGdPV
EifWK3YmaHay5LgVrmslLzv6+L4qTgUqp5xk67JV6RRFINb98pAZUbnpTrbzvc5VIbl4y3E669na
jrhRvkUPX3Kz3ayWWxnsoJaHKw5BvPZY8ep1irZe9+3LNVKtnVOtKGw4nE1W4+X6b6aV2OUVqNWK
vc5RjhYw1JFdlvjYNn9w7mUSb7XpdWaDfV+K7f6Qn+Omt5rJ3XPBtOktNnJEDG22/AucJOYH6zTr
rJTxwLaTGftqNJ/aBwtUV1hO6qJWm+1fM3WKAjdnpPSRMdS8AyS/nWwPrCRx1xBuCgIemTx8WSQ+
8K78VYPMaNdyN7HhJsgwmMhew4abrZnrnRT4ggGKLtroHu4sFFcYhxmADFTULrzGW86UlNpydIzo
RSi49RxdLccfhorGR0Wn3HYtfwnQcLG192fyIo9ps1oPlws5eYeabXbdPT+KXRG32sBE/xjIWLfQ
oot3JWWbLAajzrHQn0Sj3vGSGIV2oG4W8n3NqB6+1U72mhlotxl3wCSXu2YHNRps0T07CxibvIZj
VNv61FVSoj2uzaKCRroKV+/wO99tBvvbRo+aXBQb/FmKXjn458rOv1hQ9NY/aLUWokH8xh1oORJB
mFg7VosfLzgSm/qxHXOBknxLUMuyINH9ex3eNbgSDZernoxUxA02MhSLG/R30gYZNNjsVpg9/jWe
bAd7gXL+TW3Qk7xJBU7iRlkf4lbD3aInQ1FMG/aGqo26i9XwO53FYrmV81JxKyUnqDfnmIbGTSUd
u88m4x7K7/HYnHZKwfmcg73KMWrFFgXaIPdR9hpd3A9z/1lv/pfMJbqchsvteO/D8n3v6L45x/s+
GKeFzma7j0JlE/wRVRtpdPUmcwnnlkvM7H3NjTQ+hIMc7c2qI7w1FB5XkelTOy3RDY9QyKW0KHf2
Vgj3WXk0PP0xutsu8+B18zELD5ILWI7D6LgP5t1Bn4kHiU7sODCSN7D56jSYAg8StVP8lNeD3mRz
crMYC6Cw7IkV7YWnr3tfJnga+giiQ27+r+Siv4+QoeAo+pGivmJgJS0Q7vbP7vD1Y9xfRE/6WMLu
b6/lqdF1kA5L0WZ5Gm9p9M3penwJ0IcHL4dv+EGQfqptY4mhPz1F6XSdxJBshQ9PnZZQxTMmTHQm
RNgchsqdjrCEp4+E6fnNT1jHE3j0PbQTll2gSliLrwnCRhadpCPUMmLwbiJuenFtnJsiDC4xdT2V
vsN0DN23/+aZv+GLffBhuONTMvM1iN/p1utwqBu1rp5zkbx/E/ZlHpv21PLN1UiuP97IxFuqVUuF
oqEeZY56F6SjNKhbwq1PJ5krV+Jk5tvtcH4TmRJlNYwb3IG4rBX0LQavfUQxxhLTsD/z8CMYwIb4
NCSchrAmIWhid2x8aeeTNtOGP9Mzsq9vJfb4LGzW6+Cmsf6Y+fKkw1VlUIAvd9t360vrXunIi9EI
L1ILNJTSEcvrz7g5YqcLvp0lnCb0R7RhoK5lpbqQAtoGjH1+jatHsDygoW/3r3lFigJte97KUkAz
2lnX8XYEChjjgH0k3jfaRqssDvQlZAgH4u85MaCWYM/1KAHUPb7TmR+eXEXxubpar2SKNBdFgWpS
fc+Dt2J6FgNKpmrNxBEorAsXrEerK1ejUSmg32Ra+1YXB5q2RQzZrv1VDCisy8dPx8OCLRsMglWl
g9tZHwMFkuwm+avaWn86c88IqOl0Te3vrlAxbgGgriVKjxeQUvsxJQnUPStptlJAO+u2XtcQA3qn
g3dTPc/C4KExWCHQTfSTlgKacS3fW0txoI8a48bg1a8xUERjPLDr3TelMxmf3j/FgFoegxWpmXq0
2t/dm1cMKJIwrtY7mco/lkURrEnN/TrXc+JFDCiZWk5ykkD1xdIgjYHe6U7m6moNyPSL9k18VZ+b
pG7qaFQBqHclALoxpL/26G3ZjEegdzoM1v07rVaYuSY/pike0LcwWcj6aQTUfDLTzPTX64o9ucSA
koX5cICBImnJA4uB+orJdlcKaJsszUpVcaB5w1vebl+uBUABCgZbLdJesblioIW0K++SAPruImvZ
qkkC6G5bLaTfvXc60bk2yO1EEmht8OwYSwHNko22ISwAClAYsAW/oWEknp9EgTZtDb0k0GbUGNRK
AZ2Qb9YQSH7xuT5nBz9Ez2wUBfrZ1RQlgU4DM0NOABRBYcB+PJHtdtQlDrRk0azMIN5FgX7Tr0ZJ
oJpW2+zAGllkro8EsV6nylME1HLCNCVnxKLxPfYAaOBXKJN21KLBAp36zRgoq/cx2N8v73yNgYK2
N2Z4CDaVLYHlNomAWk85tebQlSbFCgCNbIQzTT6vSOBKBuz2ySIQhTry4YthGufnNpDji4cXMpms
pxBQ+6kg1BGGgdHbAqCpHQYKWuwoCkMOW5MB+kTlbQKgmlquxogH+qleKHCBOrcLwhnf9hBQ8mSm
DfrjTvfzmng0A9gcIUTwep207LVqeS54Sjj92aH0U7qXtR2fnmgxSzi0nEm+DaJXv5Z8SiYf+9b9
0+riVMIUIpn3/fPGiYAvVGpfMk/73z3pp0ViNjqsvthz14Nd+mlpN/2Rflpt+P3HpycYI6vjZEz6
7VplWZJ8ut5anXullm6JyORG3fu7f/4hZDSyMYrvpJ82H8oPMk89H8YjxkSeZ8YJ6adv7neL9NPP
qbF0fHqKsbbR9Sr9dnvUHkg+BeUeDos9ZTFGuRq2jvTbIfuwLv005ne5pJ8+h+mlDMao0m8gKPk0
oF8tvySfEnpL3L1/+rU+wRjxUAxP98+7QtlHOMnEnP90JfDAkJipHJxQPeslhVemxxXIp+KCFT6d
Soz99p17OngHmVAtMaXiMUeumdAOctXEk6Va89kI/Q6+pcsRx9YQT71+pPpH7w060BqOWozjAGsd
k1DXBMuoSYJEf6rwZN9a4zSEyjbG9kJ+DmemYS1tgL5zcyxakZ/T4tpjjqJvYQAv+HWH1Agir+Gj
GFCQ6AFKEij2cySAerR3OuTpfB7B8oC2PiSBgmm7oqWBIj+HR8l8sMjTGe2BpmdcoI+EiQvUVX3g
orfsdnKA9vV67REoeBbI/j+ApXlA3WNk/c/EgbpMn9JANamOnWeP8cFi618CKPiDYP1/SwBtfUkC
hblo0g8eybli618CKJgGYFN0pIBWjkAZq4+H4Od8Qxoosin4pPSAnloP32ysuWQOOYSrL9GSjpMq
eiS/zYGofDtWWmJj6ygvUBDJxbxzGrkyYOwcwzJhf/o17jQ8kVmEFloY8Apbkzg+Bv/HfMRt5vjB
XX9BZ7Bf0G+VIzcBUt0mS2y5eWbGAN8SKG6QxJAFggnA18vwp16Hbf6deQ+AMYJZAJzxlPWrfZNq
hBt7AqFH5tw63fEjvDL2a6zFjHvhxpSgOQw08ss04sX18JBjjvEgoUMf2gN2zGKROZjBe4LqPBgy
BwQ6j9EeNORwUsd+WItLsUHxhpTayA5JS1nrlBV9vLM2PxtzYUdW4iD9yZjMyyOd/ei8Jo5etWB+
oF/QDOmHYL5wnKH4/NCH0voZNGLrh1aft4KIP5tcn0Zkfsh4PWv92AiJ2AqSg59B4xxkSRMDzGWw
mTaVOlNF7Esq+blJi+H9TncuZQXtKjhHgHcOxviY/1rfhnPIYdy+p+QLkCUQPcmPsJkvepJH0bPn
/cP8z1yNlnXNQ+BhwDwEotUv2/WMUXaKuyTyprOct4Wj+doZQLYXrQfcie4HYK5sJ52fu1heXHCL
ciUTjxOZmk0jNrUTrlSY2lPgpSgzNYaHTHrMQ8eB8KVly7o68JjcrNJ5Pbv6IsSe/A==
	]]>
	<![CDATA[
	SNgEE+JKftUTQu4cl84PbMijcz36qLD65ZTI20lySGla5yNGgJajlmZiF3w9HTOyZBMqOvZTZ4I6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==
	]]>
	<![CDATA[
	OPcafrE0OuEe34UF6tRkwCpkpeUljx2edYgM2/wozfCMCltK+USdL4PAUWZqpZnkZ61O0aH0QAmu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==
	]]>
	<![CDATA[
	w4tNXuvVbXsxsA+j71fQzst3q6h+ckktq86q/GezsTqEpxeWZlxd8vTq6jZVDCXlatWVltsOw565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==
	]]>
	<![CDATA[
	pdpGah8uaTZUjglF0DUwVdaDyimPXONnGvuXxQ5SG0sUdBIM3XqIqzo6jNxmAQdt0SVsRnlabJj7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==
	]]>
	<![CDATA[
	PmZcYuiK0Aw4V5BYfGpxLDQ2CCS0tsuOU4sdO/FiMh3M2opEyle2mMOAyQtim8iy3+8SJFCgaG0I
5j9ApFrRCY8lEvkT30bkQ9Gh2x0mtYGJZX2bp1MoVhB5qBb7o6uzASbUOATzH2CQ7MFOPPDG4FId
Jf4oMAJ7GGqKoJDnMZVJNNqh2FRZxU1U0lUchNHYh+pU22ASPuaIU/yN8STmvdAqJwEcgLHMtgTl
GqN0rgnf6A99AEQY+R5dYLY1BHPksQ2jJvMRBfYtA+vC8EYrc1Bh5pwicfAfX/MeMBT07P9OqnLU
2iOjFvMZSP+3EihWdcAipks4ofnMw041Ie9ldyT0zn2e7I6smPk/A0bPbA0p5vHUTLaTc3XC8MjR
Z4aXVJiTMGAt5cjsEsTUD8lbXnIwDF1uOw571fLODAPXcnZJDtpXlm5x8KTPGp3w2xIk9UIYwF6d
ezKdh82OdKY+c07eBTyTqVLPoN1Yy7tXCTJuThhykBbrOiiqEMnxSsJAkNRcTlnHu+ZQsZWXOi6B
wPLUYUxkwJvPOldJgkGgYXvT9rrPr5hMx8hM5qJI08RQOu9WTDhXG2iAGFeOVeJ9qNoycBUqZBav
hhdxobdCXXT4fZv8p+aBf5PdyLSsO8LKr3guHdGr5rdQhpniAd2L6Fgw8m9rXkVSkYnodBNVW/ZC
HsLub33/j5L/4mbUu3zgfEvJ3iWL5oJUUa6DgykNE8k6XlbKElQRBLujbuNINHOyq2RjviaYlSWG
ulDVNoo3CX2bQw3SP5BkUKp0O1WdqwV5qhgrEaEcBObGkEFFYHMzcb07AkNAQnPYUBhlYmLNW4jO
iB23kWSFjFJtuI1EgYL0EinF+dkDXVPlc3fMbAjKtmGnCVTiHfFa26xtRs87pZaJouv21k0PNJZA
Zeoxq7BEoY5apZNqSDMIVDbHCCae/Qde5qy36ZMAai2nYtTblZeV7vYM+eYmKRTy7LvVrublYqy/
zON1zv5C6agYWZb91AVkLEBct9ax0MyOgKKRvaZMPyOgQJkyaWAJKXLhlQ0NgBQN7TV1ysD0Yuhl
nHgJKUKky4YGQPY6ID3rCtoz0W9+zoDi1+U4PEeVmPf6W60j0msKs8KGNoVwgDT3JiiTQ/OsYY6N
xDxH2Dhy3lkFO5epp12+ktlQMWH/sRqbGHDUh41iHmEdoYJ7yBU7UV++36U90CKYVMRF6DiQiyGK
ZLK8EMlQyAALxOR0zOXorGfqMR2AAE/QySTRifIayj9vNfuQQ7hLgu/cpf9sjB/DKLpBm1LIJJhO
DFvM5VyOc+G+Y6HSQSAxMDLnRqXW1Q0NLgMt6cQdEI0pgJgLtRsTPpaaGwQqm9ujBGBKmi4sCp2q
TgYdK1K8BAlzZ+mRyYPMIdzyBEuggozYkKomr1O++2CGgkpaZ4W6Gzo/ECQ0xxxFzBDD1w4sl/NA
UEGCPBPblQ+NAy68Br9CqArTECvbuUQg8k8BEvmnjAsXBMQgUNmctKCHgMrIeIEEg0Blc7u9IRZ9
ai5glaNuLmBJgtJXk6RrCr2SiT8EJFxyEaTOEJDQnCQGBoAmqSt3WUvR81dwRpaO5G7HqOwWtwz6
oLEIsvPEGovNDQIVze3VQUUqRhlVZToZvEgvWwygDxpLIFfcBBOaGwQqm2sPImyoZlsdY+hsgHJZ
04OQ7800J6hmfj8qQWMJBF12ru6x1NwgUNnc3kZdCBQWVkk5ocIqKUDNDcyyhe3KxbWwzdz215Y4
t8ICLEDCpbeyuUEgobmd5/ZXTi2jxvLFwmarYcJTy8PtuiF7ahZ0qFKnTACNJVBk7qLZFpJd3EVz
g0Blc7vuE/HVdAdtkseWZHJ15btJREUylSCBAkVrQzB7TyTGx3VTgopUCoaPoCjfXmGVqVSCBAqU
zQ0C7T2dkoad4jW+V075KNOJV9R4adWn7PyX6VSCBBKUzQ0CDaLTLhk+TLc4lQiTlw96l32pG7Sr
IZtxorkigAT7oWxuEGjPr9YKferbxCKdBMNZAJW+A6G5QaCiuX/idvslfjYNuVNHywM+Pls68swX
1XWP0M/WJ00BGgsgx2v73bv0Y6G5QSChud1Oy65yNKyXqZG8SAAfCt1HGNsgUCpN08JlNAjkQqG0
CZMyCITxNinGLc/Bo8wDg0BZ5W+cT7M/G6ru9mFHSXrfW+AiB/RBIjswSWW3RJzpQaCyuR3s419t
JhcarOeV+E6S9axVkxkDr3MFlZwE4umPTSr4fG+a1zDRUuXdzDqUIMpXOUlxm/N+8eVCCWquYfK1
UgP5bBfLzri6R9RyUAXkZT7RsYGPpzYCXqrHMwltu76d9kJnCoQ0phJU0KboTEnhnWdqfRrFWI6/
3FvzoziTLCHWC6BsAra9xnBiI/Rrhi20UyRAJAKUIK2qmZjCvlD2xvPZOVVPU7VLBOhD0BQzpOjI
gzKtbaqlepggxfDxOp2wZMTelBBpWvugkjpFb0oa7zxXe5VCkKaN1kzP14xBFKnW856/j6bh5yTK
OAGEdT7bO13jl6wrM1sVcShIaI6Bn0wro3J41ECMsVV+LyIk7H3NM8klAQaBBgn5XbZ3+ymUvC/t
OMZBdN9FKUFjCeQEU7ZobhCobG6vvMcMz+q8xCK9SJMPq4W3ZJpyYbxFnUMw271V0zsuzm9P9J+q
aULDOu/fCI/HCJhyFoTGBoF+9KmaX+0dLqhreynLJrPaL5/Mqi59+kWdQzBl/dvOKmRgR6vU8rT2
QeK8msKjLzU3CFQ091+bWAVL3kx7PVuu/fJ2YoWXooo6h2CE+rebWIxt3tkgTWwBkia2fDZKaG0I
pmxsjxSPVOwxjLebePyCngbsdr3TBWZcYtDFqnkIiDmemitbRWODQEJr/5WXfjyvGOerhExm1Unj
39z1c74fBe/mMvbbWoBo5skuinXxw36Dzi+yO44/573/uYcA+GXohYgXVRaIpi9lcTGKoj2OfkKc
ia2UezcXTJ8fcXWxl/S/wDjfi9yfzzaefImYULFf7Ipf9lvP9zjnmm/G0S8lkfsZ/8ufhv5NgaID
JaQleq+4GHPRfEE3keB7fVs/UxOKvDEqWN7FooUMi5GXCWNtHGvSfYTLeTMwbF7Ka4JVKgVbha8t
hpr5rwpEwwC9Ul38rN+wnWuXnZ0vwczw/NbWRmEeIMPr/k9y+kmoG7ygyFwo/Sb7gHa++6XFCIt2
ezQSCNtdeQxFsa62lo/JtCsvhSpqg30K05h4XbePoXxmRgHsgOiGjYuJV+og4r3nw1IqlIgJ4fvF
dv6nWOb91ke+33weUlHKKbBzlUk/9YY3EhW2EWctU60VHSgh7Uz0iosxF80XdBMJPmTl/dKF10tQ
buauHeRsFF710qEXmLGAqatoYI9bE/hsGT3SZVtDMGVbu/3yYb9LfBFyvt8CjUqQQKSRFyhZNjcI
VDa311dWmRmMScjpP6pNhKBVzJ7C9FROc+sl3azvlCXmaYdlZjR3tfZOCx8KTVExY4m3ObcNXdR1
srXF3mxipgdUjU5Zyk+T8SFvPr8bmgsiO3dn9w/HoNZqwzuCjteMGyVqfmyNEpk3KhWwo2eDoxyc
S8zqgnEEWwOTM6EXo6MFFfhcttPom6bmWVB7QJf+A5wFFW7G7Yt8VrVz1SfnQKBzZ+7+VAkaS6D5
e0U01IrGBkDKpnabsyJvx+MLiILYZEMoacT0xyYaw7e9eRFG6HYBKQcvNDUINIhGuyywepJGWo6F
xBIWUSFqpNVYyCxpXQ/o0h5IrZ6sEeR6IbQEgVyIGkGwFyKr3B927s4PcNYv9QlAl0kwPLGQFCy2
Wme9wVckk0/0+tBDUIDo09JG8T0P6PjZGQCeAJmcpvcXW72AyDprWazmGytbD5WGfRmCrxV9Nro1
IPqlqJwT2u2E9NNELysfXYEdZWuh/RKRO14W90dctF6STaR41/gZwQrTiq+C0CiZzAcTEU3ZRwsg
z8c4FB2AsaZ/Kss7yDGLma8ZsOkkSDMhRXGkVzB4iEkebcKKKNsHLWY5IqD9NV3vl77MOiEYdrpY
xJ9aPiRae6Y78tmtUHSghDRTUhQXgy7bL0gnUn2vzldLJZqnxbOueVmxL0CCYq+7b69J+vqOAKmZ
XTd8QmWYzYlnq3VOkUdHQoDozS9VN4YPIxk5aHQ05W5HxcsUlAI+n5flIw1dR+ZMtF7lZ6rRYPLO
83FrH7Ir3zOPOJP4Yp/TgbnLmSh0usCta6i0Y4/+MwGCUGzQtWSYtFVxjKOc4TzWfH3K5fBARhoY
l5KOii+1+AIyliAuzGtSMkhXpLZPIIuhS6uu0ZuawR0Qq4aL08415XmUwrCa/KB7VvXmARRfdY78
iTokra1QB4QEX4XAxsyHjKzQDwnSG8/6ggCKneWQOUGlio8yJ2bkijlJygBISToJBEbUxjhINZs3
18BABfQmKtKHCLB8QHlO/QUdRKBdH9LsxjXUn5oe5eCCWE/BMkVnSkRJvp04b/clSdEjM+f7EddC
DyKxOR9rrHl07yAEcu4cF8AF2M08vfc1c27nt4+gAjVJdia2SK1jZBqZmC9E6JSgQhrHnUuF/Dw3
332BxmBqBgc0+UGZ0hVyx5GKdD9Dfa2jTtxgY85BlGyFaqG3QNMNdQTCVzWPokGg5Lxt6oA+wryq
IF1+fs3VicnGIvOs8hkwgrjO0AEMlGeZeeg8GpzkNuCg+JQruA3zA91Zt5qyxexO0gs19XhmUIf+
g0ZDqytDgEKvctA/msaYTz4pDMFhnS46BvxbPhALhmuHxZAf7PkwZwxHQdJErTHDDrOZXaT5fSkm
/WN6YaNFJuRzsLVmwA/zleQXYnbki93nVIOxweBilj/sz66QK9jxGIGjGPNnVW2ZDK8UPSWEcSSz
HCcyxFaBz8x7PutOHRdsMHvSNyd8AeNiS4Qxzgfcqc8xMRQDwGGJJkbtFZBGU49Mh4mGYR4FsZ5C
4BadKRFzI1qXRGkxaAGCybB8aRXLLGSTgC8L1YZbRqqz+51ZtKALU8pJI577/mVWNxJGZcFCzQTO
V1BOcNEFAdIf605ssvuMa7GOeagSmZFf2DPf5wMSJkHBHoTK5D1TgMwdHskQxTgqSCrIXAP6WT7d
YDG+um4e9SoyFcEeBXthL4TYAU9JyYw4k8wBr/hcAY9ipdRK0jz0OiMgesdh0oLuD1pYrRFd4eNE
3Dio2TBJT0rBGD7PkTWsfgonadQ9CI+xXJV3e0aLWKelesq5LnojsEN/2DtxzO7zMLQdYBT0eINN
oNQB3md/GOgSuBBVTlVe7Bg8AtdMDJhYxlRQholasYejl7oN98oPHITA/InKNRlNlaWq6gC0sE2M
CCoXjAAJVd4XsYMbqmwYFBQPqgSwdbIYj8zUlx9usokqG1rDTzAzitEsWaj1IW1gAQ/+g0YteTUU
9Qgz2uvMTnO+/k+lhKVKwPciMEbKUFgGni+K17p5/wDY7jQJQ54HcMDgaVCNqTJt7Q==
	]]>
	<![CDATA[
	yioYsw9Gcgx3UM3K7vdCgPSHCwiWBQP/HbVEMgK5sMnbT2bOs1wyJppy0CBh+nsmmpZBP6DM/Ern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==
	]]>
	<![CDATA[
	D2bIkQs59xglFJrWiqmQfJQhPVqsL5SggqpjEeQq5ndhYFRkvFXZZeyjaExh7wSTGmcE6hWQdYGI
BWg8hNLbu3d2ONn5VV6e4uDJZxbr3Dp4L4FAs9nj19mky9qiTQa2j0l58AWoPNfmTZbp2TKzzgkQ
XXjTBRAE3+QVZw57UehN/2FHYVR9yLowdOGNRdiZ1fQ4Bja1AMpn6UwEHPgqHObGM3q5KRUGmMst
M3zPxrBYNlPM1YDp3DNBH8t3h5lQMHty88GUER2yBUhyyLqWBcuHIOVyodJJpFNxlzzEqo2eyJOU
10P/LnkfMy4xwj3/srFBIKG1vQ3llroYGIamYLtCNbF5P7dm/gbgyOdLKZ1zvLEAQk8rSE5eAqGg
3YZske4k5lypNTThuA3Zen2anhTYOH9fctS8iWegZ2HfYsJikTH5YFbj2zeBaZ1ExqQx1B4AYRnW
7S7aa47PbHQiAmRQv097Fd4GaDU9U1dZDOXcG7zTNBUzTJza5tlodulMI8tAp0YmtaA8/RPdx1lF
N4ixquWONDvbbNykinl7FBT8HKkk5sXg+aHp7CkyyKcqzURClpPMd2I0d28mrsk12arDi+39xdnB
uwnZTpKosWe3zCW+KV7IzgFzwgvWTXl5i1ri2CGg7d7ILiPlhDeyBXlRPlotgMoL7EJzg0A//Eb2
Lztbh4KqmTo7LxB54wxgTY3GaJuzHXGPE0DlXiI0Nwgkbam7fGSj5nM9jHKO2GksSX50mlJqPiKy
AI0FEFMOtqIp1cb6VhrNNzcIJDQ35MR/fG5h6ewl//TCh1fj5/+79Xk0Wlhauvb89datz8/fvNv6
vPD6y/P/b2vx+YcPH78+/7r1N75ZfP1568vXj5+3Fr/8+fF/WIKfTOBLSxeubiz8XwOl54A=
	]]>
</i:pgf>
</svg>`, ou = '<svg id="Layer_3" data-name="Layer 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><title>Artboard 107</title><path d="M75.978,24.711H52.026a2.11,2.11,0,0,0-2.111,2.111V55H40.585a2.111,2.111,0,0,0-1.658,3.418L62.347,88.112a2.111,2.111,0,0,0,3.315,0L89.073,58.417A2.111,2.111,0,0,0,87.415,55H78.089V26.822A2.11,2.11,0,0,0,75.978,24.711Zm7.086,34.51L64,83.4,44.939,59.221h7.088a2.11,2.11,0,0,0,2.111-2.111V28.933H73.866V57.11a2.11,2.11,0,0,0,2.111,2.111Z"/><path d="M34.52,101.178a2.11,2.11,0,0,0,2.111,2.111H91.369a2.111,2.111,0,0,0,0-4.222H36.631A2.11,2.11,0,0,0,34.52,101.178Z"/></svg>';
class Le {
  static mainRender(e, t) {
    var n, i, r, o, a, l, u, h, p, g;
    return b`
      <div id="overlay" class="overlay ${this.isAsideOpen ? "active" : ""}"></div>
      <section id="chat__containerWrapper" class="chat__containerWrapper ${this.isFullscreen && this.fullscreen ? " has-fullscreen" : ""}${this.isAsideOpen ? " aside-open" : ""}${this.isDragOver ? " drag-over" : ""}${this.mini ? " is-mini" : ""}">
        ${this.isCustomBranding && !this.isChatStarted ? b` <chat-stage
              svgIcon="${zr}"
              pagetitle="${e.BRANDING_HEADLINE}"
              url="${e.BRANDING_URL}"
            >
            </chat-stage>` : ""}
        
        ${this.isFullscreen && this.fullscreen ? b`<div class="fullscreen-col"><conversation-list selectedconversationid="${this.convoId}" fullmode="true"></conversation-list></div>` : ""}            

        <section class="chat__container" id="chat-container"> 
        
          ${this.isChatStarted ? b`
                <div class="chat__messages-container">
                  ${Le.renderChatThread.bind(this)(this.chatThread, e)}                  
                  ${!this.chatController.isAwaitingResponse && this.isShowingProgress ? b`<progress-bar 
                    .progress="${this.progressPercentage}"
                    .message="${this.progressMessage}"
                    .stage="${this.progressStage}">
                  </progress-bar>` : ""}
                  ${!this.mini && this.isDefaultPromptsEnabled && this.isChatStarted ? b`<div style="padding: 1rem;">
                      <teaser-list-component
                        .heading="${this.interactionModel === "chat" ? t.HEADING_CHAT : t.HEADING_ASK}"
                        .clickable="${!0}"
                        .actionLabel="${t.TEASER_CTA_LABEL}"
                        @teaser-click="${Z.handleQuestionInputClick.bind(this)}"
                        .teasers="${t.DEFAULT_PROMPTS}"
                      ></teaser-list-component>
                    </div>` : ""}
                </div>
              ` : ""}
       
         
           
            ${!this.mini && this.isDefaultPromptsEnabled && !this.isChatStarted ? b`<div class="chat__container">         
                  <teaser-list-component
                    .heading="${this.interactionModel === "chat" ? t.HEADING_CHAT : t.HEADING_ASK}"
                    .clickable="${!0}"
                    .actionLabel="${t.TEASER_CTA_LABEL}"
                    @teaser-click="${Z.handleQuestionInputClick.bind(this)}"
                    .teasers="${t.DEFAULT_PROMPTS}"
                  ></teaser-list-component>
                </div>` : ""}
        
          ${this.liveChatOn ? b`<voice-chat 
            model="${this.overrides.selectedModel ? `${this.overrides.selectedModel.model.value}` : ""}" 
            avatar="${this.overrides.avatar ? `${this.overrides.avatar}` : ""}"
            conversationId="${this.convoId || ""}"
            knowledgeIds="${JSON.stringify(this.selectedKnowledge || [])}"
            fullKnowledgeIds="${JSON.stringify(this.fullKnowledgeIds || [])}"
            writingStyleIds="${JSON.stringify(((n = this.selectedStyles) == null ? void 0 : n.map((y) => y.id)) || [])}"
            promptSlots="${(i = this.promptSlots) != null && i.value ? JSON.stringify(this.promptSlots.value) : ""}"
            @voice-chat:conversation-end="${Z.handleVoiceChatEnd.bind(this)}"
          ></voice-chat>` : ""}
        
          ${this.showControls ? b`<form
            id="chat-form"
            class="form__container ${this.inputPosition === "sticky" ? "form__container-sticky" : ""}${this.isDragOver ? " drag-over" : ""}"
            @submit="${(y) => {
      y.preventDefault();
    }}"
            @dragover="${$e.onFormDragOver.bind(this)}"
            @dragleave="${$e.onFormDragLeave.bind(this)}"
            @drop="${$e.onDrop.bind(this)}"
          >
            ${(o = (r = this.currentUser) == null ? void 0 : r.accountGrade) != null && o.promptAssist ? Le.aiAssistRender.bind(this)() : ""}
            ${Le.filePreviewRender.bind(this)()}
            ${this.showControls && !this.compact ? b`            ${this.showControls ? b`<div class="input-helper-text">
              <div class="helper-explanation">
                <div class="helper-ex-item"><kbd-key noclick="true" small="true">/</kbd-key>${e.AUTOCOMPLETE_STYLES_HELPER}</div>
                <div class="helper-ex-item"><kbd-key noclick="true" small="true">#</kbd-key>${e.AUTOCOMPLETE_PROJECTS_HELPER}</div>
                <div class="helper-ex-item"><kbd-key noclick="true" small="true">@</kbd-key>${e.AUTOCOMPLETE_KNOWLEDGE_HELPER}</div>
              </div>
              <div class="keyboard-shortcut">
                <kbd-key noclick="true" small="true">Shift</kbd-key> + <kbd-key noclick="true" small="true">Enter</kbd-key>${e.CHAT_INPUT_NEWLINE_HELPER}
              </div>
              <shortcuts-info></shortcuts-info>
            </div>` : ""}` : ""}
            ${this.advancedPromptingEnabled && ((l = (a = this.currentUser) == null ? void 0 : a.accountGrade) != null && l.advancedPrompts) ? Le.slotPromptRender.bind(this)() : ""}

            <div class="chatbox__container">
            ${this.mini ? "" : b`<div class="chatbox__voice-switch">
              <part-switch name="autotalk" .value="${this.autoTalkEnabled}" label="${e.AUTOTALK_LABEL}" @click="${this.handleAutoTalkClick.bind(this)}"></part-switch>
            </div>`}
              <div class="chatbox__input-container">
                <div class="input_container_wrapper">
                  ${Le.renderAutocomplete.bind(this)(e)}
                  <textarea
                    class="chatbox__input"
                    data-testid="question-input"
                    id="question-input"
                    placeholder="${this.mini ? "" : e.CHAT_INPUT_PLACEHOLDER}"
                    aria-labelledby="chatbox-label"
                    name="chatbox"
                    type="text"
                    ?disabled="${this.isDisabled}"
                    autocomplete="off"
                    @keydown="${this.handleOnKeyDown}"
                    @keyup="${this.handleOnInputChange}"
                    @input="${this.handleOnInputChange}"
                    @paste="${this.handlePasteEvent.bind(this)}"                    
                  ></textarea>
                  ${Le.renderFilePrompt.bind(this)(e)}                  
                  ${this.chatController.isAwaitingResponse ? b`<loading-indicator label="${e.LOADING_INDICATOR_TEXT}"></loading-indicator>` : ""}                  
                </div>
                <div class="input-group-append">
                  ${this.isResetInput ? b`<button
                    title="${e.RESET_BUTTON_TITLE_TEXT}"
                    class="chatbox__button btn-outline-danger chat-reset${this.isChatStarted ? " started" : ""}"
                    type="reset"
                    id="resetBtn"
                    @click="${this.resetInputField}"
                  >
                    <i class="simple-icon-ban"></i>
                  </button>` : ""}
                  ${Le.renderChatOrCancelButton.bind(this)(e)}
                  ${this.isResetInput || this.mini ? "" : b`<rws-tooltip side="left" text="${e.TOOLTIPS.PROMPT_WITH_MICROPHONE}"><voice-input-button @on-voice-input="${this.handleVoiceInput}" class="chatbox__button btn-outline-secondary voice-button" /></rws-tooltip>`}
                  ${this.mini ? "" : b`<button
                    title="${e.LIVE_CHAT_BUTTON_LABEL_TEXT}"
                    class="chatbox__button btn-outline-secondary live-chat"
                    type="reset"
                    id="resetBtn"
                    @click="${this.startLiveChat}"
                  >
                    <i class="simple-icon-speech"></i>
                  </button>`}
                </div>
              </div>
              
            </div>

            ${e.WEB_SEARCH_CHECKBOX_ENABLED && !this.compact ? b`<div class="web-search__wrapper">                  
                  ${this.compact ? "" : b`<simple-model-select
                    name="bot"                         
                    value="${this.overrides.selectedModel ? this.overrides.selectedModel.model.value : this.overrides.avatar ? this.overrides.avatar : this.externalSelectedModel ? (u = this.externalSelectedModel.model) == null ? void 0 : u.value : this.externalSelectedAvatar ? this.externalSelectedAvatar.id : null}"
                    @model:selected="${Z.handleModelSelected.bind(this)}">
                  </simple-model-select> `}
                  ${(p = (h = this.currentUser) == null ? void 0 : h.accountGrade) != null && p.advancedPrompts ? b`<div class="web-search__container">
                    <input
                      type="checkbox"
                      class="web-search__checkbox"
                      id="adv-prompt-checkbox"
                      .checked="${this.advancedPromptingEnabled}"
                      @change="${Z.handleAdvancedPromptingChange.bind(this)}"
                    />
                    <label class="web-search__label" for="adv-prompt-checkbox">
                      ${e.ADV_PROMPT_CHECKBOX_LABEL}
                    </label>
                  </div>` : ""}
                  <div class="web-search__container">
                    <input
                      type="checkbox"
                      class="web-search__checkbox"
                      id="web-search-checkbox"
                      .checked="${this.webSearchEnabled}"
                      @change="${Z.handleWebSearchChange.bind(this)}"
                    />
                    <label class="web-search__label" for="web-search-checkbox">
                      ${e.WEB_SEARCH_CHECKBOX_LABEL}
                    </label>
                  </div>
                  ${e.DEEP_SEARCH_CHECKBOX_ENABLED && this.webSearchEnabled ? b`<div class="web-search__container">
                        <input
                          type="checkbox"
                          class="web-search__checkbox"
                          id="deep-search-checkbox"
                          .checked="${this.deepSearchEnabled}"
                          @change="${Z.handleDeepSearchChange.bind(this)}"
                        />
                        <label class="web-search__label" for="deep-search-checkbox">
                          ${e.DEEP_SEARCH_CHECKBOX_LABEL}
                        </label>
                      </div>` : ""}
                  ${Le.renderExtraInputFooterButtons.bind(this, e)()}
                </div>` : this.compact ? "" : b`
                <div class="web-search__wrapper">
                  <simple-model-select
                    name="bot"                         
                        value="${this.overrides.selectedModel ? this.overrides.selectedModel.model.value : this.overrides.avatar ? this.overrides.avatar : null}"
                        @model:selected="${Z.handleModelSelected.bind(this)}">
                  </simple-model-select>  
               
                  ${Le.renderExtraInputFooterButtons.bind(this, e)()}
                </div>`}

            ${this.isDefaultPromptsEnabled, ""}
          </form>` : ""}
        </section>        
        ${this.isAsideOpen && ((g = this.showCode) != null && g.id) ? b`
              <aside class="aside">
                <code-screen 
                  language="${this.showCode.language}" 
                  componentId=${this.showCode.id} 
                  .passedContent=${this.showCode.code} 
                  .activatePreview="${this.showCode.preview}" 
                  .ended="${this.showCode.ended}"></code-screen>
              </aside>
            ` : ""}
        ${this.showSettings ? b`
            <rws-modal name="chat_settings" header="${e.MODAL_TITLES.CHAT_SETTINGS}" centerTop="true">
              <chat-settings></chat-settings>
            </rws-modal>
            ` : ""}
      </section>
    `;
  }
  static renderFilePrompt(e) {
    return b`<div class="file-prompt-wrap"><button
      class="chatbox__file_prompt"
      data-testid="submit-prompt-button"
      type="button"
      @click="${$e.handleAddFile.bind(this)}"
    >
      <rws-tooltip side="left" text="${e.TOOLTIPS.ATTACH_FILE_TO_PROMPT}"><i class="simple-icon-paper-clip"></i></rws-tooltip>
    </button></div>`;
  }
  static renderAutocomplete(e) {
    return this.compact ? "" : b`<autocomplete-triggers 
      id="prompt-autocomplete-component" 
      route="ai.triggerSearch"
      .selectedNotification="${{
      "/": e.AUTOCOMPLETE_STYLE_SELECTED || "{name} has been added",
      "#": e.AUTOCOMPLETE_PROJECT_SELECTED || "{name} has been added",
      "@": e.AUTOCOMPLETE_KNOWLEDGE_SELECTED || "{name} has been added"
    }}"></autocomplete-triggers>`;
  }
  static filePreviewRender() {
    return !this.promptFiles || this.promptFiles.length === 0 ? b`` : b`<div id="file-prompt-preview" class="file-prompt-preview">
    ${this.promptFiles.map((e, t) => {
      var n;
      return b`
      <div class="file-prompt__file">      
        ${e.mimeType && e.mimeType.startsWith("image/") ? b`<img class="file-prompt__img" src="data:${e.mimeType};base64,${e.base64}" alt="${e.filename}" />` : b`<div class="file-prompt__img file-prompt__file-icon">
              <i class="simple-icon-doc"></i>
              <span>${e.mimeType && ((n = e.mimeType.split("/")[1]) == null ? void 0 : n.toUpperCase()) || "FILE"}</span>
            </div>`}
        <div class="file-prompt__footer">
          <span class="file-prompt__file-size">${e.size ? `${(e.size / 1024 / 1024).toFixed(2)} MB` : "Unknown size"}</span>
          <button class="file-prompt__remove-button" type="button" @click="${() => $e.removeFile.bind(this)(t)}">
            <i class="simple-icon-close"></i>
          </button>
        </div>
      </div>
    `;
    })}
  </div>`;
  }
  static renderChatThread(e, t) {
    var n;
    return b`<chat-thread-component
      .injectCss="${this.injectCss.split(",")}"
      .aiAssistantSignal="${this.aiAssistantSignal}"
      .appChatSignal="${this.appChatSignal}"
      .mini="${this.mini}"
      .fullscreenEnabled=${this.fullscreen}
      .chatThread="${e}"
      .conversationTitle="${this.overrides.conversationTitle}"
      .conversationUid="${this.overrides.conversationUid}"
      .customConfig="${this.customConfig}"
      .customHeaders="${this.customHeaders}"
      .isTalking="${this.isTalking}"
      .currentStreamingMessageId="${this.speakingMessageId || ((n = this.chatController.processingMessage) == null ? void 0 : n.id) || null}"
      .upperLoader="${this.upperLoader}"
      .autoTalkEnabled="${this.autoTalkEnabled}"
      .showInitialMessagesReasoningClosed="${!0}"
      .actionButtons="${[
      // {
      //   id: 'chat-show-thought-process',
      //   label: globalConfig.SHOW_THOUGH_PROCESS_BUTTON_LABEL_TEXT,
      //   svgIcon: iconLightBulb,
      //   isDisabled: this.isShowingThoughtProcess,
      // },
      {
        id: "speak",
        label: t.SPEAK_BUTTON_LABEL_TEXT,
        svgIcon: ru,
        isDisabled: this.chatController.isProcessingResponse
      },
      {
        id: "download-speech",
        label: t.DOWNLOAD_SPEECH_BUTTON_LABEL_TEXT,
        svgIcon: ou,
        isDisabled: this.chatController.isProcessingResponse
      }
    ]}"
      .isDisabled="${this.isDisabled}"
      .isProcessingResponse="${this.chatController.isProcessingResponse}"
      .selectedCitation="${this.selectedCitation}"
      .isCustomBranding="${this.isCustomBranding}"
      .isFullscreen="${this.isFullscreen}"
      .svgIcon="${zr}"
      @on-action-button-click="${Z.handleChatEntryActionButtonClick.bind(this)}"
      @on-citation-click="${Z.handleCitationClick.bind(this)}"
      @on-followup-click="${Z.handleQuestionInputClick.bind(this)}"
      @on-fullscreen-toggle="${Z.handleFullscreenToggle.bind(this)}"
    >
    </chat-thread-component>`;
  }
  static renderChatOrCancelButton(e) {
    const t = b`<rws-tooltip side="left" text="${e.TOOLTIPS.SEND_PROMPT}"><button
          class="chatbox__button chatbox_submit"
          data-testid="submit-question-button"
          @click="${this.handleUserChatSubmit}"
          title="${e.CHAT_BUTTON_LABEL_TEXT}"
          ?disabled="${this.isDisabled}"
        >
          <i class="simple-icon-paper-plane"></i>
        </button></rws-tooltip>`, n = b`<rws-tooltip side="left" text="${e.TOOLTIPS.CANCEL_REQUEST}"><button
          class="chatbox__button"
          data-testid="cancel-question-button"
          @click="${this.handleUserChatCancel}"
          title="${e.CHAT_CANCEL_BUTTON_LABEL_TEXT}"
        >
          <i class="simple-icon-close"></i>
        </button></rws-tooltip>`;
    return this.chatController.isProcessingResponse ? b`${n}${t}` : t;
  }
  static renderExtraInputFooterButtons(e) {
    return b`<div class="footer-btns">
        ${this.selectedStyles.map((t) => b`
          <div class="selected-style-badge">
            ${t.title}
            <i class="simple-icon-close" @click="${(n) => this.removeStyle(n, t.id)}" title="Remove style"></i>
          </div>
        `)}
        ${this.selectedProjects.map((t) => b`
          <div class="selected-project-badge">
            ${t.title}
            <i class="simple-icon-close" @click="${(n) => this.removeProject(n, t.id)}" title="Remove project"></i>
          </div>
        `)}
        <div class="kdb-pick"><knowledge-picker absolute="true" selectedIds="${this.selectedKnowledge.join(",")}" fullKnowledgeIds="${this.fullKnowledgeIds.join(",")}" @selectionChanged="${(t) => this.handleKnowledgePickerChange(t)}"></knowledge-picker></div>          
        <div class="settings-toggler"><rws-tooltip side="left" text="${e.TOOLTIPS.CHAT_SETTINGS}"><button  type="button" @click="${this.handleSettingsExpandAside}"><i class="simple-icon-settings"></i></button></rws-tooltip></div>
    </div>`;
  }
  static aiAssistRender() {
    var e, t;
    return !((t = (e = this.currentUser) == null ? void 0 : e.accountGrade) != null && t.promptAssist) || this.chatSettings.enableAIAssistant === !1 || this.compact ? b`` : b`<ai-assist id="ai-assist-component"></ai-assist>`;
  }
  static slotPromptRender() {
    return b`<prompt-slots @change="${this.handleSlotChanges}" id="prompt-slots"></prompt-slots>`;
  }
}
class au {
  static async handleSubmit(e, t) {
    var r, o;
    this.dispatchEvent(new CustomEvent("chat:message:sending", {
      bubbles: !0,
      composed: !0
    }));
    const n = Wr.sanitize(this.questionInput.value || "");
    this.questionInput.value = "", this.isResetInput = !1, this.autoResizeTextarea();
    const i = [...this.promptFiles];
    this.promptFiles = [], this.chatController.isAwaitingResponse = !0;
    try {
      const a = (r = this.renderRoot) == null ? void 0 : r.querySelector("chat-thread-component");
      a && typeof a.resetScrollState == "function" && a.resetScrollState(), this.isChatStarted = !0, this.isDefaultPromptsEnabled = !1;
      const l = this.getMessageContext();
      let u = [];
      if (i.length > 0)
        try {
          const f = await $e.uploadFiles.bind(this)(i);
          f.success && (u = f.files);
        } catch (f) {
          this.dispatchEvent(new CustomEvent("popup:show", {
            detail: {
              message: "file.upload.error.upload_failed",
              type: "error",
              params: {
                error: f instanceof Error ? f.message : "Unknown error"
              }
            },
            bubbles: !0,
            composed: !0
          }));
        }
      let h, p = [];
      if (i.length > 0) {
        n.trim() && p.push({
          type: "text",
          text: n
        });
        const f = i.filter((x) => x.mimeType.startsWith("image/"));
        for (const x of f)
          p.push({
            type: "image",
            image: x.base64,
            mimeType: x.mimeType
          });
        f.length > 0 || n.trim() ? h = {
          content: p.length > 0 ? p : n,
          role: "user",
          files: u.length > 0 ? u : i
          // Include uploaded files or fallback to original format
        } : h = {
          content: "",
          // Empty string when no text input, backend will only use file content
          role: "user",
          files: u.length > 0 ? u : i
        };
      } else
        h = {
          content: n,
          role: "user"
        };
      this.currentQuestionHidden && (h.hidden = !0, this.currentQuestionHidden = !1, console.log("Hidden message sent, currentQuestionHidden reset to false")), (o = this.promptSlots) != null && o.value && (this.overrides.promptSlots = this.promptSlots.value);
      const g = [...l, h];
      console.log("Constructed user message:", h, this.currentQuestionHidden);
      const y = {
        ...e.overrides,
        ...this.overrides,
        chatSettings: this.chatSettings,
        webSearchEnabled: this.webSearchEnabled,
        deepSearchEnabled: this.deepSearchEnabled,
        knowledge: this.selectedKnowledge,
        fullKnowledgeIds: this.fullKnowledgeIds
      };
      Z.handleDiscussionUserTurn.bind(this)(g), console.log("Submitting message with options:", {
        requestOptions: e,
        userMessage: h
      }), await this.chatController.generateAnswer(
        {
          ...e,
          overrides: y,
          question: i.some((f) => f.mimeType.startsWith("image/")) && p.length > 1 ? "" : n,
          // Clear question only when using multimodal format with images
          type: this.interactionModel,
          messages: g
        },
        {
          // use defaults
          ...t,
          // override if the user has provided different values
          url: this.apiUrl,
          stream: this.useStream,
          headers: this.customHeaders
        },
        this.useWebSocket,
        // Pass WebSocket flag
        this.apiUrl
        // Pass WebSocket URL (same as API URL)
      ), setTimeout(() => {
        var x;
        const f = (x = this.renderRoot) == null ? void 0 : x.querySelector("chat-thread-component");
        f && typeof f.ensureAutoScroll == "function" && f.ensureAutoScroll();
      }, 100);
    } catch (a) {
      this.dispatchEvent(new CustomEvent("popup:show", {
        detail: {
          message: "file.upload.error.submission_failed",
          type: "error",
          params: {
            error: a instanceof Error ? a.message : "Unknown error"
          }
        },
        bubbles: !0,
        composed: !0
      })), this.chatController.isAwaitingResponse = !1;
    }
  }
}
class tn {
  static clearChat() {
    this.chatThread = [], this.isChatStarted = !1, this.isDefaultPromptsEnabled = !0, this.liveChatOn = !1, this.showControls = !0, this.showCode = null, this.promptFiles = [], this.initialMessages = [], this.removeAttribute("data-initial-messages"), this.updateAssistContext(), tn.resetThread.bind(this)(new Event("clear-chat"), !0);
  }
  static resetThread(e, t = !1) {
    var i;
    console.log("[resetThread]", { forced: t }), this.isChatStarted = !1, this.chatThread = [], this.isDisabled = !1, this.isDefaultPromptsEnabled = !0, this.selectedCitation = void 0, this.chatController.reset(), this.promptFiles = [], this.updateAssistContext();
    const n = (i = this.renderRoot) == null ? void 0 : i.querySelector("chat-thread-component");
    if (n && typeof n.clearAllReasoning == "function" && n.clearAllReasoning(), n && typeof n.resetScrollState == "function" && n.resetScrollState(), this.collapseAside(e), this.handleUserChatCancel(e), !t) {
      const r = new CustomEvent("chat:conversation:end", {
        detail: !0,
        bubbles: !0,
        composed: !0
      });
      this.dispatchEvent(r);
    }
  }
  static getMessageContext() {
    return this.interactionModel === "ask" ? [] : this.chatThread.map((t) => {
      if (!t)
        return { hidden: !0, role: "system", content: "" };
      const n = {
        content: t.isUserMessage ? Js(t) : t.rawContent || Js(t),
        role: t.isUserMessage ? "user" : "assistant"
      };
      return t.files && t.files.length > 0 && (n.files = t.files), n;
    });
  }
}
const lu = [
  { letter: " ", diacritics: /\u00A0/g },
  { letter: "0", diacritics: /\u07C0/g },
  { letter: "A", diacritics: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
  { letter: "AA", diacritics: /\uA732/g },
  { letter: "AE", diacritics: /[\u00C6\u01FC\u01E2]/g },
  { letter: "AO", diacritics: /\uA734/g },
  { letter: "AU", diacritics: /\uA736/g },
  { letter: "AV", diacritics: /[\uA738\uA73A]/g },
  { letter: "AY", diacritics: /\uA73C/g },
  { letter: "B", diacritics: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
  { letter: "C", diacritics: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
  { letter: "D", diacritics: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
  { letter: "Dh", diacritics: /\u00D0/g },
  { letter: "DZ", diacritics: /[\u01F1\u01C4]/g },
  { letter: "Dz", diacritics: /[\u01F2\u01C5]/g },
  { letter: "E", diacritics: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
  { letter: "F", diacritics: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
  { letter: "G", diacritics: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
  { letter: "H", diacritics: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
  { letter: "I", diacritics: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
  { letter: "J", diacritics: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
  { letter: "K", diacritics: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
  { letter: "L", diacritics: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
  { letter: "LJ", diacritics: /\u01C7/g },
  { letter: "Lj", diacritics: /\u01C8/g },
  { letter: "M", diacritics: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
  { letter: "N", diacritics: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
  { letter: "NJ", diacritics: /\u01CA/g },
  { letter: "Nj", diacritics: /\u01CB/g },
  { letter: "O", diacritics: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
  { letter: "OE", diacritics: /\u0152/g },
  { letter: "OI", diacritics: /\u01A2/g },
  { letter: "OO", diacritics: /\uA74E/g },
  { letter: "OU", diacritics: /\u0222/g },
  { letter: "P", diacritics: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
  { letter: "Q", diacritics: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
  { letter: "R", diacritics: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
  { letter: "S", diacritics: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
  { letter: "T", diacritics: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
  { letter: "Th", diacritics: /\u00DE/g },
  { letter: "TZ", diacritics: /\uA728/g },
  { letter: "U", diacritics: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
  { letter: "V", diacritics: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
  { letter: "VY", diacritics: /\uA760/g },
  { letter: "W", diacritics: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
  { letter: "X", diacritics: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
  { letter: "Y", diacritics: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
  { letter: "Z", diacritics: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
  { letter: "a", diacritics: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
  { letter: "aa", diacritics: /\uA733/g },
  { letter: "ae", diacritics: /[\u00E6\u01FD\u01E3]/g },
  { letter: "ao", diacritics: /\uA735/g },
  { letter: "au", diacritics: /\uA737/g },
  { letter: "av", diacritics: /[\uA739\uA73B]/g },
  { letter: "ay", diacritics: /\uA73D/g },
  { letter: "b", diacritics: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
  { letter: "c", diacritics: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
  { letter: "d", diacritics: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
  { letter: "dh", diacritics: /\u00F0/g },
  { letter: "dz", diacritics: /[\u01F3\u01C6]/g },
  { letter: "e", diacritics: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
  { letter: "f", diacritics: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
  { letter: "ff", diacritics: /\uFB00/g },
  { letter: "fi", diacritics: /\uFB01/g },
  { letter: "fl", diacritics: /\uFB02/g },
  { letter: "ffi", diacritics: /\uFB03/g },
  { letter: "ffl", diacritics: /\uFB04/g },
  { letter: "g", diacritics: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
  { letter: "h", diacritics: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
  { letter: "hv", diacritics: /\u0195/g },
  { letter: "i", diacritics: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
  { letter: "j", diacritics: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
  { letter: "k", diacritics: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
  { letter: "l", diacritics: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
  { letter: "lj", diacritics: /\u01C9/g },
  { letter: "m", diacritics: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
  { letter: "n", diacritics: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
  { letter: "nj", diacritics: /\u01CC/g },
  { letter: "o", diacritics: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
  { letter: "oe", diacritics: /\u0153/g },
  { letter: "oi", diacritics: /\u01A3/g },
  { letter: "ou", diacritics: /\u0223/g },
  { letter: "oo", diacritics: /\uA74F/g },
  { letter: "p", diacritics: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
  { letter: "q", diacritics: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
  { letter: "r", diacritics: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
  { letter: "s", diacritics: /[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
  { letter: "ss", diacritics: /\u00DF/g },
  { letter: "t", diacritics: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
  { letter: "th", diacritics: /\u00FE/g },
  { letter: "tz", diacritics: /\uA729/g },
  { letter: "u", diacritics: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
  { letter: "v", diacritics: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
  { letter: "vy", diacritics: /\uA761/g },
  { letter: "w", diacritics: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
  { letter: "x", diacritics: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
  { letter: "y", diacritics: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
  { letter: "z", diacritics: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }
];
function cu(s) {
  if (typeof s != "string")
    throw new TypeError(`Expected 'input' to be of type string, but received '${s}'`);
  return s.length ? s.replace(/(\S)/g, (e, t) => {
    const n = lu.find((i) => new RegExp(i.diacritics).test(t));
    return n == null ? t : n.letter;
  }) : s;
}
const bi = class ue {
  /**
   * Initialize keyboard shortcuts for the chat component
   */
  static initializeShortcuts() {
    ue.isListening || (ue.registerShortcuts.bind(this)(), ue.startListening());
  }
  /**
   * Register all available keyboard shortcuts
   */
  static registerShortcuts() {
    const e = [
      {
        key: "k",
        ctrlKey: !0,
        altKey: !0,
        description: "Open Knowledge Picker",
        action: () => {
          var t;
          (t = this.aiAssistantSignal) == null || t.setValue({
            command: "open_knowledge_picker"
          });
        }
      },
      {
        key: "n",
        ctrlKey: !0,
        altKey: !0,
        description: "Add New Knowledge",
        action: () => {
          var t;
          (t = this.aiAssistantSignal) == null || t.setValue({
            command: "open_knowledge_picker_create_form"
          });
        }
      },
      {
        key: "s",
        ctrlKey: !0,
        altKey: !0,
        description: "Open Settings",
        action: () => {
          this.handleSettingsExpandAside();
        }
      },
      {
        key: "f",
        ctrlKey: !0,
        altKey: !0,
        description: "Toggle Web Search",
        action: () => {
          this.webSearchEnabled = !this.webSearchEnabled, this.dispatchEvent(new CustomEvent("keyboard:web-search-toggle", {
            detail: { enabled: this.webSearchEnabled },
            bubbles: !0,
            composed: !0
          }));
        }
      },
      {
        key: "p",
        ctrlKey: !0,
        altKey: !0,
        description: "Toggle Advanced Prompts (Slot Structure)",
        action: () => {
          this.advancedPromptingEnabled = !this.advancedPromptingEnabled, this.dispatchEvent(new CustomEvent("keyboard:advanced-prompts-toggle", {
            detail: { enabled: this.advancedPromptingEnabled },
            bubbles: !0,
            composed: !0
          }));
        }
      }
    ];
    ue.shortcuts.clear(), e.forEach((t) => {
      const n = ue.generateShortcutKey(t);
      ue.shortcuts.set(n, t);
    });
  }
  /**
   * Generate a unique key string for the shortcut
   */
  static generateShortcutKey(e) {
    const t = [];
    return e.ctrlKey && t.push("ctrl"), e.altKey && t.push("alt"), e.shiftKey && t.push("shift"), e.metaKey && t.push("meta"), [...t, cu(e.key.toLowerCase())].join("+");
  }
  /**
   * Start listening for keyboard events
   */
  static startListening() {
    ue.isListening || (document.addEventListener("keydown", ue.handleKeydown), ue.isListening = !0);
  }
  /**
   * Stop listening for keyboard events
   */
  static stopListening() {
    ue.isListening && (document.removeEventListener("keydown", ue.handleKeydown), ue.isListening = !1, ue.shortcuts.clear());
  }
  /**
   * Handle keydown events and execute shortcuts
   */
  static handleKeydown(e) {
    const t = document.activeElement;
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement || (t == null ? void 0 : t.getAttribute("contenteditable")) === "true")
      return;
    const i = ue.generateShortcutKey({
      key: e.key,
      ctrlKey: e.ctrlKey,
      altKey: e.altKey,
      shiftKey: e.shiftKey,
      metaKey: e.metaKey,
      description: "",
      action: () => {
      }
    }), r = ue.shortcuts.get(i);
    r && (e.preventDefault(), e.stopPropagation(), r.action());
  }
  /**
   * Get all registered shortcuts for display purposes
   */
  static getShortcuts() {
    return Array.from(ue.shortcuts.values());
  }
  /**
   * Get formatted shortcut display string
   */
  static getShortcutDisplayString(e) {
    const t = [];
    e.ctrlKey && t.push("Ctrl"), e.altKey && t.push("Alt"), e.shiftKey && t.push("Shift"), e.metaKey && t.push("Cmd");
    const n = e.key === " " ? "Space" : e.key.length === 1 ? e.key.toUpperCase() : e.key;
    return [...t, n].join(" + ");
  }
};
bi.shortcuts = /* @__PURE__ */ new Map();
bi.isListening = !1;
let Ys = bi;
class uu {
  constructor(e, t = {}) {
    this.queue = [], this.displayed = "", this.htmlBuffer = "", this.rafId = null, this.timeoutId = null, this.started = !1, this.done = !0, this.onDoneCalled = !1, this.destroyed = !1, this.paused = !1, this.messageArea = e, this.config = t;
  }
  type(e) {
    !e || this.destroyed || (this.done = !1, this.onDoneCalled = !1, this.queue.push(e), this.started ? !this.rafId && !this.timeoutId && this.scheduleTick() : this.config.autoStart !== !1 && this.start());
  }
  start() {
    this.started || (this.started = !0, this.scheduleTick());
  }
  pause() {
    this.paused || this.destroyed || (this.paused = !0, this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null));
  }
  resume() {
    this.paused && (this.paused = !1, this.started && !this.destroyed && (this.queue.length > 0 || this.htmlBuffer.length > 0) && this.scheduleTick());
  }
  scheduleTick() {
    this.paused || this.rafId || this.timeoutId || (this.config.typingTempoDelay && this.config.typingTempoDelay > 0 ? this.timeoutId = setTimeout(() => {
      this.timeoutId = null, this.tick();
    }, this.config.typingTempoDelay) : this.rafId = requestAnimationFrame(() => this.tick()));
  }
  tick() {
    if (this.rafId = null, this.queue.length === 0 && this.htmlBuffer.length === 0) {
      this.done = !0, this.invokeOnDone();
      return;
    }
    this.flush(), this.queue.length > 0 ? this.scheduleTick() : this.htmlBuffer.length > 0 ? this.done = !1 : (this.done = !0, this.invokeOnDone());
  }
  flush() {
    if (this.htmlBuffer.length > 0) {
      this.collectTag();
      return;
    }
    if (this.queue.length === 0) {
      this.done = !0;
      return;
    }
    const e = this.queue[0], t = e[0];
    this.queue[0] = e.slice(1), this.queue[0].length === 0 && this.queue.shift(), t === "<" ? (this.htmlBuffer = t, this.collectTag()) : (this.displayed += t, this.updateDOM()), this.done = this.queue.length === 0 && this.htmlBuffer.length === 0;
  }
  collectTag() {
    for (; this.queue.length > 0 && this.htmlBuffer.indexOf(">") === -1; )
      this.htmlBuffer += this.queue.shift();
    const e = this.htmlBuffer.indexOf(">");
    if (e === -1) {
      this.done = !1;
      return;
    }
    const t = this.htmlBuffer.slice(0, e + 1), n = this.htmlBuffer.slice(e + 1);
    this.displayed += t, this.htmlBuffer = "", n && this.queue.unshift(n), this.updateDOM(), this.done = this.queue.length === 0 && this.htmlBuffer.length === 0;
  }
  updateDOM() {
    this.messageArea.innerHTML = this.displayed, this.config.onFlush && this.config.onFlush(this.displayed);
  }
  invokeOnDone() {
    !this.onDoneCalled && this.config.onDone && (this.onDoneCalled = !0, this.config.onDone());
  }
  destroy() {
    this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.started = !1, this.queue = [], this.displayed = "", this.htmlBuffer = "", this.done = !0, this.onDoneCalled = !1, this.destroyed = !0, this.paused = !1;
  }
  isDone() {
    return this.done && this.queue.length === 0 && this.htmlBuffer.length === 0;
  }
  getTypedText() {
    return this.displayed;
  }
  getBuffer() {
    return this.queue.join("");
  }
  setTypedText(e) {
    this.displayed = e, this.queue = [], this.htmlBuffer = "", this.done = !0, this.messageArea.innerHTML = this.displayed;
  }
  setMessageArea(e) {
    this.messageArea = e, this.messageArea.innerHTML = this.displayed;
  }
  finish() {
    if (this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.started = !1, this.paused = !1, this.queue.length > 0 || this.htmlBuffer.length > 0) {
      const e = this.htmlBuffer + this.queue.join("");
      this.displayed += e, this.queue = [], this.htmlBuffer = "", this.messageArea.innerHTML = this.displayed, this.config.onFlush && this.config.onFlush(this.displayed);
    }
    this.done = !0, this.invokeOnDone();
  }
}
function Lr(s, e = {}) {
  return new uu(s, e);
}
function Ar(s, e) {
  !s || !e || s.type(e);
}
var hu = Object.defineProperty, du = Object.getOwnPropertyDescriptor, C = (s, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? du(e, t) : e, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (i = (n ? o(e, t, i) : o(i)) || i);
  return n && i && hu(e, t, i), i;
};
let Or = Xa, Kt = Xe;
const Dr = {
  imageModel: "stableDiffusionXL",
  videoModel: null,
  voice: null,
  chatLearning: !1,
  enableAIAssistant: !0,
  temperature: 0.7,
  maxTokens: null,
  extendedContext: !1,
  thinking: !0
};
let k = class extends fe {
  constructor() {
    super(...arguments), this.inputPosition = "sticky", this.interactionModel = "chat", this.apiUrl = js.url, this.injectCss = "", this.isCustomBranding = Kt.IS_CUSTOM_BRANDING, this.useStream = js.stream, this.overrides = {}, this.customStyles = {}, this.customHeaders = {}, this.customTeasers = {}, this.customConfig = {}, this.hideDeleteButton = !1, this.dynamicTextTyping = !1, this.externalSelectedModel = null, this.externalSelectedAvatar = null, this.externalAiProvider = "", this.initialMessages = [], this.useWebSocket = !1, this.websocketEvents = {}, this.currentQuestion = "", this.fullscreen = !0, this.dataWebSearch = !1, this.dataCanTalk = !1, this.dataDeepSearch = !1, this.compact = !1, this.mini = !1, this.activeAssist = null, this.isDisabled = !1, this.isTalking = 0, this.speakingMessageId = null, this.upperLoader = !1, this.currentQuestionHidden = !1, this.isChatStarted = !1, this.isResetInput = !1, this.autoTalkEnabled = !1, this.webSearchEnabled = !1, this.deepSearchEnabled = !1, this.advancedPromptingEnabled = !1, this.isFullscreen = !1, this.showControls = !0, this.liveChatOn = !1, this.showSettings = !1, this.chatController = new nu(this), this.showCode = null, this.isDefaultPromptsEnabled = Kt.IS_DEFAULT_PROMPTS_ENABLED && !this.isChatStarted, this.selectedCitation = void 0, this.selectedChatEntry = void 0, this.isShowingProgress = !1, this.progressPercentage = 0, this.progressMessage = "", this.progressStage = "", this.chatSettings = Dr, this.isAsideOpen = !1, this.promptFiles = [], this.isDragOver = !1, this.enterSubmitBlocked = !1, this.currentUser = null, this.currentBalance = 0, this.selectedStyles = [], this.selectedProjects = [], this.selectedKnowledge = [], this.fullKnowledgeIds = [], this.convoId = null, this.chatThread = [], this.aiAssistantSignal = null, this.creditBalanceSignal = null, this.appChatSignal = null, this.customTyper = null, this.lastTypingEntryId = null, this.typerTarget = null, this.customTyperDoneCallback = null, this.lastTypedFullText = "", this.autoTalkStartListener = null, this.simulatedTyperAwaitingPlayback = !1, this.simulatedEntryIds = /* @__PURE__ */ new Set(), this.typingTempoDelay = 50, this.previousGeneratingAnswer = !1, this.isWritingSignaled = !1, this.aiAssistInitialized = !1;
  }
  getTypingDelay(s) {
    switch (s) {
      case "fast":
        return 25;
      case "very-fast":
        return 10;
      case "normal":
      default:
        return 50;
    }
  }
  emitWriting(s) {
    var e;
    this.isWritingSignaled !== s && (this.isWritingSignaled = s, (e = this.appChatSignal) == null || e.setValue({ command: s ? "start-write" : "write-ended" }));
  }
  deepCloneChatThreadEntry(s) {
    if (typeof globalThis.structuredClone == "function")
      try {
        return globalThis.structuredClone(s);
      } catch {
      }
    return JSON.parse(JSON.stringify(s));
  }
  handleTyperDone() {
    if (this.customTyperDoneCallback) {
      const s = this.customTyperDoneCallback;
      this.customTyperDoneCallback = null, s();
    }
  }
  finalizeTyping(s) {
    var i, r;
    if (this.lastTypingEntryId === null && !this.customTyper)
      return;
    const e = (i = this.shadowRoot) == null ? void 0 : i.querySelector("chat-thread-component");
    e && (e.isTyping = !1);
    const t = this.deepCloneChatThreadEntry(s);
    let n = this.chatThread.findIndex((o) => o.id === t.id);
    if (n === -1 && this.lastTypingEntryId) {
      const o = this.chatThread.findIndex((l) => l.id === this.lastTypingEntryId), a = o > -1 ? this.chatThread[o] : null;
      a && a.text.every((l) => !l.value) && (n = o);
    }
    this.chatThread = n > -1 ? lt(this.chatThread, n, t) : [...this.chatThread, t], this.requestUpdate(), this.autoTalkStartListener && (window.removeEventListener("conversation-agent:playback-started", this.autoTalkStartListener), this.autoTalkStartListener = null), (r = this.customTyper) == null || r.destroy(), this.customTyper = null, this.typerTarget = null, this.lastTypingEntryId = null, this.customTyperDoneCallback = null, this.lastTypedFullText = "", this.emitWriting(!1);
  }
  /**
   * Clean up dynamic typing state when a stream is cancelled.
   * Preserves any text that was already typed; removes empty placeholders.
   */
  cleanupDynamicTypingOnCancel() {
    var e, t, n, i;
    this.finishSimulatedTyping();
    const s = (e = this.shadowRoot) == null ? void 0 : e.querySelector("chat-thread-component");
    if (s && (s.isTyping = !1, s.showLoadingIndicator = !1, s.requestUpdate()), this.lastTypingEntryId) {
      const r = this.chatThread.findIndex((o) => (o == null ? void 0 : o.id) === this.lastTypingEntryId);
      if (r > -1) {
        const o = this.chatThread[r];
        if ((t = o == null ? void 0 : o.text) != null && t.every((a) => !a.value)) {
          const a = ((n = this.customTyper) == null ? void 0 : n.getTypedText()) || "";
          if (a) {
            const l = this.deepCloneChatThreadEntry(o);
            l.text = l.text.map((u) => ({ ...u, value: a })), this.chatThread = lt(this.chatThread, r, l);
          } else
            this.chatThread = [...this.chatThread.slice(0, r), ...this.chatThread.slice(r + 1)];
        }
      }
    }
    this.autoTalkStartListener && (window.removeEventListener("conversation-agent:playback-started", this.autoTalkStartListener), this.autoTalkStartListener = null), (i = this.customTyper) == null || i.destroy(), this.customTyper = null, this.typerTarget = null, this.lastTypingEntryId = null, this.customTyperDoneCallback = null, this.lastTypedFullText = "", this.previousGeneratingAnswer = !1, this.emitWriting(!1);
  }
  firstUpdated() {
    var s, e;
    this.autocompleteTriggers && this.autocompleteTriggers.bindTextarea(this.questionInput), this.aiAssistCheck(), this.creditBalanceSignal = (s = document.querySelector("default-layout")) == null ? void 0 : s.getCreditBalanceSignal(), (e = this.creditBalanceSignal) == null || e.value$.subscribe(async (t) => {
      this.currentBalance = t || 0, this.currentUser && (this.currentUser.accountBalance.credits = this.currentBalance);
    }), this.autocompleteTriggers && this.autocompleteTriggers.addEventListener("autocomplete:trigger:selected", (t) => {
      const n = t.detail;
      n.type === "style" ? this.selectedStyles.push({ type: n.type, id: n.id, title: n.title }) : n.type === "project" && (this.selectedProjects.push({ type: n.type, id: n.id, title: n.title }), this.notifyKnowledgePickerOfProjectSelection(n.id, n.title));
    }), setTimeout(() => {
      this.autoResizeTextarea(), this.updateAssistContext();
    }, 100);
  }
  updated(s) {
    var e, t, n, i;
    if (super.updated(s), this.overrideConfig(), s.has("customStyles") && su.setStyleColors(this.style, this.customStyles), !this.aiAssistInitialized && this.aiAssist && (this.aiAssistCheck(), this.aiAssistInitialized = !0), s.has("chatSettings")) {
      const r = s.get("chatSettings"), o = this.chatSettings;
      !(r != null && r.enableAIAssistant) && (o != null && o.enableAIAssistant) && this.aiAssistCheck();
    }
    if (s.has("initialMessages") && this.initialMessages.length > 0 && (this.chatThread.length === 0 || !this.isChatStarted) && (this.chatThread = iu.fillInitMessages(this.initialMessages), this.isChatStarted = !0, this.isDefaultPromptsEnabled = !1, this.updateAssistContext(), this.requestUpdate()), (s.has("useWebSocket") || s.has("websocketEvents")) && this.chatController.configureWebSocket(this.useWebSocket, this.websocketEvents), (s.has("isFullscreen") || s.has("isAsideOpen")) && setTimeout(() => this.autoResizeTextarea(), 100), s.has("compact") && this.compact && (this.chatSettings = Dr), this.dynamicTextTyping && this.chatController.processingMessage && this.chatController.generatingAnswer && !this.chatController.processingMessage.isUserMessage) {
      const r = (e = this.shadowRoot) == null ? void 0 : e.querySelector("chat-thread-component"), o = (t = r == null ? void 0 : r.shadowRoot) == null ? void 0 : t.querySelector(`#typing-target-${this.lastTypingEntryId}`);
      if (o) {
        const a = ((n = this.chatController.processingMessage.text[0]) == null ? void 0 : n.value) || "";
        if (this.customTyper ? (i = this.typerTarget) != null && i.isConnected || (this.customTyper.setMessageArea(o), this.typerTarget = o) : (o.innerHTML = "", this.customTyper = Lr(o, {
          onDone: () => this.handleTyperDone(),
          typingTempoDelay: this.typingTempoDelay,
          autoStart: !this.autoTalkEnabled
        }), this.typerTarget = o, this.lastTypedFullText = "", this.autoTalkEnabled && (this.autoTalkStartListener = () => {
          var l;
          (l = this.customTyper) == null || l.start(), this.autoTalkStartListener = null;
        }, window.addEventListener("conversation-agent:playback-started", this.autoTalkStartListener, { once: !0 }))), a.length > this.lastTypedFullText.length) {
          const l = a.slice(this.lastTypedFullText.length);
          this.lastTypedFullText = a, this.emitWriting(!0), Ar(this.customTyper, l);
        } else
          a.length < this.lastTypedFullText.length;
        r == null || r.ensureAutoScroll();
      }
    }
  }
  async connectedCallback() {
    var i, r, o, a, l;
    super.connectedCallback(), console.trace("CHAT COMPONENT CONNECTED"), await dn.bind(this)(), console.log(this.injectCss.split(","));
    for (const u of this.injectCss.split(","))
      await an.bind(this)(u);
    this.chatController.setReasoningCallback((u, h) => {
      this.chatController.addReasoningToProcessingMessage(h);
    });
    const s = this.getAttribute("data-web-search"), e = this.getAttribute("data-deep-search");
    (s === "true" || this.dataWebSearch === !0) && (this.webSearchEnabled = !0), (e === "true" || this.dataDeepSearch === !0) && (this.deepSearchEnabled = !0), Vs.listenToEvents.bind(this)();
    const t = localStorage.getItem("ai.chatSettings");
    t && (this.chatSettings = JSON.parse(t)), Vs.listenForFullScreenEvents.bind(this)(), this.overrideConfig(), this.boundHandleResize = this.handleResize.bind(this), window.addEventListener("resize", this.boundHandleResize), this.addEventListener("autocomplete:state:change", this.handleAutocompleteStateChange.bind(this)), Ys.initializeShortcuts.bind(this)(), this.addEventListener("keyboard:web-search-toggle", this.handleWebSearchToggle.bind(this)), this.addEventListener("keyboard:advanced-prompts-toggle", this.handleAdvancedPromptsToggle.bind(this)), this.addEventListener("knowledge:selection:changed", this.handleKnowledgeSelectionChanged.bind(this)), this.mini ? this.autoTalkEnabled = !1 : localStorage.getItem("chat:autoTalkEnabled") === "ON" ? this.autoTalkEnabled = !0 : this.autoTalkEnabled = !1, this.appChat = (o = (r = (i = this.shadowRoot) == null ? void 0 : i.host.parentElement) == null ? void 0 : r.getRootNode()) == null ? void 0 : o.host, this.appChatSignal = ((a = this.appChat) == null ? void 0 : a.getExternalSignal()) || null, this.appChatSignal && ((l = this.appChatSignal) == null || l.value$.subscribe((u) => {
      var h, p, g, y;
      if ((u == null ? void 0 : u.command) === "start-talk")
        this.toggleTalk(2);
      else if ((u == null ? void 0 : u.command) === "stop-talk")
        this.toggleTalk(0);
      else if ((u == null ? void 0 : u.command) === "stop-all")
        (h = this.customTyper) == null || h.finish(), this.emitWriting(!1), this.toggleTalk(0);
      else if ((u == null ? void 0 : u.command) === "pause-talk")
        (p = this.customTyper) == null || p.pause();
      else if ((u == null ? void 0 : u.command) === "resume-talk")
        (g = this.customTyper) == null || g.resume();
      else if ((u == null ? void 0 : u.command) === "setup-chat") {
        const f = this.getTypingDelay((y = u == null ? void 0 : u.params) == null ? void 0 : y.writingSpeed);
        this.dynamicTextTyping = !0, this.typingTempoDelay = f;
      }
    }));
    const n = new CustomEvent("chat-component-connected", {
      detail: !0,
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n), this.currentUser = window.rws_currentUser || null;
  }
  aiAssistCheck() {
    var s, e, t;
    this.aiAssist && ((e = (s = this.currentUser) == null ? void 0 : s.accountGrade) != null && e.promptAssist) && (this.aiAssist.bindInputSource(this.questionInput), this.aiAssistantSignal = this.aiAssist.getExternalSignal(), (t = this.aiAssistantSignal) == null || t.value$.subscribe(async (n) => {
      (n == null ? void 0 : n.command) === "pass_entry" && (this.activeAssist = n == null ? void 0 : n.payload);
    }), this.aiAssist.addEventListener("webchat:submit", (n) => {
      this.handleUserChatSubmit(n);
    }), this.aiAssist.addEventListener("webchat:text-insert", (n) => {
      this.handleTextInsert(n);
    }));
  }
  handleResize() {
    this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(() => {
      this.autoResizeTextarea();
    }, 100);
  }
  handleSlotChanges(s) {
    const e = s;
    this.overrides = {
      ...this.overrides,
      promptSlots: e.detail
    };
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Vs.removeFullScreenEventListeners.bind(this)(), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.boundHandleResize && window.removeEventListener("resize", this.boundHandleResize), this.removeEventListener("autocomplete:state:change", this.handleAutocompleteStateChange.bind(this)), this.removeEventListener("keyboard:web-search-toggle", this.handleWebSearchToggle.bind(this)), this.removeEventListener("keyboard:advanced-prompts-toggle", this.handleAdvancedPromptsToggle.bind(this)), this.removeEventListener("knowledge:selection:changed", this.handleKnowledgeSelectionChanged.bind(this)), Ys.stopListening(), this.chatController.cancelRequest(), this.chatThread = [], this.isChatStarted = !1, this.isDefaultPromptsEnabled = Kt.IS_DEFAULT_PROMPTS_ENABLED, this.initialMessages = [], this.currentQuestion = "", this.questionInput && (this.questionInput.value = ""), this.showControls = !1, this.liveChatOn = !1;
  }
  attributeChangedCallback(s, e, t) {
    super.attributeChangedCallback(s, e, t), s === "data-web-search" && (this.webSearchEnabled = t === "true"), s === "data-deep-search" && (this.deepSearchEnabled = t === "true");
  }
  static get observedAttributes() {
    return [...super.observedAttributes || [], "data-web-search", "data-deep-search"];
  }
  handleProgressEvent(s) {
    const e = s, { stage: t, message: n, percentage: i } = e.detail;
    this.progressStage = t || "", this.progressMessage = n || "", this.progressPercentage = i || 0, this.isShowingProgress = !0, (i >= 100 || t === "complete") && setTimeout(() => {
      this.isShowingProgress = !1, this.progressPercentage = 0, this.progressMessage = "", this.progressStage = "";
    }, 1e3);
  }
  handleAutocompleteStateChange(s) {
    const e = s, { isOpen: t } = e.detail;
    this.enterSubmitBlocked = t;
  }
  handleWebSearchToggle(s) {
    const e = s, { enabled: t } = e.detail;
    this.dispatchEvent(new CustomEvent("show-notification", {
      detail: {
        message: `Web Search ${t ? "enabled" : "disabled"}`,
        type: "info"
      },
      bubbles: !0,
      composed: !0
    }));
  }
  handleAdvancedPromptsToggle(s) {
    const e = s, { enabled: t } = e.detail;
    this.dispatchEvent(new CustomEvent("show-notification", {
      detail: {
        message: `Advanced Prompts ${t ? "enabled" : "disabled"}`,
        type: "info"
      },
      bubbles: !0,
      composed: !0
    }));
  }
  overrideConfig() {
    this.customConfig && Object.keys(this.customConfig).length > 0 && (Kt = { ...Xe, ...this.customConfig }), this.customTeasers && Object.keys(this.customTeasers).length > 0 && (Or = this.customTeasers);
  }
  clearChat() {
    tn.clearChat.bind(this)();
  }
  setQuestionInputValue(s) {
    this.questionInput.value = Wr.sanitize(s || ""), this.currentQuestion = this.questionInput.value, this.autoResizeTextarea();
  }
  setInputValue(s, e = !1, t = !1, n = !1) {
    if (n)
      this.currentQuestion = s, this.questionInput.value = s, this.currentQuestionHidden = !0;
    else if (e) {
      const r = (this.questionInput.value || "") + s;
      this.setQuestionInputValue(r);
    } else
      this.setQuestionInputValue(s);
    this.resetInputCheck(), t && this.handleUserChatSubmit(new Event("submit"));
  }
  /**
   * Add a simulated AI message directly to the chat thread.
   * Accepts HTML content which will be rendered in the message area.
   * If dynamicTextTyping is enabled, the message will be typed out using the custom typer.
   */
  addSimulatedAIMessage(s, e = {}) {
    const t = {
      id: crypto.randomUUID(),
      text: [{ value: s, followingSteps: [] }],
      followupQuestions: [],
      citations: [],
      timestamp: Date.now(),
      isUserMessage: !1,
      rawContent: s,
      ...e
    };
    this.dynamicTextTyping ? this.addSimulatedAIMessageWithTyping(t) : (this.chatThread = [...this.chatThread, t], this.isChatStarted = !0, this.isDefaultPromptsEnabled = !1, this.requestUpdate());
  }
  /**
   * Add a simulated AI message with typing animation.
   * Creates a placeholder entry and uses the custom typer to type out the content.
   */
  addSimulatedAIMessageWithTyping(s) {
    var n;
    this.forceFinishActiveTyping();
    const e = ((n = s.text[0]) == null ? void 0 : n.value) || "", t = this.deepCloneChatThreadEntry(s);
    t.text = t.text.map((i) => ({ ...i, value: "" })), this.simulatedEntryIds.add(t.id), this.chatThread = [...this.chatThread, t], this.isChatStarted = !0, this.isDefaultPromptsEnabled = !1, this.requestUpdate(), this.updateComplete.then(() => {
      var o, a;
      const i = (o = this.shadowRoot) == null ? void 0 : o.querySelector("chat-thread-component"), r = (a = i == null ? void 0 : i.shadowRoot) == null ? void 0 : a.querySelector(`#typing-target-${t.id}`);
      if (r) {
        i && (i.isTyping = !0);
        const l = this.autoTalkEnabled ? this.htmlToPlainText(e) : "", u = !!l.trim();
        this.customTyper = Lr(r, {
          onDone: () => this.handleSimulatedMessageTyperDone(t, e),
          typingTempoDelay: this.typingTempoDelay,
          autoStart: !u
        }), this.typerTarget = r, this.lastTypingEntryId = t.id, this.lastTypedFullText = "", this.emitWriting(!0), Ar(this.customTyper, e), u && (console.log("[chat-component] autotalk: requesting speech before typing:", l), this.simulatedTyperAwaitingPlayback = !0, this.speakingMessageId = t.id, this.isTalking = 1, console.log("[chat-component] autotalk: waiting for audio playback to start", l), this.dispatchEvent(new CustomEvent("chat:speak", {
          detail: { message: l },
          bubbles: !0,
          composed: !0
        })));
      } else
        this.chatThread = [...this.chatThread.slice(0, -1), s], this.requestUpdate();
    });
  }
  /**
   * Callback when simulated message typing is complete.
   * Replaces the placeholder with the full entry.
   * If autoTalk is enabled, triggers the speak action.
   */
  handleSimulatedMessageTyperDone(s, e) {
    var r, o;
    const t = this.deepCloneChatThreadEntry(s);
    t.text = t.text.map((a) => ({ ...a, value: e }));
    const n = this.chatThread.findIndex((a) => a.id === s.id);
    n > -1 && (this.chatThread = lt(this.chatThread, n, t));
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("chat-thread-component");
    i && (i.isTyping = !1), (o = this.customTyper) == null || o.destroy(), this.customTyper = null, this.typerTarget = null, this.lastTypingEntryId = null, this.lastTypedFullText = "", this.customTyperDoneCallback = null, this.requestUpdate(), this.simulatedTyperAwaitingPlayback = !1, this.emitWriting(!1), console.log("[chat-component] simulated typing done. messageId:", s.id);
  }
  /**
   * Force-finish a currently typing message: the whole text is printed immediately
   * and the typer completion handler persists the full entry in chatThread.
   */
  forceFinishActiveTyping() {
    var e, t, n;
    if (this.simulatedTyperAwaitingPlayback = !1, this.customTyper && this.customTyper.finish(), this.lastTypingEntryId) {
      const i = ((e = this.customTyper) == null ? void 0 : e.getTypedText()) || "", r = this.chatThread.findIndex((o) => o.id === this.lastTypingEntryId);
      if (r > -1) {
        const o = this.chatThread[r];
        if (o.text.every((a) => !a.value))
          if (i) {
            const a = this.deepCloneChatThreadEntry(o);
            a.text = a.text.map((l) => ({ ...l, value: i })), this.chatThread = lt(this.chatThread, r, a);
          } else
            this.chatThread = [...this.chatThread.slice(0, r), ...this.chatThread.slice(r + 1)];
      }
    }
    (t = this.customTyper) == null || t.destroy(), this.customTyper = null, this.typerTarget = null, this.lastTypingEntryId = null, this.lastTypedFullText = "", this.customTyperDoneCallback = null, this.emitWriting(!1);
    const s = (n = this.shadowRoot) == null ? void 0 : n.querySelector("chat-thread-component");
    s && (s.isTyping = !1);
  }
  /** Prints a still-typing simulated message in full so a real response can't overwrite it. */
  finishSimulatedTyping() {
    this.lastTypingEntryId && this.simulatedEntryIds.has(this.lastTypingEntryId) && this.forceFinishActiveTyping();
  }
  htmlToPlainText(s) {
    const e = document.createElement("div");
    e.innerHTML = s;
    const t = (n) => {
      var r;
      let i = "";
      for (const o of Array.from(n.childNodes))
        if (o.nodeType === Node.TEXT_NODE)
          i += o.textContent || "";
        else if (o.nodeType === Node.ELEMENT_NODE) {
          const a = o.tagName.toLowerCase();
          if (/^h[1-6]$/.test(a)) {
            const l = ((r = o.textContent) == null ? void 0 : r.trim()) || "";
            l && (i += `${l}<break time="600ms"/>`);
          } else
            i += t(o);
        }
      return i;
    };
    return t(e);
  }
  resetInputCheck() {
    this.isResetInput = !!this.questionInput.value;
  }
  handleVoiceInput(s) {
    var e;
    s == null || s.preventDefault(), this.setQuestionInputValue((e = s == null ? void 0 : s.detail) == null ? void 0 : e.input), this.resetInputCheck();
  }
  handleRecordingStateChange(s) {
    s == null || s.preventDefault();
    const { isRecording: e } = s.detail, t = new CustomEvent("recording-state-change", {
      detail: { isRecording: e },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  getMessageContext() {
    return this.chatThread.length === 1 && this.chatThread[0] === void 0 && (this.chatThread = []), tn.getMessageContext.bind(this)();
  }
  updateAssistContext() {
    var s, e;
    (e = (s = this.currentUser) == null ? void 0 : s.accountGrade) != null && e.promptAssist && Z.handleDiscussionLLMTurn.bind(this)();
  }
  // New method to trigger AI assist analysis after LLM response
  async triggerAIAssistAfterLLMResponse() {
    var s, e;
    if (this.aiAssist && ((e = (s = this.currentUser) == null ? void 0 : s.accountGrade) != null && e.promptAssist) && typeof this.aiAssist.analyzeAfterLLMResponse == "function")
      try {
        await this.aiAssist.analyzeAfterLLMResponse();
      } catch {
      }
  }
  async handleUserChatSubmit(s) {
    if (s.preventDefault(), !(this.overrides.avatar || this.overrides.selectedModel)) {
      console.log("No avatar or model in chat overrides");
      return;
    }
    if ((this.chatController.generatingAnswer || this.chatController.isProcessingResponse) && (this.chatController.cancelRequest(), await new Promise((e) => setTimeout(e, 100)), this.dynamicTextTyping && this.cleanupDynamicTypingOnCancel()), this.forceFinishActiveTyping(), this.dispatchEvent(new CustomEvent("chat:stop-talking", {
      bubbles: !0,
      composed: !0
    })), this.collapseAside(s), this.currentUser && this.currentBalance <= 0 && !["super_admin", "enterprise"].includes(this.currentUser.role)) {
      const e = new CustomEvent("appEvents.popupShow", {
        detail: {
          message: "chat.noCredits.message",
          type: "error",
          params: { balance: this.currentBalance }
        },
        bubbles: !0,
        composed: !0
      });
      this.dispatchEvent(e);
      return;
    }
    this.aiAssist && typeof this.aiAssist.toggleMinimize == "function" && (this.aiAssist.minimized || this.aiAssist.toggleMinimize()), this.aiAssist && typeof this.aiAssist.clearPromptWritingTimeout == "function" && this.aiAssist.clearPromptWritingTimeout(), await au.handleSubmit.bind(this)(Ra, js), setTimeout(() => {
      this.updateAssistContext();
    }, 500);
  }
  resetInputField(s) {
    s.preventDefault(), this.questionInput.value = "", this.currentQuestion = "", this.isResetInput = !1, this.autoResizeTextarea();
  }
  startLiveChat(s) {
    s.preventDefault(), this.showControls = !1, this.liveChatOn = !0;
  }
  showDefaultPrompts(s) {
    this.isDefaultPromptsEnabled || tn.resetThread.bind(this)(s);
  }
  handleOnKeyDown(s) {
    if (s.key === "Enter" && !s.shiftKey && this.questionInput.value.trim().length > 0) {
      if (this.currentBalance <= 0) {
        s.preventDefault();
        return;
      }
      if (this.enterSubmitBlocked) {
        s.preventDefault();
        return;
      }
      s.preventDefault();
    }
  }
  handleOnInputChange(s) {
    if (this.resetInputCheck(), this.autoResizeTextarea(), s instanceof KeyboardEvent && s.key === "Enter" && !s.shiftKey && this.questionInput.value.trim().length > 0) {
      if (s.preventDefault(), this.enterSubmitBlocked)
        return;
      this.handleUserChatSubmit(s);
    }
  }
  async handlePasteEvent(s) {
    await $e.onPaste.bind(this)(s), setTimeout(() => {
      this.autoResizeTextarea(), this.resetInputCheck();
    }, 10);
  }
  autoResizeTextarea() {
    if (!this.questionInput)
      return;
    this.questionInput.style.height = "auto";
    const s = getComputedStyle(this.questionInput), e = parseInt(s.minHeight) || 40, t = parseInt(s.maxHeight) || 120, n = this.questionInput.scrollHeight - 10, i = Math.min(Math.max(n, e), t);
    this.questionInput.style.height = `${i}px`, n > t ? this.questionInput.style.overflowY = "auto" : this.questionInput.style.overflowY = "hidden";
  }
  handleUserChatCancel(s) {
    s == null || s.preventDefault(), this.chatController.cancelRequest(), this.dynamicTextTyping && this.cleanupDynamicTypingOnCancel();
  }
  handleCodeExpandAside(s = void 0, e = null) {
    var t;
    s == null || s.preventDefault(), e ? ((t = this.showCode) != null && t.ended && (e.ended = !0, e.preview = this.showCode.preview), this.showCode = { ...this.showCode, ...e }) : this.showCode = e, this.openAside();
  }
  handleSettingsExpandAside(s = void 0) {
    s == null || s.preventDefault(), this.showSettings = !0;
  }
  openAside() {
    this.isAsideOpen = !0;
  }
  collapseAside(s) {
    s.preventDefault(), this.selectedCitation = void 0, this.isAsideOpen = !1;
  }
  willUpdate() {
    var e, t;
    const s = this.chatController.generatingAnswer;
    if (this.isDisabled = this.chatController.isAwaitingResponse && !this.chatController.isProcessingResponse, this.chatController.processingMessage) {
      const n = this.chatController.processingMessage;
      if (this.chatThread.length === 1 && this.chatThread[0] === void 0 || !n || !n.id)
        return;
      const i = this.chatThread.findIndex((a) => a.id === n.id), r = i > -1 && this.chatThread[i].text.some((a) => !!a.value), o = (e = this.shadowRoot) == null ? void 0 : e.querySelector("chat-thread-component");
      if (this.dynamicTextTyping && s && !n.isUserMessage && n.id && this.lastTypingEntryId !== n.id && !r) {
        this.finishSimulatedTyping();
        const a = this.chatThread.findIndex((p) => p.id === this.lastTypingEntryId), l = a > -1 ? this.chatThread[a] : null, u = l && l.text.every((p) => !p.value);
        this.lastTypingEntryId = n.id, (t = this.customTyper) == null || t.destroy(), this.customTyper = null, this.typerTarget = null, this.lastTypedFullText = "", o && (o.isTyping = !0), o && o.showLoadingIndicator && (o.showLoadingIndicator = !1, o.requestUpdate());
        const h = this.deepCloneChatThreadEntry(n);
        h.text = h.text.map((p) => ({ ...p, value: "" })), a > -1 && u ? this.chatThread = lt(this.chatThread, a, h) : this.chatThread = [...this.chatThread, h];
      }
      (!this.dynamicTextTyping || n.isUserMessage) && (this.chatThread = i > -1 ? lt(this.chatThread, i, n) : [...this.chatThread, n]), this.aiAssist && typeof this.aiAssist.setLLMStreaming == "function" && this.aiAssist.setLLMStreaming(!0);
    }
    if (this.previousGeneratingAnswer && !s) {
      if (this.aiAssist && typeof this.aiAssist.setLLMStreaming == "function" && this.aiAssist.setLLMStreaming(!1), this.dynamicTextTyping) {
        const n = this.deepCloneChatThreadEntry(this.chatController.processingMessage);
        this.customTyper && !this.customTyper.isDone() ? this.customTyperDoneCallback = () => this.finalizeTyping(n) : this.finalizeTyping(n);
      }
      setTimeout(() => {
        this.updateAssistContext(), this.triggerAIAssistAfterLLMResponse();
      }, 500);
    }
    this.previousGeneratingAnswer = s;
  }
  debugSlotContent() {
    var t, n, i;
    const s = (t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="model_select"]'), e = (n = this.shadowRoot) == null ? void 0 : n.querySelectorAll("slot");
    return {
      modelSelectSlot: s,
      allSlots: e,
      lightDOMContent: this.innerHTML,
      shadowDOMContent: (i = this.shadowRoot) == null ? void 0 : i.innerHTML
    };
  }
  getKeyboardShortcuts() {
    return Ys.getShortcuts();
  }
  toggleTalk(s) {
    var e;
    console.log("[chat-component] toggleTalk", s, "speakingMessageId:", this.speakingMessageId), this.isTalking = s, s !== 1 && this.simulatedTyperAwaitingPlayback && (this.simulatedTyperAwaitingPlayback = !1, console.log("[chat-component] starting typer, talk state:", s), (e = this.customTyper) == null || e.start()), s === 0 && (this.speakingMessageId = null);
  }
  toggleThreadLoading(s) {
    if (s !== void 0) {
      this.upperLoader = s;
      return;
    }
    this.upperLoader = !this.upperLoader;
  }
  handleTextInsert(s) {
    const { text: e } = s.detail;
    this.questionInput && e && (this.questionInput.value = e, this.currentQuestion = e, this.questionInput.focus(), this.questionInput.dispatchEvent(new Event("input", { bubbles: !0 })), this.autoResizeTextarea(), this.resetInputCheck()), this.activeAssist = null, this.aiAssist && typeof this.aiAssist.clearActiveEntry == "function" && this.aiAssist.clearActiveEntry();
  }
  handleSuggestionApplied(s) {
    var n;
    const e = s.detail.text, t = s.detail.suggestion;
    this.questionInput && (this.collapseAside(s), t.context === "kdb_attachment" ? ((n = this.aiAssistantSignal) == null || n.setValue({
      command: "attach_file",
      payload: t.kdb
    }), this.dispatchEvent(new CustomEvent("selectionChanged", {
      detail: { selectedIds: t.kdb ? [t.kdb.kdbId.toString()] : [] },
      bubbles: !0,
      composed: !0
    }))) : (this.questionInput.value = e, this.currentQuestion = e, this.questionInput.focus(), this.questionInput.dispatchEvent(new Event("input", { bubbles: !0 })), this.autoResizeTextarea(), this.resetInputCheck())), this.activeAssist = null, this.aiAssist && typeof this.aiAssist.clearActiveEntry == "function" && this.aiAssist.clearActiveEntry();
  }
  handleSuggestionsModalClose() {
    this.activeAssist = null, this.aiAssist && typeof this.aiAssist.clearActiveEntry == "function" && this.aiAssist.clearActiveEntry();
  }
  removeStyle(s, e) {
    s.preventDefault(), s.stopPropagation(), this.selectedStyles = this.selectedStyles.filter((n) => n.id !== e);
    const t = new CustomEvent("chat:remove:style", {
      detail: { styleId: e },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t), this.requestUpdate();
  }
  removeProject(s, e) {
    s.preventDefault(), s.stopPropagation(), this.selectedProjects = this.selectedProjects.filter((n) => n.id !== e), this.notifyKnowledgePickerOfProjectRemoval(e);
    const t = new CustomEvent("chat:remove:project", {
      detail: { projectId: e },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t), this.requestUpdate();
  }
  notifyKnowledgePickerOfProjectSelection(s, e) {
    var n;
    const t = (n = this.shadowRoot) == null ? void 0 : n.querySelector("knowledge-picker");
    if (t) {
      const i = new CustomEvent("chat:project:selected", {
        detail: { projectId: s, projectTitle: e },
        bubbles: !0,
        composed: !0
      });
      t.dispatchEvent(i);
    }
  }
  notifyKnowledgePickerOfProjectRemoval(s) {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector("knowledge-picker");
    if (e) {
      const n = new CustomEvent("chat:project:removed", {
        detail: { projectId: s },
        bubbles: !0,
        composed: !0
      });
      e.dispatchEvent(n);
    }
  }
  handleKnowledgeSelectionChanged(s) {
    const e = s, { selectedIds: t, fullKnowledgeIds: n } = e.detail;
    this.selectedKnowledge = t || [], this.fullKnowledgeIds = n || [];
  }
  handleKnowledgePickerChange(s) {
    const { selectedIds: e, fullKnowledgeIds: t, selectedKnowledge: n } = s.detail;
    this.selectedKnowledge = e || [], this.fullKnowledgeIds = t || [];
    const i = new CustomEvent("kdbPick", {
      detail: { selectedIds: e, fullKnowledgeIds: t, selectedKnowledge: n },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(i);
    const r = new CustomEvent("knowledge:selection:changed", {
      detail: { selectedIds: e, fullKnowledgeIds: t, selectedKnowledge: n },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(r);
  }
  handleAutoTalkClick() {
    this.autoTalkEnabled = !this.autoTalkEnabled, localStorage.setItem("chat:autoTalkEnabled", this.autoTalkEnabled ? "ON" : "OFF"), this.dispatchEvent(new CustomEvent("autotalk:toggle", {
      detail: this.autoTalkEnabled,
      bubbles: !0,
      composed: !0
    }));
  }
  render() {
    return Le.mainRender.bind(this)(Kt, Or);
  }
};
k.styles = [Ia];
C([
  T({ type: String, attribute: "data-input-position" })
], k.prototype, "inputPosition", 2);
C([
  T({ type: String, attribute: "data-interaction-model" })
], k.prototype, "interactionModel", 2);
C([
  T({ type: String, attribute: "data-api-url" })
], k.prototype, "apiUrl", 2);
C([
  T({ type: String, attribute: "data-inject-css" })
], k.prototype, "injectCss", 2);
C([
  T({ type: String, attribute: "data-custom-branding", converter: (s) => (s == null ? void 0 : s.toLowerCase()) === "true" })
], k.prototype, "isCustomBranding", 2);
C([
  T({ type: String, attribute: "data-use-stream", converter: (s) => (s == null ? void 0 : s.toLowerCase()) === "true" })
], k.prototype, "useStream", 2);
C([
  T({ type: String, attribute: "data-overrides", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "overrides", 2);
C([
  T({ type: String, attribute: "data-custom-styles", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "customStyles", 2);
C([
  T({ type: String, attribute: "data-custom-headers", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "customHeaders", 2);
C([
  T({ type: String, attribute: "data-custom-teasers", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "customTeasers", 2);
C([
  T({ type: String, attribute: "data-custom-config", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "customConfig", 2);
C([
  T({ type: Boolean, attribute: "data-hide-delete-button", converter: (s) => s === "true" })
], k.prototype, "hideDeleteButton", 2);
C([
  T({ type: Boolean, attribute: "data-text-typing", converter: (s) => s === "true" })
], k.prototype, "dynamicTextTyping", 2);
C([
  T({
    type: String,
    attribute: "data-selected-model",
    converter: (s) => {
      try {
        return s ? JSON.parse(s) : null;
      } catch {
        return null;
      }
    }
  })
], k.prototype, "externalSelectedModel", 2);
C([
  T({
    type: String,
    attribute: "data-selected-avatar",
    converter: (s) => {
      try {
        return s ? JSON.parse(s) : null;
      } catch {
        return null;
      }
    }
  })
], k.prototype, "externalSelectedAvatar", 2);
C([
  T({ type: String, attribute: "data-ai-provider" })
], k.prototype, "externalAiProvider", 2);
C([
  T({ type: String, attribute: "data-initial-messages", converter: (s) => JSON.parse(s || "[]") })
], k.prototype, "initialMessages", 2);
C([
  T({ type: Boolean, attribute: "data-websocket", converter: (s) => s === "true" })
], k.prototype, "useWebSocket", 2);
C([
  T({ type: String, attribute: "data-websocket-events", converter: (s) => JSON.parse(s || "{}") })
], k.prototype, "websocketEvents", 2);
C([
  T({ type: String })
], k.prototype, "currentQuestion", 2);
C([
  T({ type: Boolean, attribute: "fullscreen", converter: (s) => s === "true" })
], k.prototype, "fullscreen", 2);
C([
  T({ type: Boolean, attribute: "data-web-search", converter: (s) => s === "true" })
], k.prototype, "dataWebSearch", 2);
C([
  T({ type: Boolean, attribute: "data-can-talk", converter: (s) => s === "true" })
], k.prototype, "dataCanTalk", 2);
C([
  T({ type: Boolean, attribute: "data-deep-search", converter: (s) => s === "true" })
], k.prototype, "dataDeepSearch", 2);
C([
  T({ type: Boolean, attribute: "compact", converter: (s) => s === "true" })
], k.prototype, "compact", 2);
C([
  T({ type: Boolean, attribute: "mini", converter: (s) => s === "true" })
], k.prototype, "mini", 2);
C([
  hn("#question-input")
], k.prototype, "questionInput", 2);
C([
  hn("#ai-assist-component")
], k.prototype, "aiAssist", 2);
C([
  hn("#prompt-autocomplete-component")
], k.prototype, "autocompleteTriggers", 2);
C([
  hn("#prompt-slots")
], k.prototype, "promptSlots", 2);
C([
  O()
], k.prototype, "activeAssist", 2);
C([
  O()
], k.prototype, "isDisabled", 2);
C([
  O()
], k.prototype, "isTalking", 2);
C([
  O()
], k.prototype, "speakingMessageId", 2);
C([
  O()
], k.prototype, "upperLoader", 2);
C([
  O()
], k.prototype, "currentQuestionHidden", 2);
C([
  O()
], k.prototype, "isChatStarted", 2);
C([
  O()
], k.prototype, "isResetInput", 2);
C([
  O()
], k.prototype, "autoTalkEnabled", 2);
C([
  O()
], k.prototype, "webSearchEnabled", 2);
C([
  O()
], k.prototype, "deepSearchEnabled", 2);
C([
  O()
], k.prototype, "advancedPromptingEnabled", 2);
C([
  O()
], k.prototype, "isFullscreen", 2);
C([
  O()
], k.prototype, "showControls", 2);
C([
  O()
], k.prototype, "liveChatOn", 2);
C([
  O()
], k.prototype, "showSettings", 2);
C([
  O()
], k.prototype, "showCode", 2);
C([
  O()
], k.prototype, "isDefaultPromptsEnabled", 2);
C([
  O()
], k.prototype, "selectedCitation", 2);
C([
  O()
], k.prototype, "selectedChatEntry", 2);
C([
  O()
], k.prototype, "isShowingProgress", 2);
C([
  O()
], k.prototype, "progressPercentage", 2);
C([
  O()
], k.prototype, "progressMessage", 2);
C([
  O()
], k.prototype, "progressStage", 2);
C([
  O()
], k.prototype, "chatSettings", 2);
C([
  O()
], k.prototype, "isAsideOpen", 2);
C([
  O()
], k.prototype, "promptFiles", 2);
C([
  O()
], k.prototype, "isDragOver", 2);
C([
  O()
], k.prototype, "enterSubmitBlocked", 2);
C([
  O()
], k.prototype, "currentUser", 2);
C([
  O()
], k.prototype, "currentBalance", 2);
C([
  O()
], k.prototype, "selectedStyles", 2);
C([
  O()
], k.prototype, "selectedProjects", 2);
C([
  O()
], k.prototype, "selectedKnowledge", 2);
C([
  O()
], k.prototype, "fullKnowledgeIds", 2);
C([
  T({ type: Number, attribute: "data-convo-id" })
], k.prototype, "convoId", 2);
k = C([
  Pe("chat-component")
], k);
export {
  Oe as ChatActionButtonComponent,
  k as ChatComponent,
  dt as ChatResponseError,
  Y as ChatThreadComponent,
  gt as CitationListComponent,
  ln as DocumentPreviewerComponent,
  Yn as LoadingIndicatorComponent,
  We as ReasoningViewer,
  on as TabComponent,
  et as TeaserListComponent,
  pt as VoiceInputButton,
  dn as addIconSheet,
  Rl as callHttpApi,
  mu as cancelStream,
  Va as chatEntryToHtmlString,
  Js as chatEntryToString,
  Wa as cleanUpFollowUp,
  Rc as createReader,
  Il as getAPIResponse,
  vr as getTimestamp,
  an as injectCSS,
  lt as newListWithEntryAtIndex,
  eu as parseStreamedMessages,
  Ba as processText,
  Ic as readStream
};
